import React, { createContext, useContext, useLayoutEffect, useState, useMemo, useEffect } from 'react';
import msk from 'msk';

const LocalizationContext = createContext(undefined);

const LocalizationProvider = LocalizationContext.Provider;

const useLocalization = () => {
  const context = useContext(LocalizationContext);

  if (!context) {
    throw new Error('You probably forgot to put LocalizationProvider');
  }

  return context;
};

/**
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 *
 * @param value the value or function to persist
 */

function useCallbackRef(fn, deps = []) {
  const ref = React.useRef(fn);
  useLayoutEffect(() => {
    ref.current = fn;
  }); // eslint-disable-next-line react-hooks/exhaustive-deps

  return React.useCallback((...args) => {
    var _ref$current;

    return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.call(ref, ...args);
  }, deps);
}

const useLocalizationInput = ({
  initialValue = '',
  apiValue = '',
  // TODO: force when inputField=neighborhood
  inputField,
  onChange
}) => {
  const {
    localizationConfig
  } = useLocalization();
  const [value, setValue] = useState(initialValue);
  const localizationInput = localizationConfig.input[inputField];
  const handleInputTextChange = useCallbackRef(event => {
    setValue(event.target.value);

    if (onChange) {
      onChange(event);
    }
  }, [setValue, onChange]);
  const handleInputSelectChange = useCallbackRef(event => {
    setValue(event.target.value);

    if (onChange) {
      onChange(event);
    }
  }, [setValue, onChange]);

  if (localizationInput.type === 'dynamic-input' && !apiValue) {
    console.error(`Missing apiValue for an 'dynamic-input' type`);
  }

  return useMemo(() => {
    const input = localizationInput.type === 'dynamic-input' ? localizationInput.transform(apiValue) : localizationInput;

    if (input.type === 'select') {
      return {
        type: input.type,
        required: input.required,
        enabled: input.enabled,
        options: input.options,
        parent: input.parent,
        setValue,
        value,
        inputAttrs: {
          onChange: handleInputSelectChange
        }
      };
    }

    if (input.type === 'text') {
      const formattedValue = input.format(value);
      return {
        type: input.type,
        required: input.required,
        enabled: input.enabled,
        value: formattedValue,
        inputAttrs: {
          onChange: handleInputTextChange,
          value: formattedValue,
          maxLength: input.maxLength,
          placeholder: input.placeholder,
          inputMode: input.inputMode
        },
        validate: () => input.validate(value),
        unformat: () => input.unformat(value),
        format: () => input.format(value),
        setValue
      };
    }

    throw new Error('Invalid input type');
  }, [localizationInput, value, handleInputSelectChange, handleInputTextChange, apiValue]);
};

function mapCountryDataToFirstLevel(countryData) {
  return Object.keys(countryData);
}
function mapCountryDataToSecondLevel(countryData) {
  return Object.entries(countryData).reduce((result, [key, value]) => {
    result[key] = Array.isArray(value) ? value : Object.entries(value).map(([childKey, childValue]) => `${childKey},${childValue}`);
    return result;
  }, {});
}

var countryData$e = {
	"Ciudad Autónoma de Buenos Aires": [
		"Ciudad Autónoma de Buenos Aires"
	],
	"Buenos Aires": [
		"11 De Septiembre",
		"12 De Agosto",
		"12 De Octubre",
		"16 De Julio",
		"17 De Agosto",
		"20 De Junio",
		"25 De Mayo",
		"30 De Agosto",
		"4 De Noviembre",
		"9 De Abril",
		"9 De Julio",
		"Abasto",
		"Abbott",
		"Abel",
		"Abra De Hinojo",
		"Acassuso",
		"Aceilan",
		"Acevedo",
		"Achupallas",
		"Adela",
		"Adela Corti",
		"Adela Saenz",
		"Adolfo Alsina",
		"Adolfo Gonzáles Chaves",
		"Adrogue",
		"Aeropuerto Ezeiza",
		"Agote",
		"Aguara",
		"Aguas Corrientes",
		"Aguas Verdes",
		"Aguirrezabala",
		"Agustín Mosconi",
		"Agustin Roca",
		"Agustina",
		"Alagon",
		"Alamos",
		"Alastuey",
		"Albariño",
		"Alberdi",
		"Alberti",
		"Aldea Romana",
		"Aldea San Andrés",
		"Aldecon",
		"Aldo Bonzi",
		"Alegre",
		"Alejandro Korn",
		"Alejandro Petion",
		"Alfa",
		"Alfalad",
		"Alférez San Martín",
		"Alfredo Demarchi",
		"Algarrobo",
		"Almacén Castro",
		"Almacén El Cruce",
		"Almacén El Descanso",
		"Almacén La Colina",
		"Almacén Piatti",
		"Almirante Brown",
		"Almirante Irizar",
		"Almirante Solier",
		"Alsina",
		"Alta Vista",
		"Altamira",
		"Altamirano",
		"Alto Los Cardales",
		"Alto Verde",
		"Altona",
		"Alvarez De Toledo",
		"Alvarez Jonte",
		"Alvaro Barros",
		"Alzaga",
		"Amalia",
		"Ambrosio P Lezica",
		"América",
		"América Unida",
		"Anasagasti",
		"Ancón",
		"Andant",
		"Anderson",
		"Andrés Vaccarezza",
		"Aneque Grande",
		"Antonio Carboni",
		"Antonio De Los Heros",
		"Aparicio",
		"Arana",
		"Arano",
		"Araujo",
		"Arboleda",
		"Arbuco",
		"Arenales",
		"Arenaza",
		"Arevalo",
		"Argerich",
		"Ariel",
		"Arquedas",
		"Arrecifes",
		"Arribeños",
		"Arroyo Aguas Blancas",
		"Arroyo Aguila Negra",
		"Arroyo Alelí",
		"Arroyo Botija Falsa",
		"Arroyo Burgos",
		"Arroyo Canelón",
		"Arroyo Carabelitas",
		"Arroyo Chico",
		"Arroyo Corto",
		"Arroyo De La Cruz",
		"Arroyo De Luna",
		"Arroyo Del Pescado",
		"Arroyo Dulce",
		"Arroyo El Ahogado",
		"Arroyo El Chingolo",
		"Arroyo Grande",
		"Arroyo La Maza",
		"Arroyo Las Cruces",
		"Arroyo Las Rosas",
		"Arroyo Los Huesos",
		"Arroyo Los Tigres",
		"Arroyo Negro",
		"Arroyo Ñacurutu",
		"Arroyo Ñacurutu Chico",
		"Arroyo Pareja",
		"Arroyo Pesquería",
		"Arroyo Tajiber",
		"Arroyo Venado",
		"Arroyo Zanjon",
		"Arturo Seguí",
		"Arturo Vatteone",
		"Asamblea",
		"Ascencion",
		"Asturias",
		"Atahualpa",
		"Atalaya",
		"Atucha",
		"Avellaneda",
		"Avestruz",
		"Ayacucho",
		"Azcuenaga",
		"Azopardo",
		"Azul",
		"B Los Aromos San Patricio",
		"B Sarmiento Don Rolando",
		"Bacacay",
		"Badano",
		"Bahía Blanca",
		"Bahía San Blas",
		"Baigorrita",
		"Bajo Hondo",
		"Balcarce",
		"Balneario Atlántida",
		"Balneario Camet Norte",
		"Balneario Chapalco",
		"Balneario Claromeco",
		"Balneario Frente Mar",
		"Balneario La Baliza",
		"Balneario La Caleta",
		"Balneario Los Angeles",
		"Balneario Mar Chiquita",
		"Balneario Mar De Cobo",
		"Balneario Océano",
		"Balneario Orense",
		"Balneario Oriente",
		"Balneario Parada",
		"Balneario Playa Dorada",
		"Balneario Reta",
		"Balneario San Antonio",
		"Balneario Santa Elena",
		"Balneario Sauce Grande",
		"Balsa",
		"Banderalo",
		"Banfield",
		"Baradero",
		"Barker",
		"Barrientos",
		"Barrio 1 De Mayo",
		"Barrio Almafuerte",
		"Barrio Avellaneda",
		"Barrio Batan",
		"Barrio Caisamar",
		"Barrio Carosio",
		"Barrio Chapadmalal",
		"Barrio El Cazador",
		"Barrio El Hueco",
		"Barrio El Porteño",
		"Barrio Emir Ramón Juárez",
		"Barrio Garin Norte",
		"Barrio Gastronómico",
		"Barrio General Roca",
		"Barrio General San Martín",
		"Barrio Indio Trompa",
		"Barrio José M Estrada",
		"Barrio Juárez",
		"Barrio Julio De Vedia",
		"Barrio Juramento",
		"Barrio La Dolly",
		"Barrio La Falda",
		"Barrio La Luisa",
		"Barrio Las Mandarinas",
		"Barrio Loma Paraguaya",
		"Barrio Los Andes",
		"Barrio Noroeste",
		"Barrio Obrero",
		"Barrio Oeste",
		"Barrio Parque Bristol",
		"Barrio Parque Lambare",
		"Barrio Parque Leloir",
		"Barrio Parque Patagonia",
		"Barrio Pedro Rico",
		"Barrio Pedro Rocco",
		"Barrio Pinares",
		"Barrio Primera Junta",
		"Barrio Pueblo Nuevo",
		"Barrio Rosario Sud",
		"Barrio San Alejo",
		"Barrio San Blas",
		"Barrio San Carlos",
		"Barrio San Cayetano",
		"Barrio San Jacinto",
		"Barrio San José",
		"Barrio San Martín",
		"Barrio San Pablo",
		"Barrio San Roque",
		"Barrio Santa Magdalena",
		"Barrio Tierra De Oro",
		"Barrio Tiro Federal",
		"Barrio Trocha",
		"Barrio Villa Muñiz",
		"Barrio Villa Ortega",
		"Barrio Villa Saladillo",
		"Barrio Vista Alegre",
		"Base Aeronaval Cmte Espora",
		"Base Aeronaval Punta Indio",
		"Base Naval Azopardo",
		"Base Naval Río Santiago",
		"Baterías",
		"Bathurst Estación",
		"Baudrix",
		"Bayauca",
		"Beccar",
		"Belén De Escobar",
		"Bella Vista",
		"Bellocq",
		"Benavidez",
		"Benitez",
		"Benito Juárez",
		"Berazategui",
		"Berdier",
		"Berisso",
		"Bermúdez",
		"Bernal Este",
		"Bernal Oeste",
		"Bernardo Vera Y Pintado",
		"Berraondo",
		"Beruti",
		"Berutti",
		"Blanca Grande",
		"Blandengues",
		"Blaquier",
		"Blas Durañona",
		"Blondeau",
		"Bme Bavio Gral Mansilla",
		"Bo Sta Catalina Hornero La Loma",
		"Bocayuba",
		"Bolívar",
		"Bonifacio",
		"Bonnement",
		"Bordenave",
		"Bordeu",
		"Bosch",
		"Bosques",
		"Boulogne",
		"Bragado",
		"Brandsen",
		"Bravo Del Dos",
		"Buchanan",
		"Burzaco",
		"Cabeza De Buey",
		"Cabildo",
		"Cabo San Fermín",
		"Cachari",
		"Cadret",
		"Cailomuta",
		"Calderón",
		"Calera Avellaneda",
		"Calfucura",
		"Calvo",
		"Camarón Chico",
		"Cambaceres",
		"Camet",
		"Caminera Azul",
		"Caminera General López",
		"Caminera Juárez",
		"Caminera Lujan",
		"Caminera Napaleofu",
		"Caminera Samborombon",
		"Camino Centenario Km 11500",
		"Campamento",
		"Campana",
		"Campo Aristimuño",
		"Campo Buena Vista",
		"Campo Coliqueo",
		"Campo Crisol",
		"Campo De Mayo",
		"Campo Del Norte Americano",
		"Campo Funke",
		"Campo La Elisa",
		"Campo La Lima",
		"Campo La Nena",
		"Campo La Plata",
		"Campo La Tribu",
		"Campo La Zulema",
		"Campo Leite",
		"Campo Lope Seco",
		"Campo Los Aromos",
		"Campo Maipu",
		"Campo Pelaez",
		"Campo Peña López",
		"Campo Rojas",
		"Campo Sabate",
		"Campo San Juan",
		"Campodonico",
		"Campomar Viñedo",
		"Canal 15 Cerro De La Gloria",
		"Canal Martín Irigoyen",
		"Canal N Alem 1a Sec",
		"Canal N Alem 2a Sec",
		"Cancha Del Pollo",
		"Cangallo",
		"Canning",
		"Canónigo Gorriti",
		"Cantera Aguirre",
		"Cantera Albion",
		"Cantera La Aurora",
		"Cantera La Federación",
		"Cantera La Movediza",
		"Cantera Monte Cristo",
		"Cantera San Luis",
		"Cantera Villalonga",
		"Canteras De Gregorini",
		"Cañada De Arias",
		"Cañada La Rica",
		"Cañada Mariano",
		"Cañada Marta",
		"Cañada Seca",
		"Cañuelas",
		"Capdepont",
		"Capilla Del Señor",
		"Capitán Castro",
		"Capitán Sarmiento",
		"Carabelas",
		"Carapachay",
		"Cardenal Cagliero",
		"Carhue",
		"Cari Larquea",
		"Carilo",
		"Carlos Beguerie",
		"Carlos Casares",
		"Carlos Keen",
		"Carlos Lemee",
		"Carlos María Naon",
		"Carlos Salas",
		"Carlos Spegazzini",
		"Carlos Tejedor",
		"Carmen De Areco",
		"Carmen De Patagones",
		"Casalins",
		"Casbas",
		"Cascada",
		"Caseros",
		"Casey",
		"Castelar",
		"Castelli",
		"Castilla",
		"Cazón",
		"Centenario",
		"Centro Agrícola El Pato",
		"Centro Guerrero",
		"Cerrito",
		"Cerro Aguila",
		"Cerro De La Gloria Canal 15",
		"Cerro De Los Leones",
		"Cerro Negro",
		"Cerro Sotuyo",
		"Chacabuco",
		"Chacra Experimental Inta",
		"Chala Quilca",
		"Chancay",
		"Chapaleufú",
		"Chapar",
		"Chapi Talo",
		"Chas",
		"Chascomus",
		"Chasico",
		"Chenaut",
		"Chiclana",
		"Chillar",
		"Chivilcoy",
		"Choique",
		"Churruca",
		"City Bell",
		"Ciudad Evita",
		"Ciudad Jardín Del Palomar",
		"Ciudad Madero",
		"Ciudadela",
		"Claraz",
		"Claudio C Molina",
		"Claverie",
		"Claypole",
		"Cobo",
		"Cochrane",
		"Colegio San Pablo",
		"Coliqueo",
		"Colman",
		"Colon",
		"Colonia  Miguel Esteverena",
		"Colonia Alberdi",
		"Colonia Barga",
		"Colonia Barón Hirsch",
		"Colonia Beethoven",
		"Colonia Bella Vista",
		"Colonia Cuarenta Y Tres",
		"Colonia De Vac Chapadmalal",
		"Colonia Dr Gdor Udaondo",
		"Colonia El Balde",
		"Colonia El Guanaco",
		"Colonia El Pincen",
		"Colonia Escuela Argentina",
		"Colonia Ferrari",
		"Colonia Hinojo",
		"Colonia Hipolito Yrigoyen",
		"Colonia Hogar R Gutiérrez",
		"Colonia Inchausti",
		"Colonia La Beba",
		"Colonia La Catalina",
		"Colonia La Celina",
		"Colonia La Esperanza",
		"Colonia La Estrella",
		"Colonia La Graciela",
		"Colonia La Invernada",
		"Colonia La Merced",
		"Colonia La Nena",
		"Colonia La Noria",
		"Colonia La Reina",
		"Colonia La Vanguardia",
		"Colonia La Vascongada",
		"Colonia Laborderoy",
		"Colonia Lapin",
		"Colonia Las Yescas",
		"Colonia Leven",
		"Colonia Los Alamos",
		"Colonia Los Alfalfares",
		"Colonia Los Bosques",
		"Colonia Los Hornos",
		"Colonia Los Huesos",
		"Colonia Los Toldos",
		"Colonia Los Tres Usaris",
		"Colonia Mauricio",
		"Colonia Miguel Esteverena",
		"Colonia Monte La Plata",
		"Colonia Murature",
		"Colonia Nac De Alienados",
		"Colonia Nacional De Alienados",
		"Colonia Nacional De Menores",
		"Colonia Naviera",
		"Colonia Nieves",
		"Colonia Ocampo",
		"Colonia Palantelen",
		"Colonia Phillipson N 1",
		"Colonia Pueblo Ruso",
		"Colonia Rusa",
		"Colonia San Eduardo",
		"Colonia San Enrique",
		"Colonia San Francisco",
		"Colonia San Martín",
		"Colonia San Miguel",
		"Colonia San Pedro",
		"Colonia San Ramón",
		"Colonia Santa María",
		"Colonia Santa Mariana",
		"Colonia Santa Rosa",
		"Colonia Sere",
		"Colonia Stegman",
		"Colonia Tapatta",
		"Colonia Velez",
		"Colonia Zambungo",
		"Comahue Oeste",
		"Comandante Giribone",
		"Comandante Nicanor Otamendi",
		"Comodoro Py",
		"Condarco",
		"Cooper",
		"Copetonas",
		"Coraceros",
		"Corazzi",
		"Corbett",
		"Coronel Boerr",
		"Coronel Brandsen",
		"Coronel Charlone",
		"Coronel Dorrego",
		"Coronel Falcón",
		"Coronel Granada",
		"Coronel Isleños",
		"Coronel Marcelino Freyre",
		"Coronel Martínez De Hoz",
		"Coronel Mon",
		"Coronel Pringles",
		"Coronel Rodolfo Bunge",
		"Coronel Seguí",
		"Coronel Suarez",
		"Coronel Vidal",
		"Corti",
		"Cortines",
		"Costa Azul",
		"Costa Bonita Balneario",
		"Costa Brava",
		"Costa Del Este",
		"Covello",
		"Cristiano Muerto",
		"Cristino Benavidez",
		"Crotto",
		"Crucesita",
		"Cuartel 2",
		"Cuartel 6",
		"Cuartel 8",
		"Cuartel Cuatro",
		"Cuartel Ii",
		"Cuartel Iv",
		"Cuartel V",
		"Cuartel Vii",
		"Cuatreros",
		"Cuatro De Noviembre",
		"Cucha Cucha",
		"Cucullu",
		"Cuenca",
		"Cura Malal",
		"Curamalan",
		"Curaru",
		"D Orbigny",
		"Daireaux",
		"Dantas",
		"Darregueira",
		"De Bary",
		"De Bruyn",
		"De Ferrari",
		"De La Canal",
		"De La Garma",
		"Deferrari",
		"Del Carril",
		"Del Valle",
		"Del Viso",
		"Delfín Huergo",
		"Delgado",
		"Dennehy",
		"Despeñaderos",
		"Destilería Fiscal",
		"Desvío Aguirre",
		"Desvío El Chingolo",
		"Desvío Garbarini",
		"Desvío Kilometro 234",
		"Desvío Kilometro 55",
		"Desvío Kilometro 95",
		"Desvío San Alejo",
		"Desvío Sandrini",
		"Diego Gaynor",
		"Dionisia",
		"Dique Lujan",
		"Doce De Agosto",
		"Dock Central",
		"Dock Sud",
		"Doctor Domingo Cabred",
		"Doctor Domingo Harosteguy",
		"Dolores",
		"Domingo Faustino Sarmiento",
		"Domselaar",
		"Don Bosco",
		"Don Cipriano",
		"Don Torcuato",
		"Don Vicente",
		"Dos Hermanos",
		"Dos Naciones",
		"Doyhenard",
		"Doyle",
		"Drabble",
		"Drysdale",
		"Ducos",
		"Dudignac",
		"Dufaur",
		"Duggan",
		"Duhau",
		"Durañona",
		"Dussaud",
		"Edmundo Perkins",
		"Eduardo Costa",
		"Egaña",
		"El 60",
		"El Alba",
		"El Araza",
		"El Arbolito",
		"El Arbolito Pergamino",
		"El Bagual",
		"El Bombero",
		"El Boquerón",
		"El Camoati",
		"El Carbón",
		"El Carmen",
		"El Carmen De Langueyu",
		"El Carpincho",
		"El Carretero",
		"El Centinela",
		"El Chajá",
		"El Chalar",
		"El Cheique",
		"El Chelforo",
		"El Chumbeau",
		"El Chumbiao",
		"El Cortapie",
		"El Cristiano",
		"El Cruce",
		"El Descanso",
		"El Destino",
		"El Día",
		"El Divisorio",
		"El Dorado",
		"El Durazno",
		"El Espinillo",
		"El Eucaliptus",
		"El Fénix",
		"El Gallo",
		"El Gavilan",
		"El Gualicho",
		"El Hervidero",
		"El Jabalí",
		"El Jaguel",
		"El Junco",
		"El Jupiter",
		"El Lenguaraz",
		"El Libertador",
		"El Lucero",
		"El Luchador",
		"El Mangrullo",
		"El Marquesado",
		"El Mirador",
		"El Moro",
		"El Nacional",
		"El Nilo",
		"El Palomar",
		"El Pampero",
		"El Paraíso",
		"El Parche",
		"El Parque",
		"El Pelado",
		"El Pensamiento",
		"El Perdido Est Jose Guisasola",
		"El Peregrino",
		"El Pino",
		"El Pito",
		"El Porvenir",
		"El Quemado",
		"El Recado",
		"El Refugio",
		"El Retiro",
		"El Retiro Pdo Gral Viamonte",
		"El Rincón",
		"El Rosario",
		"El Santiago",
		"El Sauce",
		"El Siasgo",
		"El Silencio",
		"El Socorro",
		"El Soldado",
		"El Talar",
		"El Tatu",
		"El Tejar",
		"El Trebañon",
		"El Triángulo",
		"El Trigo",
		"El Trío",
		"El Triunfo",
		"El Vence",
		"El Verano",
		"El Vigilante",
		"El Volante",
		"El Zorro",
		"Elías Romero",
		"Elordi",
		"Elvira",
		"Emiliano Reynoso",
		"Emilio Ayarza",
		"Emilio Ayerza",
		"Emilio Bunge",
		"Emilio Lamarca",
		"Emita",
		"Emma",
		"Empalme",
		"Empalme Cerro Chato",
		"Empalme Lobos",
		"Empalme Magdalena",
		"Empalme Piedra Echada",
		"Empalme Querandies",
		"Encina",
		"Energía",
		"Enrique Fynn",
		"Enrique Lavalle",
		"Ensenada",
		"Epumer",
		"Erezcano",
		"Erize",
		"Ernestina",
		"Esc Nav Militar Río Sant",
		"Escalada",
		"Escribano P Nicolás",
		"Escuela Agrícola Don Bosco",
		"Escuela Agrícola Rural",
		"Escuela Agrícola Salesiana",
		"Espadaña",
		"Espartillar",
		"Espigas",
		"Espora",
		"Esquina De Crotto",
		"Est Jauregui Va Flandria",
		"Est San Francisco Belloq",
		"Establecimiento San Miguel",
		"Estación Ascensión",
		"Estación Baradero",
		"Estación Barrow",
		"Estación Caiomuta",
		"Estación Coronel Pringles",
		"Estación General Arenales",
		"Estación Gómez",
		"Estación Lago Epecuen",
		"Estación Lazzarino",
		"Estación Lincoln",
		"Estación Mitikili",
		"Estación Moreno",
		"Estación Provincial",
		"Estancia Chapar",
		"Estancia Las Gamas",
		"Estancia Las Isletas",
		"Estancia Mitikili",
		"Estancia San Antonio",
		"Estancia San Claudio",
		"Estancia San Rafael",
		"Estancia Santa Catalina",
		"Estancia Vieja",
		"Estancias",
		"Esteban A Gascón",
		"Esteban De Luca",
		"Esteban Díaz",
		"Estela",
		"Esther",
		"Estomba",
		"Estrella Naciente",
		"Estrugamou",
		"Etchegoyen",
		"Exaltación De La Cruz",
		"Ezeiza",
		"Ezpeleta Este",
		"Ezpeleta Oeste",
		"Fair",
		"Faro",
		"Faro Querandi",
		"Faro San Antonio",
		"Faro Segunda Barrancosa",
		"Fátima",
		"Fátima Estación Empalme",
		"Fatralo",
		"Fauzon",
		"Felipe Sola",
		"Fernando Marti",
		"Ferré",
		"Fiorito",
		"Flamenco",
		"Florencio Várela",
		"Florentino Ameghino",
		"Florida",
		"Florida Oeste",
		"Fontezuela",
		"Fortabat",
		"Fortín Acha",
		"Fortín Chaco",
		"Fortín Irene",
		"Fortín Lavalle",
		"Fortín Mercedes",
		"Fortín Necochea",
		"Fortín Olavarría",
		"Fortín Paunero",
		"Fortín Tiburcio",
		"Fortín Viejo",
		"Fortín Vigilancia",
		"Francisco Alvarez",
		"Francisco Ayerza",
		"Francisco Berra",
		"Francisco Casal",
		"Francisco De Vitoria",
		"Francisco J Meeks",
		"Francisco Madero",
		"Francisco Magnano",
		"Francisco Murature",
		"Franklin",
		"French",
		"Frigorífico Armour",
		"Frigorífico Las Palmas",
		"Fuerte Argentino",
		"Fuerte Barragán",
		"Fulton",
		"Funke",
		"Gahan",
		"Galera De Torres",
		"Galo Llórente",
		"Galvan",
		"Gándara",
		"Garcia Del Rio",
		"Gardey",
		"Garin",
		"Garre",
		"Garro",
		"General Alvarado",
		"General Alvear",
		"General Arenales",
		"General Belgrano",
		"General Conesa",
		"General Daniel Cerri",
		"General Gelly",
		"General Guido",
		"General Hornos",
		"General Lamadrid",
		"General Las Heras",
		"General Lavalle",
		"General Madariaga",
		"General Mansilla",
		"General O Brien",
		"General Pacheco",
		"General Pinto",
		"General Piran",
		"General Rivas",
		"General Rodríguez",
		"General Rojo",
		"General Rondeau",
		"General San Martín",
		"General Valdez",
		"General Viamonte",
		"General Villegas",
		"Gerente Cilley",
		"Gerli",
		"Germanía",
		"Gil",
		"Girodias",
		"Girondo",
		"Glew",
		"Glorialdo",
		"Gnecco",
		"Gobernador Andonaeghi",
		"Gobernador Arias",
		"Gobernador Castro",
		"Gobernador Costa",
		"Gobernador Obligado",
		"Gobernador Ortiz De Rosas",
		"Gobernador Udaondo",
		"Gobernador Ugarte",
		"Gobos",
		"Goldney",
		"Gómez",
		"Gómez  De La Vega",
		"Gondra",
		"González Catan",
		"González Moreno",
		"Gonzalez Risos",
		"Goñi",
		"Gorchs",
		"Gornatti",
		"Goroso",
		"Gorostiaga",
		"Gouin",
		"Gowland",
		"Goyena",
		"Goyeneche",
		"Graciarena",
		"Gral Daniel Cerri",
		"Grand Bourg",
		"Grand Dock",
		"Gregorio De La Ferrere",
		"Gregorio De Laferrere",
		"Gregorio Villafañe",
		"Grisolia",
		"Grumbein",
		"Grunbein",
		"Guamini",
		"Guanaco",
		"Guardia Del Monte",
		"Guernica",
		"Guerrero",
		"Guerrico",
		"Guido Spano",
		"Guillermo E Hudson",
		"Guirondo",
		"Gunther",
		"Haedo",
		"Halcey",
		"Hale",
		"Ham",
		"Haras 1 De Mayo",
		"Haras Chacabuco",
		"Haras Chapadmalal",
		"Haras El Carmen",
		"Haras El Catorce",
		"Haras El Centinela",
		"Haras El Cisne",
		"Haras El Moro",
		"Haras El Ombu",
		"Haras El Salaso",
		"Haras La Elvira",
		"Haras La Lula",
		"Haras Los Cardales",
		"Haras Nacional",
		"Haras Ojo Del Agua",
		"Haras R De La Parva",
		"Haras San Ignacio",
		"Haras San Jacinto",
		"Haras Trujui",
		"Heavy",
		"Henderson",
		"Henry Bell",
		"Hereford",
		"Herrera Vegas",
		"Hilario Ascasubi",
		"Hinojales",
		"Hinojo",
		"Hogar Mariano Ortiz Basualdo",
		"Hornos",
		"Hortensia",
		"Hospital Necochea",
		"Hospital San Antonio De La Lla",
		"Huanguelen",
		"Hueso Clavado",
		"Huetel",
		"Hunter",
		"Hurlingham",
		"Húsares",
		"Ibañez",
		"Igarzabal",
		"Ignacio Correas",
		"Ignacio Correas Arana",
		"Indacochea",
		"India Muerta",
		"Indio Rico",
		"Inés Indart",
		"Ingeniero Adolfo Sourdeaux",
		"Ingeniero Allan",
		"Ingeniero Balbin",
		"Ingeniero Beaugey",
		"Ingeniero Budge",
		"Ingeniero De Madrid",
		"Ingeniero Maschwitz",
		"Ingeniero Moneta",
		"Ingeniero Silveyra",
		"Ingeniero Thompson",
		"Ingeniero White",
		"Ingeniero Williams",
		"Inocencio Sosa",
		"Invernadas",
		"Irala",
		"Iraola",
		"Irene",
		"Ireneo Portela",
		"Iriarte",
		"Isidro Casanova",
		"Isla Catarelli",
		"Isla Los Laureles",
		"Isla Martín García",
		"Isla Paulino",
		"Isla Santiago",
		"Isla Verde",
		"Islas",
		"Isondu",
		"Iturregui",
		"Ituzaingo",
		"J M Micheo",
		"Jarrilla",
		"Jauregui José María",
		"Jeppener",
		"Joaquín Gorina",
		"José A Guisasola",
		"José B Casas",
		"José Clemente Paz",
		"José Ferrari",
		"José Ingenieros",
		"José León Suarez",
		"Jose M Micheo",
		"José María Blanco",
		"José María Gutiérrez",
		"José Mármol",
		"José Sojo",
		"Juan A Pradere",
		"Juan Atucha",
		"Juan B Justo Ing White",
		"Juan Bautista Alberdi",
		"Juan Blaquier",
		"Juan Couste",
		"Juan E Barra",
		"Juan F Ibarra",
		"Juan G Pujol",
		"Juan José Almeyra",
		"Juan José Paso",
		"Jose Leon Suarez",
		"Juan Maria Gutierrez",
		"Juan N Fernández",
		"Juan Tronconi",
		"Juan V Cilley",
		"Juan Vela",
		"Juan Vucetich Ex Dr R Levene",
		"Juana A De La Peña",
		"Juancho",
		"Julio Arditi",
		"Junín",
		"Kenny",
		"Kilometro 102",
		"Kilometro 103",
		"Kilometro 108",
		"Kilometro 11",
		"Kilometro 112",
		"Kilometro 116",
		"Kilometro 117",
		"Kilometro 125",
		"Kilometro 128",
		"Kilometro 146",
		"Kilometro 172",
		"Kilometro 184",
		"Kilometro 187",
		"Kilometro 212",
		"Kilometro 282",
		"Kilometro 321",
		"Kilometro 322",
		"Kilometro 333",
		"Kilometro 352",
		"Kilometro 356",
		"Kilometro 36",
		"Kilometro 386",
		"Kilometro 393",
		"Kilometro 404",
		"Kilometro 433",
		"Kilometro 44",
		"Kilometro 440",
		"Kilometro 45",
		"Kilometro 53",
		"Kilometro 563",
		"Kilometro 58",
		"Kilometro 59",
		"Kilometro 61",
		"Kilometro 652",
		"Kilometro 666",
		"Kilometro 697",
		"Kilometro 70",
		"Kilometro 77",
		"Kilometro 79",
		"Kilometro 82",
		"Kilometro 83",
		"Kilometro 88",
		"Kilometro 9 Sud",
		"Kilometro 90",
		"Kilometro 92",
		"Kilometro 95",
		"Krabbe",
		"La  Aurora",
		"La Adela",
		"La Adelaida",
		"La Alameda",
		"La Alcira",
		"La Amalia",
		"La Amistad",
		"La Amorilla",
		"La Angelita",
		"La Argentina",
		"La Armonía",
		"La Aurora",
		"La Azotea",
		"La Azotea Grande",
		"La Azucena",
		"La Balandra",
		"La Ballena",
		"La Ballenera",
		"La Barrancosa",
		"La Beba",
		"La Blanca",
		"La Blanqueada",
		"La Bolsa",
		"La Brava",
		"La Buana Moza",
		"La Calera",
		"La Caleta",
		"La California Argentina",
		"La Campana",
		"La Carlota",
		"La Carreta",
		"La Cautiva",
		"La Celia",
		"La Celina",
		"La Central",
		"La Choza",
		"La Chumbeada",
		"La Colina",
		"La Colmena",
		"La Colorada",
		"La Colorada Chica",
		"La Constancia",
		"La Copeta",
		"La Cora",
		"La Corina",
		"La Corinco",
		"La Costa",
		"La Cotorra",
		"La Delfina",
		"La Delia",
		"La Despierta",
		"La Dorita",
		"La Dormilona",
		"La Dulce",
		"La Elma",
		"La Esperanza",
		"La Esperanza Gral Madariaga",
		"La Esperanza Pdo Las Flores",
		"La Esperanza Rosas Las Flores",
		"La Estrella",
		"La Eva",
		"La Feliciana",
		"La Florida",
		"La Fraternidad",
		"La Garita",
		"La Gaviota",
		"La Gleva",
		"La Gloria",
		"La Gracielita",
		"La Gregoria",
		"La Herminia",
		"La Higuera",
		"La Horqueta",
		"La Huayqueria",
		"La Invencible",
		"La Isabel",
		"La Larga",
		"La Larga Nueva",
		"La Lata",
		"La Leonor",
		"La Limpia",
		"La Loma",
		"La Lucia",
		"La Lucila",
		"La Lucila Del Mar",
		"La Luisa",
		"La Luna",
		"La Luz",
		"La Madrecita",
		"La Mantequeria",
		"La Manuela",
		"La Margarita",
		"La María",
		"La Martina",
		"La Mascota",
		"La Matilde",
		"La Nacion",
		"La Narcisa",
		"La Navarra",
		"La Negra",
		"La Nelida",
		"La Nevada",
		"La Niña",
		"La Noria",
		"La Numancia",
		"La Nutria",
		"La Oriental",
		"La Pala",
		"La Palma",
		"La Palmira",
		"La Pampa",
		"La Para",
		"La Pastora",
		"La Paz",
		"La Paz Chica",
		"La Peregrina",
		"La Perla",
		"La Pesquería",
		"La Piedra",
		"La Pinta",
		"La Plata",
		"La Playa",
		"La Pochola",
		"La Porteña",
		"La Posada",
		"La Posta",
		"La Pradera",
		"La Primavera",
		"La Primitiva",
		"La Protección",
		"La Protegida",
		"La Providencia",
		"La Querencia",
		"La Rabia",
		"La Razón",
		"La Reforma",
		"La Reja",
		"La Reserva",
		"La Rica",
		"La Rinconada",
		"La Rosada",
		"La Rosalia",
		"La Rubia",
		"La Salada",
		"La Sara",
		"La Sarita",
		"La Saudade",
		"La Sirena",
		"La Soberana",
		"La Soberanía",
		"La Sofía",
		"La Sombra",
		"La Sortija",
		"La Suiza",
		"La Tablada",
		"La Talina",
		"La Tigra",
		"La Tobiana",
		"La Tomasa",
		"La Torrecita",
		"La Tribu",
		"La Trinidad",
		"La Unión",
		"La Valerosa",
		"La Vanguardia",
		"La Vascongada",
		"La Verde",
		"La Victoria",
		"La Victoria Desvío",
		"La Violeta",
		"La Virginia",
		"La Vitícola",
		"La Yesca",
		"La Zanja",
		"La Zarateña",
		"Labarden",
		"Lago Epecuen",
		"Laguna Alsina",
		"Laguna Brava",
		"Laguna Chasico",
		"Laguna De Gómez",
		"Laguna De Lobos",
		"Laguna De Los Padres",
		"Laguna Del Cura",
		"Laguna Del Monte",
		"Laguna Del Soldado",
		"Laguna Las Mulitas",
		"Laguna Medina",
		"Laguna Redonda",
		"Laguna Sauce Grande",
		"Langueyu",
		"Lanús",
		"Laplacette",
		"Laprida",
		"Larramendy",
		"Larrea",
		"Lartigau",
		"Las Achiras",
		"Las Armas",
		"Las Bahamas",
		"Las Bandurrias",
		"Las Bruscas",
		"Las Chacras",
		"Las Chilcas",
		"Las Cortaderas",
		"Las Cuatro Hermanas",
		"Las Cuatro Puertas",
		"Las Escobas",
		"Las Flores",
		"Las Guasquitas",
		"Las Hermanas",
		"Las Isletas",
		"Las Juanitas",
		"Las Lomas",
		"Las Malvinas",
		"Las Marianas",
		"Las Martinetas",
		"Las Mercedes",
		"Las Mostazas",
		"Las Mulas",
		"Las Negras",
		"Las Nieves",
		"Las Nutrias",
		"Las Oscuras",
		"Las Pajas",
		"Las Palmas",
		"Las Parvas",
		"Las Piedritas",
		"Las Rosas",
		"Las Saladas",
		"Las Suizas",
		"Las Sultanas",
		"Las Tahonas",
		"Las Toninas",
		"Las Tortugas",
		"Las Toscas",
		"Las Tres Flores",
		"Las Vaquerías",
		"Las Víboras",
		"Lastra",
		"Lazzarino",
		"Leandro N Alem",
		"Legaristi",
		"Lertora",
		"Leubuco",
		"Lezama",
		"Lezica Y Torrezuri",
		"Líbano",
		"Libertad",
		"Libres Del Sud",
		"Licenciado Matienzo",
		"Lierra Adjemiro",
		"Lima",
		"Lin Calel",
		"Lincoln",
		"Lisandro Olmos Etcheverry",
		"Llavallol",
		"Loberia",
		"Lobos",
		"Loma De Salomon",
		"Loma Del Indio",
		"Loma Hermosa",
		"Loma Negra",
		"Loma Partida",
		"Loma Verde",
		"Lomas De Zamora",
		"Lomas Del Mirador",
		"Lomas Del Rio Lujan",
		"Longchamps",
		"López",
		"López Lecube",
		"López Molinari",
		"Los Acantilados",
		"Los Altos",
		"Los Angeles",
		"Los Arcos",
		"Los Aromos",
		"Los Bosques",
		"Los Caldenes",
		"Los Callejones",
		"Los Cardales",
		"Los Cardos",
		"Los Cerrillos",
		"Los Cerros",
		"Los Chañares",
		"Los Chucaros",
		"Los Coloniales",
		"Los Cuatro Caminos",
		"Los Eucaliptos",
		"Los Eucaliptus Casco Urbano",
		"Los Gauchos",
		"Los Huesos",
		"Los Indios",
		"Los Laureles",
		"Los Leones",
		"Los Merinos",
		"Los Molles",
		"Los Ortiz",
		"Los Patos",
		"Los Pinos",
		"Los Polvorines",
		"Los Pozos",
		"Los Santos Viejos",
		"Los Talas",
		"Los Toldos",
		"Louge",
		"Lozano",
		"Lucas Monteverde",
		"Luis Chico",
		"Luis Guillon",
		"Lujan",
		"Lumb",
		"Luro",
		"Macedo",
		"Magallanes",
		"Magdala",
		"Magdalena",
		"Maguirre",
		"Maipu",
		"Malabia",
		"Malecón Gardelia",
		"Malecon Gardella",
		"Malvinas Argentinas",
		"Mamaguita",
		"Manantiales",
		"Manantiales Grandes",
		"Manuel Alberti",
		"Manuel B Gonnet",
		"Manuel José García",
		"Manuel Ocampo",
		"Manzanares",
		"Manzo Y Niño",
		"Manzone",
		"Maori",
		"Mapis",
		"Maquinista F Savio",
		"Mar Azul",
		"Mar Chiquita",
		"Mar De Ajo",
		"Mar De Cobo",
		"Mar De Las Pampas",
		"Mar Del Plata",
		"Mar Del Sud",
		"Mar Del Tuyu",
		"Marcelino Ugarte",
		"Marcos Paz",
		"Marcos Paz B Bernasconi",
		"Marcos Paz B El Martillo",
		"Marcos Paz B El Moro",
		"Marcos Paz B El Zorzal",
		"Marcos Paz B La Lonja",
		"Marcos Paz B La Milagrosa",
		"Marcos Paz B Martín Fierro",
		"Marcos Paz B Urioste",
		"Mari Lauquen",
		"María Ignacia",
		"María Lucila",
		"María P Moreno",
		"Mariano Acosta",
		"Mariano Benitez",
		"Mariano Benitez Pergamino",
		"Mariano H Alfonzo",
		"Mariano Roldan",
		"Mariano Unzue",
		"Mariscal Sucre",
		"Martín Berraondo",
		"Martín Coronado",
		"Martín Fierro",
		"Martínez",
		"Marucha",
		"Masurel",
		"Matheu",
		"Mauras",
		"Mauricio Hirsch",
		"Máximo Fernández",
		"Máximo Paz",
		"Mayor Buratovich",
		"Mayor José Orellano",
		"Maza",
		"Mecha",
		"Mechita",
		"Mechongue",
		"Medaland",
		"Médano Blanco",
		"Médanos",
		"Melchor Romero",
		"Membrillar",
		"Mercado Central",
		"Mercedes",
		"Meridiano Vo",
		"Merlo",
		"Micaela Cascallares",
		"Ministro Rivadavia",
		"Mira Pampa",
		"Miramar",
		"Miramonte",
		"Miranda",
		"Moctezuma",
		"Molino Galileo",
		"Moll",
		"Monasterio",
		"Mones Cazón",
		"Monroe",
		"Monsalvo",
		"Monte Chingolo",
		"Monte Crespo",
		"Monte Fiore",
		"Monte Grande",
		"Monte Hermoso",
		"Monte Veloz",
		"Montecarlo",
		"Montes De Oca",
		"Moores",
		"Morea",
		"Moreno",
		"Morón",
		"Morse",
		"Mouras",
		"Mulcahy",
		"Munro",
		"Muñiz",
		"Muñoz",
		"Mutti",
		"Nahuel Ruca",
		"Napaleofu",
		"Naposta",
		"Navarro",
		"Necochea",
		"Necol Estación Fcgm",
		"Newton",
		"Nicanor Olivera",
		"Nicolás Descalzi",
		"Nicolás Levalle",
		"Nieves",
		"Norberto De La Riestra",
		"Nordelta",
		"Norumbega",
		"Nuestra Señora De La Paz",
		"Nueva Atlantis",
		"Nueva España",
		"Nueva Hermosura",
		"Nueva Plata",
		"Nueva Roma",
		"Nueva Suiza",
		"O Higgins",
		"Ochandio",
		"Odorqui",
		"Olascoaga",
		"Olavarría",
		"Oliden",
		"Oliveira Cesar",
		"Olivera",
		"Oliviera Cesar",
		"Olivos",
		"Ombu",
		"Ombucta",
		"Once De Setiembre",
		"Open Door",
		"Orense",
		"Oriente",
		"Orlando",
		"Ortiz Basualdo",
		"Ortiz De Rosas",
		"Ostende",
		"Otamendi",
		"Otoño",
		"Pablo Acosta",
		"Pablo Nogues",
		"Pablo Podesta",
		"Pachan",
		"Palantelen",
		"Palemon Huergo",
		"Palmitas",
		"Palo Blanco",
		"Paname",
		"Pancho Díaz",
		"Papin",
		"Parada Kilometro 158",
		"Parada Kilometro 76",
		"Parada Los Robles",
		"Parada Robles",
		"Parada Tatay",
		"Paragüil",
		"Paraje Fra Pal",
		"Paraje La Aurora",
		"Paraje La Vasca",
		"Paraje Miramar",
		"Paraje Santa Ana",
		"Paraje Santa Rosa",
		"Paraje Starache",
		"Pardo",
		"Parish",
		"Parque Carilo",
		"Parque Muñoz",
		"Parque San Martín",
		"Parque Taillade",
		"Parravichini",
		"Pasman",
		"Paso Alsina",
		"Paso Cramer",
		"Paso Del Médano",
		"Paso Del Rey",
		"Paso Mayor",
		"Pasos",
		"Pasteur",
		"Patricios",
		"Paula",
		"Pavón",
		"Payro R",
		"Pazos Kanki",
		"Pearson",
		"Pedernales",
		"Pedro Gamen",
		"Pedro Lasalle",
		"Pedro Luro",
		"Pedro Nicolás Escribano",
		"Pehuajo",
		"Pehuelches",
		"Pehuen Co",
		"Pelicura",
		"Pellegrini",
		"Peñaflor",
		"Pereyra",
		"Pereyra Iraola Parque",
		"Pérez Millán",
		"Pergamino",
		"Pessagno",
		"Pichincha",
		"Piedra Ancha",
		"Piedritas",
		"Pieres",
		"Pierini",
		"Pigue",
		"Pila",
		"Pilar",
		"Pillahuinco",
		"Pinamar",
		"Pinzón",
		"Piñeiro",
		"Piñeyro",
		"Pipinas",
		"Pirovano",
		"Piruco",
		"Pla",
		"Pla Y Ragnoni",
		"Plátanos",
		"Playa Chapadmalal",
		"Playa Las Margaritas",
		"Playa Serena",
		"Plaza Montero",
		"Plomer",
		"Plumacho",
		"Poblet",
		"Pocito",
		"Polvaredas",
		"Pontaut",
		"Pontevedra",
		"Porvenir",
		"Pourtale",
		"Pradere Juan A",
		"Presidente Derqui",
		"Presidente Quintana",
		"Primera Junta",
		"Puan",
		"Pueblitos",
		"Pueblo Martínez De Hoz",
		"Pueblo Nuevo",
		"Pueblo Nuevo Dto Junín",
		"Pueblo Otero",
		"Pueblo San Esteban",
		"Pueblo San José",
		"Pueblo Santa María",
		"Puente Batalla",
		"Puente Cañete",
		"Puente Castex",
		"Puente El Ochenta",
		"Puerto Bahía Blanca",
		"Puerto Belgrano",
		"Puerto Coloma",
		"Puerto De Escobar",
		"Puerto Galvan",
		"Puerto La Plata",
		"Puerto Necochea",
		"Puerto Rosales",
		"Puerto Tres Bonetes",
		"Puerto Wassermann",
		"Puesto Del Medio",
		"Pujol",
		"Punta Alta",
		"Punta De Canal",
		"Punta Indio",
		"Punta Lara",
		"Punta Médanos",
		"Quenuma",
		"Quequen",
		"Quilco",
		"Quilmes",
		"Quilmes Oeste",
		"Quiñihual Estación",
		"Quirno Costa",
		"Quiroga",
		"Rafael Calzada",
		"Rafael Castillo",
		"Rafael Obligado",
		"Ramallo",
		"Ramón Biaus",
		"Ramón J Neild",
		"Ramón Santamarina",
		"Ramos Mejía",
		"Ramos Otero",
		"Rancagua",
		"Ranchos",
		"Ranelagh",
		"Rauch",
		"Raulet",
		"Rawson",
		"Real Audiencia",
		"Recalde",
		"Reginaldo J Neild",
		"Remedios De Escalada",
		"Requena",
		"Reta",
		"Retiro San Pablo",
		"Ricardo Cano",
		"Ricardo Gaviña",
		"Ricardo Rojas",
		"Rincón De Baudrix",
		"Rincón De Milberg",
		"Rincón De Noario",
		"Rincón De Vivot",
		"Rincón Norte",
		"Río Lujan",
		"Río Tala",
		"Rivadavia",
		"Rivadeo",
		"Rivera",
		"Roberto Cano",
		"Roberto Payro",
		"Roberts",
		"Rocha",
		"Rojas",
		"Rolito Estación Fcgb",
		"Roman Báez",
		"Roosevelt",
		"Roosevelt Partido Rivadavia",
		"Roque Pérez",
		"Rosas",
		"Rovira",
		"Ruiz Solis",
		"Ruta 11 Kilometro 23",
		"Ruta 205 Kilometro 57",
		"Ruta 3 Kilometro 75 700",
		"Ruta 8 Kilometro 77",
		"Ruta 9 Kilometro 169 5",
		"Ruta 9 Kilometro 72",
		"Saavedra",
		"Sabbi",
		"Saforcada",
		"Salada Chica",
		"Salada Grande",
		"Saladillo",
		"Saladillo Norte",
		"Salazar",
		"Saldungaray",
		"Salina De Piedra",
		"Salinas Chicas",
		"Salliquelo",
		"Salto",
		"Salvador María",
		"Samborombon",
		"San Adolfo",
		"San Agustín",
		"San Alberto",
		"San Andrés",
		"San Andrés De Giles",
		"San Andrés De Tapalque",
		"San Antonio",
		"San Antonio De Areco",
		"San Antonio De Padua",
		"San Benito",
		"San Bernardo",
		"San Bernardo Del Tuyu",
		"San Cala",
		"San Carlos",
		"San Cayetano",
		"San Clemente Del Tuyu",
		"San Cornelio",
		"San Daniel",
		"San Eduardo Del Mar",
		"San Eladio",
		"San Emilio",
		"San Enrique",
		"San Ernesto",
		"San Federico",
		"San Felipe",
		"San Fermín",
		"San Fernando",
		"San Francisco De Bellocq",
		"San Francisco Solano",
		"San Germán",
		"San Gervacio",
		"San Ignacio",
		"San Isidro",
		"San Jacinto",
		"San Jorge",
		"San José",
		"San José De Gali",
		"San José De Los Quinteros",
		"San José De Otamendi",
		"San Juan",
		"San Juan De Nelson",
		"San Julián",
		"San Justo",
		"San Laureano",
		"San Manuel",
		"San Martín De Tours",
		"San Mauricio",
		"San Mayol",
		"San Miguel",
		"San Miguel Arcángel",
		"San Miguel Del Monte",
		"San Miguel Del Moro",
		"San Nicolás De Los Arroyos",
		"San Pascual",
		"San Patricio",
		"San Pedro",
		"San Quilco",
		"San Rafael",
		"San Ramón",
		"San Ramón De Anchorena",
		"San Roman",
		"San Roque",
		"San Sebastián",
		"San Severo",
		"San Simón",
		"San Valentín",
		"San Vicente",
		"Sansinena",
		"Santa Alicia",
		"Santa Catalina",
		"Santa Cecilia Centro",
		"Santa Cecilia Norte",
		"Santa Cecilia Sud",
		"Santa Clara Del Mar",
		"Santa Clementina",
		"Santa Coloma",
		"Santa Elena",
		"Santa Eleodora",
		"Santa Felicia",
		"Santa Inés",
		"Santa Irene",
		"Santa Isabel",
		"Santa Lucia",
		"Santa Luisa",
		"Santa María",
		"Santa María Belloq",
		"Santa Regina",
		"Santa Rita",
		"Santa Rita Pdo Guamini",
		"Santa Rosa",
		"Santa Rosa De Minellono",
		"Santa Teresa",
		"Santa Teresita",
		"Santa Teresita Pergamino",
		"Santa Trinidad",
		"Santiago Garbarini",
		"Santiago Larre",
		"Santo Domingo",
		"Santo Tomas",
		"Santo Tomas Chico",
		"Santos Lugares",
		"Santos Unzue",
		"Sarandi",
		"Sarasa",
		"Saturno",
		"Sauce Chico",
		"Sauce Corto",
		"Sauce Grande",
		"Sauzales",
		"Segurola",
		"Seminario Pío Xii",
		"Sevigne",
		"Shaw",
		"Siempre Verde",
		"Sierra Chica",
		"Sierra De La Ventana",
		"Sierra De Los Padres",
		"Sierras Bayas",
		"Smith",
		"Sol De Mayo",
		"Solale",
		"Solanet",
		"Solano",
		"Solis",
		"Sourigues",
		"Speratti",
		"Speroni",
		"Spurr",
		"Stegmann",
		"Stroeder",
		"Sucre",
		"Suipacha",
		"Sundblad",
		"Tablada",
		"Tacuari",
		"Tamangueyu",
		"Tambo Nuevo",
		"Tandil",
		"Tapalque",
		"Tapiales",
		"Tatay",
		"Tedin Uriburu",
		"Tejo Galeta",
		"Temperley",
		"Teniente Coronel Miñana",
		"Teniente Origone",
		"Termas Los Gauchos",
		"Thames",
		"Tigre",
		"Timote",
		"Tío Domingo",
		"Todd",
		"Toldos Viejos",
		"Tomas Jofre",
		"Tordillo",
		"Tornquist",
		"Toro",
		"Torres",
		"Tortuguitas",
		"Trenque Lauquen",
		"Tres  Lagunas",
		"Tres Algarrobos",
		"Tres Arroyos",
		"Tres Cuervos",
		"Tres Lagunas",
		"Tres Leguas",
		"Tres Lomas",
		"Tres Picos",
		"Tres Sargentos",
		"Trigales",
		"Tristán Suarez",
		"Triunvirato",
		"Troncos Del Talar",
		"Tronge",
		"Tropezón",
		"Trujui",
		"Turdera",
		"Tuyuti",
		"Uballes",
		"Udaquiola",
		"Unidad Turística Chapadmalal",
		"Urdampilleta",
		"Uribelarrea",
		"Urquiza",
		"Vagues",
		"Valdez",
		"Valentín Alsina",
		"Valentín Gómez",
		"Valenzuela Antón",
		"Valeria Del Mar",
		"Vallimanca",
		"Vaña",
		"Vasquez",
		"Vecino",
		"Vedia",
		"Vela",
		"Velloso",
		"Venancio",
		"Vergara",
		"Verónica",
		"Víboras",
		"Vicente Casares",
		"Vicente López",
		"Vicente Pereda",
		"Victoria",
		"Victorino De La Plaza",
		"Vieytes",
		"Vigelencia",
		"Vilela",
		"Villa Adelina",
		"Villa Adriana",
		"Villa Agueda",
		"Villa Aldeanita",
		"Villa Angus",
		"Villa Arcadia",
		"Villa Astolfi",
		"Villa Ballester",
		"Villa Belgrano",
		"Villa Bosch",
		"Villa Branda",
		"Villa Brown",
		"Villa Buenos Aires",
		"Villa Buide",
		"Villa Burgos",
		"Villa Cacique",
		"Villa Capdepont",
		"Villa Carola",
		"Villa Carucha",
		"Villa Castelar Est Erize",
		"Villa Celina",
		"Villa Centenario",
		"Villa Cerrito",
		"Villa Clelia",
		"Villa Copacabana",
		"Villa Da Fonte",
		"Villa Daza",
		"Villa De Mayo",
		"Villa Del Mar",
		"Villa Delfina",
		"Villa Depietri",
		"Villa Diamantina",
		"Villa Díaz Velez",
		"Villa Domingo Pronsato",
		"Villa Dominico",
		"Villa Dufau",
		"Villa Elena",
		"Villa Elisa",
		"Villa España",
		"Villa Espil",
		"Villa Flandria",
		"Villa Floresta",
		"Villa Florida",
		"Villa Fox",
		"Villa Francia",
		"Villa Galicia",
		"Villa General Arias",
		"Villa Gesell",
		"Villa Gobernador Udaondo",
		"Villa Godoy",
		"Villa Gral Savio Est Sanchez",
		"Villa Gral Savio Ex Sánchez",
		"Villa Harding Green",
		"Villa Herminia",
		"Villa Igollo",
		"Villa Insuperable",
		"Villa Iris",
		"Villa Italia",
		"Villa Juarez",
		"Villa La Chechela",
		"Villa La Florida",
		"Villa Laura",
		"Villa Laza",
		"Villa Leandra",
		"Villa Lía",
		"Villa Libre",
		"Villa Loma",
		"Villa Loreto",
		"Villa Luzuriaga",
		"Villa Lynch",
		"Villa Lynch Pueyrredon",
		"Villa Madero",
		"Villa Maio",
		"Villa Margarita",
		"Villa María",
		"Villa Martelli",
		"Villa Massoni",
		"Villa Mayor",
		"Villa Maza",
		"Villa Mitre",
		"Villa Mónica",
		"Villa Moquehua",
		"Villa Mosconi",
		"Villa Nocito",
		"Villa Numancia",
		"Villa Obrera",
		"Villa Olga Grumbein",
		"Villa Ortega",
		"Villa Ortiz",
		"Villa Penotti",
		"Villa Preceptor M Robles",
		"Villa Preceptor Manuel Cruz",
		"Villa Progreso",
		"Villa Pueblo Nuevo",
		"Villa Puerto Quequen",
		"Villa Raffo",
		"Villa Ramallo",
		"Villa Ramallo Est Ffcc",
		"Villa Ramallo Estación Ffcc",
		"Villa Río Chico",
		"Villa Roch",
		"Villa Rosa",
		"Villa Rosas",
		"Villa Ruiz",
		"Villa Saboya",
		"Villa Saenz Peña",
		"Villa San Alberto",
		"Villa San José",
		"Villa San Pedro",
		"Villa Sánchez Elia",
		"Villa Sanguinetti",
		"Villa Santa María",
		"Villa Santos Tesei",
		"Villa Sanz",
		"Villa Sarita",
		"Villa Sarmiento",
		"Villa Sauce",
		"Villa Sauri",
		"Villa Sena",
		"Villa Serra",
		"Villa Talleres",
		"Villa Teresa",
		"Villa Triángulo",
		"Villa Vallier",
		"Villa Vatteone",
		"Villa Ventana",
		"Villa Verde",
		"Villa Vignolo",
		"Villa York",
		"Villafañe",
		"Villaigrillo",
		"Villalonga",
		"Villanueva",
		"Villars",
		"Viña",
		"Virrey Del Pino",
		"Virreyes",
		"Vista Alegre",
		"Vitel",
		"Vivorata",
		"Volta",
		"Voluntad",
		"Vuelta De Obligado",
		"Vuelta De Zapata",
		"Warnes",
		"Wilde",
		"William Morris",
		"Yerbas",
		"Yraizos",
		"Yutuyaco",
		"Zamudio",
		"Zapiola",
		"Zarate",
		"Zavalia",
		"Zeballos",
		"Zelaya",
		"Zenon Videla Dorna",
		"Zentena",
		"Zoilo Peralta",
		"Zona Cangrejales",
		"Zona Delta Campana",
		"Zona Delta San Fernando",
		"Zona Delta Tigre",
		"Zona Delta Zarate",
		"Zubiaurre"
	],
	Catamarca: [
		"Achalco",
		"Acheral",
		"Aconquija",
		"Acostilla",
		"Adolfo E Carranza",
		"Agua Amarilla La Hoyada",
		"Agua Amarilla Pta De Balasto",
		"Agua Colorada",
		"Agua De Dionisio",
		"Agua De Las Palomas",
		"Agua Del Campo",
		"Agua Del Simbol",
		"Agua Escondida",
		"Agua Grande",
		"Agua Los Matos",
		"Agua Salada",
		"Agua Verde",
		"Aguada",
		"Aguadita",
		"Aguas Calientes",
		"Albigasta",
		"Algarrobal",
		"Alijilan",
		"Almigaucho",
		"Alta Gracia",
		"Alto Bello",
		"Alto De La Junta",
		"Alto Del Rosario",
		"Alto El Bolsón",
		"Alumbrera",
		"Amadores",
		"Amana",
		"Amanao",
		"Amancala",
		"Ambato",
		"Ampajango",
		"Ampolla",
		"Ampujaco",
		"Ancasti",
		"Ancastillo",
		"Anchoca",
		"Andalgala",
		"Andalhuala",
		"Andalucía",
		"Angelina",
		"Angostura",
		"Anillaco",
		"Anjuli",
		"Anquincila",
		"Antapoca",
		"Antinaco",
		"Antofagasta De La Sierra",
		"Apocango",
		"Apoyaco",
		"Arima",
		"Asampay",
		"Aserradero El Pilcio",
		"Ayapaso",
		"Balcosna",
		"Balcosna De Afuera",
		"Balde",
		"Balde La Punta",
		"Balde Nuevo",
		"Balsa",
		"Balungasta",
		"Banda",
		"Banda De Lucero",
		"Banda Várela",
		"Bañado De Divisadero",
		"Bañado De Ovanta",
		"Baños Termales",
		"Barranca Larga",
		"Barranquitas",
		"Barro Negro",
		"Bastidor",
		"Baviano",
		"Bebida",
		"Belén",
		"Bella Vista",
		"Biscotal",
		"Brea",
		"Brea Chimpana",
		"Buen Retiro",
		"Buena Vista",
		"Buey Muerto",
		"Caballa",
		"Cabrera",
		"Cachi",
		"Cachijan",
		"Cachuan",
		"Calacio",
		"Calera",
		"Calera La Norma",
		"Campitos",
		"Campo Bello",
		"Campo Blanco",
		"Candelaria",
		"Cantera Rota",
		"Cañada",
		"Cañada De Ipizca",
		"Cañada De Paez",
		"Cañada Larga",
		"Capayan",
		"Carapunco",
		"Caridad",
		"Carrizal",
		"Carrizal De Abajo",
		"Carrizal De La Costa",
		"Casa Armada",
		"Casa De Alto",
		"Casa De La Cumbre",
		"Casa De Piedra",
		"Casa Grande",
		"Casa Vieja",
		"Casa Viejas",
		"Caspinchango",
		"Castañar",
		"Catita",
		"Cerdas",
		"Cerrillada",
		"Cerrillos",
		"Cerro Colorado",
		"Cerro Negro",
		"Cerviño",
		"Chacabuco",
		"Chacritas",
		"Chafiñan",
		"Chamorro",
		"Chanero",
		"Chañar Laguna",
		"Chañar Punco",
		"Chañarcito",
		"Chañaritos",
		"Chañaryaco",
		"Chaquiago",
		"Chavarria",
		"Chavero",
		"Chichagasta",
		"Chiflón",
		"Chilca",
		"Chiquerito",
		"Choya",
		"Chuchucaruana",
		"Chucolay",
		"Chumbicha",
		"Ciénaga",
		"Cienaguita",
		"Collagasta",
		"Colonia Del Valle",
		"Colonia Nueva Coneta",
		"Colpes",
		"Concepción",
		"Cóndor Huasi",
		"Cóndor Huasi De Belén",
		"Coneta",
		"Copacabana",
		"Cordobita",
		"Corral De Piedra",
		"Corral Quemado",
		"Corral Viejo",
		"Corralita",
		"Corralito",
		"Corralitos",
		"Cortadera",
		"Cortaderas",
		"Costa De Reyes",
		"Cotagua",
		"Cueva Blanca",
		"Culampaja",
		"Cumbre Del Laudo",
		"Desrumbe",
		"Distrito Espinillo",
		"Divisadero",
		"Dos Pocitos",
		"Dos Troncos",
		"Duraznillo",
		"Durazno",
		"El Abra",
		"El Alamito",
		"El Alto",
		"El Arbol Solo",
		"El Arbolito",
		"El Arenal",
		"El Arroyo",
		"El Atoyal",
		"El Aybal",
		"El Balde",
		"El Bañado",
		"El Barreal",
		"El Barrial",
		"El Barrialito",
		"El Bastidor",
		"El Bello",
		"El Biscote",
		"El Bolsón",
		"El Cachiyuyo",
		"El Cacho",
		"El Cajón",
		"El Calchaquí",
		"El Campillo",
		"El Carmen",
		"El Carrizal",
		"El Centenario",
		"El Cercado",
		"El Cerrito",
		"El Cevil",
		"El Cevilarcito",
		"El Chamico",
		"El Chañaral",
		"El Chorro",
		"El Cienago",
		"El Cienego",
		"El Ciflon",
		"El Colegio",
		"El Contador",
		"El Desmonte",
		"El Duraznillo",
		"El Durazno",
		"El Eje",
		"El Espinillo",
		"El Gacho",
		"El Garabato",
		"El Hueco",
		"El Lindero",
		"El Medanito",
		"El Medio",
		"El Milagro",
		"El Mistolito",
		"El Mojón",
		"El Molinito",
		"El Molino",
		"El Mollar",
		"El Molle",
		"El Moreno",
		"El Nogal",
		"El Pajonal",
		"El Parque",
		"El Peñón",
		"El Pie De La Cuesta",
		"El Polear",
		"El Portezuelo",
		"El Potrerillo",
		"El Potrero",
		"El Potrero De Los Córdoba",
		"El Pozo",
		"El Pucara",
		"El Pueblito",
		"El Puestito",
		"El Puesto",
		"El Quebrachal",
		"El Quebrachito",
		"El Quimilo",
		"El Realito",
		"El Recreo",
		"El Retiro",
		"El Rodeito",
		"El Rodeo",
		"El Rodeo Grande",
		"El Rosario",
		"El Saladillo",
		"El Saltito",
		"El Salto",
		"El Sauce",
		"El Sauce Ipizca",
		"El Saucecito",
		"El Simbol",
		"El Suncho",
		"El Tabique",
		"El Taco",
		"El Tala",
		"El Tambillo",
		"El Tesoro",
		"El Tío",
		"El Tolar",
		"El Totoral",
		"El Trapiche",
		"El Valle",
		"El Vallecito",
		"El Zapallar",
		"El Zarzo",
		"Empalme San Carlos",
		"Ensenada",
		"Entre Ríos",
		"Esquiu",
		"Establecimiento Minero Cerro B",
		"Estación Poman",
		"Estancia",
		"Estancia Vieja",
		"Estancito",
		"Estanque",
		"Estanzuela",
		"Faldeo",
		"Famabalastro",
		"Famatanca",
		"Farallón Negro",
		"Fiambala",
		"Fuerte Quemado",
		"Galpón",
		"Garay",
		"Garzon",
		"Gentile",
		"Guanaco",
		"Guanchicito",
		"Guanchin",
		"Guayamba",
		"Guincho",
		"Higuera Del Alumbre",
		"Huaco",
		"Huacra",
		"Hualfin",
		"Huasan",
		"Huasayaco",
		"Huaschaschi",
		"Huasi Ciénaga",
		"Huaycama",
		"Huillapima",
		"Humaya",
		"Iapes",
		"Icaño",
		"Ichipuca",
		"Iloga",
		"Inacillo",
		"Infanzon",
		"Ipizca",
		"Isla Larga",
		"Jacipunco",
		"Jesús María",
		"Joyango",
		"Joyanguito",
		"Julipao",
		"Julumao",
		"Jumeal",
		"Junta",
		"Kilometro 1006",
		"Kilometro 1008",
		"Kilometro 1017",
		"Kilometro 1093",
		"Kilometro 128",
		"Kilometro 38",
		"Kilometro 955",
		"Kilometro 969",
		"Kilometro 975",
		"Kilometro 99",
		"Kilometro 997",
		"Kilometro 999",
		"La Aguada",
		"La Aguada Grande",
		"La Aguadita",
		"La Aguita",
		"La Alumbrera",
		"La Antigua",
		"La Bajada",
		"La Banda",
		"La Barranca Larga",
		"La Barrosa",
		"La Bebida",
		"La Brea",
		"La Buena Estrella",
		"La Calera",
		"La Calera Del Sauce",
		"La Campana",
		"La Candelaria",
		"La Cañada",
		"La Cañada Larga",
		"La Capellania",
		"La Carrera",
		"La Chacarita",
		"La Chacarita De Los Padres",
		"La Chilca",
		"La Ciénaga",
		"La Ciénaga De Los Zondones",
		"La Colonia",
		"La Costa",
		"La Cuesta",
		"La Dorada",
		"La Esquina",
		"La Estancia",
		"La Estancita",
		"La Estanzuela",
		"La Estrella",
		"La Falda",
		"La Falda De San Antonio",
		"La Florida",
		"La Granja",
		"La Guardia",
		"La Higuera",
		"La Higuerita",
		"La Horqueta",
		"La Hoyada",
		"La Huerta",
		"La Isla",
		"La Laguna",
		"La Loma",
		"La Majada",
		"La Maravilla",
		"La Merced",
		"La Mesada",
		"La Montosa",
		"La Ollada",
		"La Ovejeria",
		"La Palca",
		"La Parada",
		"La Paraguaya",
		"La Peña",
		"La Piedra",
		"La Puerta",
		"La Puerta De San Jose",
		"La Puntilla",
		"La Puntilla De San José",
		"La Quebrada",
		"La Quinta",
		"La Ramada",
		"La Ramadita",
		"La Renovación",
		"La Represa",
		"La Salvia",
		"La Soledad",
		"La Tercena",
		"La Tigra",
		"La Toma",
		"La Totora",
		"La Valentina",
		"La Victoria",
		"La Viña",
		"La Viña De Abajo",
		"La Yegua Muerta",
		"La Zanja",
		"Laguna Blanca",
		"Laguna Colorada",
		"Lagunita",
		"Laja",
		"Lampasillo",
		"Lampasito",
		"Lampaso",
		"Las Aguitas",
		"Las Barrancas",
		"Las Barrancas Casa Armada",
		"Las Barras",
		"Las Bayas",
		"Las Breas",
		"Las Burras",
		"Las Cañas",
		"Las Casitas",
		"Las Cayas",
		"Las Chacras",
		"Las Chacritas",
		"Las Ciénagas",
		"Las Cortaderas",
		"Las Cortaderitas",
		"Las Cuchillas",
		"Las Cuchillas Del Aybal",
		"Las Cuevas",
		"Las Esquinas",
		"Las Estancias",
		"Las Flores",
		"Las Higueritas",
		"Las Huertas",
		"Las Iguanas",
		"Las Juntas",
		"Las Justas",
		"Las Lajas",
		"Las Latillas",
		"Las Lomitas",
		"Las Losas",
		"Las Manzas",
		"Las Minas",
		"Las Mojarras",
		"Las Palmas",
		"Las Palmitas",
		"Las Palomas",
		"Las Pampas",
		"Las Pampitas",
		"Las Papas",
		"Las Peladas",
		"Las Peñas",
		"Las Piedras Blancas",
		"Las Puertas",
		"Las Retamas",
		"Las Tapias",
		"Las Tejas",
		"Las Tejas De Valle Viejo",
		"Las Toscas",
		"Las Trancas",
		"Las Tranquitas",
		"Las Trillas",
		"Las Tunas",
		"Las Varitas",
		"Las Zanjas",
		"Lavalle",
		"Lazareto",
		"Liebre",
		"Lindero",
		"Loconte",
		"Loma Cortada",
		"Loma Grande",
		"Loma Sola",
		"Londres",
		"Londres Este",
		"Londres Oeste",
		"Loro Huasi",
		"Los Alamos",
		"Los Altos",
		"Los Angeles",
		"Los Baldes",
		"Los Balverdis",
		"Los Bastidores",
		"Los Bazan",
		"Los Bulacio",
		"Los Bulacios",
		"Los Cadillos",
		"Los Cajones",
		"Los Castillos",
		"Los Caudillos",
		"Los Chanampa",
		"Los Chañares",
		"Los Chañaritos",
		"Los Cisternas",
		"Los Colorados",
		"Los Cordobeses",
		"Los Corrales",
		"Los Estantes",
		"Los Galpones",
		"Los Gonzales",
		"Los Guaytimas",
		"Los Guindos",
		"Los Huaycos",
		"Los Loros",
		"Los Mogotes",
		"Los Molles",
		"Los Morteritos",
		"Los Morteros",
		"Los Nacimientos",
		"Los Narvaez",
		"Los Navarros",
		"Los Nogales",
		"Los Ortices",
		"Los Ovejeros",
		"Los Palacios",
		"Los Pedrazas",
		"Los Pinos",
		"Los Pintados",
		"Los Piquillines",
		"Los Pocitos",
		"Los Potrerillos",
		"Los Pozuelos",
		"Los Puestos",
		"Los Quinteros",
		"Los Rastrojos",
		"Los Rincones",
		"Los Robledos",
		"Los Saltos",
		"Los Talas",
		"Los Troncos",
		"Los Valdez",
		"Los Valveros",
		"Los Varela",
		"Los Várelas",
		"Los Zanjones",
		"Luna Aguada",
		"Majada",
		"Malcasco",
		"Malli 1",
		"Malli 2",
		"Manantiales",
		"María Dora",
		"María Elena",
		"Matambre",
		"Medanito",
		"Medanitos",
		"Médano",
		"Mesada De Los Zarate",
		"Mesada Grande",
		"Mina Dal",
		"Mina Inca Huasi",
		"Minas Agua Tapada",
		"Minas Capillitas",
		"Miraflores",
		"Mischango",
		"Mistol Ancho",
		"Molle Quemado",
		"Mollecito",
		"Mollegasta",
		"Monte Potrero",
		"Monte Redondo",
		"Mota Botello",
		"Motegasta",
		"Mutquin",
		"Nacimiento",
		"Nacimientos De Abajo",
		"Nacimientos De Arriba",
		"Nacimientos De San Antonio",
		"Nacimientos Del Bolsón",
		"Naipa",
		"Navaguin",
		"Navigan",
		"Negro Muerto",
		"Nogalito",
		"Ocho Vados",
		"Ojo De Agua",
		"Ojo De La Cortadera",
		"Ollita",
		"Olmos",
		"Olta",
		"Orellano",
		"Ovanta",
		"Ovejeria",
		"Oyola",
		"Pajanguillo",
		"Palacios",
		"Palo Blanco",
		"Palo Cruz",
		"Palo Labrado",
		"Palo Parado",
		"Palo Seco",
		"Paloma Yaco",
		"Pampa",
		"Pampa Blanca",
		"Pampa Chacra",
		"Pampa Ciénaga",
		"Pampa Pozo",
		"Pan De Azúcar",
		"Pantanos",
		"Papa Chacra",
		"Parada Kilometro 62",
		"Paraje Los Chañaritos",
		"Paso San Francisco",
		"Pastos Amarillos",
		"Payabuayca",
		"Peñaflor",
		"Peñas Blancas",
		"Peñón",
		"Pie Del Médano",
		"Piedra Blanca",
		"Piedra Larga",
		"Pilciao",
		"Pillahuasi",
		"Planchada",
		"Plaza De San Pedro",
		"Plumero",
		"Pocitos",
		"Polcos",
		"Poman",
		"Pomancillo",
		"Portezuelo",
		"Portillo Chico",
		"Posta",
		"Potrerito",
		"Potrero",
		"Pozancones",
		"Pozo De Piedra",
		"Pozo Del Algarrobo",
		"Pozo Del Campo",
		"Pozo Del Mistol",
		"Pozo Grande",
		"Pozos Cavados",
		"Pozuelos",
		"Pto Espinal",
		"Pueblito",
		"Puerta De Corral Quemado",
		"Puerta Grande",
		"Puerto Blanco",
		"Puerto Chipi",
		"Puerto De La Pampa",
		"Puerto Potrero",
		"Puesto De Fadel O De Lobo",
		"Puesto De La Viuda",
		"Puesto De Los Morales",
		"Puesto De Vera",
		"Puesto Del Medio",
		"Puesto Los Gómez",
		"Puesto Sabatte",
		"Punta De Agua",
		"Punta De Balasto",
		"Punta Del Pozo",
		"Quebrachal",
		"Quebracho",
		"Quebrachos Blancos",
		"Quebrada Honda",
		"Quemadita",
		"Quemado",
		"Quimilpa",
		"Quiquero",
		"Quiros",
		"Qusto",
		"Rafael Castillo",
		"Ramblones",
		"Recreo",
		"Retiro",
		"Retiro De Colana",
		"Rincón",
		"Rincón Grande",
		"Río Abajo",
		"Río Chico",
		"Río Colorado",
		"Río De Avila",
		"Río De Bazanes",
		"Río De Don Diego",
		"Río De La Dorada",
		"Río De La Plata",
		"Río De Los Indios",
		"Río Del Tala",
		"Río Grande",
		"Río Los Molinos",
		"Río Potrero",
		"Rodeo",
		"Rodeo Gervan",
		"Rodeo Grande",
		"Rosario De Colana",
		"Rosario Del Sumalao",
		"Rumimonion",
		"Salado",
		"Salauca",
		"Salcedo",
		"San Antonio",
		"San Antonio De La Paz",
		"San Antonio De P Blanca",
		"San Antonio De Paclin",
		"San Antonio Del Cajón",
		"San Antonio Fray M Esquiu",
		"San Antonio Viejo",
		"San Buenaventura",
		"San Fdo Del Valle De Catamarca",
		"San Fernando",
		"San Francisco",
		"San Geronimo",
		"San Isidro",
		"San Jerónimo",
		"San José",
		"San José Banda",
		"San Jose De Piedra Blanca",
		"San José De Tinogasta",
		"San José Norte",
		"San Lorenzo",
		"San Luis",
		"San Manuel",
		"San Martín",
		"San Miguel",
		"San Nicolás",
		"San Pablo",
		"San Pedro",
		"San Pedro Capayan",
		"San Rafael",
		"San Roque",
		"San Vicente",
		"Sancho",
		"Santa Ana",
		"Santa Barbara",
		"Santa Cruz",
		"Santa Gertrudis",
		"Santa Lucia",
		"Santa María",
		"Santa Rosa",
		"Santo Domingo",
		"Santo Tomas",
		"Santos Lugares",
		"Sauce",
		"Sauce De Los Cejas",
		"Sauce Huacho",
		"Sauce Mayo",
		"Saujil",
		"Saujil De Tinogasta",
		"Sebila",
		"Shincal",
		"Sicha",
		"Sierra Brava",
		"Sijan",
		"Singuil",
		"Sisiguasi",
		"Soledad",
		"Sucuma",
		"Sumalao",
		"Sumampa",
		"Suncho",
		"Superi",
		"Suruipiana",
		"Tacahuasi",
		"Tacana",
		"Taco",
		"Taco De Abajo",
		"Tacopampa",
		"Tajamares",
		"Tala",
		"Tala Zapata",
		"Talaguada",
		"Talamayo",
		"Talar",
		"Talega",
		"Talita",
		"Tamberia",
		"Tambu",
		"Tapso",
		"Taton",
		"Telaritos",
		"Termas Villa Vil",
		"Tierra Verde",
		"Tinajera",
		"Tinogasta",
		"Tintigasta",
		"Tiorco",
		"Toro Muerto",
		"Toroyaco",
		"Totora",
		"Totoral",
		"Totorilla",
		"Trampasacha",
		"Tres Puentes",
		"Troya",
		"Tula",
		"Tuscumayo",
		"Vallecito",
		"Vega",
		"Vega Curutu",
		"Vega Tamberia",
		"Vicuña Pampa",
		"Vilisman",
		"Villa Collantes",
		"Villa Coronel Arroyo",
		"Villa Cubas",
		"Villa Dolores",
		"Villa Las Pirquitas",
		"Villa Macedo",
		"Villa Ofelia",
		"Villa Parque Chacabuco",
		"Villa Quintin Ahumada",
		"Villa San Roque",
		"Villa Seleme",
		"Villa Sotomayor",
		"Villa Vil",
		"Villavil",
		"Vinquis",
		"Viña Del Cerro",
		"Viscote",
		"Yacochuyo",
		"Yapes",
		"Yaquicho",
		"Yerba Buena",
		"Yocan",
		"Zanja",
		"Zarcito",
		"Zarza"
	],
	Chaco: [
		"10 De Mayo",
		"2 De Mayo",
		"9 De Julio",
		"Agua Buena",
		"Aldea Forestal",
		"Aleloy",
		"Almirante Brown",
		"Amambay",
		"Arbol Solo",
		"Arroyo Quintana",
		"Avanzada",
		"Avía Terai",
		"Bajo Hondo",
		"Bajo Verde",
		"Barranqueras",
		"Barrio Gral Jose De San Martin",
		"Barrio Sarmiento",
		"Basail",
		"Berlín",
		"Bocas",
		"Bolsa Grande",
		"Botija",
		"Cabañaro Pasaje",
		"Cabeza De Tigre",
		"Cabral",
		"Cabral Cue",
		"Cacui",
		"California",
		"Campo De Galnasi",
		"Campo De La Choza",
		"Campo Echegaray",
		"Campo El Aibal",
		"Campo El Bermejo",
		"Campo El Jacarandá",
		"Campo El Onza",
		"Campo Feldman",
		"Campo Ferrando",
		"Campo Grande",
		"Campo Largo",
		"Campo Las Puertas",
		"Campo Moreno",
		"Campo Nuevo",
		"Campo Overos",
		"Campo Winter",
		"Campo Zapa",
		"Cancha Larga",
		"Capitán Solari",
		"Castellin",
		"Cerrito",
		"Charadai",
		"Charata",
		"Chorotis",
		"Ciervo Petiso",
		"Cnia Agrícola Pampa Napenay",
		"Colombia",
		"Colonia Abate",
		"Colonia Aborigen",
		"Colonia Aborigen Chaco",
		"Colonia Alelay",
		"Colonia Bajo Hondo",
		"Colonia Baranda",
		"Colonia Barrera",
		"Colonia Benitez",
		"Colonia Bermejo",
		"Colonia Bernardino Rivadavia",
		"Colonia Blas Parera",
		"Colonia Bravo",
		"Colonia Cabeza De Buey",
		"Colonia Cabral",
		"Colonia Campo Rossi",
		"Colonia Codutti",
		"Colonia Coronel Brandsen",
		"Colonia Coronel Dorrego",
		"Colonia Cuero Quemado",
		"Colonia Drydale",
		"Colonia Echegaray",
		"Colonia Economía",
		"Colonia El Aguara",
		"Colonia El Alazán",
		"Colonia El Ciervo",
		"Colonia El Curupi",
		"Colonia El Fiscal",
		"Colonia El Paraisal",
		"Colonia El Pilar",
		"Colonia El Tigre",
		"Colonia El Tizon",
		"Colonia El Triángulo",
		"Colonia Elisa",
		"Colonia Esperanza",
		"Colonia Florencia",
		"Colonia Fortuni",
		"Colonia General Necochea",
		"Colonia General Paz",
		"Colonia Gualtieri",
		"Colonia Hamburguesa",
		"Colonia Herrera",
		"Colonia Hipolito Vieytes",
		"Colonia Indígena",
		"Colonia José Mármol",
		"Colonia Juan José Castelli",
		"Colonia Juan José Paso",
		"Colonia Juan Larrea",
		"Colonia Juan Lavalle",
		"Colonia Juan Penco",
		"Colonia La Avanzada",
		"Colonia La Filomena",
		"Colonia La Florida Chica",
		"Colonia La Florida Grande",
		"Colonia La Lola",
		"Colonia La María Luisa",
		"Colonia La Tota",
		"Colonia Las Avispas",
		"Colonia Leandro N Alem",
		"Colonia Los Ganzos",
		"Colonia Lote 10",
		"Colonia Lote 12",
		"Colonia Lote 3",
		"Colonia Lucinda",
		"Colonia Malgratti",
		"Colonia Mariano Sarratea",
		"Colonia Matheu",
		"Colonia Mixta",
		"Colonia Monte Quemado",
		"Colonia Necochea Sud",
		"Colonia Palmira",
		"Colonia Popular",
		"Colonia Pueblo Viejo",
		"Colonia Puente Philipon",
		"Colonia Puente Uriburu",
		"Colonia Quebrachales",
		"Colonia Río De Oro",
		"Colonia Rodríguez Peña",
		"Colonia Sabina",
		"Colonia San Antonio",
		"Colonia Santa Elena",
		"Colonia Schmidt",
		"Colonia Siete Arboles",
		"Colonia Tacuari",
		"Colonia Tañigo",
		"Colonia Tres Lagunas",
		"Colonia Velez Sarsfield",
		"Colonia Welhers",
		"Colonias Unidas",
		"Comandancia Frías",
		"Concepción Del Bermejo",
		"Coronel Avalos",
		"Coronel Brandsen",
		"Coronel Du Graty",
		"Corralito",
		"Corzuela",
		"Costa Ine",
		"Cote Lai",
		"Cuarta Legua 14",
		"Cuatro Arboles",
		"Cuatro Bocas",
		"Curandu",
		"Curva De Novoa",
		"Diez De Mayo",
		"Doña Paula",
		"Dos Boliches",
		"El 14",
		"El 15",
		"El Aibal",
		"El Asustado",
		"El Bañado",
		"El Boquerón",
		"El Cajón",
		"El Campamento",
		"El Cañón",
		"El Catorce",
		"El Cuadrado",
		"El Cuarenta Y Seis",
		"El Curundu",
		"El Desierto",
		"El Destierro",
		"El Espinillo",
		"El Esquinero",
		"El Estero",
		"El Guanaco",
		"El Indio",
		"El Lapacho",
		"El Mirasol",
		"El Ñandubay",
		"El Obraje",
		"El Oro Blanco",
		"El Palmar",
		"El Palmar  Tres Isletas",
		"El Paraíso",
		"El Perdido",
		"El Picaso",
		"El Pintado",
		"El Porongal",
		"El Porvenir",
		"El Puca",
		"El Puma",
		"El Quebrachal",
		"El Raigonal",
		"El Recoveco",
		"El Recovo",
		"El Recreo",
		"El Retiro",
		"El Saladillo",
		"El Sauzal",
		"El Sauzalito",
		"El Simbolar",
		"El Tacuruzal",
		"El Totoral",
		"El Tragadero",
		"El Treinta Y Seis",
		"El Triángulo",
		"El Tupí Kilometro 474",
		"El Valla",
		"El Viscacheral",
		"El Zanjón",
		"El Zapallar",
		"Enrique Urien",
		"Estancia El Sábalo",
		"Estancia La Aurora",
		"Estancia Loma Alta",
		"Estero Redondo",
		"Ex Fortín Arenales",
		"Ex Fortín Comandante Frías",
		"Ex Fortín Lavalle",
		"Ex Fortín Pérez Millán",
		"Ex Fortín Wilde",
		"Ex Fortín Zelava",
		"Ex Fortín Zelaya",
		"Floradora",
		"Fontana",
		"Fortín Aguilar",
		"Fortín Cardoso",
		"Fortín Chajá",
		"Fortín Las Chuñas",
		"Fortín Lavalle",
		"Fortín Potrero",
		"Fortín Totoralita Lugar Histor",
		"Fuerte Esperanza",
		"Gancedo",
		"Gandolfi",
		"General Capdevila",
		"General Capdevilla",
		"General Donovan",
		"General José De San Martín",
		"General Necochea",
		"General Obligado",
		"General Pinedo",
		"General Vedia",
		"Girasol",
		"Guayaibi",
		"Guaycuru",
		"Haumonia",
		"Hermoso Campo",
		"Hivonnait",
		"Horquilla",
		"India Muerta",
		"Ingeniero Barbet",
		"Invernada",
		"Ipora Guazu",
		"Isla Antequera",
		"Isla Del Cerrito",
		"Itin",
		"Juan José Castelli",
		"Kilometro 1183",
		"Kilometro 15",
		"Kilometro 184",
		"Kilometro 2 Fcgb",
		"Kilometro 22",
		"Kilometro 29",
		"Kilometro 34",
		"Kilometro 38",
		"Kilometro 39",
		"Kilometro 40",
		"Kilometro 42",
		"Kilometro 443",
		"Kilometro 474",
		"Kilometro 48",
		"Kilometro 498",
		"Kilometro 5",
		"Kilometro 501",
		"Kilometro 519",
		"Kilometro 520",
		"Kilometro 523",
		"Kilometro 525",
		"Kilometro 53",
		"Kilometro 530",
		"Kilometro 575",
		"Kilometro 59",
		"Kilometro 596",
		"Kilometro 602",
		"Kilometro 62",
		"Kilometro 76 Rio Bermejo",
		"Kilometro 841",
		"Kilometro 855 Estacion",
		"Kilometro 884",
		"La Aguada",
		"La Argentina",
		"La Armonía",
		"La Cañada",
		"La Chaco",
		"La China",
		"La Chiquita",
		"La Choza",
		"La Clotilde",
		"La Colonia",
		"La Costosa",
		"La Cuchilla",
		"La Dificultad",
		"La Economía",
		"La Eduviges",
		"La Eduvigis",
		"La Elaboradora",
		"La Entrada",
		"La Escondida",
		"La Esperanza",
		"La Estación",
		"La Evangélica",
		"La Fidelidad",
		"La Flecha",
		"La Flojera",
		"La Ganadera",
		"La Gringa",
		"La Ilusión",
		"La Invernada",
		"La Isla",
		"La Leonesa",
		"La Libertad",
		"La Liguria",
		"La Loma",
		"La Lucinda",
		"La Magdalena",
		"La Manuela",
		"La Mascota",
		"La Matanza",
		"La Media Luna",
		"La Mora",
		"La Negra",
		"La Nueva",
		"La Ñata",
		"La Ofelia",
		"La Paloma",
		"La Palometa",
		"La Pastoril",
		"La Pilar",
		"La Pinta",
		"La Pobladora",
		"La Posta",
		"La Providencia",
		"La Raquel",
		"La Rinconada",
		"La Sabana",
		"La Saltarina",
		"La Sara",
		"La Soledad",
		"La Suiza",
		"La Tambora",
		"La Tapera",
		"La Tigra",
		"La Tranquilidad",
		"La Verde",
		"La Vicuña",
		"La Viruela",
		"La Zanja",
		"Laguna Beligay",
		"Laguna Blanca",
		"Laguna Escondida",
		"Laguna Limpia",
		"Laguna Patos",
		"Lapachito",
		"Lapacho",
		"Las Banderas",
		"Las Blancas",
		"Las Breñas",
		"Las Carpas",
		"Las Cuatro Bocas",
		"Las Cuchillas",
		"Las Cuchillas Cnia J Mármol",
		"Las Delicias",
		"Las Flores",
		"Las Garcitas",
		"Las Golondrinas",
		"Las Golondrinas Sur",
		"Las Hacheras",
		"Las Leonas",
		"Las Lomitas",
		"Las Maravillas",
		"Las Mercedes",
		"Las Moreras",
		"Las Palmas",
		"Las Piedritas",
		"Las Rosas",
		"Las Toscas",
		"Las Vertientes",
		"Liva",
		"Loma Alta",
		"Loma Florida",
		"Lorena",
		"Loro Blanco",
		"Los Algarrobos",
		"Los Barriles",
		"Los Cerritos",
		"Los Chinacos",
		"Los Fortines",
		"Los Frentones",
		"Los Gansos",
		"Los Gualcos",
		"Los Magos",
		"Los Palmares",
		"Los Porongos",
		"Los Pozos",
		"Los Quebrachitos",
		"Los Quirquinchos",
		"Los Tigres",
		"Los Tobas",
		"Los Tunales",
		"Lote 1",
		"Lote 10",
		"Lote 11",
		"Lote 12",
		"Lote 14",
		"Lote 15 Escuela 268",
		"Lote 15 La Sabana",
		"Lote 16 Escuela 204",
		"Lote 17",
		"Lote 18 Pozo Colorado",
		"Lote 23",
		"Lote 23 Samuhu",
		"Lote 24",
		"Lote 25",
		"Lote 3",
		"Lote 33",
		"Lote 34",
		"Lote 4 Colonia Pastoril",
		"Lote 4 Quitilipi",
		"Lote 42",
		"Lote 43 Escuela 250",
		"Lote 48 Colonia Mixta",
		"Lote 53 Colonia Mixta",
		"Lote 7",
		"Lote 77",
		"Lote 8",
		"Lote 9",
		"Lote 92 La Rinconada",
		"Lote Ocho",
		"Machagai",
		"Macomitas",
		"Madre De Dios",
		"Makalle",
		"Malbalaes",
		"Malbalaes Lote 45 Y 46",
		"Manantiales",
		"Margarita Belén",
		"María Sara",
		"Martínez De Hoz",
		"Mesón De Fierro",
		"Mieres",
		"Ministro Ramón Gómez",
		"Miraflores",
		"Miramar",
		"Misión Angelicana",
		"Misión Nueva Pompeya",
		"Molle Marcado",
		"Monte Caseros",
		"Napalpi",
		"Napenay",
		"Ntra Señora De La Concepción",
		"Nueva Población",
		"Nueva Unión",
		"Nueva York",
		"Obraje La Vicuña",
		"Palmar Central",
		"Palmar Norte",
		"Palo Blanco",
		"Palo Marcado",
		"Pampa Aguado",
		"Pampa Aguara",
		"Pampa Alegría",
		"Pampa Alelai",
		"Pampa Almiron",
		"Pampa Alsina",
		"Pampa Avila",
		"Pampa Bandera",
		"Pampa Barrera",
		"Pampa Bolsa",
		"Pampa Borracho",
		"Pampa Brugnoli",
		"Pampa Cabrera",
		"Pampa Cabure",
		"Pampa Castro",
		"Pampa Cejas",
		"Pampa Chica",
		"Pampa Cuvalo",
		"Pampa De Las Flores",
		"Pampa De Los Locos",
		"Pampa Del Cielo",
		"Pampa Del Huevo",
		"Pampa Del Indio",
		"Pampa Del Infierno",
		"Pampa Del Regimiento",
		"Pampa Del Tordillo",
		"Pampa Del Zorro",
		"Pampa Dorotier",
		"Pampa El 11",
		"Pampa El 12",
		"Pampa El Fosforito",
		"Pampa El Mangrullo",
		"Pampa El Mollar",
		"Pampa El Silencio",
		"Pampa Flores",
		"Pampa Florida",
		"Pampa Galpón",
		"Pampa Gamba",
		"Pampa Grande",
		"Pampa Hermosa",
		"Pampa Ipora Guazu",
		"Pampa Juanita",
		"Pampa La Peligrosa",
		"Pampa Landriel",
		"Pampa Larga",
		"Pampa Legua Cuatro",
		"Pampa Loca",
		"Pampa Los Bedogni",
		"Pampa Machete",
		"Pampa Mitre",
		"Pampa Oculta",
		"Pampa Pelado",
		"Pampa Pereyra",
		"Pampa Quimili",
		"Pampa Ralera",
		"Pampa San Martín",
		"Pampa Sommer",
		"Pampa Tolosa Chica",
		"Pampa Tolosa Grande",
		"Pampa Vargas",
		"Pampa Verde",
		"Pampa Villordo",
		"Pampa Virgen",
		"Pampa Zanata",
		"Pampini",
		"Paraje El Colchón",
		"Paraje El Colorado",
		"Paraje Independencia",
		"Paraje Kilometro 77",
		"Paraje Las Tablas",
		"Paraje Ojo De Agua",
		"Paraje Santa Cruz",
		"Paralelo 28",
		"Paso De Los Libres",
		"Paso Del Oso",
		"Picaditas",
		"Pilar",
		"Pindo",
		"Pinedo Central",
		"Pozo De La Línea",
		"Pozo De La Mula",
		"Pozo De La Pava",
		"Pozo De La Tuna",
		"Pozo De Las Garzas",
		"Pozo De Los Suris",
		"Pozo Del Cincuenta",
		"Pozo Del Gato",
		"Pozo Del Gris",
		"Pozo Del Indio Estación Fcgb",
		"Pozo Del Molle",
		"Pozo Del Negro",
		"Pozo Del Tala",
		"Pozo Del Tigre",
		"Pozo Del Toro",
		"Pozo El Chañar",
		"Pozo Hondo",
		"Pozo La Brea",
		"Pozo La Osca",
		"Pozo Navagan",
		"Presidencia De La Plaza",
		"Presidencia Roca",
		"Presidencia Roque Saenz Peña",
		"Pueblo Clodomiro Díaz",
		"Pueblo Puca",
		"Puente Ine",
		"Puente Palometa",
		"Puente Philippon",
		"Puente Svritz",
		"Puerta De León",
		"Puerto Antequera",
		"Puerto Bastiani",
		"Puerto Bermejo",
		"Puerto Eva Peron",
		"Puerto Las Palmas",
		"Puerto Lavalle",
		"Puerto Tirol",
		"Puerto Urquiza",
		"Puerto Velaz",
		"Puerto Vicentini",
		"Puerto Vilelas",
		"Puerto Zapallar",
		"Puesto Carrizo",
		"Puesto Cocheri",
		"Puesto Mendizabal",
		"Punta De Rieles",
		"Punta Nueva",
		"Punta Rieles",
		"Quia",
		"Quitilipi",
		"Ranchos Viejos",
		"Reducc San Bernardo De Vertiz",
		"Reduccion De La Cangaye",
		"Reducción De La Cangaye Lugar",
		"Reducción De San Bernardo El V",
		"Reducción Napalpi",
		"Resistencia",
		"Rincón Del Zorro",
		"Río Araza",
		"Río Bermejo",
		"Río De Oro",
		"Río Muerto",
		"Río Tapenaga",
		"Rosales",
		"Salto De La Vieja",
		"Samuhu",
		"San Agustín",
		"San Antonio",
		"San Bernardo",
		"San Carlos",
		"San Eduardo",
		"San Fernando",
		"San José",
		"San Juancito",
		"San Lorenzo",
		"San Luis",
		"San Martín",
		"San Miguel",
		"San Telmo",
		"Santa Agueda",
		"Santa Elena",
		"Santa Elvira",
		"Santa María",
		"Santa Marta",
		"Santa Rita",
		"Santa Rosa",
		"Santa Sylvina",
		"Santa Teresa De Carballo",
		"Santo Domingo",
		"Santos Lugares",
		"Selvas Del Río De Oro",
		"Sol De Mayo",
		"Solalinde",
		"Taco Pozo",
		"Tacuari",
		"Tartagal",
		"Termas Del Cerrito",
		"Tigre",
		"Timbo",
		"Tolderias",
		"Tres Boliches",
		"Tres Estacas",
		"Tres Horquetas",
		"Tres Isletas",
		"Tres Mojones",
		"Tres Monjes",
		"Tres Naciones",
		"Tres Palmas",
		"Tres Pozos",
		"Tropezón",
		"Tucuru",
		"Urundel",
		"Velaz",
		"Venados Grandes",
		"Venezuela",
		"Víboras",
		"Vicentini",
		"Villa Alta",
		"Villa Angela",
		"Villa Barberan",
		"Villa Berthet",
		"Villa Dos",
		"Villa El Dorado",
		"Villa El Palmar",
		"Villa Forestacion",
		"Villa Jalón",
		"Villa Juan De Garay",
		"Villa Libertad",
		"Villa Paranacito",
		"Villa Río Bermejito",
		"Villa Sarmiento",
		"Welhers",
		"Wichi",
		"Yatay",
		"Zaparinqui",
		"Zuberbhuler",
		"Zuberbuhler"
	],
	Chubut: [
		"28 De Julio",
		"Aguada De Las Tejas",
		"Aguada Del Pito",
		"Aldea Apeleg",
		"Aldea Beleiro",
		"Aldea Escolar",
		"Alto De Las Plumas",
		"Alto Rio Mayo",
		"Alto Río Pico",
		"Alto Río Senguer",
		"Angostura",
		"Angostura Segunda",
		"Arenoso",
		"Arroyo Chalia",
		"Arroyo El Mosquito",
		"Arroyo Gato",
		"Arroyo Guilaia",
		"Arroyo Percy",
		"Arroyo Pescado",
		"Arroyo Quilla",
		"Arroyo Verde",
		"Bahía Bustamante",
		"Bahía Cracher",
		"Bahía Solano",
		"Bajada Del Diablo",
		"Bajada Moreno",
		"Bajo Bartolo",
		"Bajo De Los Huesos",
		"Bajo Del Gualicho",
		"Bajo La Cancha",
		"Bajo Las Damajuanas",
		"Barrio Astra",
		"Base Aeronaval Almirante Iriza",
		"Base Aeronaval Almirante Zar",
		"Betesta",
		"Boca De La Zanja",
		"Boca Zanja Sud",
		"Bryn Brown",
		"Bryn Gwyn",
		"Buen Pasto",
		"Buenos Aires Chico",
		"Cabaña Del Valle",
		"Cabeza De Buey",
		"Cabo Raso",
		"Cachel",
		"Cajón De Ginebra Chico",
		"Cajón De Ginebra Grande",
		"Caleta Cordova",
		"Caleta Valdez",
		"Camarones",
		"Campamento Villegas",
		"Cañada Bagual",
		"Cañadón Bagual",
		"Cañadón Blanco",
		"Cañadón Caliente",
		"Cañadón Carril",
		"Cañadón Chacay",
		"Cañadón Chileno",
		"Cañadón Ferráis",
		"Cañadón Grande",
		"Cañadón La Madera",
		"Cañadón Lagarto",
		"Cañadón López",
		"Cañadón Pedro Ex Valle Hermoso",
		"Cañadón Tacho",
		"Carhue Niyeo",
		"Carrenleufu",
		"Casa Blanca",
		"Catayco",
		"Cerro Centinela",
		"Cerro Cóndor",
		"Cerro Fofocahuel",
		"Cerro Lonco Trapial",
		"Cerro Mallaco",
		"Cerro Negro",
		"Cerro Pichalao",
		"Cerro Radal",
		"Cerro Santa Ana",
		"Chacay Este",
		"Chacay Oeste",
		"Chacra De Austin",
		"Charque Chico",
		"Chasico",
		"Cholila",
		"Colan Conhue",
		"Colelache",
		"Colhue Huapi",
		"Colonia 16 De Octubre",
		"Colonia Cushamen",
		"Colonia Epulef",
		"Colonia Epulief",
		"Colonia Germanía",
		"Comodoro Rivadavia",
		"Corcovado",
		"Corralitos",
		"Costa Chubut",
		"Costa Del Lepa",
		"Costa Río Chico",
		"Cushamen",
		"Dique Florentino Ameghino",
		"Doctor Ricardo Rojas",
		"Dolavon",
		"Dos Pozos",
		"Ebenecer",
		"El Alamo",
		"El Argentino",
		"El Boquete",
		"El Cajón",
		"El Calafate",
		"El Canquel",
		"El Chacay",
		"El Chacay  Dpto Gastre",
		"El Chalet",
		"El Cherque",
		"El Coihue",
		"El Coite",
		"El Colhue",
		"El Coyte",
		"El Cronometro",
		"El Cuche",
		"El Desempeño",
		"El Escorial",
		"El Hoyo",
		"El Jaguel",
		"El Kaquel",
		"El Maiten",
		"El Mirador",
		"El Mirasol",
		"El Molle",
		"El Pajarito",
		"El Pastizal",
		"El Piquillin",
		"El Portezuelo",
		"El Porvenir",
		"El Poyo",
		"El Quilimuay",
		"El Ruano",
		"El Salitral",
		"El Shaman",
		"El Sombrero",
		"El Trebol",
		"El Triana",
		"El Tropezón",
		"El Turbio",
		"Empalme A Astra",
		"Empalme Puerto Lobos",
		"Enrique Hermitte",
		"Epuyen",
		"Esquel",
		"Estancia El Moro",
		"Estancia La Mimosa",
		"Estancia Nueva Lubecka",
		"Estancia Pampa Chica",
		"Facundo",
		"Fithen Verin",
		"Fitirhuin",
		"Florentino Ameghino",
		"Fofo Cahuel",
		"Fotocahuel",
		"Frontera De Río Pico",
		"Futaleufu",
		"Gaiman",
		"Gan Gan",
		"Garayalde",
		"Gastre",
		"Glasfryn",
		"Gobernador Costa",
		"Gualjaina",
		"Hito 43",
		"Hito 45",
		"Hito 50",
		"Holdich",
		"Ing Bruno J Thomae",
		"José De San Martín",
		"Kilometro 11",
		"Kilometro 191",
		"La Bombilla",
		"La Cancha",
		"La Castellana",
		"La Corona",
		"La Lancha",
		"La Laurita",
		"La Nicolasa",
		"La Pepita",
		"La Primavera",
		"La Rosilla",
		"La Salamanca",
		"La Siberia",
		"Lago Blanco",
		"Lago Carlos Pellegrini",
		"Lago Fontana",
		"Lago Lezama",
		"Lago Lezana",
		"Lago Musters",
		"Lago Paz",
		"Lago Puelo",
		"Lago Rivadavia",
		"Lago Rosario",
		"Lago Verde",
		"Lago Vintter",
		"Laguna Blanca",
		"Laguna De Vacas",
		"Laguna Del Mate",
		"Laguna Fría",
		"Laguna Grande",
		"Laguna Palacio",
		"Laguna Rincón Del Moro",
		"Laguna Terraplén",
		"Laguna Verde",
		"Lagunita Salada",
		"Languiñeo",
		"Larralde",
		"Las Chapas",
		"Las Cortaderas",
		"Las Golondrinas",
		"Las Horquetas",
		"Las Mulas",
		"Las Pampas",
		"Las Plumas",
		"Las Pulgas",
		"Las Salinas",
		"Legua 24",
		"Leleque",
		"Lenzanilleo",
		"Loma Redonda",
		"Loreto",
		"Los Altares",
		"Los Cipreses",
		"Los Corralitos",
		"Los Manantiales",
		"Los Tamariscos",
		"Maesteg",
		"Malaspina",
		"Mallin Blanco",
		"Mallin Grande",
		"Mallin Grande Corcovado",
		"Manantial Grande",
		"Manantiales Behr",
		"Mata Grande",
		"Matucana",
		"Mayoco",
		"Médanos",
		"Nahuel Pan Estación Fcgr",
		"Niriguao",
		"Niriguce Pampa",
		"Nueva Lubecka",
		"Ñorquinco Sud",
		"Painaluf",
		"Pampa De Agnia",
		"Pampa Del Castillo",
		"Pampa Pelada",
		"Pampa Salamanca",
		"Pampa Tepuel",
		"Paraje Entre Rios",
		"Parque Nacional Los Alerces",
		"Paso De Indios",
		"Paso De Torres",
		"Paso Del Sapo",
		"Paso Moreno",
		"Pastos Blancos",
		"Pico Salamanca",
		"Piedra Parada",
		"Piedra Shotel",
		"Pirre Mahuida",
		"Plancuntre",
		"Playa Unión",
		"Pocitos De Quichaura",
		"Puente Hendre",
		"Puerto Lobos",
		"Puerto Madryn",
		"Puerto Pirámides",
		"Puerto San Roman",
		"Punta Bajos",
		"Punta Delgada",
		"Punta Ninfas",
		"Punta Norte",
		"Punta Quiroga",
		"Putrachoique",
		"Rada Tilly",
		"Ranquil Huao",
		"Rawson",
		"Río Chico",
		"Río Corinto",
		"Río Frías",
		"Río Mayo",
		"Río Pico",
		"Ruta 3 Kilometro 1646",
		"Ruta 3 Kilometro 1711",
		"Sacanana",
		"Salinas Chicas",
		"Salinas Grandes",
		"San José",
		"Sarmiento",
		"Seprucal",
		"Siempre Viva",
		"Sierra Chata",
		"Sierra Chica",
		"Sierra Colorada",
		"Sierra Corrientes",
		"Sierra Cuadrada",
		"Sierra De Tecka",
		"Sierra Nevada Buen Pasto",
		"Sierra Nevada Paso De Indios",
		"Sierra Overa Chicas Y Grandes",
		"Sierra Rosada",
		"Sierra Victoria",
		"Sol De Mayo",
		"Sunica",
		"Talagapa",
		"Taquetren",
		"Tatúen",
		"Tecka",
		"Telsen",
		"Toma De Los Canales",
		"Toro Hosco",
		"Trelew",
		"Treorki",
		"Tres Picos",
		"Trevelin",
		"Uzcudun",
		"Valle Del Río Chubut",
		"Valle Del Tecka",
		"Valle Frío",
		"Valle Garin",
		"Valle Hermoso",
		"Valle Hondo",
		"Valle Huemules",
		"Valle Los Mártires",
		"Villa Futalaufquen",
		"Villa Inés",
		"Villa Lago Rivadavia"
	],
	"Córdoba": [
		"9 De Julio",
		"Abburra",
		"Achiras",
		"Acollarado",
		"Acostilla",
		"Adelia Maria",
		"Agua De Crespin",
		"Agua De Las Piedras",
		"Agua De Oro",
		"Agua De Tala",
		"Agua Del Tala",
		"Agua Hedionda",
		"Agua Pintada",
		"Agua Sacha",
		"Aguada Del Monte",
		"Aguadita",
		"Aguas De Ramón",
		"Aguasacha",
		"Alcira Estación Gigena",
		"Alejandro",
		"Alejandro Roca",
		"Alejo Ledesma",
		"Algarrobal",
		"Algarrobo",
		"Alicia",
		"Almafuerte",
		"Alpa Corral",
		"Alpapuca",
		"Alta Gracia",
		"Altautina",
		"Alto Alegre",
		"Alto Castro",
		"Alto De Castillo",
		"Alto De Fierro",
		"Alto De Flores",
		"Alto De Las Mulas",
		"Alto De Los Quebrachos",
		"Alto De San Pedro",
		"Alto Del Durazno",
		"Alto Del Tala",
		"Alto Grande",
		"Alto Resbaloso",
		"Alto Verde",
		"Altos De Chipion",
		"Amboy",
		"Ambul",
		"Ana Zumaran",
		"Angostura",
		"Animi",
		"Anisacate",
		"Antonio Catalano",
		"Arbol Blanco",
		"Arbol Chato",
		"Arboles Blancos",
		"Arcoyo",
		"Arias",
		"Aromito",
		"Arroyito",
		"Arroyo",
		"Arroyo Algodón",
		"Arroyo Cabral",
		"Arroyo De Alvarez",
		"Arroyo Del Pino",
		"Arroyo La Higuera",
		"Arroyo Los Patos",
		"Arroyo San Antonio",
		"Arroyo Santa Catalina",
		"Arroyo Santana",
		"Arroyo Seco",
		"Arroyo Toledo",
		"Arsenal José María Rojas",
		"Ascochinga",
		"Asconchinga",
		"Assunta",
		"Atahona",
		"Athos Pampa",
		"Atos Pampa",
		"Atumi Pampa",
		"Augusto Vandersande",
		"Ausonia",
		"Avellaneda",
		"Bajada Nueva",
		"Bajo Chico",
		"Bajo Chico  Bajo Grande",
		"Bajo Chico Bajo Grande",
		"Bajo De Fernández",
		"Bajo De Gómez",
		"Bajo De Olmos",
		"Bajo Del Burro",
		"Bajo Del Carmen",
		"Bajo El Molino",
		"Bajo Galindez",
		"Bajo Grande",
		"Bajo Hondo",
		"Bajo Lindo",
		"Balbuena",
		"Balde De La Mora",
		"Balde De La Orilla",
		"Balde Lindo",
		"Ballesteros",
		"Ballesteros Sud",
		"Balnearia",
		"Balneario Guglieri",
		"Banda De Várela",
		"Bañado De Paja",
		"Bañado De Soto",
		"Bañado Del Fuerte",
		"Barranca Yaco",
		"Barreto",
		"Barrial",
		"Barrialitos",
		"Barrio Ameghino",
		"Barrio Ana Maria Zumaran",
		"Barrio Belgrano",
		"Barrio Deán Funes",
		"Barrio Del Libertador",
		"Barrio Granadero Pringles",
		"Barrio La Feria",
		"Barrio La Fortuna",
		"Barrio La France",
		"Barrio Las Magnolias",
		"Barrio Los Paraisos",
		"Barrio Loza",
		"Barrio Marques De Sobremonte",
		"Barrio Muller",
		"Barrio Poeta Lugones",
		"Barrio San Lorenzo Sur",
		"Barrio San Martin Norte",
		"Barrio Sargento Cabral",
		"Barrio Villa Unión",
		"Batan",
		"Belén",
		"Bell Ville",
		"Bella Vista",
		"Bengolea",
		"Benjamin Gould",
		"Berrotaran",
		"Beuce",
		"Bialet Masse",
		"Blas De Rosales",
		"Bo Flores Guarnición Aérea",
		"Bo Oficial Y Suboficial Ge",
		"Boca Del Río",
		"Bordo De Los Espinosa",
		"Bosque Alegre",
		"Bouwer",
		"Brinkmann",
		"Buen Retiro",
		"Buena Vista",
		"Buey Muerto",
		"Bulnes",
		"Burmeister",
		"Cabalango",
		"Cabana",
		"Cabeza De Buey",
		"Cabindo",
		"Cachi Yaco",
		"Cachiyullo",
		"Cadete Chavez",
		"Cajón Del Río",
		"Calabalumba",
		"Calasuya",
		"Calchin",
		"Calchin Oeste",
		"Calera Central",
		"Calmayo",
		"Camarones",
		"Camilo Aldao",
		"Caminiaga",
		"Camino A Punta Del Agua",
		"Camoati",
		"Campamento Minnetti",
		"Campo Alegre",
		"Campo Alvarez",
		"Campo Ambroggio",
		"Campo Bandillo",
		"Campo Beiro",
		"Campo Boero",
		"Campo Bourdichon",
		"Campo Calvo",
		"Campo Coyunda",
		"Campo De La Torre",
		"Campo De Las Piedras",
		"Campo General Paz",
		"Campo Grande",
		"Campo La Luisa",
		"Campo La Piedra",
		"Campo Ramallo",
		"Campo Rossiano",
		"Campo San Antonio",
		"Campo San Juan",
		"Campo Sol De Mayo",
		"Canals",
		"Candelaria",
		"Candelaria Norte",
		"Candelaria Sud",
		"Candonga",
		"Cantera Los Vieras",
		"Canteras Alta Gracia",
		"Canteras De Quilpo",
		"Canteras El Manzano",
		"Canteras El Sauce",
		"Canteras Iguazú",
		"Canteras Kilometro 428",
		"Canteras La Calera",
		"Canteras Los Morales",
		"Canteras Quilpo",
		"Caña Cruz",
		"Cañada Ancha Santa Rosa",
		"Cañada De Alvarez",
		"Cañada De Coria",
		"Cañada De Cuevas",
		"Cañada De Jume",
		"Cañada De Las Chacras",
		"Cañada De Las Gatiadas",
		"Cañada De Luque",
		"Cañada De Machado",
		"Cañada De Machado Sud",
		"Cañada De Mateo",
		"Cañada De Mayo",
		"Cañada De Pocho",
		"Cañada De Río Pinto",
		"Cañada De Salas",
		"Cañada Del Durazno",
		"Cañada Del Puerto",
		"Cañada Del Sauce",
		"Cañada Del Simbol",
		"Cañada Del Tala",
		"Cañada Grande",
		"Cañada Honda",
		"Cañada Larga",
		"Cañada San Antonio",
		"Cañada Verde",
		"Cañadas Hondas",
		"Cañadón De Los Mogotes",
		"Cap Gral Bernardo O Higgins",
		"Cap Gral Bernardo O Higins",
		"Capilla De Cosme",
		"Capilla De Dolores",
		"Capilla De Los Remedios",
		"Capilla De Romero",
		"Capilla De San Antonio",
		"Capilla De Siton",
		"Capilla De Tegua",
		"Capilla Del Carmen",
		"Capilla Del Monte",
		"Capilla La Candelaria",
		"Capilla La Esperanza",
		"Capilla San Antonio",
		"Capilla San Antonio De Yucat",
		"Capilla Santa Rosa",
		"Carahuasi",
		"Carlomagno",
		"Carnerillo",
		"Carnero Yaco",
		"Carolina",
		"Caroya",
		"Carrilobo",
		"Carrizal",
		"Cartaberol",
		"Casa Bamba",
		"Casa Blanca",
		"Casa De Piedra",
		"Casa Grande",
		"Casa Nueva",
		"Casa Serrana Huerta Grande",
		"Casas Vejas",
		"Casas Viejas",
		"Cascadas",
		"Caseros Este",
		"Caspichuma",
		"Caspicuchana",
		"Cassaffousth Estación Fcgb",
		"Castellanos",
		"Cavanagh",
		"Cayuqueo",
		"Cerritos De Anizacate",
		"Cerro Blanco",
		"Cerro Bola",
		"Cerro Colorado",
		"Cerro De La Cruz",
		"Cerro Negro",
		"Cerro San Lorenzo",
		"Cerros Asperos",
		"Chacha Del Rey",
		"Chacras",
		"Chacras Del Potrero",
		"Chacras Del Sauce",
		"Chacras Viejas",
		"Chajan",
		"Chalacea",
		"Chamico",
		"Chancani",
		"Chañar Viejo",
		"Chañariaco",
		"Chañaritos",
		"Chaquinchuna",
		"Characato",
		"Charbonier",
		"Charcas Norte",
		"Charras",
		"Chazon",
		"Chile Corral Al Aguada",
		"Chilibroste",
		"Chilli Corral",
		"Chipitin",
		"Chua",
		"Chuchiras",
		"Chucul",
		"Chuña",
		"Chuña Huasi",
		"Churqui Cañada",
		"Ciénaga De Allende",
		"Cienaga De Britos",
		"Ciénaga Del Coro",
		"Cintra",
		"Cnia Hogar Velez Sarsfield",
		"Cnia Vacaciones De Empleado",
		"Colazo",
		"Colonia 10 De Julio",
		"Colonia 25 Los Surgentes",
		"Colonia Alemana",
		"Colonia Almada",
		"Colonia Angelita",
		"Colonia Anita",
		"Colonia Argentina",
		"Colonia Arroyo De Alvarez",
		"Colonia Ballesteros",
		"Colonia Banco Pcia Bs As",
		"Colonia Barge",
		"Colonia Beiro",
		"Colonia Bismarck",
		"Colonia Boero",
		"Colonia Botturi",
		"Colonia Bremen",
		"Colonia Calchaquí",
		"Colonia Cañadón",
		"Colonia Caroya",
		"Colonia Ceferina",
		"Colonia Cortadera",
		"Colonia Cosme Sud",
		"Colonia Coyunda",
		"Colonia Cristina",
		"Colonia Deán Funes",
		"Colonia Del Banco Nación",
		"Colonia Dolores",
		"Colonia Dorotea",
		"Colonia Dos Hermanos",
		"Colonia El Carmen Paraje",
		"Colonia El Chajá",
		"Colonia El Fortín",
		"Colonia El Milagro",
		"Colonia El Trabajo",
		"Colonia Eugenia",
		"Colonia Garzon",
		"Colonia General Deheza",
		"Colonia Gorchs",
		"Colonia Hamburgo",
		"Colonia Holandesa",
		"Colonia Italiana",
		"Colonia Iturraspe",
		"Colonia La Argentina",
		"Colonia La Calle",
		"Colonia La Carmensita",
		"Colonia La Celestina",
		"Colonia La Leoncita",
		"Colonia La Lola",
		"Colonia La Magdalena De Oro",
		"Colonia La Morocha",
		"Colonia La Muriucha",
		"Colonia La Palestina",
		"Colonia La Piedra",
		"Colonia La Primavera",
		"Colonia La Providencia",
		"Colonia La Tordilla",
		"Colonia La Trinchera",
		"Colonia Las Cuatro Esquinas",
		"Colonia Las Pichanas",
		"Colonia Lavarello",
		"Colonia Ledesma",
		"Colonia Los Vascos",
		"Colonia Luque",
		"Colonia Maipu",
		"Colonia Marina",
		"Colonia Maschi",
		"Colonia Maunier",
		"Colonia Milessi",
		"Colonia Montes Negros",
		"Colonia Nuevo Piamonte",
		"Colonia Orcovi",
		"Colonia Palo Labrado",
		"Colonia Paso Carril",
		"Colonia Prodamonte",
		"Colonia Progreso",
		"Colonia Prosperidad",
		"Colonia Sagrada Familia",
		"Colonia San Bartolomé",
		"Colonia San Igancio",
		"Colonia San Ignacio",
		"Colonia San Isidro",
		"Colonia San Pedro",
		"Colonia San Rafael",
		"Colonia Santa Ana",
		"Colonia Santa Catalina",
		"Colonia Santa Margarita",
		"Colonia Santa María",
		"Colonia Santa Paula",
		"Colonia Santa Rita",
		"Colonia Silvio Pellico",
		"Colonia Tacurales",
		"Colonia Tirolesa",
		"Colonia Tiroleza",
		"Colonia Toro Pujio",
		"Colonia Udine",
		"Colonia Valle Grande",
		"Colonia Valtelina",
		"Colonia Veinticinco",
		"Colonia Vicente Aguero",
		"Colonia Videla",
		"Colonia Vignaud",
		"Colonia Yareta",
		"Colonia Yucat Sud",
		"Colonias",
		"Columbo",
		"Come Tierra",
		"Comechingones",
		"Concepción",
		"Cóndor Huasi",
		"Conlara",
		"Constitución",
		"Copacabana",
		"Copina",
		"Córdoba",
		"Corimayo",
		"Corito",
		"Coronel Baigorria",
		"Coronel Moldes",
		"Coronel Olmedo",
		"Corral De Barranca",
		"Corral De Bustos",
		"Corral De Caballos",
		"Corral De Gómez",
		"Corral De Guardia",
		"Corral De Mulas",
		"Corral Del Bajo",
		"Corral Del Rey",
		"Corral Viejo",
		"Corralito",
		"Corralito San Javier",
		"Cortaderas",
		"Cosquin",
		"Costa Alegre",
		"Costa Del Castaño",
		"Costa Del Río Quinto",
		"Costa Del Tambo",
		"Costa Sácate",
		"Cotagaita",
		"Cristina",
		"Cruz Alta",
		"Cruz Chica",
		"Cruz De Caña",
		"Cruz Del Eje",
		"Cruz Del Quemado",
		"Cruz Mojada",
		"Cuatro Caminos",
		"Cuatro Vientos",
		"Cuchilla Nevada",
		"Cuchillo Yaco",
		"Cuesta Blanca",
		"Curapaligue",
		"Dalmacio Velez Sarsfield",
		"De La Serna",
		"Deán Funes",
		"Del Campillo",
		"Demarchi",
		"Desaguadero",
		"Despeñaderos",
		"Desvío Chalacea",
		"Desvio El Volcan",
		"Desvío Kilometro 57",
		"Devoto",
		"Diego De Rojas",
		"Diez Ríos",
		"Dique Chico",
		"Dique La Viña",
		"Dique Las Vaquerías",
		"Dique Los Molinos",
		"Dique San Roque",
		"Doctor Nicasio Salas Oroño",
		"Dolores Nuñez Del Prado",
		"Dolores San Esteban",
		"Domingo Funes",
		"Dos Arroyos",
		"Dos Lagunas",
		"Dos Ríos",
		"Dos Rosas",
		"Duarte Quiros",
		"Dumesnil",
		"Durazno",
		"El  Pantanillo",
		"El Aguila Blanca",
		"El Alcalde",
		"El Algadobal",
		"El Algarrobal",
		"El Algarrobo",
		"El Algodonal",
		"El Alto",
		"El Arañado",
		"El Arbol",
		"El Bagual",
		"El Bajo",
		"El Baldecito",
		"El Bañado",
		"El Barreal",
		"El Barrial",
		"El Bordo",
		"El Bosque",
		"El Brete",
		"El Callejón",
		"El Cano",
		"El Caracol",
		"El Carmen",
		"El Carmen Guiñazu",
		"El Carmen Guiñazú",
		"El Carrilito",
		"El Carrizal",
		"El Carrizal Chuñaguasi",
		"El Carrizal Chuñahuasi",
		"El Cerrito",
		"El Cerro",
		"El Chacho",
		"El Chanchito",
		"El Chingolo",
		"El Chiquillan",
		"El Coro",
		"El Corte",
		"El Crestón De Piedra",
		"El Crispin",
		"El Cuadrado",
		"El Descanso",
		"El Desmonte",
		"El Diquecito",
		"El Divisadero",
		"El Dorado",
		"El Duraznito",
		"El Durazno",
		"El Espinal",
		"El Espinillal",
		"El Espinillo",
		"El Estanque",
		"El Florentino",
		"El Florida",
		"El Fortín",
		"El Francés",
		"El Fuertecito",
		"El Gabino",
		"El Gallego",
		"El Gateado",
		"El Guaico",
		"El Guanaco",
		"El Guindo",
		"El Ialita",
		"El Jordán",
		"El Jume",
		"El Jumial",
		"El Laurel",
		"El Manantial",
		"El Mangrullo",
		"El Manzano",
		"El Medanito",
		"El Mirador",
		"El Mojoncito",
		"El Molino",
		"El Moyano",
		"El Noy",
		"El Ochenta",
		"El Ojo De Agua",
		"El Overo",
		"El Pampero",
		"El Panal",
		"El Pantanillo",
		"El Pantano",
		"El Parador De La Montaña",
		"El Paraíso",
		"El Paso",
		"El Paso De La Pampa",
		"El Pastor",
		"El Payador",
		"El Pedacito",
		"El Perchel",
		"El Pértigo",
		"El Peruel",
		"El Pilcado",
		"El Pingo",
		"El Porteño",
		"El Portezuelo",
		"El Portillo",
		"El Porvenir",
		"El Potosí",
		"El Potrero",
		"El Pozo",
		"El Prado",
		"El Progreso",
		"El Pueblito",
		"El Puente",
		"El Puesto",
		"El Puesto Los Cabrera",
		"El Quebrachal",
		"El Quebrachito",
		"El Quebracho",
		"El Quicho",
		"El Ranchito",
		"El Rastreador",
		"El Reymundo",
		"El Rincón",
		"El Río",
		"El Rodeito",
		"El Rodeo",
		"El Rosario",
		"El Salto",
		"El Salto Norte",
		"El Sauce",
		"El Sauzal",
		"El Sebil",
		"El Silverio",
		"El Simbol",
		"El Simbolar",
		"El Sunchal",
		"El Tajamar",
		"El Tala",
		"El Talar",
		"El Talita",
		"El Talita Villa Gral Mitre",
		"El Tambero",
		"El Tambo",
		"El Tío",
		"El Tomillo",
		"El Torreón",
		"El Tostado",
		"El Trabajo",
		"El Triángulo",
		"El Tule",
		"El Tuscal",
		"El Vado",
		"El Vallecito",
		"El Vallesito",
		"El Veinticinco",
		"El Vence",
		"El Vergel",
		"El Vismal",
		"El Zaino",
		"El Zapallar",
		"El Zapato",
		"Elena",
		"Embalse",
		"Empalme Barrio Flores",
		"Encrucijada",
		"Enfermera Kelly",
		"Escobas",
		"Escuela De Artillería",
		"Esperanza",
		"Espinillo",
		"Espinillo Nuñez Del Prado",
		"Esquina",
		"Esquina Del Alambre",
		"Est Candelaria Norte",
		"Est Juarez Celman",
		"Estación Achiras",
		"Estacion Bell Ville",
		"Estación Calchin",
		"Estación Caroya",
		"Estación Colonia Tirolesa",
		"Estación General Paz",
		"Estación Punta De Agua",
		"Estación Soto",
		"Estancia Bottaro",
		"Estancia De Guadalupe",
		"Estancia Dos Ríos",
		"Estancia El Carmen",
		"Estancia El Chañar",
		"Estancia El Nacional",
		"Estancia El Taco",
		"Estancia Gorosito",
		"Estancia La Chiquita",
		"Estancia La Morocha",
		"Estancia La Punta Del Agua",
		"Estancia Las Cañas",
		"Estancia Las Margaritas",
		"Estancia Las Mercedes",
		"Estancia Las Rosas",
		"Estancia Los Matorrales",
		"Estancia Patiño",
		"Estancia Vieja",
		"Etruria",
		"Eufrasio Loza",
		"Fabrica Militar",
		"Fabrica Militar Río Tercero",
		"Falda De Los Reartes",
		"Falda Del Carmen",
		"Ferreyra",
		"Flora",
		"Fragueyro",
		"Fray Cayetano Rodríguez",
		"Freyre",
		"Galpón Chico",
		"Gavilán",
		"General Baldissera",
		"General Cabrera",
		"General Deheza",
		"General Fotheringham",
		"General Las Heras",
		"General Levalle",
		"General Ortiz De Ocampo",
		"General Pueyrredon",
		"General Roca",
		"General Soler",
		"General Viamonte",
		"Gigena Alcira",
		"Glorialdo Fernández",
		"Golpe De Agua",
		"Graciela",
		"Gruta De San Antonio",
		"Guallascate",
		"Guanaco Boleado",
		"Guanaco Muerto",
		"Guardia Vieja",
		"Guasapampa",
		"Guasta",
		"Guatimozin",
		"Guindas",
		"Gutemberg",
		"Haras San Antonio",
		"Haras Santa Martha",
		"Hernando",
		"Higuerias",
		"Higuerillas",
		"Hipolito Bouchard",
		"Holmberg",
		"Hornillos",
		"Hospital Flia Domingo Funes",
		"Huanchilla",
		"Huanchilla Sud",
		"Huascha",
		"Huasta",
		"Hucle",
		"Huerta Grande",
		"Huinca Renanco",
		"Idiazabal",
		"Iglesia Vieja",
		"Impira",
		"Independencia",
		"India Muerta",
		"Ingeniero Bertini",
		"Inriville",
		"Invernada",
		"Irigoyen",
		"Ischilín",
		"Isla De San Antonio",
		"Isla Del Cerro",
		"Isla Larga",
		"Isla Verde",
		"Isleta Negra",
		"Italo",
		"Iti Huasi",
		"Jaime Peter",
		"James Craik",
		"Jarillas",
		"Jeanmaire",
		"Jerónimo Cortes",
		"Jesús María",
		"José De La Quintana",
		"Jovita",
		"Juan Bautista Alberdi",
		"Juan Garcia",
		"Juarez Celman",
		"Julio Argentino Roca",
		"Jume",
		"Justiniano Posse",
		"Kilegruman",
		"Kilometro 25",
		"Kilometro 25 La Carbonada",
		"Kilometro 267",
		"Kilometro 271",
		"Kilometro 294",
		"Kilometro 316",
		"Kilometro 364",
		"Kilometro 394",
		"Kilometro 430",
		"Kilometro 450",
		"Kilometro 505",
		"Kilometro 531",
		"Kilometro 541",
		"Kilometro 545",
		"Kilometro 55",
		"Kilometro 57",
		"Kilometro 579",
		"Kilometro 581",
		"Kilometro 592",
		"Kilometro 608",
		"Kilometro 658",
		"Kilometro 679",
		"Kilometro 680 Ruta 9",
		"Kilometro 691",
		"Kilometro 692",
		"Kilometro 711",
		"Kilometro 730",
		"Kilometro 745",
		"Kilometro 784",
		"Kilometro 807",
		"Kilometro 827",
		"Kilometro 832",
		"Kilometro 859",
		"Kilometro 865",
		"Kilometro 881",
		"Kilometro 907",
		"Kilometro 931",
		"L A Providencia",
		"La Abra",
		"La Aguada",
		"La Aguadita",
		"La Arabia",
		"La Argentina",
		"La Aura",
		"La Banda",
		"La Barranca",
		"La Barranquita",
		"La Batalla",
		"La Batea",
		"La Betania",
		"La Bismutina",
		"La Botija",
		"La Brianza",
		"La Buena Parada",
		"La Cajuela",
		"La Calera",
		"La Cantera",
		"La Cañada",
		"La Cañada Angosta",
		"La Cañada Grande",
		"La Cañada Santa Cruz",
		"La Carbonada",
		"La Carbonera",
		"La Carlota",
		"La Carolina",
		"La Cascada",
		"La Cautiva",
		"La Celina",
		"La Cesira",
		"La Chacra",
		"La Chicharra",
		"La Choza",
		"La Ciénaga",
		"La Cocha",
		"La Colonia",
		"La Colorada",
		"La Compasión",
		"La Concepción",
		"La Cortadera",
		"La Costa",
		"La Cotita",
		"La Cruz",
		"La Cumbre",
		"La Cumbrecita",
		"La Curva",
		"La Dora",
		"La Dormida",
		"La Esperanza",
		"La Esquina",
		"La Estacada",
		"La Estancia",
		"La Estancita",
		"La Estrella",
		"La Falda",
		"La Falda Del Carmen",
		"La Florida",
		"La Francia",
		"La Fronda",
		"La Frontera",
		"La Fuente",
		"La Gilda",
		"La Gramilla",
		"La Granadilla",
		"La Granja",
		"La Gruta",
		"La Guardia",
		"La Herradura",
		"La Higuera",
		"La Higuerita",
		"La Invernada",
		"La Isabela",
		"La Isla",
		"La Isleta",
		"La Isolina",
		"La Italiana",
		"La Jarilla",
		"La Laguna",
		"La Lagunilla",
		"La Lilia",
		"La Línea",
		"La Luz",
		"La Majada",
		"La Maza",
		"La Mercantil",
		"La Mesada",
		"La Mesilla",
		"La Milka",
		"La Mostaza",
		"La Mudana",
		"La Nacional",
		"La Oscuridad",
		"La Paisanita",
		"La Palestina",
		"La Palma",
		"La Palmerina",
		"La Pampa",
		"La Paquita",
		"La Para",
		"La Patria",
		"La Paz",
		"La Penca",
		"La Perlita",
		"La Piedra Blanca",
		"La Piedra Movediza",
		"La Pintada",
		"La Playa",
		"La Playosa",
		"La Plaza",
		"La Población",
		"La Pobladora",
		"La Porfía",
		"La Porteña",
		"La Posta",
		"La Posta Chuñaguas",
		"La Primavera",
		"La Providencia",
		"La Puerta",
		"La Puerta Villa De Soto",
		"La Quebrada",
		"La Quinta",
		"La Quintana",
		"La Ramada",
		"La Ramoncita",
		"La Redención",
		"La Reducción",
		"La Reina",
		"La Represa",
		"La Rinconada",
		"La Rinconada Candelaria",
		"La Rosarina",
		"La Ruda",
		"La Selva",
		"La Serranita",
		"La Siena",
		"La Sierrita",
		"La Soledad",
		"La Tablada",
		"La Tigra",
		"La Toma",
		"La Tordilla Norte",
		"La Totorilla",
		"La Trampa",
		"La Travesía",
		"La Trinchera",
		"La Tuna",
		"La Tuna Tinoco",
		"La Udine",
		"La Usina",
		"La Ventana",
		"La Verónica",
		"La Vicenta",
		"La Victoria",
		"La Virginia",
		"La Zanja",
		"La Zara",
		"La Zarita",
		"Laborde",
		"Laboulaye",
		"Ladera Yacus",
		"Laguna Brava",
		"Laguna Clara",
		"Laguna De Gómez",
		"Laguna Larga",
		"Laguna Larga Sud",
		"Laguna Oscura",
		"Laguna Seca",
		"Lagunilla",
		"Lagunillas",
		"Larsen",
		"Las Abahacas",
		"Las Abras",
		"Las Acacias",
		"Las Acequias",
		"Las Aguaditas",
		"Las Albahacas",
		"Las Aleras",
		"Las Aromas",
		"Las Arrias",
		"Las Astillas",
		"Las Averías",
		"Las Bajadas",
		"Las Bandurrias",
		"Las Bandurrias Norte",
		"Las Cabras",
		"Las Calecitas",
		"Las Caleras",
		"Las Calles",
		"Las Canteras",
		"Las Cañadas",
		"Las Cañas",
		"Las Cañitas",
		"Las Cardas",
		"Las Casitas",
		"Las Cebollas",
		"Las Chacras",
		"Las Chacras Ruta 111 Kilometro",
		"Las Chacras Ruta 111 Km 14",
		"Las Cinco Cuadras",
		"Las Conanitas",
		"Las Cortaderas",
		"Las Crucecitas",
		"Las Cuatro Esquinas",
		"Las Cusenadas",
		"Las Delicias",
		"Las Encadenadas",
		"Las Encrucijadas",
		"Las Ensenadas",
		"Las Flores",
		"Las Gamas",
		"Las Gemelas",
		"Las Gramillas",
		"Las Guindas",
		"Las Heras",
		"Las Higueras",
		"Las Higuerillas",
		"Las Higueritas",
		"Las Hileras",
		"Las Horquetas",
		"Las Isletillas",
		"Las Jarillas",
		"Las Juntas",
		"Las Junturas",
		"Las Lagunitas",
		"Las Latas",
		"Las Lomas",
		"Las Lomitas",
		"Las Manzanas",
		"Las Masitas",
		"Las Mercedes",
		"Las Merceditas",
		"Las Mojarras",
		"Las Moras",
		"Las Oscuras",
		"Las Overias",
		"Las Palmas",
		"Las Palmeras",
		"Las Palmitas",
		"Las Palomas",
		"Las Palomitas",
		"Las Pampillas",
		"Las Pencas",
		"Las Peñas",
		"Las Peñas Norte",
		"Las Peñas Sud",
		"Las Perdices",
		"Las Pichanas",
		"Las Piedras Anchas",
		"Las Piedritas",
		"Las Piguas",
		"Las Playas",
		"Las Playas Lozada",
		"Las Quintas",
		"Las Rabonas",
		"Las Rosas",
		"Las Saladas",
		"Las Sesenta Cuadras",
		"Las Sierras",
		"Las Sierritas",
		"Las Tapias",
		"Las Tinajeras",
		"Las Toscas",
		"Las Totoritas",
		"Las Trancas",
		"Las Tres Piedras",
		"Las Tuscas",
		"Las Vaquerías",
		"Las Varas",
		"Las Varillas",
		"Las Vertientes",
		"Las Vertientes De La Granja",
		"Latan Hall",
		"Lecueder",
		"Leguizamon",
		"Leones",
		"Lo Machado",
		"Lobera",
		"Loma Blanca",
		"Loma Bola",
		"Loma De Piedra",
		"Loma Redonda",
		"Lomas Del Trozo",
		"Lomitas",
		"Los Alamos",
		"Los Alfalfares",
		"Los Algarrobitos",
		"Los Algarrobos",
		"Los Alvarez",
		"Los Avilés",
		"Los Barriales",
		"Los Bordos",
		"Los Brinzes",
		"Los Cadillos",
		"Los Cajones",
		"Los Callejones",
		"Los Cardos",
		"Los Castaños",
		"Los Cedros",
		"Los Cejas",
		"Los Cerrillos",
		"Los Cerros",
		"Los Cerros Negros",
		"Los Chañares",
		"Los Chañaritos",
		"Los Cigarrales",
		"Los Cisnes",
		"Los Cocos",
		"Los Cometierra",
		"Los Condores",
		"Los Coquitos",
		"Los Desagues",
		"Los Dos Pozos",
		"Los Dos Ríos",
		"Los Duraznos",
		"Los Eslabones",
		"Los Gauchos De Guemes",
		"Los Gigantes",
		"Los Guevara",
		"Los Guindos",
		"Los Helechos",
		"Los Hormigueros",
		"Los Hornillos",
		"Los Hoyos",
		"Los Huesos",
		"Los Jagueles",
		"Los Justes",
		"Los Manguitos",
		"Los Mansillas",
		"Los Medanitos",
		"Los Médanos",
		"Los Miguelitos",
		"Los Miquiles",
		"Los Mistoles",
		"Los Mogotes",
		"Los Molinos",
		"Los Molles",
		"Los Morteros",
		"Los Ojos De Agua",
		"Los Olivares",
		"Los Pantalles",
		"Los Pantanillos",
		"Los Paraísos",
		"Los Paredones",
		"Los Pedernales",
		"Los Piquillines",
		"Los Pocitos",
		"Los Potreros",
		"Los Pozos",
		"Los Puentes",
		"Los Puestitos",
		"Los Quebrachitos",
		"Los Quebrachos",
		"Los Reartes",
		"Los Reyunos",
		"Los Ruices",
		"Los Sauces",
		"Los Socabones",
		"Los Surgentes",
		"Los Tajamares",
		"Los Talares",
		"Los Tártagos",
		"Los Tasis",
		"Los Terrones",
		"Los Tres Pozos",
		"Los Troncos",
		"Los Ucles",
		"Los Valdés",
		"Los Vázquez",
		"Los Zorros",
		"Lozada",
		"Luca",
		"Lucio V Mansilla",
		"Luis Sauze",
		"Luque",
		"Lutti",
		"Luxardo",
		"Luyaba",
		"Macha",
		"Majada De Santiago",
		"Majadilla",
		"Malagueño",
		"Malena",
		"Mallin",
		"Malvinas Argentinas",
		"Manantiales",
		"Mándala",
		"Manfredi",
		"Manguitas",
		"Maquinista Gallini",
		"Mar Azul",
		"Marcos Juárez",
		"María",
		"María Lastenia",
		"Marull",
		"Matacos",
		"Matorrales",
		"Mattaldi",
		"Maunier",
		"Mayu Sumaj",
		"Medanitos",
		"Media Luna",
		"Media Naranja",
		"Medio Naranja",
		"Melideo",
		"Melo",
		"Mendiolaza",
		"Mesa De Mariano",
		"Mesillas",
		"Mi Granja",
		"Mi Valle",
		"Miguel Salas",
		"Miguelito",
		"Mina Araujo",
		"Mina Clavero",
		"Mina La Bismutina",
		"Miquilos",
		"Miraflores",
		"Miramar",
		"Modestino Pizarro",
		"Modesto Acuña",
		"Mogigasta",
		"Mogote Verde",
		"Molinari",
		"Molinos",
		"Monsalvo",
		"Monte Buey",
		"Monte Castillo",
		"Monte Cristo",
		"Monte De Los Gauchos",
		"Monte De Los Lazos",
		"Monte De Toro Pujio",
		"Monte Del Frayle",
		"Monte Del Rosario",
		"Monte Grande",
		"Monte Grande Rafael Garcia",
		"Monte La Invernada",
		"Monte Leña",
		"Monte Maíz",
		"Monte Ralo",
		"Monte Redondo",
		"Morrison",
		"Morteros",
		"Movado",
		"Mula Muerta",
		"Mussi",
		"Navarro",
		"Nazca",
		"Negro Huasi",
		"Nicho",
		"Nicolás Bruzone",
		"Nido Del Aguila",
		"Ninalquin",
		"Nintes",
		"Niña Paula",
		"Noetinger",
		"Nono",
		"Nueva Andalucía",
		"Nueva Esperanza",
		"Nuñez Del Prado",
		"Ñu Pora",
		"Obispo Trejo",
		"Obregon",
		"Ojo De Agua",
		"Ojo De Agua De Totox",
		"Olaeta",
		"Oliva",
		"Olivares San Nicolás",
		"Olmos",
		"Onagoity",
		"Oncativo",
		"Ongamira",
		"Oratorio De Peralta",
		"Orcosuni",
		"Ordoñez",
		"Oro Grueso",
		"Overa Negra",
		"Pachango",
		"Pacheco De Melo",
		"Pajas Blancas",
		"Pajonal",
		"Palo Cortado",
		"Palo Labrado",
		"Palo Negro",
		"Palo Parado",
		"Palo Quemado",
		"Paloma Pozo",
		"Pampa De Achala",
		"Pampa De Olaen",
		"Pampayasta Norte",
		"Pampayasta Sur",
		"Panaholma",
		"Parque Siquiman",
		"Pascanas",
		"Pasco",
		"Paso Cabral",
		"Paso Castellanos",
		"Paso De Los Gallegos",
		"Paso De Montoya",
		"Paso De Velez",
		"Paso Del Durazno",
		"Paso Del Sauce",
		"Paso Del Silverio",
		"Paso Grande",
		"Paso Las Tropas",
		"Paso Sandialito",
		"Paso Viejo",
		"Pastos Altos",
		"Paunero",
		"Pavin",
		"Pedania Candelaria Sud",
		"Pedro E Funes",
		"Pedro E Vivas",
		"Permanentes",
		"Pichanas",
		"Piedra Blanca",
		"Piedra Grande",
		"Piedra Movediza",
		"Piedra Pintada",
		"Piedras Amontonadas",
		"Piedras Anchas",
		"Piedras Blancas",
		"Piedras Grandes",
		"Piedrita Blanca",
		"Piedritas Rosadas",
		"Pilar",
		"Pinas",
		"Pincen",
		"Piquillin",
		"Pisco Huasi",
		"Pitoa",
		"Playa Grande",
		"Plaza Bruno",
		"Plaza De Mercedes",
		"Plaza Minetti",
		"Plaza Rodríguez",
		"Plaza San Francisco",
		"Plujunta",
		"Pocho",
		"Pocito Del Campo",
		"Porteña",
		"Potrero De Funes",
		"Potrero De Garay",
		"Potrero De Lujan",
		"Potrero De Marques",
		"Potrero De Tutzer",
		"Pozo Conca",
		"Pozo Correa",
		"Pozo De Juancho",
		"Pozo De La Esquina",
		"Pozo De La Loma",
		"Pozo De La Pampa",
		"Pozo De Las Ollas",
		"Pozo De Las Yeguas",
		"Pozo De Los Arboles",
		"Pozo De Los Troncos",
		"Pozo De Molina",
		"Pozo Del Avestruz",
		"Pozo Del Barrial",
		"Pozo Del Chajá",
		"Pozo Del Chañar",
		"Pozo Del Molle",
		"Pozo Del Moro",
		"Pozo Del Simbol",
		"Pozo Del Tigre",
		"Pozo La Piedra",
		"Pozo Nuevo",
		"Pozo Seco",
		"Pozo Solo",
		"Pretot Freyre",
		"Primavera",
		"Providencia",
		"Pueblo Alberdi",
		"Pueblo Argentino",
		"Pueblo Carlos Sauveran",
		"Pueblo Gambande",
		"Pueblo Italiano",
		"Pueblo Pianelli",
		"Pueblo Río Tercero",
		"Pueblo Sarmiento",
		"Pueblo Viejo",
		"Puente Del Cura",
		"Puente Los Molles",
		"Puente Río Plujunta",
		"Puerta Colorada",
		"Puerta De La Quebrada",
		"Puesto De Afuera",
		"Puesto De Arriba",
		"Puesto De Batalla",
		"Puesto De Castro",
		"Puesto De Cerro",
		"Puesto De Fierro",
		"Puesto De La Oveja",
		"Puesto De Los Alamos",
		"Puesto De Los Rodríguez",
		"Puesto De Luna",
		"Puesto De Pucheta",
		"Puesto De Vera",
		"Puesto Del Gallo",
		"Puesto Del Medio",
		"Puesto Del Rosario",
		"Puesto El Abra",
		"Puesto Guzmán",
		"Puesto Mulita",
		"Puesto Nuevo",
		"Puesto San José",
		"Puesto Viejo",
		"Punilla",
		"Punta Del Agua",
		"Punta Del Monte",
		"Pusisuna",
		"Quebrachitos",
		"Quebracho Herrado",
		"Quebracho Ladeado",
		"Quebracho Solo",
		"Quebrachos",
		"Quebrada De Los Pozos",
		"Quebrada De Luna",
		"Quebrada De Nona",
		"Quebrada Del Horno",
		"Quilino",
		"Quilmes",
		"Quiscasacate",
		"Racedo",
		"Rafael García",
		"Ramallo",
		"Ramblón",
		"Ramírez",
		"Ramón J Carcano",
		"Rangel",
		"Ranqueles",
		"Rara Fortuna",
		"Rayo Cortado",
		"Recreo Victoria",
		"Reducción",
		"Represa De Morales",
		"Rincón",
		"Rincón Casa Grande",
		"Rincón De Luna",
		"Río Arriba",
		"Río Bamba",
		"Río Ceballos",
		"Río Chico",
		"Río Cuarto",
		"Río De Jaime",
		"Río De La Población",
		"Río De Las Manzanas",
		"Río De Los Sauces",
		"Río De Los Talas",
		"Río Del Durazno",
		"Río Dulce",
		"Río Grande",
		"Río Grande  Amboy",
		"Rio Grande Amboy",
		"Río Hondo",
		"Río Los Molinos",
		"Río Pedro",
		"Río Pinto",
		"Río Primero",
		"Río San Miguel",
		"Río Seco",
		"Río Segundo",
		"Río Tercero",
		"Río Viejo",
		"Rodeito",
		"Rodeo De Los Caballos",
		"Rodeo De Piedra",
		"Rodeo Las Yeguas",
		"Rodeo Viejo",
		"Rojas",
		"Rosales",
		"Ruiz Díaz De Guzmán",
		"Rumiaco",
		"Rumiguasi",
		"Rumihuasi",
		"Ruta 111 Kilometro 14",
		"Ruta 19 Kilometro 317",
		"Sacanta",
		"Sagrada Familia",
		"Saira",
		"Sajón",
		"Saladillo",
		"Saldan",
		"Salguero",
		"Salsacate",
		"Salsipuedes",
		"Salto",
		"Sampacho",
		"San Agustín",
		"San Ambrosio",
		"San Antonio",
		"San Antonio De Arredondo",
		"San Antonio De Bella Vista",
		"San Antonio De Litin",
		"San Antonio De Yucat",
		"San Antonio Norte",
		"San Bartolo",
		"San Bartolomé",
		"San Basilio",
		"San Bernardo",
		"San Buenaventura",
		"San Carlos",
		"San Carlos Minas",
		"San Clemente",
		"San Cristóbal",
		"San Esteban",
		"San Eusebio",
		"San Francisco",
		"San Francisco Del Chañar",
		"San Gabriel",
		"San Geronimo",
		"San Ignacio",
		"San Isidro",
		"San Javier",
		"San Jerónimo",
		"San Joaquín",
		"San Jorge",
		"San José",
		"San José De La Dormida",
		"San José De Las Salinas",
		"San José Del Salteño",
		"San Juancito",
		"San Lorenzo",
		"San Lucas Norte",
		"San Luis",
		"San Marcos Sierra",
		"San Marcos Sierras",
		"San Marcos Sud",
		"San Martín",
		"San Meliton",
		"San Miguel",
		"San Miguel Chancani",
		"San Miguel San Vicente",
		"San Nicolás",
		"San Pablo",
		"San Pedro",
		"San Pedro De San Alberto",
		"San Pedro De Toyos",
		"San Pedro Norte",
		"San Pellegrino",
		"San Rafael",
		"San Ramón",
		"San Roque",
		"San Roque Las Arrias",
		"San Salvador",
		"San Sebastián",
		"San Vicente",
		"Sanabria",
		"Santa Ana",
		"Santa Catalina",
		"Santa Cecilia",
		"Santa Clara",
		"Santa Cristina",
		"Santa Cruz",
		"Santa Elena",
		"Santa Eufemia",
		"Santa Isabel",
		"Santa Lucia",
		"Santa Magdalena",
		"Santa María",
		"Santa María De Punilla",
		"Santa María De Sobremonte",
		"Santa Mónica",
		"Santa Rita",
		"Santa Rosa",
		"Santa Rosa De Calamuchita",
		"Santa Rosa De Río Primero",
		"Santa Rosa Huerta Grande",
		"Santa Sabina",
		"Santa Teresa",
		"Santa Victoria",
		"Santanilla",
		"Santiago Temple",
		"Santo Domingo",
		"Santo Tomas",
		"Sapansoto",
		"Sarlaco",
		"Sarmica",
		"Sarmiento",
		"Saturnino M Laspiur",
		"Sauce Arriba",
		"Sauce Chiquito",
		"Sauce De Los Quevedos",
		"Sauce Punco",
		"Sebastián El Cano",
		"Sebastian Elcano",
		"Seeber",
		"Segunda Usina",
		"Sendas Grandes",
		"Serrano",
		"Serrezuela",
		"Sevilla",
		"Sierra Blanca",
		"Sierra De Abregu",
		"Sierra De Las Paredes",
		"Sierras Morenas",
		"Simbolar",
		"Sinsacate",
		"Soconcho",
		"Socorro",
		"Solar Los Molinos",
		"Solares De Ycho Cruz",
		"Soledad",
		"Soria",
		"Suco",
		"Sunchal",
		"Suncho Huico",
		"Tabanillo",
		"Tabaquillo",
		"Taco Pozo",
		"Tacurel",
		"Tajamares",
		"Tala Cañada",
		"Tala Cruz",
		"Tala Del Río Seco",
		"Tala Huasi",
		"Tala Norte",
		"Tala Sud",
		"Talaini",
		"Tancacha",
		"Tanti",
		"Tanti Lomas",
		"Tanti Nuevo",
		"Taruca Pampa",
		"Tasacuna",
		"Tasma",
		"Tegua",
		"Tejeda",
		"Tercer Cuerpo Del Ejercito",
		"Tercera",
		"Ticino",
		"Tigre Muerto",
		"Tilquicho",
		"Tinoco",
		"Tintizaco",
		"Tío Pujio",
		"Todos Los Santos",
		"Toledo",
		"Tomas Echenique",
		"Tordilla Norte",
		"Toro Muerto",
		"Toro Pujio",
		"Tosno",
		"Tosquita",
		"Totora Guasi",
		"Totoral",
		"Totoralejos",
		"Totoritas",
		"Totrilla",
		"Transito",
		"Tres Arboles",
		"Tres Chañares",
		"Tres Esquinas",
		"Tres Lomas",
		"Tres Pozos",
		"Trinchera",
		"Tristán Narvaja",
		"Tronco Pozo",
		"Tuclame",
		"Tulumba",
		"Tuscal",
		"Ucacha",
		"Unidad Turística Embalse",
		"Unquillo",
		"Uritorco",
		"Usina Nuclear Embalse",
		"Vacas Blancas",
		"Valle Del Sol",
		"Valle Dorado",
		"Valle Hermoso",
		"Valle Verde",
		"Vanguardia",
		"Viamonte",
		"Vicuña Mackenna",
		"Villa Aguada De Los Reyes",
		"Villa Ahora",
		"Villa Albertina",
		"Villa Allende",
		"Villa Alpina",
		"Villa Amancay",
		"Villa Angélica",
		"Villa Anisacate",
		"Villa Ascasubi",
		"Villa Aurora",
		"Villa Berna",
		"Villa Bustos",
		"Villa Caeiro",
		"Villa Candelaria Norte",
		"Villa Carlos Paz",
		"Villa Carlos Pellegrini",
		"Villa Cerro Azul",
		"Villa Cerro Negro",
		"Villa Ciudad De América",
		"Villa Ciudad Pque Los Reartes",
		"Villa Clodomira",
		"Villa Colimba",
		"Villa Concepción Del Tío",
		"Villa Corazón De María",
		"Villa Costa Azul",
		"Villa Cuesta Blanca",
		"Villa Cura Brochero",
		"Villa De Las Rosas",
		"Villa De María",
		"Villa De Soto",
		"Villa Del Dique",
		"Villa Del Lago",
		"Villa Del Parque",
		"Villa Del Prado",
		"Villa Del Rosario",
		"Villa Del Tala",
		"Villa Del Totoral",
		"Villa Díaz",
		"Villa Dolores",
		"Villa El Chacay",
		"Villa El Corcovado",
		"Villa El Descanso",
		"Villa El Torreón",
		"Villa Elisa",
		"Villa Emilia",
		"Villa Esquiu",
		"Villa Flor Serrana",
		"Villa Fontana",
		"Villa General Belgrano",
		"Villa General Mitre",
		"Villa Giardino",
		"Villa Gracia",
		"Villa Gutiérrez",
		"Villa Huidobro",
		"Villa Independencia",
		"Villa La Bolsa",
		"Villa La Coba",
		"Villa La Rancherita",
		"Villa Lago Azul",
		"Villa Las Mercedes",
		"Villa Leonor",
		"Villa Los Altos",
		"Villa Los Aromos",
		"Villa Los Leones",
		"Villa Los Patos",
		"Villa Mar Chiquita",
		"Villa María",
		"Villa Mirea",
		"Villa Moderna",
		"Villa Naturaleza",
		"Villa Nueva",
		"Villa Parque Santa Ana",
		"Villa Parque Siquiman",
		"Villa Posse",
		"Villa Quilino",
		"Villa Quillinzo",
		"Villa Rafael Benegas",
		"Villa Río Ycho Cruz",
		"Villa Rosario Del Saladillo",
		"Villa Rossi",
		"Villa Rumipal",
		"Villa San Esteban",
		"Villa San Javier",
		"Villa San Miguel",
		"Villa Santa Cruz Del Lago",
		"Villa Santa Isabel",
		"Villa Santa María",
		"Villa Santa Rita",
		"Villa Santa Rosa",
		"Villa Sarmiento",
		"Villa Satite",
		"Villa Satyta",
		"Villa Sierras De Lago",
		"Villa Sierras Del Lago",
		"Villa Suiza Argentina",
		"Villa Taninga",
		"Villa Tortosa",
		"Villa Valeria",
		"Villa Vaudagna",
		"Villa Vieja",
		"Villa Yacanto",
		"Viso",
		"Vista Alegre",
		"Vivero",
		"Washington",
		"Watt",
		"Wenceslao Escalante",
		"Yacanto",
		"Yacanto Calamuchita",
		"Yanacato",
		"Yatay",
		"Ycho Cruz Sierras",
		"Yerba Buena",
		"Yocsina",
		"Zapata",
		"Zapoloco"
	],
	Corrientes: [
		"2 De Julio",
		"8 De Diciembre",
		"9 De Julio",
		"Abalo",
		"Abeli",
		"Abo Nezu",
		"Abra",
		"Abra Guazu",
		"Acuña",
		"Acuña Cue",
		"Aguapey",
		"Aguara Cua",
		"Aguay",
		"Aguirre Cue",
		"Aguirre Lomas",
		"Alamo",
		"Albardon",
		"Albardones",
		"Alejandría",
		"Alen Cue",
		"Alfonso Lomas",
		"Algarrobal",
		"Algarrobal Puisoye",
		"Algarrobales",
		"Algarrobo",
		"Algarrobo Paraje",
		"Alta Mora",
		"Altamira",
		"Altamora Parada",
		"Alvear",
		"Angostura",
		"Angua",
		"Apipe Grande",
		"Arañita",
		"Arbol Solo",
		"Arerungua",
		"Aristia",
		"Arroyito",
		"Arroyo Ambrosio",
		"Arroyo Balmaceda",
		"Arroyo Carancho",
		"Arroyo Casco",
		"Arroyo Castillo",
		"Arroyo Ceibal",
		"Arroyo Garay",
		"Arroyo González",
		"Arroyo Grande",
		"Arroyo Horqueta",
		"Arroyo Manganga",
		"Arroyo Méndez",
		"Arroyo Paiso",
		"Arroyo Pelon",
		"Arroyo Pontón",
		"Arroyo San Juan",
		"Arroyo Sarandí",
		"Arroyo Saturno",
		"Arroyo Seco",
		"Arroyo Solís",
		"Arroyo Soro",
		"Arroyo Timboy",
		"Arroyo Totoras",
		"Arroyo Vega",
		"Ayala Cue",
		"Bacacay",
		"Baibiene",
		"Bajo Grande",
		"Bajo Guazu",
		"Balengo",
		"Bañado Norte",
		"Bañado San Antonio",
		"Bañado Sur",
		"Bargone",
		"Barrancas",
		"Barranqueras",
		"Barrio Algarrobo",
		"Barrio Villa Córdoba",
		"Bartolomé Mitre",
		"Bastidores",
		"Basualdo",
		"Batal",
		"Batara",
		"Batay",
		"Batel",
		"Batelito",
		"Baygorria",
		"Bedoya",
		"Bella Vista",
		"Bernachea",
		"Beron De Astrada",
		"Blanco Cue",
		"Boliche Lata",
		"Bonete",
		"Bonpland",
		"Boquerón",
		"Boranza",
		"Bregain Cue",
		"Briganis",
		"Broja Cue",
		"Buen Retiro",
		"Buena Esperanza",
		"Buena Ventura",
		"Buena Vista",
		"Caa Carai",
		"Caa Cati",
		"Caa Garay",
		"Caa Garay Gdor Valentín",
		"Caabi Poi",
		"Caaby Poy",
		"Caaguazu",
		"Caayobay",
		"Cabana",
		"Cabaña",
		"Cabral",
		"Cabred",
		"Cafarreño",
		"Caimán",
		"Callejón",
		"Camba Cua",
		"Cambal",
		"Cambara",
		"Cambireta",
		"Campo Araujo",
		"Campo Bordón",
		"Campo Cafferata",
		"Campo Cardozo",
		"Campo De Carlos",
		"Campo Escalada",
		"Campo Fernández",
		"Campo Grande",
		"Campo Maidana",
		"Campo Morato",
		"Campo Poy",
		"Campo Romero",
		"Campo San Jacinto",
		"Cañada Burgos",
		"Cañada Grande",
		"Cañada Mala",
		"Cañada Quiroz",
		"Cañaditas",
		"Capi Vari",
		"Capiguari",
		"Capilla Cue",
		"Capillita",
		"Capirari",
		"Capita Mini",
		"Capitán Joaquín Madariaga",
		"Carabajal",
		"Carabajal Este",
		"Carabi Poy",
		"Carambola",
		"Carandaiti",
		"Caraya",
		"Cardozo Phi",
		"Carman",
		"Carreta Paso",
		"Carrizal",
		"Carrizal Norte",
		"Caruso Apeadero Fcgu",
		"Casillas",
		"Casualidad",
		"Casuarina",
		"Casuarinas",
		"Catalán Cue",
		"Cau Garay",
		"Cavi Poy",
		"Cavia Cue",
		"Caza Pava",
		"Cazadores Correntinos",
		"Cebollas",
		"Centinela",
		"Cerrito",
		"Cerrudo Cue",
		"Chacras",
		"Chacras 1a Sección",
		"Chacras 2a Sección",
		"Chacras 3a Sección",
		"Chacras 4a Sección",
		"Chacras Norte",
		"Chacras Sección Ejido",
		"Chacras Sud",
		"Chamorro",
		"Chaquito",
		"Chavarria",
		"Chilecito",
		"Chircal",
		"Cnia Oficial Juan Bautista",
		"Colonia",
		"Colonia 3 De Abril",
		"Colonia Acuña",
		"Colonia Alvarez",
		"Colonia Amadei",
		"Colonia Arocena Ina",
		"Colonia Arrocera",
		"Colonia Barrientes",
		"Colonia Basualdo",
		"Colonia Beron De Astrada",
		"Colonia Branchi",
		"Colonia Brougnes",
		"Colonia Caimán",
		"Colonia Carlos Pellegrini",
		"Colonia Carolina",
		"Colonia Cecilio Echeverría",
		"Colonia Chircal",
		"Colonia Danuzzo",
		"Colonia Dora Elena",
		"Colonia Durazno",
		"Colonia Florencia",
		"Colonia Gaiman",
		"Colonia Garabi",
		"Colonia General Ferré",
		"Colonia General Uriburu",
		"Colonia Gobernador Ruiz",
		"Colonia Jacobo Finh",
		"Colonia José R Gómez",
		"Colonia Juan B Cabral",
		"Colonia Juan Pujol",
		"Colonia La Carmen",
		"Colonia La Habana",
		"Colonia La Unión",
		"Colonia Libertad",
		"Colonia Liebig S",
		"Colonia Liebigs",
		"Colonia Llano",
		"Colonia Lucero",
		"Colonia Lujan",
		"Colonia M Aberastury",
		"Colonia Madariaga",
		"Colonia María Esther",
		"Colonia Matilde",
		"Colonia Méndez Bar",
		"Colonia Mercedes Cossio",
		"Colonia Mota",
		"Colonia Nueva Valencia",
		"Colonia Pairiri",
		"Colonia Pando",
		"Colonia Porvenir",
		"Colonia Progreso",
		"Colonia Pucheta",
		"Colonia Rolon Cossio",
		"Colonia Romero",
		"Colonia San Antonio",
		"Colonia San Eugenio",
		"Colonia San José",
		"Colonia San Martín",
		"Colonia San Mateo",
		"Colonia Santa Rosa",
		"Colonia Sauce",
		"Colonia Tacuaralito",
		"Colonia Tatacua",
		"Colonia Urdaniz",
		"Colonia Vedoya",
		"Concepción",
		"Corona",
		"Coronel Abraham Schweizer",
		"Coronel Desiderio Sosa",
		"Corrientes",
		"Corsa Cue",
		"Costa",
		"Costa Arroyo Garay",
		"Costa Batel",
		"Costa Cenisal",
		"Costa De Arroyo San Lorenzo",
		"Costa De Empedrado",
		"Costa Del Batel",
		"Costa Grande",
		"Costa Guaviravi",
		"Costa Guazu",
		"Costa Río Paraná",
		"Costa San Lorenzo",
		"Costa Santa Lucia",
		"Costa Toledo",
		"Costas",
		"Crucecitas",
		"Crucecitas Santa Lucia",
		"Cruz De Los Milagros",
		"Cuarta Seccion Lomas",
		"Cuatro Bocas",
		"Cuay Chico",
		"Cuay Grande",
		"Cuña Suegra",
		"Curtiembre",
		"Curupayti",
		"Curuzu",
		"Curuzu Cuatia",
		"Curuzu Laurel",
		"Desaguadero",
		"Desmochado",
		"Doctor Felix María Gómez",
		"Don Máximo",
		"Dos Hermanas",
		"Dos Hermanos",
		"Dos Ombues",
		"El Buen Retiro",
		"El Carmen",
		"El Carrizal",
		"El Ceibo",
		"El Centinela",
		"El Cerrito",
		"El Cerro",
		"El Chircal",
		"El Coquito",
		"El Loto",
		"El Ñandubay",
		"El Pago",
		"El Palmar",
		"El Paraíso",
		"El Parque",
		"El Pelón",
		"El Pilar",
		"El Plata",
		"El Pollo",
		"El Pontón",
		"El Porvenir",
		"El Porvenir Colonia Libertad",
		"El Progreso",
		"El Remanso",
		"El Rosario",
		"El Salvador",
		"El Socorro",
		"El Sombrero",
		"El Tatare",
		"El Tesoro",
		"El Tigre",
		"El Toro Pi",
		"El Transito",
		"El Vasco",
		"El Yapu",
		"El Yuqueri",
		"Emilio R Coni",
		"Empedrado",
		"Empedrado Limpio",
		"Ensenada Grande",
		"Ensenadita",
		"Esfadal",
		"Esperanza",
		"Espinillar",
		"Espinillo",
		"Esquina",
		"Esquivel Cue",
		"Est Solari",
		"Establecimiento La Merced",
		"Estación Agronómica",
		"Estación Libertad",
		"Estación Saladas",
		"Estancia Aguaceros",
		"Estancia Buena Vista",
		"Estancia Cafferatta",
		"Estancia Casurina",
		"Estancia Cerro Verde",
		"Estancia Del Medio",
		"Estancia Durruti",
		"Estancia El Carmen",
		"Estancia El Chañar",
		"Estancia El Ombu",
		"Estancia El Porvenir",
		"Estancia González Cruz",
		"Estancia Ita Caabo",
		"Estancia La Arboleda",
		"Estancia La Calera",
		"Estancia La Carmencha",
		"Estancia La Carolina",
		"Estancia La Loma",
		"Estancia La Loma Alta",
		"Estancia La María",
		"Estancia Laguna Limpia",
		"Estancia Las Magnolias",
		"Estancia Las Magñolas",
		"Estancia Las Salinas",
		"Estancia Las Tunas",
		"Estancia Lomatora",
		"Estancia Los Milagros",
		"Estancia Los Paraísos",
		"Estancia Mandure",
		"Estancia Marquez Lui",
		"Estancia Mbota",
		"Estancia Pozo Cuadrado",
		"Estancia Rincón Grande",
		"Estancia Rosario",
		"Estancia San Antonio",
		"Estancia San Javier",
		"Estancia San Juan",
		"Estancia San Julio",
		"Estancia San Mateo",
		"Estancia San Miguel",
		"Estancia San Roberto",
		"Estancia San Solano",
		"Estancia Santa Cruz",
		"Estancia Santa María",
		"Estancia Soledad",
		"Estancia Tunas",
		"Este Argentino",
		"Estero Grande",
		"Estero Piru",
		"Estero Sauce",
		"Estero Yatay",
		"Estingana",
		"Estrella",
		"Fanegas",
		"Felipe Yofre",
		"Fernández",
		"Ferret",
		"Ferro",
		"Florida",
		"Francisco Gauna",
		"Frontera",
		"Galarza Cue",
		"Garabata",
		"Garcitas",
		"Garrido",
		"Garrido Cue",
		"Garruchos",
		"Gdor Ing Valentín Viraso",
		"Gdor Juan Eusebio Torren",
		"General Paz",
		"Gobernador Juan E Martínez",
		"Gobernador Ruiz",
		"Gobernador Virasoro",
		"Gómez Cue",
		"Goya",
		"Granja Amelia",
		"Guaviravi",
		"Guay Grande",
		"Guaycuru",
		"Guayquiraro",
		"Guayu",
		"Guazu Cora",
		"Herlitzka",
		"Ibahay",
		"Ibaviyu",
		"Ibera",
		"Ibira Pita",
		"Ibiray",
		"Ibiritangay",
		"Ifran",
		"Iguate Pora",
		"Independencia",
		"Infante",
		"Inga",
		"Ingenio Primer Correntino",
		"Invernada",
		"Ipacarapa",
		"Isabel Victoria",
		"Isla Alta",
		"Isla Apipe Chico",
		"Isla Grande",
		"Isla Ibatay",
		"Isla Ibate",
		"Isla San Mateo",
		"Isla Sola",
		"Isla Tacuara",
		"Isoqui",
		"Ita Cora",
		"Ita Cua",
		"Ita Curubi",
		"Ita Ibate",
		"Ita Paso",
		"Ita Pucu",
		"Itati",
		"Itati Rincón",
		"Ituzaingo",
		"Jardín Florido",
		"Jesús María",
		"Jose Rafael Gomez Garabi",
		"Juan Diaz",
		"Juan Pujol",
		"Juan Ramón Vidal",
		"Justino Solari",
		"Kilometro 104",
		"Kilometro 120",
		"Kilometro 13",
		"Kilometro 134",
		"Kilometro 148",
		"Kilometro 151",
		"Kilometro 161",
		"Kilometro 167",
		"Kilometro 173",
		"Kilometro 182",
		"Kilometro 204",
		"Kilometro 235",
		"Kilometro 261",
		"Kilometro 268",
		"Kilometro 287 Fcgu",
		"Kilometro 296",
		"Kilometro 31",
		"Kilometro 374",
		"Kilometro 382",
		"Kilometro 387",
		"Kilometro 393",
		"Kilometro 394",
		"Kilometro 396",
		"Kilometro 402",
		"Kilometro 405",
		"Kilometro 406",
		"Kilometro 410",
		"Kilometro 416",
		"Kilometro 42",
		"Kilometro 431",
		"Kilometro 442",
		"Kilometro 451",
		"Kilometro 459",
		"Kilometro 462",
		"Kilometro 470",
		"Kilometro 475",
		"Kilometro 476",
		"Kilometro 479",
		"Kilometro 485",
		"Kilometro 489",
		"Kilometro 49",
		"Kilometro 492",
		"Kilometro 494",
		"Kilometro 501",
		"Kilometro 504",
		"Kilometro 506",
		"Kilometro 512",
		"Kilometro 516",
		"Kilometro 517",
		"Kilometro 55",
		"Kilometro 57",
		"Kilometro 61",
		"Kilometro 76",
		"Kilometro 84",
		"Kilometro 89",
		"Kilometro 95",
		"Km 425",
		"La Agripina",
		"La Amelia",
		"La Amistad",
		"La Angela",
		"La Angelita",
		"La Armonía",
		"La Aurora",
		"La Belermina",
		"La Blanca",
		"La Blanqueada",
		"La Bolsa",
		"La Cañada",
		"La Carlina",
		"La Carlota",
		"La Casualidad",
		"La Cautiva",
		"La Celeste",
		"La Celia",
		"La Celina",
		"La Chiquita",
		"La Colorada",
		"La Concepción",
		"La Constancia",
		"La Criolla",
		"La Cruz",
		"La Delicia",
		"La Diana",
		"La Elena",
		"La Eloisa",
		"La Elsa",
		"La Elva",
		"La Elvira",
		"La Emilia",
		"La Estrella",
		"La Fe",
		"La Flecha",
		"La Flor",
		"La Florencia",
		"La Florentina",
		"La Floresta",
		"La Florida",
		"La Fortuna",
		"La Garcia",
		"La Haydee",
		"La Herminia",
		"La Hileorica",
		"La Isabel",
		"La Jaula",
		"La Leonor",
		"La Leontina",
		"La Lolita",
		"La Loma",
		"La Loma Torrent",
		"La Luisa",
		"La Magnolia",
		"La Mansion",
		"La Matilde",
		"La Morocha",
		"La Nena",
		"La Pachina",
		"La Palma",
		"La Palmera",
		"La Palmira",
		"La Parada",
		"La Pastoril",
		"La Pepita",
		"La Porteña",
		"La Pupi",
		"La Pupii",
		"La Querencia",
		"La Unión",
		"La Venta",
		"La Verde",
		"Labory",
		"Lago Arias",
		"Laguna Alfonso",
		"Laguna Avalos",
		"Laguna Brava",
		"Laguna Paiva",
		"Laguna Pucu",
		"Laguna Sirena",
		"Laguna Soto",
		"Lapacho",
		"Las Animas",
		"Las Cuchillas",
		"Las Delicias",
		"Las Elinas",
		"Las Garzas",
		"Las Lagunas",
		"Las Lomas",
		"Las Matreras",
		"Las Mercedes",
		"Las Palmas",
		"Las Palmiras",
		"Las Palmitas",
		"Las Ratas",
		"Las Rosas",
		"Las Taperas",
		"Las Tres Hermanas",
		"Las Violetas",
		"Laurel",
		"Lauretti",
		"Lavalle",
		"León Cua",
		"Libertad",
		"Libertador",
		"Limas Cue",
		"Linda Vista",
		"Lobory",
		"Loma Alta",
		"Loma Negra",
		"Loma Poy",
		"Loma Villanueva",
		"Lomas",
		"Lomas De Aguirre",
		"Lomas De Empedrado",
		"Lomas De Galarza",
		"Lomas De González",
		"Lomas De Vallejos",
		"Lomas De Vergara",
		"Lomas Esquivel",
		"Lomas Este",
		"Lomas Floridas",
		"Lomas Ramírez",
		"Lomas Redondas",
		"Lomas Saladas",
		"Lomas San Cayetano",
		"Lomas San Juan",
		"Lomas Vázquez",
		"Loreto",
		"Los Algarrobos",
		"Los Angeles",
		"Los Angeles Del Batel",
		"Los Arboles",
		"Los Bretes",
		"Los Ceibos",
		"Los Eucaliptos",
		"Los Flotadores",
		"Los Gemelos",
		"Los Laureles",
		"Los Lirios",
		"Los Manantiales",
		"Los Medios",
		"Los Paraísos",
		"Los Pinos",
		"Los Sauces",
		"Los Tres Amigos",
		"Los Tres Cerros",
		"Los Tres Hermanos",
		"Los Vences",
		"Luis Gómez",
		"Lujambio",
		"Lujan",
		"Macedo",
		"Madariaga",
		"Malezal",
		"Maloya",
		"Maloyita",
		"Malvinas",
		"Malvinas Centro",
		"Malvinas Norte",
		"Malvinas Sur",
		"Manantiales",
		"Manchita",
		"Mandinga",
		"Mansión De Invierno",
		"Manuel Derqui",
		"Manuel Florencio Mantilla",
		"María",
		"María Del Carmen",
		"María Idalina",
		"Mariano I Losas Est Solar",
		"Mariano I Loza Est Solari",
		"Martín",
		"Martín García",
		"Martínez Cue",
		"Maruchas",
		"Maruchitas",
		"Masdeu Escuela 197",
		"Matadero Santa Catalina",
		"Matilde",
		"Matrera",
		"Mbalguiapu",
		"Mbarigui",
		"Mboi Cua",
		"Mburucuya",
		"Mediodía",
		"Mercedes",
		"Minuanes",
		"Mira Flores",
		"Mirador",
		"Mirunga",
		"Mocoreta",
		"Mojón",
		"Montaña",
		"Monte Caseros",
		"Monte Florido",
		"Monte Grande",
		"Montevideo",
		"Mora",
		"Morica",
		"Mota",
		"Mota Piedritas",
		"Muchas Islas",
		"Naranjaty",
		"Naranjito",
		"Naranjito San Roque",
		"Nina",
		"Ntra Sra Del Ros De Caa Cati",
		"Ntra Sra Del Rosario De Caa Cati",
		"Nueva Esperanza",
		"Nueva Granada",
		"Nueva Palmira",
		"Nuevo Paraíso",
		"Nuevo Porvenir",
		"Ñaembe",
		"Ñatiu",
		"Ñuruguay",
		"Obraje Cue",
		"Obraje Del Vasco",
		"Ocanto Cue",
		"Ojo De Agua",
		"Ombu",
		"Ombu Lomas",
		"Ombu Solo",
		"Ombucito",
		"Oratorio",
		"Oscuro",
		"Pago Alegre",
		"Pago Arias",
		"Pago De Los Deseos",
		"Pago Largo",
		"Pago Poi",
		"Pago Redondo",
		"Paimbre",
		"Palma Sola",
		"Palmar",
		"Palmar Arerungua",
		"Palmar Grande",
		"Palmera",
		"Palmira",
		"Palmita",
		"Palmitas",
		"Pampin",
		"Pancho Cue",
		"Parada Labougle",
		"Parada Pucheta",
		"Paraíso",
		"Paraje Augua",
		"Paraje Barranquitas",
		"Paraje El Carmen",
		"Paraje Florida",
		"Paraje Iribu Cua",
		"Paraje Portillo",
		"Paraje Poton",
		"Paraje San Isidro",
		"Parque San Martín",
		"Pasaje Santa Juana",
		"Pasito",
		"Paso Aguirre",
		"Paso Algarrobo",
		"Paso Ancho",
		"Paso Bandera",
		"Paso Bermúdez",
		"Paso Cejas",
		"Paso Chañaral",
		"Paso Concepción",
		"Paso Coronel",
		"Paso De La Patria",
		"Paso De Las Piedras",
		"Paso De Los Libres",
		"Paso De Mula",
		"Paso Esterito",
		"Paso Florentin",
		"Paso Gallego",
		"Paso Iribu Cua",
		"Paso Ledesma",
		"Paso López",
		"Paso Los Angeles",
		"Paso Lovera",
		"Paso Lucero",
		"Paso Martinez",
		"Paso Mesa",
		"Paso Naranjito",
		"Paso Pesoa",
		"Paso Potrero",
		"Paso Pucheta",
		"Paso Rosario",
		"Paso Rubio",
		"Paso Saldaña",
		"Paso San Juan",
		"Paso Santa Rosa",
		"Paso Tala",
		"Paso Tirante",
		"Paso Vallejos",
		"Pastores",
		"Pay Ubre Chico",
		"Pedro Díaz Colodrero",
		"Pedro R Fernández",
		"Pehuaho",
		"Perugorria",
		"Piedra Ita Pucu",
		"Piedrita",
		"Piedritas",
		"Pilincho",
		"Pindo",
		"Pindoncito",
		"Piracu",
		"Pirayu",
		"Pirra Puy",
		"Playadito",
		"Porvenir",
		"Potrero Grande",
		"Progreso",
		"Pueblito",
		"Pueblito Espinosa",
		"Pueblito San Juan",
		"Pueblo De Julio",
		"Puente Avalos",
		"Puente Batel",
		"Puente Machuca",
		"Puerta Ifran",
		"Puerto Araza",
		"Puerto González",
		"Puerto Goya",
		"Puerto Hormiguero",
		"Puerto Juan De Dios",
		"Puerto Las Lajas",
		"Puerto Las Tacuaritas",
		"Puerto Naranjito",
		"Puerto Piedra",
		"Puerto Ubajay",
		"Puerto Valle",
		"Puesto De Isla",
		"Puesto Lata",
		"Puisoye",
		"Pujol Bedoya",
		"Punta Grande",
		"Punta Ifran",
		"Punta Mercedes",
		"Puntas De Francisco Gómez",
		"Puntas Del Tigre",
		"Quinta Sección Ombucito",
		"Quinta Teresa",
		"Quiyati",
		"Raíces",
		"Ralera Sud",
		"Ramada Paso",
		"Ramones",
		"Ranegas",
		"Real Cue",
		"Recreo",
		"Reducción",
		"Remanso",
		"Riachuelito",
		"Riachuelo",
		"Riachuelo Bardeci",
		"Riachuelo Sud",
		"Rincón",
		"Rincón Chico",
		"Rincón De Ambrosio",
		"Rincón De Animas",
		"Rincón De Gómez",
		"Rincón De Las Mercedes",
		"Rincón De Mercedes",
		"Rincón De Pago",
		"Rincón De San Lorenzo",
		"Rincón De Sarandy",
		"Rincón De Soto",
		"Rincón De Tunas",
		"Rincón De Vences",
		"Rincón De Yaguary",
		"Rincón Del Rosario",
		"Rincón Del Sombrero",
		"Rincón Del Tigre",
		"Rincón Itaembe",
		"Rincón Mercedes Estancia",
		"Rincon Quiroz",
		"Rincón San Pedro",
		"Rincón Tranquera General",
		"Rincón Zalazar",
		"Rodeito",
		"Rolon Jacinto",
		"Romero",
		"Romero Cuazu",
		"Rosadito",
		"Rosado Grande",
		"Ruiz Cue",
		"Saenz Valiente",
		"Saladas",
		"Saladero San Antonio",
		"Saldana",
		"Saldana 9 De Julio",
		"Salinas",
		"Salinas Gandes",
		"Salto Ita Jhase",
		"San Agustín",
		"San Alejo",
		"San Alonso",
		"San Andrés",
		"San Antonio",
		"San Antonio Del Caimán",
		"San Borjita",
		"San Carlos",
		"San Cayetano",
		"San Celestino",
		"San Cosme",
		"San Diego",
		"San Dionisio",
		"San Eduardo",
		"San Emilio",
		"San Eugenio",
		"San Felipe",
		"San Fermín",
		"San Fernando",
		"San Francisco",
		"San Francisco Cue",
		"San Francisco Guavirari",
		"San Gabriel",
		"San Gregorio",
		"San Guillermo",
		"San Gustavo",
		"San Ignacio",
		"San Isidro",
		"San Jacinto",
		"San Javier",
		"San Jerónimo",
		"San Joaquín",
		"San José",
		"San José Caacati",
		"San José Est Libertad Dp",
		"San Juan",
		"San Julián",
		"San Justo",
		"San Lorenzo",
		"San Luis",
		"San Luis Cue",
		"San Luis Del Palmar",
		"San Luis Est Libertad Dp",
		"San Manuel",
		"San Marcos",
		"San Martín",
		"San Miguel",
		"San Miguel Estación Libertad",
		"San Nicanor",
		"San Nicolás",
		"San Paladio",
		"San Pedro",
		"San Rafael",
		"San Roque",
		"San Roquito",
		"San Salvador",
		"San Sebastián",
		"San Vicente",
		"Sangara",
		"Santa Ana",
		"Santa Catalina",
		"Santa Cecilia",
		"Santa Elisa",
		"Santa Emilia",
		"Santa Irene",
		"Santa Isabel",
		"Santa Juana",
		"Santa Lea",
		"Santa Librada",
		"Santa Lucia",
		"Santa Lucia 9 De Julio",
		"Santa Magdalena",
		"Santa María",
		"Santa Marta",
		"Santa Rita",
		"Santa Rita Parada Pucheta",
		"Santa Rosa",
		"Santa Sinforosa",
		"Santa Tecla",
		"Santa Teresa",
		"Santiago Alcorta",
		"Santillan",
		"Santo Domingo",
		"Santo Tomas",
		"Santo Tome",
		"Santos Lugares",
		"Sarandi",
		"Sauce",
		"Saucesito",
		"Sección Primera San Juan",
		"Seriano Cue",
		"Siete Arboles",
		"Silvero Cue",
		"Socorro",
		"Solari Mariano I Loza",
		"Soledad",
		"Sombrero",
		"Sosa",
		"Sosa Cue",
		"Soto",
		"Tabay",
		"Tablada",
		"Tacuabe",
		"Tacuaracarendy",
		"Tacuaral",
		"Tacuarembo",
		"Tacuaritas",
		"Tacural",
		"Tacural Mercedes",
		"Tajibo",
		"Tala Cora",
		"Tala Paso",
		"Talaty",
		"Talita Cue",
		"Talleres",
		"Tambo Nuevo",
		"Tape Rati",
		"Tapebicua",
		"Tarangullo",
		"Tareiri",
		"Tartaguito",
		"Tartaria",
		"Tatacua",
		"Tatare",
		"Teblenari",
		"Tierra Colorada",
		"Tilita",
		"Timbo",
		"Timbo Cora",
		"Timbo Paso",
		"Timboy",
		"Tingui",
		"Tiquino",
		"Tolatu",
		"Topador",
		"Toro Chipay",
		"Toro I",
		"Toro Pichay",
		"Toros Cora",
		"Torrent",
		"Tres Arboles",
		"Tres Bocas",
		"Tres Capones",
		"Tres Cerros",
		"Tres Cruces",
		"Tres Hermanas",
		"Tres Hojas",
		"Tres Taperas",
		"Trípoli",
		"Tristán Chico",
		"Tunitas",
		"Tuyuti",
		"Uguay",
		"Ulajay",
		"Uriburu",
		"Uruguay",
		"Vaca Cua",
		"Vaca Paso",
		"Valencia",
		"Vecindad",
		"Vedoya",
		"Veloso",
		"Vergara",
		"Vergara Lomas",
		"Veron Cue",
		"Villa Aquino",
		"Villa Córdoba",
		"Villa Cristia",
		"Villa Cue",
		"Villa El Dorado",
		"Villa Juan De Vera",
		"Villa La Florida",
		"Villa Lujan",
		"Villa Olivari",
		"Villa Ortiz",
		"Villa P Argentina",
		"Villa Rollet",
		"Villa Rolon",
		"Villa San Isidro",
		"Villa San Juan",
		"Villa San Ramón",
		"Villa Solari",
		"Villa Soto",
		"Villa Tesaro",
		"Villaga Cue",
		"Virgen María",
		"Vizcaino",
		"Vuelta Del Ombu",
		"Yacaré",
		"Yacarey",
		"Yagua Rincón",
		"Yagua Rocau",
		"Yaguaru",
		"Yaguary",
		"Yahape",
		"Yapeyu",
		"Yapuca",
		"Yataiti Sata",
		"Yataity Calle",
		"Yataity Poi",
		"Yatay",
		"Yatay Cora",
		"Yatayti Calle",
		"Yatayti Poi",
		"Yatayti Sata",
		"Yazuca",
		"Yta Paso",
		"Yuqueri",
		"Yurucua",
		"Zapallar",
		"Zapallos"
	],
	"Entre Ríos": [
		"1 De Mayo",
		"20 De Septiembre",
		"Achiras",
		"Aero Club Canal",
		"Alarcon",
		"Albardon",
		"Albariño",
		"Alberto Gerchunoff",
		"Alcaracito",
		"Alcaraz  2do",
		"Alcaraz 1ro",
		"Alcaraz 2do",
		"Alcaraz Norte",
		"Alcaraz Pueblo Arrúa",
		"Alcaraz Sud",
		"Álcete",
		"Aldea Asunción",
		"Aldea Brasilera",
		"Aldea Chaleco",
		"Aldea Cuesta",
		"Aldea Eigenfeld",
		"Aldea María Luisa",
		"Aldea Merou",
		"Aldea Protestante",
		"Aldea Salto",
		"Aldea San Antonio",
		"Aldea San Francisco",
		"Aldea San Gregorio",
		"Aldea San Jorge",
		"Aldea San José",
		"Aldea San Juan",
		"Aldea San Miguel",
		"Aldea San Rafael",
		"Aldea Santa Celia",
		"Aldea Santa María",
		"Aldea Santa Rosa",
		"Aldea Santafecina",
		"Aldea Spatzenkutter",
		"Aldea Valle María",
		"Algarrobito 1ro",
		"Algarrobitos 1ro",
		"Almacén Cristian Schubert",
		"Almirante Iglesias",
		"Altamirano Norte",
		"Altamirano Sud",
		"Anahi",
		"Antelo",
		"Antonio Tomas",
		"Antonio Tomas Sud",
		"Aranguren",
		"Arroyo Baltazar",
		"Arroyo Baltazar Chico",
		"Arroyo Baru",
		"Arroyo Bicho Feo",
		"Arroyo Boca Falsa",
		"Arroyo Brasilero",
		"Arroyo Bravo Gutiérrez",
		"Arroyo Brazo Chico",
		"Arroyo Brazo De La Tinta",
		"Arroyo Buen Pastor",
		"Arroyo Burgos",
		"Arroyo Caballo",
		"Arroyo Caraballo",
		"Arroyo Carbón",
		"Arroyo Carboncito",
		"Arroyo Carpincho",
		"Arroyo Ceibito",
		"Arroyo Ceibo",
		"Arroyo Cle",
		"Arroyo Cle Desvío",
		"Arroyo Concepción",
		"Arroyo Corralito",
		"Arroyo Correntoso",
		"Arroyo Cucharas",
		"Arroyo Cuzco",
		"Arroyo De La Rosa",
		"Arroyo Del Cura",
		"Arroyo Del Medio",
		"Arroyo Desaguadero Del Gutierr",
		"Arroyo Desaguadero Del Sauce",
		"Arroyo El Mocho",
		"Arroyo Garcete",
		"Arroyo Grande",
		"Arroyo Gutiérrez Chico",
		"Arroyo Hondo",
		"Arroyo Ibicuycito",
		"Arroyo Jacinto",
		"Arroyo La Paciencia",
		"Arroyo La Tinta",
		"Arroyo La Virgen",
		"Arroyo Lara",
		"Arroyo Las Animas",
		"Arroyo Las Tunas",
		"Arroyo Llorones",
		"Arroyo Los Platos",
		"Arroyo Malambo",
		"Arroyo Manzano",
		"Arroyo María",
		"Arroyo Martínez",
		"Arroyo Maturrango",
		"Arroyo Merlo",
		"Arroyo Molino",
		"Arroyo Moreira",
		"Arroyo Mosquito",
		"Arroyo Negro",
		"Arroyo Obispo",
		"Arroyo Paciencia Chico",
		"Arroyo Paciencia Grande",
		"Arroyo Palmar",
		"Arroyo Palo Seco",
		"Arroyo Pancho",
		"Arroyo Pelado",
		"Arroyo Perdido Ceibo",
		"Arroyo Perdido Mosquito",
		"Arroyo Pereyra",
		"Arroyo Piedras",
		"Arroyo Pito",
		"Arroyo Platitos",
		"Arroyo Principal",
		"Arroyo Qancay",
		"Arroyo Sagastume Chico",
		"Arroyo Sagastume Grande",
		"Arroyo Salado",
		"Arroyo Sánchez Chico",
		"Arroyo Sánchez Grande",
		"Arroyo Santos Chico",
		"Arroyo Santos Grande",
		"Arroyo Tiroles",
		"Arroyo Urquiza",
		"Arroyo Venerato",
		"Arroyo Zapallo",
		"Atencio",
		"Avenida Ejercito Paraná",
		"Ayui Parada",
		"Bajada Grande",
		"Balneario Pelay",
		"Banderas",
		"Bañadero Oficial Burgos",
		"Bañadero Oficial Las Galarzas",
		"Barón Hirsch",
		"Barrancas Coloradas",
		"Basavilbaso",
		"Belez",
		"Bella Unión Paraje",
		"Benitez",
		"Benito Legeren",
		"Berduc",
		"Berisso",
		"Berisso Desvío Fcgu",
		"Betbeder",
		"Bizcocho",
		"Boca Del Tigre",
		"Boca Del Tigre Apeadero Fcgu",
		"Boca Gualeguay",
		"Bonaldi",
		"Bovril",
		"Bovril Dto Nro 12",
		"Brazo Largo",
		"Britos",
		"Buena Vista Paraje",
		"Cabi Monda",
		"Calabacillas",
		"Calandria",
		"Calera",
		"Camba Paso",
		"Camino A Diamante Km 1",
		"Campo De Villamil",
		"Campo Domínguez",
		"Campo Escales",
		"Campo Moreno",
		"Campo Riquelme",
		"Camps",
		"Canal Nuevo",
		"Canal Principal",
		"Canal San Martín",
		"Cantera La Constancia",
		"Cañada De Las Ovejas",
		"Cañada Del Cerro",
		"Cañada Grande",
		"Caraguata",
		"Carpinchoris",
		"Carrizal",
		"Caseros",
		"Catalotti",
		"Ceibal",
		"Ceibas",
		"Centella",
		"Centenario La Paz",
		"Centenario Paraná",
		"Centro Comunitario Cnia Nue",
		"Cerrito",
		"Chacras",
		"Chajari",
		"Chañar",
		"Chañar Feliciano",
		"Chañar María Grande Primera",
		"Chaviyu Colonia Flores",
		"Chaviyu Parada Fcgu",
		"Chilcas",
		"Chilcas Sud",
		"Chiquero",
		"Chiqueros",
		"Chircalito",
		"Clara",
		"Clodomiro Ledesma",
		"Cnia Justo José De Urquiza",
		"Colegio Adventista Del Plata",
		"Colon",
		"Colonia 1 De Mayo",
		"Colonia 5 Ensanche De Mayo",
		"Colonia Achiras",
		"Colonia Adela",
		"Colonia Adivinos",
		"Colonia Alcarcito",
		"Colonia Alemana",
		"Colonia Algarrabitos",
		"Colonia Ambis",
		"Colonia Angela",
		"Colonia Argentina",
		"Colonia Arroyo Urquiza",
		"Colonia Avellaneda",
		"Colonia Avigdor",
		"Colonia Aylman",
		"Colonia Ayui",
		"Colonia Ayui Grande",
		"Colonia Bailina",
		"Colonia Barón Hirsch",
		"Colonia Baylina",
		"Colonia Belez",
		"Colonia Belga Americana",
		"Colonia Belgrano",
		"Colonia Berro",
		"Colonia Bertozzi",
		"Colonia Bizcocho",
		"Colonia Buena Vista",
		"Colonia Campos",
		"Colonia Caraballo",
		"Colonia Carlos Calvo",
		"Colonia Carmel",
		"Colonia Carmelo",
		"Colonia Carrasco",
		"Colonia Celina",
		"Colonia Centenario",
		"Colonia Crespo",
		"Colonia Crucesitas",
		"Colonia Cupalen",
		"Colonia Curbelo",
		"Colonia Delta",
		"Colonia Don Bosco",
		"Colonia Duportal",
		"Colonia Egido",
		"Colonia El Carmen",
		"Colonia El Potrero",
		"Colonia Elia",
		"Colonia Elisa",
		"Colonia Emilio Gouchon",
		"Colonia Ensanche Mayo",
		"Colonia Ensanche Sauce",
		"Colonia Ensayo",
		"Colonia Espindola",
		"Colonia F Sillen",
		"Colonia Falco",
		"Colonia Feimberg",
		"Colonia Flores",
		"Colonia Fontanini",
		"Colonia Frazer",
		"Colonia Freitas",
		"Colonia Gdor Basavilbaso",
		"Colonia General Roca",
		"Colonia Gral Urquiza",
		"Colonia Grapschental",
		"Colonia Gualeguaycito",
		"Colonia Guiburg",
		"Colonia Hebrea",
		"Colonia Hernandarias",
		"Colonia Higuera",
		"Colonia Hocker",
		"Colonia Hughes",
		"Colonia Ida",
		"Colonia Italiana",
		"Colonia Jorge Fink",
		"Colonia La Argentina",
		"Colonia La Armonía",
		"Colonia La Blanquita",
		"Colonia La Delia",
		"Colonia La Esperanza",
		"Colonia La Gama",
		"Colonia La Gloria",
		"Colonia La Llave",
		"Colonia La Marta",
		"Colonia La Matilde",
		"Colonia La Matilde Santa Ana",
		"Colonia La Mora",
		"Colonia La Morenita",
		"Colonia La Pampa",
		"Colonia La Paz",
		"Colonia La Providencia",
		"Colonia La Quinta",
		"Colonia La Rosada",
		"Colonia Lamarca",
		"Colonia Las Gamas",
		"Colonia Las Pepas",
		"Colonia Leven",
		"Colonia Loma Negra",
		"Colonia López",
		"Colonia Los Sauces",
		"Colonia Luca",
		"Colonia Lucienville",
		"Colonia Lucrecia",
		"Colonia Mabragaña",
		"Colonia María Luisa",
		"Colonia Maximo Castro",
		"Colonia Merou",
		"Colonia Miguel",
		"Colonia N 1",
		"Colonia N 2",
		"Colonia N 3",
		"Colonia N 4",
		"Colonia Navarro",
		"Colonia Nueva",
		"Colonia Nueva Al Sud",
		"Colonia Nueva Alemania",
		"Colonia Nueva Montevideo",
		"Colonia Nueva Norte",
		"Colonia Nueva San Miguel",
		"Colonia Nueva Sur",
		"Colonia Oficial N 1 La Flori",
		"Colonia Oficial N 1 La Florida",
		"Colonia Oficial N 11",
		"Colonia Oficial N 13",
		"Colonia Oficial N 14",
		"Colonia Oficial N 3",
		"Colonia Oficial N 4",
		"Colonia Oficial N 5",
		"Colonia Oficial N 6",
		"Colonia Oficial Nro 5",
		"Colonia Ougrie",
		"Colonia Palmar",
		"Colonia Pereira",
		"Colonia Perfección",
		"Colonia Perliza",
		"Colonia Reffino",
		"Colonia Rivadavia",
		"Colonia Rivas",
		"Colonia Saenz Valiente",
		"Colonia Sagastume",
		"Colonia San Antonio",
		"Colonia San Bonifacio",
		"Colonia San Cipriano",
		"Colonia San Ernesto",
		"Colonia San Francisco",
		"Colonia San Ignacio",
		"Colonia San Jorge",
		"Colonia San José",
		"Colonia San Juan",
		"Colonia San Lorenzo",
		"Colonia San Manuel",
		"Colonia San Martín",
		"Colonia San Miguel",
		"Colonia San Ramón",
		"Colonia Sandoval",
		"Colonia Santa Ana",
		"Colonia Santa Elena",
		"Colonia Santa Eloisa",
		"Colonia Santa Elvira",
		"Colonia Santa Juana",
		"Colonia Santa Luisa",
		"Colonia Santa Rosa",
		"Colonia Santa Teresita",
		"Colonia Sauce",
		"Colonia Sonenfeld",
		"Colonia Stauwer",
		"Colonia Tres De Febrero",
		"Colonia Tunas",
		"Colonia Ubajay",
		"Colonia Vázquez",
		"Colonia Velez",
		"Colonia Villa Libertad",
		"Colonia Villaguaycito",
		"Colonia Viraro",
		"Colonia Yerua",
		"Concepción Del Uruguay",
		"Concordia",
		"Conscripto Bernardi",
		"Cooperativa Brazo Largo",
		"Cooperativa Gral San Martín",
		"Corrales",
		"Corrales Nuevos",
		"Correa",
		"Costa Del Nogoya",
		"Costa Del Payticu",
		"Costa Del Uruguay",
		"Costa Grande",
		"Costa Grande Doll",
		"Costa San Antonio",
		"Costa Uruguay Norte",
		"Costa Uruguay Sur",
		"Costas De San Antonio",
		"Crespo",
		"Crespo Norte",
		"Crucecitas 3a Sección",
		"Crucecitas 7a Sección",
		"Crucecitas 8a Sección",
		"Crucecitas Urquiza",
		"Crucesitas 3 Seccion",
		"Crucesitas 7 Seccion",
		"Crucesitas 8 Seccion",
		"Crucesitas Urquiza",
		"Cuarto Distrito",
		"Cuatro Bocas",
		"Cuatro Bocas Paraje",
		"Cuatro Manos",
		"Cuchilla",
		"Cuchilla Redonda",
		"Cueva Del Tigre",
		"Cupalen",
		"Curtiembre",
		"Curupi",
		"Curuzu Chali",
		"Desparramados",
		"Destacamento General Guemes",
		"Diamante",
		"Diego Lopez",
		"Dist Raices Al Norte",
		"Dist Raices Al Sud",
		"Distrito El Sauce",
		"Distrito Espinillo",
		"Distrito Tala",
		"Doctor Eugenio Muñoz",
		"Doctor García",
		"Don Cristóbal",
		"Don Cristobal 1 Seccion",
		"Don Cristobal 2 Seccion",
		"Don Cristóbal 2da Sección",
		"Don Gonzalo",
		"Don Roberto",
		"Dos Hermanas",
		"Durazno",
		"Eben Horoscha",
		"Echague",
		"Ejido Colón",
		"Ejido Diamante",
		"Ejido Sud",
		"El Avestruz",
		"El Brillante",
		"El Carmen",
		"El Chajá",
		"El Cimarrón",
		"El Colorado",
		"El Corcovado",
		"El Diecisiete",
		"El Duraznal",
		"El Embalsado",
		"El Empalme Paraje",
		"El Gato",
		"El Gaucho",
		"El Gramillal",
		"El Gramiyal",
		"El Gualeguay",
		"El Martillo",
		"El Nuevo Rincón",
		"El Pago Apeadero Fcgu",
		"El Palenque",
		"El Pingo",
		"El Potrero",
		"El Pueblito",
		"El Quebracho",
		"El Ramblón",
		"El Redomon",
		"El Refugio",
		"El Remance",
		"El Rosario",
		"El Sarandi",
		"El Sauce",
		"El Solar",
		"El Taller",
		"El Tropezón",
		"Embarcadero Ferrari",
		"Empalme Holt",
		"Empalme Neild",
		"Enrique Berduc",
		"Enrique Carbo",
		"Escriña",
		"Escuela Alberdi",
		"Espinillo",
		"Espinillo Norte",
		"Establecimiento El Carmen",
		"Establecimiento El Cimarrón",
		"Establecimiento El Tala",
		"Establecimiento La Calera",
		"Establecimiento La Esperanza",
		"Establecimiento Las Margaritas",
		"Establecimiento Los Monigotes",
		"Establecimiento Punta Alta",
		"Establecimiento San Eduardo",
		"Establecimiento San Eusebio",
		"Establecimiento San Francisco",
		"Establecimiento San Martín",
		"Estacas",
		"Estación Alcaraz",
		"Estación General Racedo",
		"Estacion Raices",
		"Estación Santa Ana",
		"Estación Sola",
		"Estación Urquiza",
		"Estación Uruguay",
		"Estación Yerua",
		"Estancia Bella Vista",
		"Estancia Cnia La Primavera",
		"Estancia Cnia Santa Elena",
		"Estancia Cnia Sta Teresa",
		"Estancia Colonia El Ombu",
		"Estancia Colonia El Toropi",
		"Estancia Colonia La Tapera",
		"Estancia Colonia Peribebuy",
		"Estancia Colonia San Pedro",
		"Estancia Colonia Santa Eloisa",
		"Estancia Colonia Santa Juana",
		"Estancia El Toropi",
		"Estancia Grande",
		"Estancia La Floresta",
		"Estancia La Gama",
		"Estancia Los Vascos",
		"Estancia Salinas",
		"Estancia San José",
		"Estancia San Juan",
		"Estaquitas",
		"Fabrica Colon",
		"Faustino M Parera",
		"Febre",
		"Federación",
		"Federal",
		"Fernández",
		"Floresta",
		"Florida",
		"Fortuna",
		"Frigorífico Yuqueri",
		"Fronteras",
		"Genacito",
		"General Almada",
		"General Alvear",
		"General Campos",
		"General Galarza",
		"General Racedo",
		"General Ramírez",
		"Geribebuy",
		"Gilbert",
		"Gobernador Echague",
		"Gobernador Febre",
		"Gobernador Macia",
		"Gobernador Mansilla",
		"Gobernador Sola",
		"Gobernador Urquiza",
		"González",
		"González Calderón",
		"Grupo Achiras",
		"Grupo Parrero",
		"Gualeguay",
		"Gualeguaychu",
		"Gualeguaycito",
		"Gualeyan",
		"Guardamonte",
		"Guayaquil",
		"Hambis",
		"Hasenkamp",
		"Hernandarias",
		"Hernandez",
		"Herrera",
		"Hervidero",
		"Hinojal",
		"Hipódromo",
		"Hojas Anchas",
		"Holt",
		"Ibicuy",
		"Ing Miguel Sajaroff",
		"Irazusta",
		"Irazusta Estación",
		"Isla Curuzu Chali",
		"Isla Del Charigue",
		"Isla Del Ibicuy",
		"Isla El Dorado",
		"Isla El Pillo",
		"Isla La Paz",
		"Isla Lynch",
		"Isla San José",
		"Islas Alcaraz",
		"Islas De Las Lechiguanas",
		"Isletas",
		"Isletas Norte",
		"Isthilart",
		"Jorge Fink",
		"Juan B Monti",
		"Juan Jorge",
		"Jubileo",
		"Kilmetro 165",
		"Kilometro 108",
		"Kilometro 11",
		"Kilometro 112",
		"Kilometro 114",
		"Kilometro 115",
		"Kilometro 116",
		"Kilometro 131",
		"Kilometro 147",
		"Kilometro 148",
		"Kilometro 160",
		"Kilometro 180",
		"Kilometro 183",
		"Kilometro 189",
		"Kilometro 192",
		"Kilometro 200",
		"Kilometro 208",
		"Kilometro 220",
		"Kilometro 231",
		"Kilometro 24",
		"Kilometro 242",
		"Kilometro 244",
		"Kilometro 25",
		"Kilometro 253",
		"Kilometro 268",
		"Kilometro 270",
		"Kilometro 279",
		"Kilometro 28",
		"Kilometro 283",
		"Kilometro 284",
		"Kilometro 285",
		"Kilometro 288",
		"Kilometro 290",
		"Kilometro 293",
		"Kilometro 303",
		"Kilometro 305",
		"Kilometro 306",
		"Kilometro 310",
		"Kilometro 311",
		"Kilometro 32",
		"Kilometro 322",
		"Kilometro 324",
		"Kilometro 325",
		"Kilometro 329",
		"Kilometro 33",
		"Kilometro 333",
		"Kilometro 336",
		"Kilometro 337",
		"Kilometro 340",
		"Kilometro 342",
		"Kilometro 343",
		"Kilometro 344",
		"Kilometro 347",
		"Kilometro 353",
		"Kilometro 355",
		"Kilometro 361",
		"Kilometro 37",
		"Kilometro 373",
		"Kilometro 376",
		"Kilometro 389",
		"Kilometro 43",
		"Kilometro 44",
		"Kilometro 45",
		"Kilometro 47",
		"Kilometro 49",
		"Kilometro 50",
		"Kilometro 51",
		"Kilometro 56",
		"Kilometro 6",
		"Kilometro 84",
		"Kilometro 86",
		"Kilometro 88",
		"Kilometro 89",
		"Kilometro 99",
		"La Alicia",
		"La Amiguita",
		"La Argentina",
		"La Balsa",
		"La Balsa Paraná",
		"La Barraca",
		"La Blanqueada",
		"La Calera",
		"La Capilla",
		"La Carlota",
		"La Chica",
		"La Chilena Canal",
		"La Chilena Zanja",
		"La Clarita",
		"La Colina",
		"La Colmena",
		"La Colorada",
		"La Corvina",
		"La Costa",
		"La Criolla",
		"La Cuadra",
		"La Diligencia",
		"La Emilia",
		"La Encierra",
		"La Escondida",
		"La Esmeralda",
		"La Estrella",
		"La Favorita",
		"La Florencia",
		"La Florida",
		"La Fraternidad Y Santa Juana",
		"La Goya",
		"La Granja",
		"La Hierra",
		"La Ilusión",
		"La Invernada",
		"La Joya",
		"La Juliana",
		"La Lata",
		"La Llave",
		"La Loma",
		"La María Luisa",
		"La Maruja A",
		"La Nobleza",
		"La Odilia",
		"La Ollita",
		"La Pampa",
		"La Paz",
		"La Perla",
		"La Picada",
		"La Picada Norte",
		"La Querencia",
		"La Quinta",
		"La Rosada",
		"La S Diez Casas",
		"La Selva",
		"La Sesteada",
		"La Soledad",
		"La Suiza",
		"La Tigresa",
		"La Verbena",
		"La Virginia",
		"La Zelmira",
		"Laguna Benitez",
		"Laguna Del Pescado",
		"Laguna Larga",
		"Lamarca",
		"Lambare",
		"Larroque",
		"Las Achiras",
		"Las Bateas",
		"Las Catorce",
		"Las Colas",
		"Las Colonias",
		"Las Cuevas",
		"Las Garzas",
		"Las Gauchas",
		"Las Guachas",
		"Las Lagunas",
		"Las Masitas",
		"Las Mercedes",
		"Las Mochas",
		"Las Moscas",
		"Las Mulitas",
		"Las Pajitas",
		"Las Peñas",
		"Las Rosas",
		"Las Tejas",
		"Las Toscas",
		"Las Tunas",
		"Laurencena",
		"Lazo",
		"Lesca",
		"Libaros",
		"Libertador Gral San Martín",
		"Libertador San Martín",
		"Liebig",
		"Línea 19",
		"Línea 20",
		"Línea 24",
		"Línea 25",
		"Lionel",
		"Lobos Arroyo",
		"Loma Limpia",
		"Loma Negra",
		"Lomas Blancas",
		"Los Amigos",
		"Los Brillantes",
		"Los Burgos Apeadero Fcgu",
		"Los Ceibos",
		"Los Charrúas",
		"Los Conquistadores",
		"Los Gansos",
		"Los Naranjos",
		"Los Ombues",
		"Los Paraísos",
		"Los Sauer",
		"Lucas González",
		"Lucas Noreste",
		"Lucas Norte",
		"Lucas Sud",
		"Lucas Sur 1ra Seccion",
		"Lucas Sur 2da Seccion",
		"Lucienville 1",
		"Lucienville 2",
		"Lucienville 3",
		"Lucienville 4",
		"Mac Dougall",
		"Mac Keller",
		"Macia",
		"Manantiales",
		"Manatiales",
		"Mandisovi",
		"Mangrullo",
		"María Grande",
		"María Grande Primera",
		"Maria Grande Segunda",
		"María Grande Segunda Sur",
		"Martinetti",
		"Martiniano Leguizamon",
		"Mauricio Ribole",
		"Mazaruca",
		"Médanos",
		"Mesa",
		"Miguel J Perliza",
		"Mira Monte",
		"Mojones Norte",
		"Mojones Sud Primero",
		"Mojones Sur Primero",
		"Mojones Sur Segundo",
		"Molino Bob",
		"Molino Doll",
		"Monte Chico",
		"Monte Redondo",
		"Monte Verde",
		"Montiel",
		"Montoya",
		"Montoya Victoria",
		"Moreno",
		"Mulas Grandes",
		"Nicolás Herrera",
		"Nogoya",
		"Novibuco Primero",
		"Nueva Escocia",
		"Nueva Vizcaya",
		"Ñandubaysal",
		"Ombu",
		"Ombues",
		"Oro Verde",
		"Osvaldo Magnasco",
		"Paja Brava",
		"Pajas Blancas",
		"Pajonal",
		"Palacio San José",
		"Palavecino",
		"Palmar",
		"Palmar Yatay",
		"Palo A Pique",
		"Paracao",
		"Parada Yuqueri",
		"Paraje Guayabo",
		"Paraje Palaveroi",
		"Paraná",
		"Parana Bravo",
		"Paranacito",
		"Paranacito Río",
		"Parque Nacional El Palmar",
		"Pasaje Al Río Aguila",
		"Pasaje Talavera",
		"Paso De La Arena",
		"Paso De La Balza",
		"Paso De La Laguna",
		"Paso De La Legua",
		"Paso De Las Piedras",
		"Paso Del Abra",
		"Paso Del Cisnero",
		"Paso Del Gallo",
		"Paso Del Molino",
		"Paso Duarte",
		"Paso Garibaldi",
		"Paso Margariños",
		"Paso Medina",
		"Paso Potrillo",
		"Paso Puerto Augusto",
		"Paso Sociedad",
		"Paso Telégrafo",
		"Pastor Britos",
		"Pedermar",
		"Pedernal",
		"Pehuajo Norte",
		"Pehuajo Sud",
		"Perdices",
		"Perucho Verna",
		"Pesquería Diamantino",
		"Picada Beron",
		"Piedras Blancas",
		"Piloto Avila",
		"Pos Pos",
		"Presidente Avellaneda",
		"Primer Congreso",
		"Primer Cuartel",
		"Primer Distrito",
		"Pronunciamiento",
		"Pueblito",
		"Pueblito Norte",
		"Pueblo Arrua Est Alcaraz",
		"Pueblo Bellocq",
		"Pueblo Brugo",
		"Pueblo Cazes",
		"Pueblo Colorado",
		"Pueblo Domínguez",
		"Pueblo Ellison",
		"Pueblo Ferré",
		"Pueblo General Belgrano",
		"Pueblo General Paz",
		"Pueblo Liebig",
		"Pueblo Moreno",
		"Pueblo Nuevo",
		"Pueblo Primero",
		"Puente Carmona",
		"Puente De Gualeguaychu",
		"Puente De Las Pencas",
		"Puente De Lucas",
		"Puente Del Chañar",
		"Puente Del Doll",
		"Puente Ñancay",
		"Puente Obispo",
		"Puente Paranacito",
		"Puente Pellegrini",
		"Puente Victoria",
		"Puerta De Crespo",
		"Puerto Algarrobo",
		"Puerto Almiron",
		"Puerto Barriles",
		"Puerto Cadenas",
		"Puerto Campinchuelo",
		"Puerto Colorado",
		"Puerto Constanza",
		"Puerto Curtiembre",
		"Puerto Diamante",
		"Puerto Esquina",
		"Puerto Ibicuy",
		"Puerto La Esmeralda",
		"Puerto Las Cuevas",
		"Puerto López",
		"Puerto Marquez",
		"Puerto Perazzo",
		"Puerto Ruiz",
		"Puerto San Juan",
		"Puerto Unzue",
		"Puerto Víboras",
		"Puerto Viejo",
		"Puerto Villarruel",
		"Puerto Yerua",
		"Puerto Yunque",
		"Punta Del Monte",
		"Puntas De Moreira",
		"Puntas Del Gualeguaychu",
		"Puntas Del Palmar",
		"Quebrachito",
		"Quebrachitos",
		"Quebracho",
		"Quintas Al Sud",
		"Quinto Cuartel Victoria",
		"Quinto Distrito",
		"Racedo",
		"Rachel",
		"Raíces",
		"Raíces Al Este",
		"Raíces Al Norte",
		"Raíces Oeste",
		"Ramblón",
		"Ramírez",
		"Ramón A Parera",
		"Rincón De Cinto",
		"Rincón De Las Guachas",
		"Rincón De Mojones",
		"Rincón De Nogoya",
		"Rincon Del Cinto",
		"Rincón Del Doll",
		"Rincón Del Gato",
		"Rincón Del Nogoya Sur",
		"Rincón Lucas Norte",
		"Rincón Lucas Sud",
		"Río Aguila",
		"Río Alférez Nelson Page",
		"Río Ceibo",
		"Río Paraná Guazu",
		"Rio Pasaje Al Aguila",
		"Río Sauce",
		"Río Talavera",
		"Rivas",
		"Rocamora",
		"Rosario Del Tala",
		"Rospina",
		"Ruta 138 Kilometro 1",
		"Ruta 14 Km 443",
		"Sagastume",
		"Saladero Alzua",
		"Saladero Concordia",
		"Saladero San José",
		"San Anselmo",
		"San Antonio",
		"San Benito",
		"San Buenaventura",
		"San Cipriano",
		"San Francisco",
		"San Geronimo",
		"San Gregorio",
		"San Gustavo",
		"San Jaime",
		"San Jaime De La Frontera",
		"San Jorge",
		"San José",
		"San José De Feliciano",
		"San Juan",
		"San Juan La Querencia",
		"San Julián",
		"San Justo",
		"San Lorenzo",
		"San Luis San José Feliciano",
		"San Martín",
		"San Miguel",
		"San Miguel Nro 2",
		"San Pedro",
		"San Ramirez",
		"San Roque",
		"San Salvador",
		"San Vicente",
		"San Víctor",
		"Sanatorio Adventista Del Plata",
		"Sanatorio Apeadero Fcgu",
		"Santa Ana",
		"Santa Anita",
		"Santa Elena",
		"Santa Inés",
		"Santa Isabel",
		"Santa Juana",
		"Santa Lucia",
		"Santa Luisa",
		"Santa María",
		"Santa Marta",
		"Santa Rosa",
		"Santa Sara",
		"Sarandi",
		"Sarandi Cora",
		"Sarandi-Cora",
		"Sauce",
		"Sauce De Luna",
		"Sauce Montrull",
		"Sauce Norte",
		"Sauce Pinto",
		"Sauce Río",
		"Sauce Sud",
		"Sauce Sur",
		"Saxto Distrito Colon",
		"Sección Urquiza",
		"Seguí",
		"Segunda Sección Lucas Al Sud",
		"Segundo Cuartel",
		"Séptimo Distrito",
		"Sexto Distrito",
		"Sexto Distrito Colon",
		"Sir Leonard",
		"Sola",
		"Sosa",
		"Spindola",
		"Strobel",
		"Subcentral Santa María",
		"Surst",
		"Tablada Norte Concordia",
		"Tablada Oeste Concordia",
		"Tabossi",
		"Tacuaras Yacaré",
		"Talita",
		"Talitas",
		"Talitas Gualeguaychu",
		"Talitas-Gualeguaychu",
		"Tases",
		"Tatuti",
		"Tezanos Pinto",
		"Tiro Federal",
		"Tomas Rocamora",
		"Tres Aldeas",
		"Tres Bocas",
		"Tres Esquinas",
		"Tres Lagunas",
		"Tte Primero Brigio Cainzo",
		"Ubajay",
		"Urdinarrain",
		"Valle María",
		"Vergara",
		"Viale",
		"Víboras",
		"Victoria",
		"Villa Aída",
		"Villa Angélica",
		"Villa Antony",
		"Villa Boreilo",
		"Villa Clara",
		"Villa Del Cerro",
		"Villa Del Rosario",
		"Villa Domínguez",
		"Villa Eleonora",
		"Villa Elisa",
		"Villa Faustino M Parera",
		"Villa Fontana",
		"Villa Gob Luis Etchevehere",
		"Villa Hernandarias",
		"Villa Libertad",
		"Villa Libertador San Martín",
		"Villa Lila",
		"Villa Mantero",
		"Villa Paranacito",
		"Villa Perper",
		"Villa Porteña",
		"Villa Romero",
		"Villa San José",
		"Villa San Justo",
		"Villa San Marcial",
		"Villa San Miguel",
		"Villa Sarmiento",
		"Villa Tres De Febrero",
		"Villa Udine",
		"Villa Uranga",
		"Villa Urquiza",
		"Villa Zorraquin",
		"Villaguay",
		"Villaguay Este",
		"Villaguaycito",
		"Villamil",
		"Virano",
		"Vizcachera",
		"Walter Moss",
		"Yacaré",
		"Yaros",
		"Yatay",
		"Yerua",
		"Yeso",
		"Yeso Oeste",
		"Yuqueri",
		"Zenon Roca",
		"Zona Delta Del Parana"
	],
	Formosa: [
		"19 De Marzo",
		"9 De Julio",
		"Agente Argentino Alegre",
		"Agente Felipe Santiago Ibañez",
		"Agua Verde",
		"Aguas Negras",
		"Alfonsina Storni",
		"Alolague",
		"Alto Alegre",
		"Andrade Olegario Víctor",
		"Andrés Flores",
		"Angostura",
		"Apayerey",
		"Arbol Solo",
		"Ayudante Paredes",
		"Bahía Negra",
		"Bajo Hondo",
		"Bajo Verde",
		"Ballon",
		"Banco Payagua",
		"Bañaderos",
		"Barrio San Jose Obrero",
		"Barrio San Martín",
		"Barrio Sud América",
		"Bartolome De Las Casas",
		"Bella Vista",
		"Boca Del Riacho De Pilaga",
		"Bocarin",
		"Bolsa De Palomo",
		"Brigadier General Pueyrredon",
		"Bruchard",
		"Buen Lugar",
		"Buena Vista",
		"Caballo Muerto",
		"Cabo 1ro Casimiro Benitez",
		"Cabo Adriano Ayala",
		"Cabo Noroña",
		"Cabo Primero Chavez",
		"Campo Alegre",
		"Campo Azcurra",
		"Campo Del Cielo",
		"Campo El Suri",
		"Campo Goreta",
		"Campo Grande",
		"Campo Hardy",
		"Campo Oswald",
		"Campo Redondo",
		"Campo Rigonato",
		"Cañada Doce",
		"Cañada San Pedro",
		"Capilla San Antonio",
		"Capitán Juan Sola",
		"Carlos Pelegrini",
		"Carlos Saavedra Lamas",
		"Casco Cue",
		"Cataneo Cue",
		"Ceibo Trece",
		"Centro Fronterizo Clorinda",
		"Chagaday",
		"Chirochilas",
		"Churqui Cue",
		"Clorinda",
		"Cmte Principal Ismael St",
		"Cnel Miguel Martínez De Hoz",
		"Cnia Aborigen B Bartolomé D",
		"Cnia Aborigen Bme De Las Casas",
		"Colonia  Francisco J Muñiz",
		"Colonia 25 De Mayo",
		"Colonia 5 De Octubre",
		"Colonia 8 De Septiembre",
		"Colonia 8 De Setiembre",
		"Colonia Alfonso",
		"Colonia Alto Tigre",
		"Colonia Aquino",
		"Colonia Bouvier",
		"Colonia Buena Vista",
		"Colonia Campo Villafañe",
		"Colonia Cano",
		"Colonia Coronel Dorrego",
		"Colonia Dalmacia",
		"Colonia El Alba",
		"Colonia El Catorce",
		"Colonia El Olvido",
		"Colonia El Rincon",
		"Colonia El Silencio",
		"Colonia El Zapallito",
		"Colonia Francisco J Muñiz",
		"Colonia Guillermina",
		"Colonia Hardy",
		"Colonia Isla Alvarez",
		"Colonia Isla De Oro",
		"Colonia Isla Sola",
		"Colonia Jose M Paz",
		"Colonia Juan B Alberdi",
		"Colonia Juanita",
		"Colonia La Brava",
		"Colonia La Disciplina",
		"Colonia La Sociedad",
		"Colonia Los Tres Reyes",
		"Colonia Palmar Grande",
		"Colonia Pastoril",
		"Colonia Perin",
		"Colonia Puente Pucu",
		"Colonia Puente Uriburu",
		"Colonia Reconquista",
		"Colonia Sabina",
		"Colonia San Bernardo",
		"Colonia San Isidro",
		"Colonia San José",
		"Colonia San Pablo",
		"Colonia Santa Catalina",
		"Colonia Santa Rosa",
		"Colonia Santoro",
		"Colonia Siete Quebrados",
		"Colonia Tatane",
		"Colonia Unión Escuela",
		"Colonia Villa Rica",
		"Comandante Fontana",
		"Comisaria Pte Yrigoyen",
		"Coronel Argentino Larrabure",
		"Coronel Enrique Rostagno",
		"Coronel Felix Bogado",
		"Coronel José I Warnes",
		"Costa Del Lindo",
		"Costa Del Pilcomayo",
		"Costa Río Negro",
		"Costa Salado",
		"Curtiembre Cue",
		"Curupay",
		"Desvío Los Matacos",
		"Doctor Carlos Montag",
		"Doctor Gumersindo Sayago",
		"Doctor Luis Agote",
		"Domingo F Sarmiento",
		"Dr E Ramos Mejía  Chiriguanos",
		"El Acheral",
		"El Aibalito",
		"El Alambrado",
		"El Algarrobo",
		"El Angelito",
		"El Arbol Solo",
		"El Arbolito",
		"El Azotado",
		"El Bañadero",
		"El Bordo Santo",
		"El Bragado",
		"El Cañón",
		"El Cavado",
		"El Ceibal",
		"El Coatí",
		"El Cogoik",
		"El Colorado",
		"El Corralito",
		"El Corredero",
		"El Descanso",
		"El Desmonte",
		"El Espinillo",
		"El Gato",
		"El Guajho",
		"El Marcado",
		"El Mirador",
		"El Mistolar",
		"El Mojón",
		"El Ñandu",
		"El Oculto",
		"El Olvido",
		"El Ombu",
		"El Palmar",
		"El Palo Santo",
		"El Paraíso",
		"El Perdido",
		"El Pilón",
		"El Pimpin",
		"El Pindo",
		"El Poi",
		"El Pombero",
		"El Porteñito",
		"El Porteño",
		"El Potrerito",
		"El Potrillo",
		"El Qandu",
		"El Quebracho",
		"El Quebranto",
		"El Quemado",
		"El Recodo",
		"El Recreo",
		"El Remanso",
		"El Resguardo",
		"El Rosado",
		"El Salado",
		"El Sauce",
		"El Silencio",
		"El Simbolar",
		"El Sombrero Negro",
		"El Surr",
		"El Tacuruzal",
		"El Tastas",
		"El Totoral",
		"El Tucumancito",
		"El Yacaré",
		"El Yuchan",
		"El Yulo",
		"El Zorro",
		"Espinillo",
		"Esquinitas",
		"Estancia El Ciervo",
		"Estancia Las Horquetas",
		"Estanislao Del Campo",
		"Esterito",
		"Estero Grande",
		"Estero Patiño",
		"Ex Fortín Sola",
		"Ex Posta General Lavalle",
		"Florencio Sánchez",
		"Florentino Ameghino",
		"Formosa",
		"Fortín Cabo 1 Lugones",
		"Fortín Cabo 1ro Chaves",
		"Fortín Cabo 1ro Chavez",
		"Fortin Cabo 1ro Lugones",
		"Fortín Fontana",
		"Fortín Galpón",
		"Fortín Guemes",
		"Fortín La Soledad",
		"Fortín Media Luna",
		"Fortín Pilcomayo",
		"Fortín Sargento 1ro Leyes",
		"Francisco Narciso De Laprida",
		"Fray Mamerto Esquiu",
		"Frontera",
		"Gabriela Mistral",
		"Garcete Cue",
		"Gendarme Viviano Garcete",
		"General Francisco B Bosch",
		"General Julio De Vedia",
		"General Lucio Victorio Mansill",
		"General Manuel Belgrano",
		"General Mosconi",
		"General Pablo Ricchieri",
		"Gobernador Luna Olmos",
		"Gobernador Yalur",
		"Gral Ignacio H Fotheringham",
		"Gral Lucio V Mansilla",
		"Gran Guardia",
		"Guadalcazar",
		"Guaycolec",
		"Hermindo Bonas",
		"Herradura",
		"Hipolito Vieytes",
		"Hospital Rural",
		"Ibarreta",
		"Ing Guillermo N Juárez",
		"Ingeniero Enrique H Faure",
		"Isla 9 De Julio",
		"Isla Apando",
		"Isla Apango",
		"Isla Caraya",
		"Isla De Puen",
		"Isla Gral Belgrano",
		"Isla Oca",
		"Isla Payagua",
		"Isla Toldo",
		"Isleta",
		"Ituzaingo",
		"Joaquín V González",
		"José Cancio",
		"José Fernández",
		"Jose Hernandez",
		"José Manuel Estrada",
		"Juan G Bazan",
		"Juan José Paso",
		"Julio Cue",
		"Kilometro 100",
		"Kilometro 109",
		"Kilometro 128",
		"Kilometro 139",
		"Kilometro 142",
		"Kilometro 15",
		"Kilometro 1695",
		"Kilometro 1769",
		"Kilometro 1895",
		"Kilometro 193",
		"Kilometro 213",
		"Kilometro 224",
		"Kilometro 232",
		"Kilometro 254",
		"Kilometro 503",
		"Kilometro 525",
		"Kilometro 642",
		"Kilometro 642 Nav R Bermejo",
		"La Blanca",
		"La China",
		"La Colonia",
		"La Esperanza",
		"La Florencia",
		"La Florida",
		"La Frontera",
		"La Inmaculada",
		"La Junta",
		"La Libertad",
		"La Loma",
		"La Lucrecia",
		"La Manija",
		"La Media Luna",
		"La Nobleza",
		"La Palma Sola",
		"La Palmita",
		"La Paloma",
		"La Pasión",
		"La Picadita",
		"La Primavera",
		"La Represa",
		"La Sirena",
		"La Soledad",
		"La Urbana",
		"Laguna Blanca",
		"Laguna Gallo",
		"Laguna Inés",
		"Laguna Murua",
		"Laguna Naick Neck",
		"Laguna Yema",
		"Lamadrid",
		"Las Avispas",
		"Las Bolivianas",
		"Las Cañitas",
		"Las Choyas",
		"Las Delicias",
		"Las Lolas",
		"Las Lomitas",
		"Las Mochas",
		"Las Saladas",
		"Las Tres Marías",
		"Lazo Quemado",
		"Legua A",
		"Loma Clavel",
		"Loma Hermosa",
		"Loma Sene",
		"Loma Senes",
		"Loma Zapatu",
		"Loro Cue",
		"Los Baldes",
		"Los Chaguancos",
		"Los Chiriguanos",
		"Los Claveles",
		"Los Esteros",
		"Los Galpones",
		"Los Inmigrantes",
		"Los Nidos",
		"Los Pilagas",
		"Los Pocitos",
		"Los Suspiros",
		"Los Tres Reyes",
		"Lote 4",
		"Lote Nro 8",
		"Lucero Cue",
		"Maestra Blanca Gómez",
		"Maestro Fermín Báez",
		"Marca M",
		"María Cristina",
		"Mariano Boedo",
		"Matías Gulacsi",
		"Mayor Edmundo V Villafañe",
		"Mayor Marcelo T Rojas",
		"Mayor Vicente E Villafañe",
		"Media Luna",
		"Mercedes Cue",
		"Miguel Cane",
		"Misión El Carmen",
		"Mision El Quebracho",
		"Mision Evangelica Lag Yacare",
		"Misión Evangélica Laguna De Ya",
		"Misión Tacaagle",
		"Mistol Marcado",
		"Mojón De Fierro",
		"Monseñor De Andrea",
		"Monte Agudo",
		"Monte Claro",
		"Monte Lindo",
		"Monte Lindo  Cnia Pastoril",
		"Monteagudo",
		"Nicora",
		"Nueva Italia",
		"Nuevo Pilcomayo",
		"Olegario Víctor Andrade",
		"Palma Sola",
		"Palmar Chico",
		"Palmar Largo",
		"Palmarcito",
		"Palo Santo",
		"Para Todo",
		"Parque Botánico Forestal Igr L",
		"Parque Nacional",
		"Paso De Los Tobas",
		"Paso De Naite",
		"Paso La Cruz",
		"Paso Nalte",
		"Pato Marcado",
		"Pavao",
		"Pescado Negro",
		"Pigo",
		"Pilaga Iii",
		"Pilanga Iii",
		"Pirane",
		"Poncho Quemado",
		"Porteño Viejo",
		"Portón Negro",
		"Posta Cambio A Zalazar",
		"Posta Lencina",
		"Posta San Martín 1",
		"Posta San Martín 2",
		"Posta Santa Fe",
		"Posta Sargento Cabral",
		"Potrero De Los Caballos",
		"Potrero Norte",
		"Pozo De La Yegua",
		"Pozo De Las Botijas",
		"Pozo De Las Garzas",
		"Pozo De Los Chanchos",
		"Pozo De Mara",
		"Pozo De Maza",
		"Pozo De Navagan",
		"Pozo De Piedra",
		"Pozo Del Cuchillo",
		"Pozo Del León",
		"Pozo Del Maza",
		"Pozo Del Mortero",
		"Pozo Del Tigre",
		"Pozo El Lecherón",
		"Pozo Hondo",
		"Pozo La China",
		"Pozo La Negra",
		"Pozo Verde",
		"Pozo Verde  Ingeniero G N Ju",
		"Pozo Verde Ing G N Juarez",
		"Pque Bot Forestal L Tortorelli",
		"Presidente Avellaneda",
		"Presidente Yrigoyen",
		"Primavera",
		"Primera Junta",
		"Puerto Dalmacia",
		"Puerto Irigoyen",
		"Puerto Pilcomayo",
		"Puerto Ramona",
		"Puerto San Carlos",
		"Puerto Yrigoyen",
		"Puesto Aguara",
		"Punta De Agua",
		"Punta Guía",
		"Punta Pora",
		"Quebracho Marcado",
		"Racedo Escobar",
		"Ranero Cue",
		"Reducción Cacique Coquena",
		"Reserva Natural Formosa",
		"Riacho He He",
		"Riacho Lindo",
		"Riacho Negro",
		"Riacho Ramírez",
		"Ricardo Guiraldes",
		"Rincón Florido",
		"Rincon Ñandu",
		"Rincon Ñaro",
		"Rincón Qandu",
		"Río Cue",
		"Río Muerto",
		"Rodeo Tapiti",
		"Rozadito",
		"Saladillo",
		"Salado",
		"Salvación",
		"San Antonio",
		"San Camilo",
		"San Cayetano",
		"San Francisco De Laishi",
		"San Hilario",
		"San Isidro",
		"San Jacinto",
		"San Juan",
		"San Lorenzo",
		"San Martín 1",
		"San Martin 2",
		"San Martín Ii",
		"San Miguel",
		"San Ramón",
		"San Simón",
		"Santa Catalina",
		"Santa Isabel",
		"Santa María",
		"Santa Rosa",
		"Santa Teresa",
		"Sargento Agramonte",
		"Sargento Cabral",
		"Saturnino Segurola",
		"Segunda Punta",
		"Selva María",
		"Sgto Ayudante V Sanabria",
		"Sgto Mayor Bernardo Aguila",
		"Siete Palmas",
		"Sol De Mayo",
		"Soldado Alberto Villalba",
		"Soldado Dante Salvatierra",
		"Soldado Edmundo Sosa",
		"Soldado Ermindo Luna",
		"Soldado Heriberto Avalos",
		"Soldado Ismael Sánchez",
		"Soldado Marcelino Torales",
		"Soldado Ramón A Arrieta",
		"Soldado Tomas Sánchez",
		"Sombrero Negro",
		"Sto Mayor Bernardo Aguila",
		"Subteniente Perin",
		"Subtte Ricardo E Masaferro",
		"Suipacha",
		"Sumayen",
		"Tatane",
		"Tatu Pire",
		"Teniente Brown",
		"Timbo Pora",
		"Tomas Godoy Cruz",
		"Toro Paso",
		"Transito Cue",
		"Tres Lagunas",
		"Tres Lagunas  Herradura",
		"Tres Lagunas  Pilcomayo",
		"Tres Marías",
		"Tres Mojones",
		"Tres Pocitos",
		"Tres Pozos",
		"Tte Cnel Gaspar Campos",
		"Tte Gral Juan C Sanche",
		"Tte Gral Juan C Sanchez",
		"Tte Gral Rosendo N Fra",
		"Urbana Vieja",
		"Vaca Perdida",
		"Villa Adelaida",
		"Villa Dos Trece",
		"Villa Emilia",
		"Villa Escolar",
		"Villa General Guemes",
		"Villa General Urquiza",
		"Villa Gral Manuel Belgrano",
		"Villa Hermosa",
		"Villa Lucero",
		"Villa Mercedes",
		"Villa Real",
		"Virasol",
		"Yunca",
		"Zorrilla Cue"
	],
	Jujuy: [
		"23 De Agosto",
		"Abdon Castro Tolay",
		"Abra De Peñas",
		"Abra De Pives",
		"Abra Del Trigo",
		"Abra Mayo",
		"Abra Pampa",
		"Abralaite",
		"Achacamayoc",
		"Agua Bendita",
		"Agua Caliente",
		"Agua Caliente De La Puna",
		"Agua Chica",
		"Agua De Castilla",
		"Agua Negra",
		"Agua Palomar",
		"Aguas Blancas",
		"Aguas Calientes",
		"Alegría",
		"Alfarcito",
		"Algarrobal",
		"Alisos  De Abajo",
		"Alisos De Arriba",
		"Alto Calilegua",
		"Alto Comedero",
		"Alto De Casa",
		"Alto De Lozano",
		"Alto De Mojón",
		"Alto Del Angosto",
		"Alto Del Saladillo",
		"Alto Huancar",
		"Alto Minero",
		"Alto Potrerillo",
		"Alto Quemado",
		"Alto Quirquincho",
		"Alto Verde",
		"Amancayoc",
		"Amarguras",
		"Angosto Del Perchel",
		"Animas",
		"Antiguo",
		"Antiguyos",
		"Antumpa",
		"Aparejo",
		"Aparzo",
		"Arbolito Nuevo",
		"Arenal Barroso",
		"Arrayanal",
		"Arroyo Colorado",
		"Arroyo Del Medio",
		"Atalaya",
		"Azul Pampa",
		"Bajada Alta",
		"Baliazo",
		"Balliazo",
		"Barcena",
		"Barrancas",
		"Barrio 9 De Julio",
		"Barrio Alberdi",
		"Barrio Alto La Loma",
		"Barrio Alto La Viña",
		"Barrio Bajo La Viña",
		"Barrio Chijra",
		"Barrio Cuyaya",
		"Barrio La Providencia",
		"Barrio La Unión",
		"Barrio Lujan",
		"Barrio Parque 19 De Abril",
		"Barrio Santa Rita",
		"Barrios",
		"Barro Negro",
		"Bateas",
		"Bella Vista",
		"Boletería",
		"Bomba",
		"Bordo La Isla",
		"Cabreria",
		"Cachi Punco",
		"Cachihuaico",
		"Cacho",
		"Cadilla",
		"Caimancito",
		"Cajas",
		"Calahoyo",
		"Cálete",
		"Calilegua",
		"Campo Bajo",
		"Campo Colorado",
		"Campo La Tuna",
		"Campo Oculto",
		"Canchahuasi",
		"Canchuela",
		"Candelaria",
		"Cangrejillos",
		"Cangrejos",
		"Cañas",
		"Capachacra",
		"Capla",
		"Caracara",
		"Carahuasi",
		"Carahunco",
		"Carayoc",
		"Cárcel",
		"Casa Colorada",
		"Casa Grande",
		"Casa Negra",
		"Casa Vieja",
		"Casabindo",
		"Casayock",
		"Casilla",
		"Casillas",
		"Casira",
		"Caspala",
		"Casti",
		"Catamontaña",
		"Catari",
		"Catua",
		"Cauchari",
		"Ceibal",
		"Centro Forestal",
		"Cerrillos",
		"Cerrito",
		"Cerro Agua Caliente",
		"Cerro Chico",
		"Cerro Negro",
		"Cerro Redondo",
		"Cerros Zapla",
		"Cevilar",
		"Chalican",
		"Chamical",
		"Chañar Solo",
		"Chañaral",
		"Chañarcito",
		"Chañi",
		"Chañi Chico",
		"Chaupi Rodero",
		"Chilcar",
		"Chilcayoc",
		"Chocoite",
		"Chorcan",
		"Chorojra",
		"Chorrillo",
		"Chorrillos",
		"Chorro",
		"Chucalezna",
		"Chucupal",
		"Chulin O Inca Nueva",
		"Chuquina",
		"Cianzo",
		"Ciénaga",
		"Ciénaga Grande",
		"Cienego Grande",
		"Cieneguillas",
		"Cincel",
		"Cochagate",
		"Cochinoca",
		"Coctaca",
		"Coiruro",
		"Colonia 8 De Septiembre",
		"Colonia Los Lapachos",
		"Colorados",
		"Cóndor",
		"Coranzuli",
		"Coranzulli",
		"Coraya",
		"Coronel Arias",
		"Corral Blanco",
		"Corral De Piedras",
		"Corralito",
		"Cortaderas",
		"Costillar",
		"Coyaguaima",
		"Cruz Nido",
		"Cusi Cusi",
		"Doglonzo",
		"Don Jorge",
		"Doncellas",
		"Duraznal",
		"El Acheral",
		"El Aguilar",
		"El Aibal",
		"El Algarrobal",
		"El Amancay",
		"El Angosto",
		"El Arenal",
		"El Bananal",
		"El Brete",
		"El Cabral",
		"El Cadillal",
		"El Callejón",
		"El Cardonal",
		"El Carmen",
		"El Caulario",
		"El Chaguaral",
		"El Chucupal",
		"El Colorado",
		"El Cóndor",
		"El Cucho",
		"El Durazno",
		"El Fuerte",
		"El Manantial",
		"El Mistol",
		"El Molino",
		"El Mollar",
		"El Monumento",
		"El Moreno",
		"El Morro",
		"El Naranjo",
		"El Ollero",
		"El Olvido",
		"El Palmar",
		"El Palmar De San Francisco",
		"El Perchel",
		"El Piquete",
		"El Pongo",
		"El Porvenir",
		"El Potrero De La Puna",
		"El Quemado",
		"El Remate",
		"El Río Negro",
		"El Saladillo",
		"El Sauce",
		"El Sunchal",
		"El Talar",
		"El Tipal",
		"El Toba",
		"El Toro",
		"Encrucijada",
		"Ensenada",
		"Entre Ríos",
		"Escaya",
		"Esquina",
		"Esquina De Huancar",
		"Esquina De Quisto",
		"Esquina Grande",
		"Esquinas Blancas",
		"Estación Perico",
		"Estación Zootecnica",
		"Estancia Grande",
		"Falda Del Quebrachal",
		"Falda Mojón",
		"Falda Montosa",
		"Farillon",
		"Finca Agua Salada",
		"Finca Agua Tapada",
		"Finca La Lucrecia",
		"Finca La Realidad",
		"Finca Leach",
		"Finca Santa Cornelia",
		"Florencia",
		"Fraile Pintado",
		"Fundiciones",
		"Galeta",
		"General Manuel Savio",
		"Gobernador Ovejero",
		"Gobernador Tello",
		"Gral Manuel Savio",
		"Granadas",
		"Guachan",
		"Guayacan",
		"Guayatayoc",
		"Guemes",
		"Guerrero",
		"Guerreros",
		"Higueritas",
		"Hipolito Yrigoyen  Est Iturbe",
		"Hipolito Yrigoyen Est Iturbe",
		"Hornaditas",
		"Hornillos",
		"Huacalera",
		"Huachichocana",
		"Huaico Chico",
		"Huallatayoc",
		"Huancar",
		"Huichaira",
		"Humahuaca",
		"Inca Huasi",
		"Ingenio La Esperanza",
		"Ingenio Ledesma",
		"Inticancho",
		"Iriarte",
		"Isla Chica",
		"Isla Grande",
		"Ituaicochico",
		"Iturbe",
		"Jaramillo",
		"Juan Galán",
		"Juan Manuel De Rosas",
		"Juella",
		"Kilometro 1129",
		"Kilometro 1183",
		"Kilometro 1289",
		"Kilometro 1321",
		"Kilometro 1369",
		"Kilometro 1397",
		"La Aguadita",
		"La Almona",
		"La Bajada",
		"La Banda",
		"La Cabaña",
		"La Calera",
		"La Chinaca",
		"La Ciénaga",
		"La Cruz",
		"La Cuesta",
		"La Cueva",
		"La Esperanza",
		"La Falda",
		"La Intermedia",
		"La Mendieta",
		"La Ollada",
		"La Ovejeria",
		"La Puerta",
		"La Quiaca",
		"La Quinta",
		"La Reducción",
		"La Ronda",
		"La Sanga",
		"La Toma",
		"La Unión",
		"La Vertiente",
		"La Veta",
		"Laguna San Miguel",
		"Laguna Totorillas",
		"Lagunas",
		"Lagunas De Yala",
		"Lagunas Deyala",
		"Lagunilla El Carmen",
		"Lagunilla Ledesma",
		"Lagunillas",
		"Lapachal Ledesma",
		"Lapachal Santa Barbara",
		"Las Cañadas",
		"Las Capillas",
		"Las Chicapenas",
		"Las Escaleras",
		"Las Higuerillas",
		"Las Higueritas",
		"Las Pampitas",
		"Las Pichanas",
		"Las Pircas",
		"Las Quintas",
		"Lavayen",
		"Leachs",
		"Lechería",
		"Ledesma",
		"León",
		"Lib Gral San Martín",
		"Lindero",
		"Lipan",
		"Llameria",
		"Llulluchayoc",
		"Loma Blanca",
		"Loma Del Medio",
		"Loma Larga",
		"Loma Pelada",
		"Los Alisos",
		"Los Baños Termales",
		"Los Bayos",
		"Los Blancos",
		"Los Catres",
		"Los Cedros",
		"Los Lapachos",
		"Los Manantiales",
		"Los Matos",
		"Lote Don David",
		"Lote Don Emilio",
		"Lote El Puesto",
		"Lote La Ciénaga",
		"Lote La Posta",
		"Lote Maíz Negro",
		"Lote Miraflores",
		"Lote Palmera",
		"Lote Parapeti",
		"Lote Piedritas",
		"Lote Prediliana",
		"Lote San Antonio",
		"Lote San Juancito",
		"Lote Sauzal",
		"Lote Zora",
		"Lozano",
		"Lumara",
		"Maimara",
		"Mal Paso",
		"Maquinista Veron",
		"Marta",
		"Mayilte",
		"Mayinte",
		"Merco",
		"Milán",
		"Mina 9 De Octubre",
		"Mina Ajedrez",
		"Mina Bélgica",
		"Mina Pan De Azucar",
		"Mina Pirquitas",
		"Mina Pulpera",
		"Mina San Francisco",
		"Mina Sol De Mayo",
		"Minas Azules",
		"Minas De Borato",
		"Miniaio",
		"Mira Flores",
		"Miraflores De La Candelaria",
		"Mires",
		"Miyuyoc",
		"Mocoraite",
		"Mojón Azucena",
		"Molinos",
		"Molli Punco",
		"Molular",
		"Molulo",
		"Monte Rico",
		"Monterrico",
		"Moralito",
		"Moreno Chico",
		"Morrito",
		"Morro",
		"Mullí Punco",
		"Muñayoc",
		"Naranjito",
		"Nazareno",
		"Nogal",
		"Nogales",
		"Nogalito",
		"Normenta",
		"Obraje San José",
		"Ocloyas",
		"Oculto",
		"Ocumazo",
		"Ojo De Agua",
		"Olacapato",
		"Olaroz Chico",
		"Olaroz Grande",
		"Oratorio",
		"Ornillo",
		"Oros San Juan",
		"Orosmayo",
		"Ovara",
		"Paicone",
		"Pairique Chico",
		"Pairique Grande",
		"Palca De Aparzo",
		"Palma Sola",
		"Palo A Pique",
		"Palo Blanco",
		"Palo Santo",
		"Pálpala",
		"Pampa Blanca",
		"Pampa Larga",
		"Pampa Vieja",
		"Pampichuela",
		"Pan De Azúcar Mina",
		"Paño",
		"Pasajes",
		"Pasto Pampa",
		"Pastos Chicos",
		"Paulete",
		"Paulina",
		"Payo",
		"Peña Colorada",
		"Peñas Blancas",
		"Perico",
		"Perico Del Carmen",
		"Perico San Juan",
		"Picacho",
		"Pie De La Cuesta",
		"Piedra Blanca",
		"Piedra Chota",
		"Piedras Amontonadas",
		"Piedras Blancas",
		"Pilcomayo",
		"Piscuno",
		"Pisungo",
		"Porvenir",
		"Posta De Hornillos",
		"Posta Gdaparque Nac Calilegua",
		"Posta Guardaparque Nacional Ca",
		"Potrerillo",
		"Potrero",
		"Potrero Alegre",
		"Potrero De La Puna",
		"Pozo Bravo",
		"Pozo Cavado",
		"Pozo Colorado",
		"Pozo De Las Avispas",
		"Pozo Verde",
		"Pozuelo",
		"Prediliana",
		"Pucara",
		"Pueblo",
		"Pueblo Ledesma",
		"Pueblo Nuevo",
		"Pueblo Pla",
		"Pueblo Viejo",
		"Puerta De Colorados",
		"Puerta De Lipan",
		"Puerta De Salas",
		"Puerta Patacal",
		"Puerta Potrero",
		"Puerta Vieja",
		"Puerto Tolava",
		"Puesto",
		"Puesto Chico",
		"Puesto Del Marquez",
		"Puesto Grande",
		"Puesto Nuevo",
		"Puesto Viejo",
		"Pumahuasi",
		"Puna De Jujuy",
		"Punta Canal",
		"Punta Corral",
		"Punta De Agua",
		"Punta Del Agua",
		"Punta Del Campo",
		"Puntas De Colorados",
		"Purmamarca",
		"Quebrada Huasamayo",
		"Quebraleña",
		"Quenti Taco",
		"Queñoal",
		"Quera",
		"Queta",
		"Quichagua",
		"Quimazo",
		"Quisquine",
		"Rachaite",
		"Ramada",
		"Ramallo",
		"Rastrojos",
		"Real De Los Toros",
		"Receptoria",
		"Redonda",
		"Reyes",
		"Reyes Villa Jardín",
		"Rinconada",
		"Rinconadillas",
		"Río Blanco",
		"Río Colorado",
		"Río Grande",
		"Río Negro",
		"Río Seco",
		"Riverito",
		"Rodeito",
		"Rodeitos",
		"Rodeo",
		"Rodeo Chico",
		"Rodero",
		"Ronque",
		"Rontuyoc",
		"Rumí Cruz",
		"Sala",
		"Saladillo Ledesma",
		"Saladillo San Pedro",
		"Salitre",
		"San Andrés",
		"San Antonio",
		"San Antonio Perico De",
		"San Bernardo",
		"San Francisco",
		"San Francisco De Alfarcito",
		"San Gabriel",
		"San Javier",
		"San José",
		"San José De La Rinconada",
		"San José De Miraflores",
		"San José Del Bordo",
		"San José Del Chañi",
		"San Juan",
		"San Juan De Dios",
		"San Juan De Oros",
		"San Juan De Quillagues",
		"San Juancito",
		"San León",
		"San Lorenzo",
		"San Lucas",
		"San Pablo De Reyes",
		"San Pedrito",
		"San Pedro",
		"San Pedro De Iruya",
		"San Rafael",
		"San Roque",
		"San Salvador De Jujuy",
		"San Vicente",
		"Sansana",
		"Santa Ana",
		"Santa Ana De La Puna",
		"Santa Barbara",
		"Santa Catalina",
		"Santa Clara",
		"Santa Rita",
		"Santa Rosa Tumbaya",
		"Santa Rosa Valle Grande",
		"Santillo",
		"Santo Domingo",
		"Santuario",
		"Santuyoc",
		"Sauzal",
		"Sauzalito",
		"Sayate",
		"Senador Pérez",
		"Sepultura",
		"Sey",
		"Siberia",
		"Siete Aguas",
		"Sijes",
		"Socabon",
		"Soledad",
		"Sorcuyo",
		"Soysolayte",
		"Suripujio",
		"Susques",
		"Susuyaco",
		"Tabladitas",
		"Tablón",
		"Tacta",
		"Tafna",
		"Tala Grusa",
		"Talar",
		"Tambillos",
		"Tanques",
		"Tarijita",
		"Tejadas",
		"Termas De Reyes",
		"Tesorero",
		"Teuco",
		"Tilcara",
		"Tilquiza",
		"Timón Cruz",
		"Tío Mayo",
		"Tiraxi",
		"Tiraxi Chico",
		"Toba",
		"Tocol",
		"Toquero",
		"Toquillera",
		"Toro Muerto",
		"Totorito",
		"Trancas",
		"Trementinal",
		"Tres Cruces",
		"Tres Morros",
		"Triunvirato",
		"Tucumancito",
		"Tuite",
		"Tumbaya",
		"Tumbaya Grande",
		"Tunalito",
		"Turilari",
		"Turu Tari",
		"Tusaquillas",
		"Uquia",
		"Valle Colorado",
		"Valle Grande",
		"Varas",
		"Venecias Argentinas",
		"Veta Mina Aguilar",
		"Vicuñayoc",
		"Villa Argentina",
		"Villa Ciudad De Nieva",
		"Villa Coranzuli",
		"Villa Del Perchel",
		"Villa Gorriti",
		"Villa Jardin De Reyes",
		"Vinalito",
		"Viscachani",
		"Vizacachal",
		"Volcán",
		"Volcán Higuera",
		"Yacoraite",
		"Yala",
		"Yala De Monte Carmelo",
		"Yavi",
		"Yavi Chico",
		"Yerba Buena Ledesma",
		"Yerba Buena Tilcara",
		"Yoscaba",
		"Yuto",
		"Zapla"
	],
	"La Pampa": [
		"25 De Mayo",
		"Abramo",
		"Adolfo Van Praet",
		"Agua De Torre",
		"Aguas Buenas",
		"Agustoni",
		"Alfredo Peña",
		"Algarrobo Del Aguila",
		"Alpachiri",
		"Alta Italia",
		"Anguil",
		"Anzoategui",
		"Arata",
		"Arbol De La Esperanza",
		"Arbol Solo",
		"Argentina Belvedere",
		"Arturo Almaraz",
		"Ataliva Roca",
		"Atreuco",
		"Azteazu",
		"Bajo De Las Palomas",
		"Baló Los Morros",
		"Barrancas Coloradas",
		"Barrio El Molino",
		"Belgrano",
		"Bella Vista",
		"Bernardo Larroude",
		"Bernasconi",
		"Boeuf",
		"Boliche La Araña",
		"Butalo",
		"Cachirulo",
		"Caichue",
		"Caimi",
		"Calchahue",
		"Caleu Caleu",
		"Caleufu",
		"Campo Caretto",
		"Campo Cicare",
		"Campo De Los Toros",
		"Campo De Salas",
		"Campo La Florida",
		"Campo Ludueña",
		"Campo Moisés Sección 1a",
		"Campo Nicholson",
		"Campo Pico",
		"Campo Salusso",
		"Campo Urdaniz",
		"Caraman",
		"Carlos Berg",
		"Carro Quemado",
		"Casa De Piedra",
		"Catrilo",
		"Cayupan",
		"Ceballos",
		"Cereales",
		"Cerro Azul",
		"Cerro Bayo",
		"Cerro Del Aigre",
		"Cerro La Bota",
		"Chacharramendi",
		"Chacra 16",
		"Chacra La Casilda",
		"Chacra La Magdalena",
		"Chacras De Victorica",
		"Chacu",
		"Chamaico",
		"Chanilao",
		"Chapalco",
		"Chicalco",
		"Colonia  La India",
		"Colonia 17 De Agosto",
		"Colonia Aguirre",
		"Colonia Anasagasti",
		"Colonia Barón",
		"Colonia Beatriz",
		"Colonia Beaufort",
		"Colonia Cazaux",
		"Colonia Chica",
		"Colonia Denevi",
		"Colonia Devoto",
		"Colonia Echeta",
		"Colonia El Destino",
		"Colonia El Porvenir",
		"Colonia El Sauzal",
		"Colonia El Tigre",
		"Colonia España",
		"Colonia Espiga De Oro",
		"Colonia Ferraro",
		"Colonia Giusti",
		"Colonia Gobernador Ayala",
		"Colonia Guiburg N 2",
		"Colonia Helvecia",
		"Colonia La Abundancia",
		"Colonia La Amarga",
		"Colonia La Carlota",
		"Colonia La Chispa",
		"Colonia La Esperanza",
		"Colonia La Gaviota",
		"Colonia La India",
		"Colonia La Margarita",
		"Colonia La Mutua",
		"Colonia La Oración",
		"Colonia La Pastoril",
		"Colonia La Paz",
		"Colonia La Sara",
		"Colonia Lagos",
		"Colonia Las Mercedes",
		"Colonia Las Piedritas",
		"Colonia Las Tres Piedras",
		"Colonia Las Vizcacheras",
		"Colonia Lía Y Allende",
		"Colonia Los Piojos",
		"Colonia Los Toros",
		"Colonia Luna",
		"Colonia María Luisa",
		"Colonia Médano Colorado",
		"Colonia Migliori",
		"Colonia Ministro Lobos",
		"Colonia Ramón Quintas",
		"Colonia Roca",
		"Colonia San Basilio",
		"Colonia San Felipe",
		"Colonia San Ignacio",
		"Colonia San José",
		"Colonia San Juan",
		"Colonia San Lorenzo",
		"Colonia San Miguel",
		"Colonia San Rosario",
		"Colonia San Victorio",
		"Colonia Santa Ana",
		"Colonia Santa Cecilia",
		"Colonia Santa Clara",
		"Colonia Santa Elena",
		"Colonia Santa Elvira",
		"Colonia Santa María",
		"Colonia Santa Teresa",
		"Colonia Sobadell",
		"Colonia Torello",
		"Colonia Trenquenda",
		"Colonia Trequen",
		"Colonia Vascongada",
		"Colonia Villa Alba",
		"Colonias Drysdale",
		"Colonias Murray",
		"Cona Lauquen",
		"Conhelo",
		"Coronel Hilario Lagos",
		"Coronel Hilarios Lagos",
		"Costa Del Salado",
		"Cotita",
		"Cuchillo  Co",
		"Cuchillo Co",
		"Curilco",
		"Curru Mahuida",
		"Doblas",
		"Dorila",
		"Dos Amigos",
		"Dos Chañares",
		"Dos De Ipiña",
		"Dos Violetas",
		"Eduardo Castex",
		"El Aguila",
		"El Antojo",
		"El Bélgica",
		"El Boquerón",
		"El Brillante",
		"El Carancho",
		"El Centenario",
		"El Centinela",
		"El Chillen",
		"El Cinco",
		"El Descanso",
		"El Descanso  Lonquimay",
		"El Deslinde",
		"El Destino",
		"El Destino  Rolón",
		"El Diez",
		"El Diez Y Siete",
		"El Durazno",
		"El Escabel",
		"El Eucalipto",
		"El Eucalipto Carro Quemado",
		"El Furlong",
		"El Guaicuru",
		"El Guanaco",
		"El Guanaco  Winifreda",
		"El Huitru",
		"El Lucero",
		"El Madrigal",
		"El Malacate",
		"El Mate",
		"El Mirador",
		"El Mirador De Juárez",
		"El Nueve",
		"El Oasis",
		"El Odre",
		"El Olivo",
		"El Palomar",
		"El Parque",
		"El Peludo",
		"El Pimia",
		"El Porvenir",
		"El Puma",
		"El Recreo",
		"El Refugio",
		"El Retiro",
		"El Rubí",
		"El Salitral",
		"El Sauce",
		"El Silencio",
		"El Tajamar",
		"El Tartagal",
		"El Tigre",
		"El Tordillo",
		"El Trece",
		"El Trigo",
		"El Triunfo",
		"El Uno",
		"El Vasquito",
		"El Veraneo",
		"El Volante",
		"Embajador Martini",
		"Emilio Mitre",
		"Epu Pel",
		"Establecimiento El Centinela",
		"Estancia La Lucha",
		"Estancia La Pampeana",
		"Estancia La Voluntad",
		"Euskadi",
		"Ex Escuela Hogar Nro 5",
		"Falucho",
		"Gallinao",
		"Gaviotas",
		"General Acha",
		"General Pico",
		"General San Martín",
		"Gervasio Ortiz De Rosas",
		"Gobernador Ayala",
		"Gobernador Duval",
		"Gral Manuel Campos",
		"Guadaloza",
		"Guaraco",
		"Guatrache",
		"Hidalgo",
		"Hipolito Yrigoyen",
		"Hucal",
		"Huelen",
		"Inés Y Carlota",
		"Ingeniero Foster",
		"Ingeniero Luiggi",
		"Intendente Alvear",
		"Ipiña",
		"Ivanowsky",
		"Jacinto Arauz",
		"Jaguel Del Esquinero",
		"Jaguel Del Monte",
		"Jardon",
		"Julián A Mansilla",
		"Juzgado Viejo",
		"Kilometro 619",
		"La Adela",
		"La Administración",
		"La Antonia",
		"La Araña",
		"La Asturiana",
		"La Atalaya",
		"La Aurora",
		"La Avanzada",
		"La Banderita",
		"La Barrancosa",
		"La Baya",
		"La Baya Muerta",
		"La Bilbaina",
		"La Blanca",
		"La Bota",
		"La Carmen",
		"La Carola",
		"La Casilda",
		"La Catalina",
		"La Catalinita",
		"La Catita",
		"La Cautiva",
		"La Celia",
		"La Celina",
		"La Celmira",
		"La Chapelle",
		"La Chirlandia",
		"La Chita",
		"La Chita Puelches",
		"La Ciénaga",
		"La Clelia",
		"La Colorada Chica",
		"La Colorada Grande",
		"La Constancia",
		"La Constancia  Anguil",
		"La Copelina",
		"La Cumbre",
		"La Delfina",
		"La Delicia",
		"La Dolores",
		"La Elenita",
		"La Elia",
		"La Elina",
		"La Elsa",
		"La Elva",
		"La Elvira",
		"La Energía",
		"La Enriqueta",
		"La Escondida",
		"La Esmeralda",
		"La Esmeralda  Macachin",
		"La Esmeralda Macachin",
		"La Esperanza",
		"La Esperanza  Anguil",
		"La Esperanza  Hidalgo",
		"La Esperanza  Macachin",
		"La Esperanza Anguil",
		"La Esperanza Hidalgo",
		"La Esperanza Macachin",
		"La Esperanza Vertiz",
		"La Esther",
		"La Estrella",
		"La Estrella Del Sud",
		"La Eulogia",
		"La Fe",
		"La Florencia",
		"La Florida",
		"La Fortuna",
		"La Gavenita",
		"La Gaviota",
		"La Gloria",
		"La Guadalosa",
		"La Gueñita",
		"La Humada",
		"La Imarra",
		"La Invernada",
		"La Isabel",
		"La Japonesa",
		"La Josefina",
		"La Juanita",
		"La Laurentina",
		"La Leña",
		"La Limpia",
		"La Lonja",
		"La Lucha",
		"La Lucha La Reforma",
		"La Luisa",
		"La Luz",
		"La Magdalena",
		"La Malvina",
		"La Manuelita",
		"La Marcela",
		"La Margarita",
		"La María",
		"La María Elena",
		"La María Elisa",
		"La María Rosa",
		"La María Vertiz",
		"La Marianita",
		"La Maruja",
		"La Matilde",
		"La Moderna",
		"La Morocha",
		"La Nilda",
		"La Nueva",
		"La Nueva Provincia",
		"La Olla",
		"La Oración",
		"La Paloma",
		"La Pampeana",
		"La Pampita",
		"La Pampita  Hidalgo",
		"La Pampita Hidalgo",
		"La Pastoril",
		"La Paulina",
		"La Paz",
		"La Pencosa",
		"La Perla",
		"La Perlita",
		"La Piedad",
		"La Pomona",
		"La Porteña",
		"La Pradera",
		"La Primavera",
		"La Primavera  Miguel Riglos",
		"La Primavera  Santa Rosa",
		"La Primavera Chamaico",
		"La Primavera Miguel Riglos",
		"La Primavera Santa Rosa",
		"La Primera",
		"La Puma",
		"La Puna",
		"La Puñalada",
		"La Razón",
		"La Razón Santa Isabel",
		"La Rebeca",
		"La Reforma",
		"La Reforma Vieja",
		"La Reserva  Anguil",
		"La Reserva Anguil",
		"La Reserva Ivanowsky",
		"La Rosa",
		"La Sarita",
		"La Segunda",
		"La Sin Nombre",
		"La Soledad",
		"La Sorpresa",
		"La Suerte",
		"La Teresita",
		"La Tinajera",
		"La Torera",
		"La Tosca",
		"La Trinidad",
		"La Unida",
		"La Unión",
		"La Vanguardia",
		"La Veintitrés",
		"La Verde",
		"La Verde  Anguil",
		"La Verde Anguil",
		"La Victoria",
		"La Violeta",
		"La Voluntad",
		"La Zota",
		"Labal",
		"Laguna Quiroga",
		"Las Acacias",
		"Las Chacras",
		"Las Delicias",
		"Las Dos Naciones",
		"Las Felicitas",
		"Las Gaviotas",
		"Las Malvinas",
		"Las Piedritas",
		"Las Quintas",
		"Las Tres Hermanas",
		"Legasa",
		"Leona Redonda",
		"Lihue Calel",
		"Limay Mahuida",
		"Lindo Ver",
		"Loma Redonda",
		"Lomas De Gatica",
		"Lomas Ombu",
		"Lonquimay",
		"Loo Co",
		"Los Alamos",
		"Los Algarrobos",
		"Los Dos Hermanos",
		"Los Manantiales",
		"Los Morros",
		"Los Nogales",
		"Los Olivos",
		"Los Pirineos",
		"Los Quinientos",
		"Los Tajamares",
		"Los Toros",
		"Los Tres Pozos",
		"Los Turcos",
		"Lote 10",
		"Lote 11",
		"Lote 11 Bernasconi",
		"Lote 11 Escuela 107",
		"Lote 12",
		"Lote 13",
		"Lote 13 Escuela 173",
		"Lote 14",
		"Lote 15",
		"Lote 15 Escuela 18",
		"Lote 17",
		"Lote 17 Escuela 121",
		"Lote 17 Escuela 95",
		"Lote 18",
		"Lote 18 Escuela 158",
		"Lote 19",
		"Lote 19  Colonia N Leven",
		"Lote 2 Escuela 185",
		"Lote 2 La Elina",
		"Lote 20",
		"Lote 20 La Carlota",
		"Lote 21",
		"Lote 21 Colonia Santa Elena",
		"Lote 22",
		"Lote 22 Ipiña",
		"Lote 23",
		"Lote 23 Escuela 221",
		"Lote 23 Escuela 264",
		"Lote 24",
		"Lote 24 Sección 1a",
		"Lote 25 Conhelo",
		"Lote 25 Escuela 146",
		"Lote 25 Escuela 178",
		"Lote 3",
		"Lote 4",
		"Lote 5 Caleufu  Esc 120",
		"Lote 5 Luan Toro",
		"Lote 6",
		"Lote 6 Escuela 171",
		"Lote 7",
		"Lote 7 Escuela 270",
		"Lote 8",
		"Lote 8  Escuela 179",
		"Lote 8 Escuela 141",
		"Lote 8 Escuela 179",
		"Lote 8 Escuela 184",
		"Lote 9 Escuela 140",
		"Loventuel",
		"Luan Toro",
		"Luna",
		"Macachin",
		"Maisonnave",
		"Malvinas Argentinas",
		"Manantiales",
		"Maraco",
		"Maraco Chico",
		"Mari Mari",
		"María",
		"Mariano Miro",
		"Mauricio Mayer",
		"Mayaco",
		"Médano Blanco",
		"Médano Colorado",
		"Médanos Negros",
		"Metileo",
		"Miguel Cane",
		"Miguel Riglos",
		"Minas De Sal",
		"Minerales De La Pampa",
		"Ministro Orlando",
		"Mocovi",
		"Monte Nievas",
		"Monte Ralo",
		"Nahuel Napa",
		"Naico",
		"Nanquel Huitre",
		"Narciso Leven",
		"Nerre Co",
		"Nicolás Vera",
		"Oficial E Segura",
		"Ojeda",
		"Ojo De Agua",
		"Parera",
		"Parque Luro",
		"Paso De Los Algarrobos",
		"Paso De Los Puntanos",
		"Paso La Balsa",
		"Paso La Razón",
		"Pavón",
		"Perú",
		"Piche Cona Lauquen",
		"Pichi  Huilco",
		"Pichi  Huinca",
		"Pichi Huilco",
		"Pichi Huinca",
		"Pichi Mahuida",
		"Pichi Merico",
		"Poitague",
		"Pueblo Alassa",
		"Pueblo Quintana",
		"Puelches",
		"Puelen",
		"Quehue",
		"Quemu Quemu",
		"Quetrequen",
		"Quintana",
		"Quiñi Malal",
		"Ramón Quintas",
		"Ramón Segundo",
		"Rancul",
		"Realico",
		"Relmo",
		"Remeco",
		"Ricardo Lavalle",
		"Rolon",
		"Rucahue",
		"Rucanelo",
		"Salinas",
		"Salinas Grandes  Anzoategui",
		"Salinas Grandes Hidalgo",
		"Salinas Mari Manuel",
		"San Alberto",
		"San Andrés",
		"San Antonio",
		"San Aquilino",
		"San Basilio",
		"San Benito",
		"San Bernardo",
		"San Carlos",
		"San Diego",
		"San Eduardo",
		"San Emilio",
		"San Ernesto",
		"San Felipe",
		"San Fernando",
		"San Francisco",
		"San Francisco De La Ramada",
		"San Hilario",
		"San Humberto",
		"San Ignacio",
		"San Ildefonso",
		"San Joaquín",
		"San Joaquín Metileo",
		"San José",
		"San José  Anguil",
		"San Juan",
		"San Juan Simson",
		"San Justo",
		"San Manuel",
		"San Marcelo",
		"San Miguel",
		"San Pedro",
		"San Pedro  Rolon",
		"San Pedro Rolon",
		"San Ramón",
		"San Roberto",
		"San Salvador",
		"San Simón",
		"San Urbano",
		"Santa Ana",
		"Santa Aurelia",
		"Santa Catalina",
		"Santa Clara",
		"Santa Elena",
		"Santa Elvira",
		"Santa Felicitas",
		"Santa Gracia",
		"Santa Inés",
		"Santa Isabel",
		"Santa María",
		"Santa Rosa",
		"Santa Stella",
		"Santiago Orellano",
		"Santo Domingo",
		"Santo Tomas",
		"Sarah",
		"Sección Primera Conhello",
		"Sierras De Lihuel Calel",
		"Sol De Mayo",
		"Speluzzi",
		"Ta Huilco",
		"Telen",
		"Toay",
		"Tomas M De Anchorena",
		"Traico",
		"Traico Grande",
		"Trebolares",
		"Trenel",
		"Tres Botones",
		"Tres Hermanos  Macachin",
		"Tres Hermanos Macachin",
		"Tres Hermanos Quetrequen",
		"Tres Lagunas",
		"Tres Naciones",
		"Tribuluci",
		"Trili",
		"Trubuluco",
		"Tte Gral Emilio Mitre",
		"Unanue",
		"Uriburu",
		"Utracan",
		"Valle Argentino",
		"Valle Daza",
		"Vertiz",
		"Victorica",
		"Villa Alba",
		"Villa Mencuelle",
		"Villa Mirasol",
		"Villa San José",
		"Vista Alegre",
		"Winifreda",
		"Zona Rural",
		"Zona Rural  Metileo",
		"Zona Rural De Mirasol",
		"Zona Rural De Vertiz",
		"Zona Rural Dorila",
		"Zona Urbana Norte"
	],
	"La Rioja": [
		"Abra Verde",
		"Adolfo E Carranza",
		"Agua Blanca",
		"Agua Colorada",
		"Agua De La Piedra",
		"Agua De Piedra",
		"Aguada",
		"Aguadita",
		"Aguayo",
		"Aicuña",
		"Aimogasta",
		"Alcázar",
		"Algarrobo Grande",
		"Alpasinche",
		"Altillo Del Medio",
		"Alto Bayo",
		"Alto Carrizal",
		"Alto Jaguel",
		"Amana",
		"Ambil",
		"Amilgancho",
		"Aminga",
		"Ampata",
		"Amuschina",
		"Anchico",
		"Anchumbil",
		"Andolucas",
		"Anguinan",
		"Angulos",
		"Anillaco",
		"Anjullon",
		"Antinaco",
		"Arauco",
		"Atiles",
		"Bajo Corral De Isaac",
		"Bajo De Gallo",
		"Bajo Grande",
		"Bajo Hondo",
		"Bajo Jaguel",
		"Balde Del Quebracho",
		"Balde Salado",
		"Balde San Isidro",
		"Baldes De Pacheco",
		"Banda Florida",
		"Bañados Del Pantano",
		"Barranquitas",
		"Barrio De Galli",
		"Bayo Muerto",
		"Bazan",
		"Bella Vista",
		"Boca De La Quebrada",
		"Buena Vista",
		"Cachiyuyal",
		"Campanas",
		"Campo Tres Pozos",
		"Cañada Honda",
		"Cañada Verde",
		"Capihuas",
		"Carrizal",
		"Carrizal Estación Fcgb",
		"Carrizal Tama",
		"Carrizalillo",
		"Casa Pintada",
		"Casagate",
		"Casangate",
		"Casas Viejas",
		"Castro Barros",
		"Catinzaco",
		"Catinzaco Embarcadero Fcgb",
		"Catuna",
		"Cebollar",
		"Cerro Negro",
		"Chamical",
		"Chañar",
		"Chañarmuyo",
		"Chaupihuasi",
		"Chelcos",
		"Chepes",
		"Chepes Viejos",
		"Chila",
		"Chilecito",
		"Chimenea",
		"Chulo",
		"Chumbicha",
		"Chuquis",
		"Cisco",
		"Colonia Alfredo",
		"Colonia Ortiz De Ocampo",
		"Comandante Leal",
		"Cordobita",
		"Corral De Isaac",
		"Cortaderas",
		"Cortaderas Embarcadero Fcgb",
		"Cuatro Esquinas",
		"Cueva Del Chacho",
		"Cuipan",
		"Desiderio Tello",
		"Dique De Anzulon",
		"Dique Los Sauces",
		"Distrito Pueblo",
		"El Abra",
		"El Altillo",
		"El Alto",
		"El Balde",
		"El Barranco",
		"El Barreal",
		"El Barrial",
		"El Bayito",
		"El Bordo",
		"El Calden",
		"El Cantadero",
		"El Carrizal",
		"El Carrizal Tama",
		"El Catorce",
		"El Cerco",
		"El Chiflón",
		"El Chocoy",
		"El Chuschin",
		"El Chusco",
		"El Cienago",
		"El Cincuenta",
		"El Condado",
		"El Consuelo",
		"El Divisadero",
		"El Duraznillo",
		"El Escondido",
		"El Estanquito",
		"El Fraile",
		"El Fuerte",
		"El Garabato",
		"El Horno",
		"El Huaco",
		"El Jumeal",
		"El Medanito",
		"El Médano",
		"El Mollar",
		"El Molle",
		"El Pedregal",
		"El Plumerillo",
		"El Portezuelo",
		"El Potrerillo",
		"El Potrerillo (General Roca)",
		"El Potrerillo R V Peñaloza",
		"El Potrero",
		"El Pueblito",
		"El Puesto",
		"El Quebrachal",
		"El Quebracho",
		"El Quemado",
		"El Retamal",
		"El Retamo",
		"El Retiro",
		"El Rodeo",
		"El Rosario",
		"El Tala",
		"El Valdecito",
		"El Valle",
		"El Vallecito",
		"El Verde",
		"El Zapallar",
		"Esperanza De Los Cerrillos",
		"Esquina Del Norte",
		"Esquina Del Sud",
		"Esquina Grande",
		"Estación 69",
		"Estación Mazan",
		"Estancia De Maíz",
		"Falda De Citan",
		"Famatina",
		"Flamenco",
		"Francisco Ortiz De Ocampo",
		"Gobernador Gordillo",
		"Guachin",
		"Guandacol",
		"Guayapa",
		"Huaco",
		"Huaja",
		"Hunquillal",
		"Iliar",
		"Ilisco",
		"Illisca",
		"Ismiango",
		"Jague",
		"Jesús María",
		"Kilometro 619",
		"Kilometro 645",
		"Kilometro 682",
		"Kilometro 732",
		"Kilometro 861",
		"Kilometro 875",
		"Kilometro 891",
		"Kilometro 921",
		"La Aguada",
		"La Aguadita",
		"La América",
		"La Antigua",
		"La Armonía",
		"La Banda",
		"La Buena Estrella",
		"La Buena Suerte",
		"La Calera",
		"La Callana",
		"La Carrizana",
		"La Chilca",
		"La Chimenea",
		"La Ciénaga",
		"La Consulta",
		"La Cuadra",
		"La Dora",
		"La Envidia",
		"La Escondida",
		"La Esperanza",
		"La Esquina",
		"La Flor",
		"La Florida",
		"La Higuera",
		"La Huerta",
		"La Igualdad",
		"La Invernada",
		"La Isla",
		"La Jarilla",
		"La Laguna",
		"La Lancha",
		"La Lata",
		"La Libertad",
		"La Lomita",
		"La Maravilla",
		"La Merced",
		"La Pampa",
		"La Perlita",
		"La Pintada",
		"La Pirgua",
		"La Plaza",
		"La Primavera",
		"La Puntilla",
		"La Ramadita",
		"La Reforma",
		"La Represa",
		"La Rioja",
		"La Rosilla",
		"La Serena",
		"La Tordilla",
		"La Torre",
		"La Trampa",
		"La Yesera",
		"La Zanja",
		"Las Aguaditas",
		"Las Barrancas",
		"Las Bombas",
		"Las Cañas",
		"Las Catas",
		"Las Gredas",
		"Las Higueras",
		"Las Higuerillas",
		"Las Padercitas",
		"Las Palomas",
		"Las Peñas",
		"Las Salinas",
		"Las Sierras Bravas",
		"Las Talas",
		"Las Toscas",
		"Las Tucumanesas",
		"Las Tuscas",
		"Las Vertientes",
		"Loma Blanca",
		"Loma Larga",
		"Lorohuasi",
		"Los Aguirres",
		"Los Alanices",
		"Los Algarrobos",
		"Los Baldecitos",
		"Los Baldes",
		"Los Barriacitos",
		"Los Barrialitos",
		"Los Bordos",
		"Los Cerrillos",
		"Los Colorados",
		"Los Corias",
		"Los Corrales",
		"Los Francés",
		"Los Mistoles",
		"Los Mogotes Colorados",
		"Los Molinos",
		"Los Nacimientos",
		"Los Olivares",
		"Los Olmos",
		"Los Oros",
		"Los Palacios",
		"Los Robles",
		"Los Sarmientos",
		"Los Tambillos",
		"Machigasta",
		"Malanzan",
		"Malligasta",
		"Mascasin",
		"Médano",
		"Mesillas Blancas",
		"Milagro",
		"Miranda",
		"Mollaco",
		"Monte Grande",
		"Nacate",
		"Nepes",
		"Nonogasta",
		"Nueva Esperanza",
		"Ñoqueves",
		"Olpas",
		"Olta",
		"Pacatala",
		"Padercitas",
		"Pagancillo",
		"Paganzo",
		"Palo Labrado",
		"Paraje Monte Grande",
		"Parecitas",
		"Paso San Isidro",
		"Pastos Largos",
		"Patquia",
		"Peñas Blancas",
		"Piedra De Talampaya",
		"Piedra Larga",
		"Piedra Pintada",
		"Pinchas",
		"Pituil",
		"Plaza Nueva",
		"Plaza Vieja",
		"Polco",
		"Portezuelo De Los Arce",
		"Potrero Grande",
		"Pozo Blanco",
		"Pozo De Avila",
		"Pozo De La Orilla",
		"Pozo De La Piedra",
		"Pozo De La Yegua",
		"Pozo De Piedra",
		"Pozo Del Medio",
		"Pozo Escondido",
		"Puerta De La Quebrada",
		"Puerto Alegre",
		"Puerto Del Valle",
		"Puesto De Carrizo",
		"Puesto De Los Sánchez",
		"Puesto Dichoso",
		"Puesto Talita",
		"Puluchan",
		"Punta De Agua",
		"Punta De Los Llanos",
		"Punta Del Cerro",
		"Punta Del Negro",
		"Quebrachal",
		"Quebracho Herrado",
		"Quebrada De Los Condores",
		"Quebrada Del Vallecito",
		"Real Del Cadillo",
		"Represa De La Punta",
		"Represa Del Monte",
		"Retamal",
		"Río De Las Cañas",
		"Ríos De Las Mesadas",
		"Ríos De Los Colcoles",
		"Rivadavia",
		"Salana",
		"Salicas",
		"Sálicas - San Blas",
		"Salinas De Bustos",
		"Salinas Del Leoncito",
		"Samay Huasi",
		"San Agustín",
		"San Antonio",
		"San Bernardo",
		"San Cristóbal",
		"San Guillermo",
		"San Ignacio",
		"San Isidro",
		"San Javier",
		"San José",
		"San Juan",
		"San Lorenzo",
		"San Martín",
		"San Miguel",
		"San Nicolás",
		"San Pedro",
		"San Rafael",
		"San Ramón",
		"San Roque",
		"San Solano",
		"San Vicente",
		"Santa Ana",
		"Santa Barbara",
		"Santa Clara",
		"Santa Cruz",
		"Santa Elena",
		"Santa Florentina",
		"Santa Lucia",
		"Santa Rita La Zanja",
		"Santa Rosa",
		"Santa Teresa",
		"Santa Vera Cruz",
		"Santo Domingo",
		"Santo Domingo Famatina",
		"Sañogasta",
		"Schaqui",
		"Señor De La Peña",
		"Siempre Verde",
		"Sierra Brava",
		"Sierra De Los Quinteros",
		"Simbolar",
		"Solca",
		"Suriyaco",
		"Tala Verde",
		"Talamuyuna",
		"Talva",
		"Tama",
		"Tasquin",
		"Termas",
		"Termas De Santa Teresita",
		"Tilimuqui",
		"Tinocan",
		"Torrecitas",
		"Totoral",
		"Trampa Del Tigre",
		"Tres Cerros",
		"Tres Cruces",
		"Tuani",
		"Tuizon",
		"Tuyubil",
		"Udpinango",
		"Ulapes",
		"Valle Hermoso",
		"Verde Olivo",
		"Vichigasta",
		"Villa Bustos",
		"Villa Casana",
		"Villa Castelli",
		"Villa Chepes",
		"Villa Mazan",
		"Villa Nidia",
		"Villa San José De Vinchina",
		"Villa Sanagasta",
		"Villa Santa Rita",
		"Villa Unión",
		"Vinchina"
	],
	Mendoza: [
		"12 De Octubre",
		"25 De Mayo",
		"3 De Mayo",
		"9 De Julio",
		"Adrián Maturano",
		"Agrelo",
		"Agua Amarga",
		"Agua Botada",
		"Agua De Cabrera",
		"Agua De Díaz",
		"Agua De La Mula",
		"Agua De Los Manantiales",
		"Agua Del Chancho",
		"Agua Del Toro",
		"Agua Escondida",
		"Agua Nueva",
		"Agua Rica",
		"Aguada",
		"Aguada Penepe",
		"Aguada Pérez",
		"Aguada Puesto La Totora",
		"Alberto Flores",
		"Alejandro Pérez",
		"Alfredo Lucero",
		"Algarrobal Abajo",
		"Algarrobal Arriba",
		"Algarrobito",
		"Algarrobo",
		"Algarrobo De Sortue",
		"Algarrobo Grande",
		"Alpatacal",
		"Alto Amarillo",
		"Alto Con Zampa",
		"Alto De Las Arañas",
		"Alto De Los Manantiales",
		"Alto De Los Perros",
		"Alto De Los Sapos",
		"Alto Del Olvido",
		"Alto Del Plomo",
		"Alto Del Salvador",
		"Alto Grande",
		"Alto Tres Compadres",
		"Alto Verde",
		"Alvarez",
		"Alvarez Condarco",
		"Ana De Donaire",
		"Anacleta Viuda De Pérez",
		"Anchoris",
		"Ancón",
		"Andrade",
		"Andrés Pérez",
		"Antonio Sosa",
		"Araganita",
		"Arancibia",
		"Aranzabal",
		"Arboleda",
		"Arenales",
		"Aristides Villanueva",
		"Arroyito",
		"Arroyo Claro",
		"Arroyo Los Sauces",
		"Asunción",
		"Atuel Sud",
		"Azcurra",
		"B De Araya",
		"B De Quebrado",
		"B Elena",
		"Bajada Araujo",
		"Bajada De La Salada",
		"Bajada De Los Gauchos",
		"Bajada De Los Papagayos",
		"Bajada De Yaucha",
		"Bajada Del Agua Escondida",
		"Bajada Del Fuerte",
		"Bajada Del Perro",
		"Bajada Del Sauce",
		"Bajo Del Peludo",
		"Bajo Del Yuyo",
		"Balde De La Jarilla",
		"Balde De Los Gauchos",
		"Balde De Piedra",
		"Balde E Aquera",
		"Balde El Sosneado",
		"Balde Jofre",
		"Balde La Pichana Vieja",
		"Balde Las Carpas",
		"Balde Las Catitas",
		"Balde Las Lagunitas",
		"Balde Nuevo",
		"Balde San Agustín",
		"Banderita",
		"Bañado Verde",
		"Baños De Azufre",
		"Baños De Capiz",
		"Baños La Salada",
		"Baños Lunlunta",
		"Barcala",
		"Bardas Blancas",
		"Barrancas",
		"Barreal Colorado",
		"Barreal De La Mesilla",
		"Barreal De La Pampa Seca",
		"Barreal José Luis",
		"Barreal Pájaro Muerto",
		"Barriales Los Ranchos",
		"Barrio Ferri",
		"Barrio Jardín Luzuriaga",
		"Barrio Lencina",
		"Barrio Rivadavia",
		"Barrio San Eduardo",
		"Barrio Villa Adela",
		"Becerra",
		"Belle Ville",
		"Beltran",
		"Bermejo",
		"Blanco Encalada",
		"Blas Panelo",
		"Boliche",
		"Boliche Los Barreales",
		"Borde De La Línea",
		"Bordo Amarillo De La Cruz Pied",
		"Bordo El Algarrobo",
		"Bordo Lechuzo",
		"Bordos Del Plumerillo",
		"Bowen",
		"Boyeros",
		"Buen Orden",
		"Buena Nueva",
		"Buena Vista",
		"Buitrera",
		"Buta Billón",
		"C Gonzáles Videla",
		"Ca Del Diablo",
		"Cabeza De Vaca",
		"Cacheuta",
		"Cadetes De Chile",
		"Cajón De Mayo",
		"Cajón Grande",
		"Calle Larga Vieja",
		"Calle Terrada",
		"Calmuco",
		"Camp Vizcacheras Ypf",
		"Campamento Cacheuta Ypf",
		"Campamento Carapacho",
		"Campamento Ranquilco",
		"Campamentos",
		"Campo De Los Andes",
		"Campo El Alamo",
		"Campo El Toro",
		"Canal Pescara",
		"Canalejas",
		"Cancha De Esquí",
		"Cañada Amarilla",
		"Cañada Ancha",
		"Cañada Colorada",
		"Cañada Seca",
		"Cañadita Alegre",
		"Cañadón De Bonilla",
		"Capdeville",
		"Capilla Del Covadito",
		"Capilla Del Rosario",
		"Capilla San José",
		"Capitán Montoya",
		"Capiz",
		"Caracoles",
		"Carbometal",
		"Carlos Subercaseux",
		"Carmensa",
		"Carril Norte",
		"Carrizal  De  Arriba",
		"Carrizal De Abajo",
		"Carrizal De Arriba",
		"Carrodilla  La Puntilla",
		"Carrodilla La Puntilla",
		"Cartellone",
		"Casa De Adobe",
		"Casa De Las Peñas",
		"Casa De Piedra",
		"Casas Viejas",
		"Casilla",
		"Catitas Viejas",
		"Central Hidroeléctrica 1",
		"Central Hidroeléctrica 2",
		"Cepillo Viejo",
		"Cerrillos",
		"Cerrillos Al Norte",
		"Cerrillos Al Sud",
		"Cerrillos Negros",
		"Cerrito Moro",
		"Cerro Aconcagua",
		"Cerro Agua Negra",
		"Cerro Agua Salada",
		"Cerro Aguadita",
		"Cerro Alojamiento",
		"Cerro Alquitrán",
		"Cerro Alto De Las Peñas",
		"Cerro Alvarado Centro",
		"Cerro Angostura",
		"Cerro Arroyo Hondo",
		"Cerro Aspero",
		"Cerro Baleado",
		"Cerro Barauca",
		"Cerro Barbaran O Tres Picos",
		"Cerro Bay",
		"Cerro Blanco",
		"Cerro Bonete",
		"Cerro Bravo",
		"Cerro Catedral",
		"Cerro Chato",
		"Cerro Chiquero",
		"Cerro Cielo",
		"Cerro Ciénaga",
		"Cerro Clementino",
		"Cerro Color",
		"Cerro Colorado",
		"Cerro Colorado De Las Lagunill",
		"Cerro Cortaderas",
		"Cerro Cuerno",
		"Cerro Cúpula",
		"Cerro De La Banderola",
		"Cerro De Las Leñas",
		"Cerro De Los Burros",
		"Cerro De Los Dedos",
		"Cerro De Los Leones",
		"Cerro De Los Potrerillos",
		"Cerro Del Chacay",
		"Cerro Del Medio",
		"Cerro Del Pozo",
		"Cerro Del Rincón Bayo",
		"Cerro Del Zorro",
		"Cerro Divisadero De La Cienegu",
		"Cerro Durazno",
		"Cerro El Guanaco",
		"Cerro Fiero",
		"Cerro Fundición",
		"Cerro Gaspar",
		"Cerro Grande",
		"Cerro Guadaloso",
		"Cerro Horqueta",
		"Cerro Invernada",
		"Cerro Juan Pobre",
		"Cerro L Corrales",
		"Cerro La Invernada",
		"Cerro La Mano",
		"Cerro Lagañoso",
		"Cerro Las Piedras",
		"Cerro Los Bajos",
		"Cerro Los Barros",
		"Cerro Los Dientitos",
		"Cerro Manantial",
		"Cerro Masillas",
		"Cerro Melocotón",
		"Cerro México",
		"Cerro Montura",
		"Cerro Negros De Las Mesillas",
		"Cerro Nevado",
		"Cerro Pampa Seca",
		"Cerro Pan De Azúcar",
		"Cerro Panta",
		"Cerro Pelado",
		"Cerro Piedra Colorada",
		"Cerro Plomo",
		"Cerro Ponderado",
		"Cerro Potrerillos",
		"Cerro Pozo",
		"Cerro Punta De Agua",
		"Cerro Puntilla Negra",
		"Cerro Puntudo",
		"Cerro Puquios",
		"Cerro Riquitipanche",
		"Cerro San Lorenzo",
		"Cerro Santa María",
		"Cerro Sapo",
		"Cerro Tigre",
		"Cerro Tolosa",
		"Cerro Tunduquera",
		"Cerro Yalguaras",
		"Cerro Yareta",
		"Cerros Colorados",
		"Cespedes",
		"Chachao",
		"Chacharalen",
		"Chachingo",
		"Chacras De Coria",
		"Chacras De Lima",
		"Chamuscao",
		"Chañaral Redondo",
		"Chapanay",
		"Charco Vacas",
		"Chilecito",
		"Chilote",
		"Chimba",
		"Chivilcoy",
		"Ciénaga Del Alto",
		"Circunvalacion",
		"Cirilo Mahona",
		"Ciudad De Junín",
		"Ciudad Oeste",
		"Clarentino Roldan",
		"Clodomiro Reta",
		"Cochico",
		"Coihueco",
		"Coihueco Norte",
		"Cola Mora",
		"Colon Sandalho",
		"Colonia 3 De Mayo",
		"Colonia Alazanes",
		"Colonia Alemana",
		"Colonia Alvear",
		"Colonia Alvear Oeste",
		"Colonia Andre",
		"Colonia Aspera",
		"Colonia Atuel",
		"Colonia Atuel Norte",
		"Colonia Barraquero",
		"Colonia Bombal",
		"Colonia Bombal Y Tabanera",
		"Colonia Bouquet",
		"Colonia Cano",
		"Colonia Chalet",
		"Colonia Chato",
		"Colonia Colina",
		"Colonia Colomer",
		"Colonia Curniñan",
		"Colonia De Las Mulas",
		"Colonia De Los Guanaqueros",
		"Colonia Del Carmen",
		"Colonia Del Diablo",
		"Colonia Del León",
		"Colonia Delfino",
		"Colonia Divisadero Del Cardal",
		"Colonia Divisadero Negro",
		"Colonia Durazno",
		"Colonia El Campanario",
		"Colonia El Regadío",
		"Colonia Elena",
		"Colonia Española",
		"Colonia Estrella",
		"Colonia Faro",
		"Colonia Funes",
		"Colonia Guadal",
		"Colonia Guanaco",
		"Colonia Italiana",
		"Colonia Jara",
		"Colonia Jauregui",
		"Colonia La Escondida",
		"Colonia La Llave",
		"Colonia La Torrecilla",
		"Colonia Lambare",
		"Colonia Las Rosas",
		"Colonia Lola",
		"Colonia López",
		"Colonia Los Huevos",
		"Colonia Los Oscuros",
		"Colonia Los Tapones",
		"Colonia Mirador",
		"Colonia Monte Caseros",
		"Colonia Muralla",
		"Colonia Nacional De Los Indios",
		"Colonia Negro",
		"Colonia Osamenta",
		"Colonia Papal",
		"Colonia Pascual Iacarini",
		"Colonia Pedernales",
		"Colonia Pencal",
		"Colonia Pico Colorado",
		"Colonia Reina",
		"Colonia Rusa",
		"Colonia San Agustín",
		"Colonia San Francisco",
		"Colonia San Jorge",
		"Colonia Santa Teresa",
		"Colonia Segovia",
		"Colonia Soitue",
		"Colonia Tabanera",
		"Colonia Torrecillas",
		"Colonia Torrecito",
		"Colonia Tres Altitos",
		"Com Nac De Energía Atómica",
		"Comandante Salas",
		"Comisión Nac De Emergencia",
		"Compuertas Negras",
		"Concha Subercaseaux",
		"Control Ypf",
		"Coquimbito",
		"Cordón De Plata",
		"Cordon Del Plata",
		"Coronel Beltran",
		"Coronel Dorrego",
		"Corral De Cuero",
		"Corral De Lorca",
		"Corral Del Molle",
		"Costa De Araujo",
		"Costa Del Diamante",
		"Cristo Redentor",
		"Cristóbal López",
		"Cruz Blanca",
		"Cruz De Piedra",
		"Cruz De Piedra Pto Gendarmería",
		"Cruz Del Yugo",
		"Cruz Giménez",
		"Cruz Ledesma",
		"Cto Del Tigre",
		"Cuadro Benegas",
		"Cuadro Bombal",
		"Cuadro Nacional",
		"Cuesta De Los Terneros",
		"Cupiles",
		"D López",
		"Dalmiro Zapata",
		"Daniel Lucero",
		"Daniel Morgan",
		"Delgadillo",
		"Desaguadero",
		"Dionisio Ordoñez",
		"Dionisio Ortubia",
		"Dique Del Valle De Uco",
		"Dique Río Mendoza",
		"Distrito Compuerta",
		"Divisadero",
		"Divisadero Colorado",
		"Divisadero Negro",
		"Doctor Antonio Soomas",
		"Domingo Giménez",
		"Domingo Lara",
		"Domingo Oga",
		"Domingo Real",
		"Don Martín",
		"Donato Ojeda",
		"Doroteo Ordoñez",
		"Dorrego",
		"Dulce",
		"E Rosales",
		"El 15",
		"El Aguila",
		"El Alambrado",
		"El Alamo",
		"El Algarrobal",
		"El Algarrobo",
		"El Alpero",
		"El Altillo",
		"El Alto",
		"El Alto Salvador",
		"El Arbolito",
		"El Azufre",
		"El Balsadero",
		"El Banderón",
		"El Bonito",
		"El Borbollón",
		"El Buen Pastor",
		"El Cabao Viejo",
		"El Cajón",
		"El Calvadito",
		"El Campamento",
		"El Cañito",
		"El Capacho",
		"El Caranchito",
		"El Carbalino",
		"El Carmen",
		"El Carrizal",
		"El Carrizal De Abajo",
		"El Cavadito",
		"El Cavado Chico",
		"El Ceibo",
		"El Cenizo",
		"El Central",
		"El Cepillo",
		"El Cercado",
		"El Cerrito",
		"El Chacallal",
		"El Chacay",
		"El Chalet",
		"El Challao",
		"El Chañar",
		"El Chilcal",
		"El Chircal",
		"El Choique",
		"El Cienago",
		"El Ciprés",
		"El Colon",
		"El Colorado",
		"El Consuelo",
		"El Corbalno",
		"El Desvío",
		"El Divisadero",
		"El Durazno",
		"El Escondido",
		"El Gigantillo",
		"El Gonzano",
		"El Gorgino",
		"El Guadal De Campos",
		"El Guanaco",
		"El Guerrino",
		"El Infiernillo",
		"El Infierno",
		"El Jilguero",
		"El Jume",
		"El Juncalito",
		"El Lechucito",
		"El Lemino",
		"El Luquino",
		"El Manzano",
		"El Manzano Histórico",
		"El Marcado",
		"El Marucho",
		"El Maurino",
		"El Mirador",
		"El Molino",
		"El Mollar",
		"El Moyano",
		"El Nevado",
		"El Nihuil",
		"El Ñango",
		"El Paraíso",
		"El Parral",
		"El Pascal",
		"El Pastal",
		"El Payen",
		"El Peral",
		"El Perino",
		"El Picona",
		"El Plateado",
		"El Plumerillo",
		"El Plumero",
		"El Portillo",
		"El Porvenir",
		"El Puestito",
		"El Puma",
		"El Puntiagudo",
		"El Refugio",
		"El Regadío",
		"El Resguardo",
		"El Retamo",
		"El Retamoso",
		"El Retiro",
		"El Rincón",
		"El Rosario",
		"El Salado",
		"El Salto",
		"El Sauce",
		"El Sosneado",
		"El Tamarindo",
		"El Tapón",
		"El Topon",
		"El Toscal",
		"El Tropezón",
		"El Usillal",
		"El Valle",
		"El Vaquero",
		"El Vatro",
		"El Ventarrón",
		"El Vergel",
		"El Villeguino",
		"El Vilteguino",
		"El Zampal",
		"El Zapatino",
		"El Zorzal",
		"Eloy Funes",
		"Embalse Valle Grande",
		"Emiliano Lucero",
		"Emilio Nieta",
		"Empalme Frontera",
		"Empalme Resguardo",
		"Epifanio Fernández",
		"Ernesto Alcáraz",
		"Ernesto López",
		"Escudero",
		"Espejo",
		"Espejo Resguardado",
		"Espino",
		"Estación Uspallata",
		"Estancia Aguanda",
		"Estancia Arroyo Hondo",
		"Estancia Aveiro",
		"Estancia Bella Vista",
		"Estancia Casa De Piedra",
		"Estancia Casas Viejas",
		"Estancia Chacaico",
		"Estancia Correa",
		"Estancia Cueva Del Toro",
		"Estancia El Balderon",
		"Estancia El Bonito",
		"Estancia El Campamento",
		"Estancia El Carrizal",
		"Estancia El Carrizalito",
		"Estancia Gil",
		"Estancia Guinazu",
		"Estancia Jocoli",
		"Estancia La Argentina",
		"Estancia La Chuña",
		"Estancia La Cortadera",
		"Estancia La Pampa",
		"Estancia La Puma",
		"Estancia La Rosa",
		"Estancia La Salcedina",
		"Estancia La Sarita",
		"Estancia La Trintrica",
		"Estancia La Varita",
		"Estancia La Vizcachera",
		"Estancia Las Chilcas",
		"Estancia Las Higueras",
		"Estancia Las Vizcacheras",
		"Estancia Los Chacayes",
		"Estancia Los Huaicos",
		"Estancia Los Leones",
		"Estancia Mallea",
		"Estancia San Martín",
		"Estancia Silva",
		"Estancia Sofía Raquel",
		"Estancia Tierras Blancas",
		"Estancia Uspallata",
		"Estancia Villavicencio",
		"Estancia Viluco",
		"Estancia Yalguaraz",
		"Estancia Yaucha",
		"Estanislao Ordoñez",
		"Eugenio Bustos",
		"Eusebia Viuda De Gómez",
		"Evaristo Acevedo",
		"Evaristo Salas",
		"Ex Fortín Malargue",
		"Fabriciano Rojas",
		"Felipe Garro",
		"Felipe Pérez",
		"Fermín Pérez",
		"Finca El Arroz",
		"Finca López",
		"Finca Los Alamos",
		"Florencio Garro",
		"Florencio Molina",
		"Florencio Ordoñez",
		"Florindo Flores",
		"Forzudo",
		"Francisco Molina",
		"Francisco Rojas",
		"Fray Luis Beltran",
		"Fructuoso Díaz",
		"Garganta Del León",
		"Gaspar Campos",
		"General Acha",
		"General Alvear",
		"General Gutierrez",
		"General Ortega",
		"Germán Maturano",
		"Gertrudis De Ojeda",
		"Gilberto Pérez",
		"Glaciares Del Río Blanco",
		"Gobernador Benegas",
		"Gobernador Civit",
		"Gobernador Luis Molina",
		"Godoy Cruz",
		"Goico",
		"Goudge",
		"Gregorio Zapata",
		"Guadal De Los Pérez",
		"Guadales",
		"Gualtallary",
		"Guayqueria Colorada",
		"Guido",
		"Guillermo Donaire",
		"Gurruchaga",
		"H Garzala",
		"Hermenegildo Díaz",
		"Honorio Zapata",
		"Hornito Del Gringo",
		"Hornos De Moyano",
		"Hotel Portezuelo Del Viento",
		"Hotel Termas Del Azufre",
		"Hotel Termas El Sosneado",
		"Huaicos De Rufino",
		"Huaiqueria De La Horqueta",
		"Huaiqueria De Los Burros",
		"Huecos De Los Tordillos",
		"Ignacio Villegas",
		"Iguazú",
		"Ingeniero Balloffet",
		"Ingeniero Giagnoni",
		"Ingeniero Gustavo Andre",
		"Irineo Zapata",
		"Isabel Flores",
		"Isla Chica",
		"Isla Del Cuchillo",
		"Isla Grande",
		"Isla Retamito",
		"J Campos",
		"J Ortubia",
		"J Veron",
		"Jaguel",
		"Jaguel Amarillo",
		"Jaguel De Las Chilcas",
		"Jaguel De Rosas",
		"Jaguel Del Catalán",
		"Jaguel Del Gaucho",
		"Jaguel Del Gobierno",
		"Jaime Prats",
		"Jarilloso",
		"Jaucha",
		"Jesús Nazareno",
		"Jocoli",
		"Jocoli Viejo",
		"Jofre",
		"Jorge Newbery",
		"José Campos",
		"José Díaz",
		"José Fernández",
		"José Lucero",
		"José R Molina",
		"José Sosa",
		"José Suarez",
		"Juan B Dufau",
		"Juan H Ortiz",
		"Juan Millan",
		"Juan Zapata",
		"Julio Comeglio",
		"Junin",
		"Junta De La Vaina",
		"Junta De Los Ríos",
		"Kilometro 1013",
		"Kilometro 1032",
		"Kilometro 1085",
		"Kilometro 43",
		"Kilometro 47",
		"Kilometro 55",
		"Kilometro 56",
		"Kilometro 84",
		"Kilometro 882",
		"Kilometro 884",
		"Kilometro 935 Desvio Fcgsm",
		"Kilometro 947",
		"L Del Aguero",
		"L Pérez",
		"L Prado",
		"La Adelina",
		"La Angelina",
		"La Angostura",
		"La Arboleda",
		"La Argentina",
		"La Bajada",
		"La Bandera",
		"La Barda Cortada",
		"La Batra",
		"La Bóveda",
		"La Caldenada",
		"La California",
		"La Cañada",
		"La Carrera",
		"La Carusina",
		"La Casa Del Tigre",
		"La Cautiva",
		"La Celia",
		"La Central Rivadavia",
		"La Chapina",
		"La Chilca",
		"La Chimba",
		"La Chuna",
		"La Cienaguita",
		"La Clarita",
		"La Cola",
		"La Colonia",
		"La Colonia Sud",
		"La Consulta",
		"La Corona",
		"La Cortadera",
		"La Costa",
		"La Divisoria",
		"La Dormida",
		"La Escandinava",
		"La Esperanza",
		"La Esquina",
		"La Estacada",
		"La Estancia",
		"La Estrechura",
		"La Excavación",
		"La Favorita",
		"La Florida",
		"La Fortuna",
		"La Fundicion",
		"La Guevarina",
		"La Holanda",
		"La Horqueta",
		"La Hullera",
		"La Isla",
		"La Isla Chica",
		"La Isla Grande",
		"La Jacintita",
		"La Jacinto",
		"La Jaula",
		"La Junta",
		"La Lagunita",
		"La Lata",
		"La Leona",
		"La Libertad",
		"La Llave",
		"La Llave Nueva",
		"La Llave Vieja",
		"La Lunina",
		"La Marzolina",
		"La Mina Del Peceño",
		"La Montilla",
		"La Mora",
		"La Negrita",
		"La Palmera",
		"La Pastoral",
		"La Paz",
		"La Pega",
		"La Picarona",
		"La Picasa",
		"La Picaza",
		"La Pichana",
		"La Pirata",
		"La Pomona",
		"La Porteña",
		"La Primavera",
		"La Quebrada",
		"La Salinilla",
		"La Seña",
		"La Sirena",
		"La Sombrilla",
		"La Toma",
		"La Tosca",
		"La Valenciana",
		"La Varita",
		"La Vasconia",
		"La Verde",
		"La Yesera",
		"Ladislao",
		"Ladislao Campos",
		"Laguna De Guanacache",
		"Laguna Del Rosario",
		"Laguna Negra",
		"Laguna Salada",
		"Lagunita",
		"Las Arabias",
		"Las Barrancas",
		"Las Canteras",
		"Las Carditas",
		"Las Catitas",
		"Las Chacras",
		"Las Chacritas",
		"Las Colonias",
		"Las Compuertas",
		"Las Compuertas Negras",
		"Las Cortaderas",
		"Las Cruces",
		"Las Cuevas",
		"Las Delicias",
		"Las Gateadas",
		"Las Gatitas",
		"Las Heras",
		"Las Juntas",
		"Las Loicas",
		"Las Malvinas",
		"Las Minas",
		"Las Paredes",
		"Las Peñas",
		"Las Pintadas",
		"Las Rajaduras",
		"Las Rosas",
		"Las Taguas",
		"Las Torrecitas",
		"Las Totoritas",
		"Las Vayas",
		"Las Vegas",
		"Las Violetas",
		"Las Viscacheras",
		"Las Vistas",
		"Las Vizcachas",
		"Las Yeguas",
		"Lavalle Villa Tulumaya",
		"Lezcano",
		"Libertador Gral San Martín",
		"Limón",
		"Lino Pérez",
		"Lira",
		"Lisandro Escudero",
		"Llano Blanco",
		"Lola Mora",
		"Loma Alta",
		"Loma Chata",
		"Loma Colorada",
		"Loma De Los Burros",
		"Loma Del Cerro Aspero",
		"Loma Del Chañar",
		"Loma Del Medio",
		"Loma Extendida",
		"Loma Jaguel Del Gaucho",
		"Loma Negra",
		"Loma Negra Grande",
		"Loma Pelada",
		"Loma Sola",
		"Lomas Altas",
		"Lomas Bayas",
		"Lomas Blancas",
		"Lomas Chicas",
		"Lomas Coloradas",
		"Lomita Larga",
		"Lomita Morada",
		"Lonco Vacas",
		"Los Ahumados",
		"Los Alamos",
		"Los Algarrobos",
		"Los Algodones",
		"Los Altamiques",
		"Los Amarillos",
		"Los Angeles",
		"Los Arboles",
		"Los Arboles De Villegas",
		"Los Arroyos",
		"Los Baldes",
		"Los Barriales",
		"Los Blancos",
		"Los Britos",
		"Los Burgos",
		"Los Campamentos",
		"Los Carrizales",
		"Los Chacayes",
		"Los Claveles",
		"Los Colados",
		"Los Colorados",
		"Los Cometierras",
		"Los Compartos",
		"Los Corrales",
		"Los Corralitos",
		"Los Corredores",
		"Los Embarques",
		"Los Eucaliptos",
		"Los Filtros",
		"Los Horconcitos",
		"Los Huarpes",
		"Los Médanos Negros",
		"Los Molles",
		"Los Moros",
		"Los Olmos",
		"Los Otoyanes",
		"Los Papagayos",
		"Los Paramillos",
		"Los Parlamentos",
		"Los Patos",
		"Los Pejecitos",
		"Los Pejes",
		"Los Penitentes",
		"Los Pozos",
		"Los Ralos",
		"Los Ramblones",
		"Los Repuntes",
		"Los Reyunos",
		"Los Roseti",
		"Los Sauces",
		"Los Sauces Lavalle",
		"Los Tamarindos",
		"Los Terneros",
		"Los Tolditos",
		"Los Tordillos",
		"Los Toscales",
		"Los Verdes",
		"Los Villegas",
		"Los Yaullines",
		"Los Yoles",
		"Lotes De Gaviola",
		"Luanco",
		"Lucas Donaire",
		"Luis Marquez",
		"Lujan De Cuyo",
		"Lunlunta",
		"Luzuriaga",
		"M Escudero",
		"M Quiroga",
		"Maipu",
		"Malal Del Medio",
		"Malargue",
		"Mallin Quemado",
		"Maquinista Levet",
		"Maravilla",
		"Maria Garcia",
		"María Luisa",
		"María Viuda De Donaire",
		"Mario Olguin",
		"Marquez Escuela117",
		"Masa",
		"Matancilla",
		"Matheu Norte",
		"Mathieu Norte",
		"Matías Garro",
		"Matoncilla",
		"Maturana",
		"Mauricio Calderón",
		"Mayor Drummond",
		"Maza",
		"Mechanquil",
		"Mechenguil",
		"Médanos Colorado",
		"Medanos Colorados",
		"Medardo Miranda",
		"Media Luna",
		"Medrano",
		"Meliton Campos",
		"Melocotón",
		"Mendoza",
		"Meseta Colorada",
		"Miguez",
		"Mina Argentina",
		"Mina Ethel",
		"Mina Huemul",
		"Mina Santa Cruz",
		"Mina Volcán Overo",
		"Minacar",
		"Minas De Petróleo",
		"Minas Del Nevado",
		"Minas El Sosneado",
		"Minas Salagasta",
		"Minelli",
		"Mojón Ocho",
		"Molino",
		"Moluches",
		"Monte Bayo",
		"Monte Caseros",
		"Monte Coman",
		"Monumento Al Ejercito De Los A",
		"Morón Chico",
		"Morón Viejo",
		"Morro Del Cuero",
		"Mosmota",
		"Moyano",
		"Mundo Nuevo",
		"N Zapata",
		"Natalia Donaire",
		"Navarro",
		"Necto Sosa",
		"Negro Quemado",
		"Nestor Aguilera",
		"Nicolás Ordoñez",
		"Nihuil",
		"Nire Co",
		"Nueva California",
		"Nueva Ciudad",
		"Ñacuñan",
		"Ñancuñan",
		"Ochenta Y Cuatro",
		"Ojo De Agua",
		"Onotre Puebla",
		"Ovejeria",
		"P Planchon",
		"P Rosales",
		"P San Ignacio",
		"Pachango",
		"Palermo Chico",
		"Palmira",
		"Pampa Amarilla",
		"Pampa De Las Yaretas",
		"Pampa De Los Bayos",
		"Pampa Del Salado",
		"Pampa Del Tigre",
		"Pampa Yalguaraz",
		"Pampita Embarcadero Fcgsm",
		"Panquehua",
		"Panqueua",
		"Papagayo",
		"Paradero La Superiora",
		"Paramillo",
		"Paramillo De Las Vacas",
		"Pareditas",
		"Pascual Sosa",
		"Paso De Las Canoas",
		"Paso De Las Carretas",
		"Paso De Los Andes",
		"Paso De Los Gauchos",
		"Paso Del Cisne",
		"Paso Hondo",
		"Paso Los Palos",
		"Pata Mora",
		"Patimalal",
		"Paulino Matura",
		"Payun",
		"Pedregal",
		"Pedro Castelu",
		"Pedro Pablo Pérez",
		"Pedro Vargas",
		"Peña",
		"Perdriel",
		"Petróleo",
		"Philipps",
		"Phillips",
		"Pichi Ciego Estación Fcgsm",
		"Picos Bayos",
		"Piedra De Afilar",
		"Piedras Blancas",
		"Pircas De Osorio",
		"Pirquita Embarcadero Fcgsm",
		"Plaza De Mulas",
		"Po Alvarado Norte",
		"Po Alvarado Sur",
		"Po Amarillo",
		"Po De Contrabandista",
		"Po De La Cumbre",
		"Po De La Quebrada Honda",
		"Po De Los Escalones",
		"Po Del Huanaco",
		"Po Del Rubio",
		"Po Maipu",
		"Po Mallan",
		"Po Pehuenche",
		"Po Valle Hermoso",
		"Polvareda",
		"Polvaredas",
		"Ponce",
		"Portezuelo Choique",
		"Portillo Agua De Toro",
		"Portillo Canales",
		"Portillo Cruz De Piedra",
		"Portillo D Quemado",
		"Portillo De Colina",
		"Portillo De Indio",
		"Portillo De La G  Del Camino",
		"Portillo De La Lagrima Viva",
		"Portillo De La Yesera",
		"Portillo De Las Cabezas",
		"Portillo De Las Vacas",
		"Portillo De Lomas Coloradas",
		"Portillo De Pinquenes",
		"Portillo Del Diablo",
		"Portillo Del Medio",
		"Portillo Del Norte",
		"Portillo Del Papal",
		"Portillo Del Tigre",
		"Portillo Del Viento",
		"Portillo La Pampa",
		"Portillo Occidental Del Bayo",
		"Portillo Pedernales",
		"Portillo Quemado",
		"Posta De Hierro",
		"Poste De Fierro",
		"Potrerillos",
		"Potrero San Pablo",
		"Primavera",
		"Progreso",
		"Pta Del Agua Vieja",
		"Pto Los Amarillos",
		"Pueblo Diamante",
		"Pueblo Echevarrieta",
		"Pueblo Luna",
		"Pueblo Soto",
		"Puente Del Inca",
		"Puente Viejo",
		"Puerta De La Isla",
		"Puerto Hortensa",
		"Puerto Rincón Escalona",
		"Puesta El Cavado",
		"Puesto A Martínez",
		"Puesto Agua Amarga",
		"Puesto Agua De La Liebre",
		"Puesto Agua De La Merina",
		"Puesto Agua De La Zorra",
		"Puesto Agua De Zanjón",
		"Puesto Agua Del Médano",
		"Puesto Alfarfa",
		"Puesto Algarrobo Grande",
		"Puesto Atamisqui",
		"Puesto Canales",
		"Puesto Carrizalito",
		"Puesto Chambón",
		"Puesto De Garro",
		"Puesto De La Corona",
		"Puesto De La Salada",
		"Puesto De Las Carretas",
		"Puesto De Las Tropas",
		"Puesto De Olguin",
		"Puesto De Orozco",
		"Puesto De Petra",
		"Puesto De Sosa",
		"Puesto Del Buen Pastor",
		"Puesto Del Chañacal",
		"Puesto El Carrizalito",
		"Puesto El Jagual",
		"Puesto El Jilguero",
		"Puesto El Manzano",
		"Puesto El Peral",
		"Puesto El Pichón",
		"Puesto El Retamito",
		"Puesto El Totoral",
		"Puesto El Trueno",
		"Puesto Escondido",
		"Puesto F Tello",
		"Puesto García",
		"Puesto Gendarmeria Nacional Po",
		"Puesto Gentile",
		"Puesto Guamparito",
		"Puesto Horqueta",
		"Puesto Isla Chañar",
		"Puesto J Alvarez",
		"Puesto J Castro",
		"Puesto La Cachaca",
		"Puesto La Caldenada",
		"Puesto La Costa",
		"Puesto La Florida",
		"Puesto La Gruta",
		"Puesto La Hortensia",
		"Puesto La Invernada",
		"Puesto La Jarilla",
		"Puesto La Jerilla",
		"Puesto La Mojada",
		"Puesto La Negrita",
		"Puesto La Niebla",
		"Puesto La Porteña",
		"Puesto La Seña",
		"Puesto La Suiza",
		"Puesto La Tosca",
		"Puesto La Ventana",
		"Puesto Las Aguadas",
		"Puesto Las Cortaderas",
		"Puesto Las Higueras",
		"Puesto Las Juntitas",
		"Puesto Las Pichanas",
		"Puesto Las Puntanas",
		"Puesto Las Víboras",
		"Puesto Lorca",
		"Puesto Loreto",
		"Puesto Los Alojamientos",
		"Puesto Los Causes",
		"Puesto Los Chañares",
		"Puesto Los Gauchos",
		"Puesto Los Pajaritos",
		"Puesto Los Ramblones",
		"Puesto Luffi",
		"Puesto Luna",
		"Puesto Lunina",
		"Puesto Mallin",
		"Puesto Malo",
		"Puesto Manga De Arriba",
		"Puesto Manzanito",
		"Puesto Marfil",
		"Puesto Mironda",
		"Puesto Nieves Negras",
		"Puesto Nueras",
		"Puesto Ojo De Agua",
		"Puesto P Miranda",
		"Puesto P Montriel",
		"Puesto Punta Del Agua",
		"Puesto Quemado",
		"Puesto Quiroga",
		"Puesto Rancho De La Pampa",
		"Puesto Rincón De La Pampa",
		"Puesto Rincón Del Sauce",
		"Puesto Rincón Escalona",
		"Puesto Riquitipanche",
		"Puesto S Pérez",
		"Puesto San José",
		"Puesto San Miguel",
		"Puesto San Vicente",
		"Puesto Santa Clara De Arriba",
		"Puesto Santa María",
		"Puesto Seco",
		"Puesto Sosa",
		"Puesto Ultima Aguada",
		"Puesto Vega",
		"Puesto Viuda De Estrella",
		"Puesto Vuelta Del Zanjón",
		"Puesto Zampal",
		"Punta De Vacas",
		"Punta Del Agua",
		"Punta Del Canal",
		"Puntos De Agua",
		"Quircaco",
		"R Barrí",
		"R Bebedera",
		"R Bustos",
		"Rama Caída",
		"Ramblón",
		"Ramblón De La Pampa",
		"Ramblón De Los Chilenos",
		"Ramblón Grande",
		"Ramón Donaire",
		"Ramón Giménez",
		"Ranchitos",
		"Ranquil Norte",
		"Ranquilco Pozos Petrolíferos",
		"Real Bayo",
		"Real De Moyano",
		"Real Del Colorado",
		"Real Del León",
		"Real Del Padre",
		"Real Del Pelambre",
		"Real Escondido",
		"Real Loma Blanca",
		"Real Piedra Horadada",
		"Real Primer Río",
		"Real Rincón De Las Ovejas",
		"Recoaro",
		"Reducción",
		"Refugio La Faja",
		"Refugio Militar Gral Alvarado",
		"Refugio Vialidad",
		"Regino Ojeda",
		"Reina",
		"Resolana",
		"Resurrección",
		"Retamo",
		"Retamo Partido",
		"Reyes",
		"Ricardo Videla",
		"Rincón Chico",
		"Rincón De Correa",
		"Rincón De La Ramada Chato",
		"Rincón Del Atuel",
		"Rincón Escondido",
		"Rincón Huaiquerias",
		"Río Barrancas",
		"Río Blanco",
		"Río Chico",
		"Río Grande",
		"Rivadavia",
		"Rivas",
		"Roberts",
		"Rodeo De La Cruz",
		"Rodeo Del Medio",
		"Rodeo Grande",
		"Rodolfo Iselin",
		"Rodríguez",
		"Rodríguez Peña",
		"Rosario Gatica",
		"Rufino Gómez",
		"Ruiz Huidobro",
		"Russell",
		"Ruta 7 Kilometro 1014",
		"S Cortis",
		"S Estrella",
		"Salinas El Diamante",
		"Salto De Las Rosas",
		"San Alberto",
		"San Antonio",
		"San Carlos",
		"San Francisco Del Monte",
		"San Ignacio",
		"San José",
		"San José De Guaymallen",
		"San José De Tupungato",
		"San Martin",
		"San Miguel",
		"San Pablo",
		"San Pedro",
		"San Pedro De Atuel",
		"San Pedro Del Atuel",
		"San Rafael",
		"San Roque",
		"Sánchez De Bustamante",
		"Santa Ana",
		"Santa Blanca",
		"Santa Clara",
		"Santa Elena",
		"Santa María",
		"Santa María De Oro",
		"Santa Marta",
		"Santa Rosa",
		"Santa Teresa",
		"Santiago Romero",
		"Santo Domingo",
		"Sarmiento",
		"Saturnino Romero",
		"Serviliano Ojeda",
		"Sierra Ansilta",
		"Sierra De Las Higueras",
		"Sierra Del Tontal",
		"Sixto Ledesma",
		"Soitue",
		"Sopanta",
		"T Orozco",
		"Tabanera",
		"Talquenca",
		"Tambito",
		"Tapera De Los Viejos",
		"Tapera Negra",
		"Tapón",
		"Teodoro Garro",
		"Teodoro Villaruel",
		"Teofila Acevedo",
		"Teófilo Ruben",
		"Teófilo Zapata",
		"Teresa B De Tittarelli",
		"Termas Villavicencio",
		"Tierras Blancas",
		"Tila",
		"Tilio Alcaraz",
		"Tomas Mercado",
		"Toscal Del Toro",
		"Totoral",
		"Travesía",
		"Tres Acequias",
		"Tres Banderas",
		"Tres Esquinas",
		"Tres Porteñas",
		"Trino Rosaleso",
		"Tropero Sosa",
		"Tte Benjamin Matienzo",
		"Tulumaya",
		"Tunuyan",
		"Tupungato",
		"Ugarteche",
		"Urisa",
		"Uspallata",
		"V Hipódromo",
		"V N De Cochiquita",
		"Valle De Las Leñas",
		"Valle De Uspallata",
		"Valle Hermoso",
		"Vega De Los Burros",
		"Vega De Praso",
		"Vega Ferraina",
		"Vegas De Las Ovejas",
		"Vegas De Los Corrales De Araya",
		"Vergel",
		"Vicente Muñoz",
		"Vicente Peletay",
		"Villa Antigua",
		"Villa Atuel",
		"Villa Bastias",
		"Villa Cátala",
		"Villa Centenario",
		"Villa Comparto",
		"Villa Del Carmen",
		"Villa Gaviola",
		"Villa Hipodromo",
		"Villa La Paz",
		"Villa Los Corralitos",
		"Villa Molino Orfila",
		"Villa Nueva",
		"Villa Nueva De Guaymallen",
		"Villa Primavera",
		"Villa Rivadavia",
		"Villa San Isidro",
		"Villa Seca",
		"Villa Seca De Tunuyan",
		"Villa Suava",
		"Villa Vieja",
		"Villas Unidas 25 De Mayo",
		"Villavicencio",
		"Vista Flores",
		"Vistalba",
		"Viuda De Orozco",
		"Viuda De Satelo",
		"Volcán Maipu",
		"Vra De Las Vacas",
		"Vuelta Del Zanjon",
		"Zanjón Amarillo",
		"Zanon Canal",
		"Zapata"
	],
	Misiones: [
		"1 De Mayo",
		"17 De Agosto",
		"2 De Abril",
		"2 De Mayo",
		"22 De Diciembre",
		"25 De Mayo",
		"3 De Mayo",
		"9 De Julio",
		"9 De Julio Kilometro 20",
		"Acaragua",
		"Adolfo J Pomar",
		"Alba Posse",
		"Almirante Brown",
		"Alta Unión",
		"Aparicio Cue",
		"Apóstoles",
		"Aristóbulo Del Valle",
		"Arrechea",
		"Arroyo",
		"Arroyo Del Medio",
		"Arroyo Fedor",
		"Arroyo Isabel",
		"Arroyo Magdalena",
		"Arroyo Pastora",
		"Arroyo Persiguero",
		"Arroyo Santa María",
		"Arroyo Tomas",
		"Arroyo Tunitas",
		"Arroyo Yabebiri",
		"Aserradero Echeverría",
		"Aserradero Piñalito",
		"Azara",
		"Bañado Grande",
		"Barra Bonita",
		"Barra Concepción",
		"Barracón",
		"Barrancón",
		"Barrio Don Santiago",
		"Bartolito",
		"Bayo Troncho",
		"Belgrano",
		"Bella Vista",
		"Bernardino Rivadavia",
		"Bernardo De Irigoyen",
		"Bonpland",
		"Bonpland Norte",
		"Brazo Del Tacuaruzu",
		"Bretes Mártires",
		"Buena Vista",
		"Caa Yari",
		"Caapora",
		"Cabure",
		"Cainguas",
		"Campana",
		"Campiña De Bonpland",
		"Campiña Grande",
		"Campiñas De América",
		"Campo Alegre",
		"Campo Grande",
		"Campo Ramón",
		"Campo Richardson",
		"Campo San Juan",
		"Campo Tornquinst",
		"Campo Viera",
		"Campos Salles",
		"Candelaria",
		"Capiovi",
		"Capiovisiño",
		"Capitán Antonio Morales",
		"Capivu",
		"Capueron",
		"Caraguatay",
		"Carril De Anta",
		"Carrillo Viejo",
		"Cascuda",
		"Cataratas Del Iguazú",
		"Centinela",
		"Cerro Azul",
		"Cerro Cora",
		"Cheroguita",
		"Chirimay",
		"Citrus",
		"Colonia Alberdi",
		"Colonia Alemana",
		"Colonia Alicia",
		"Colonia Almafuerte",
		"Colonia Aparecida",
		"Colonia Apóstoles",
		"Colonia Aristóbulo Del Valle",
		"Colonia Aurora",
		"Colonia Azara",
		"Colonia Caaguazu",
		"Colonia Capón Bonito",
		"Colonia Chafariz",
		"Colonia Chapa",
		"Colonia Cumanday",
		"Colonia Cunci",
		"Colonia Delicia",
		"Colonia Domingo Savio",
		"Colonia Duran",
		"Colonia El Doradillo",
		"Colonia El Pesado",
		"Colonia El Progreso",
		"Colonia Finlandesa",
		"Colonia Florida",
		"Colonia Fortaleza",
		"Colonia Gramado",
		"Colonia Guaraní",
		"Colonia Japonesa",
		"Colonia Juanita",
		"Colonia La Chillita",
		"Colonia La Gruta",
		"Colonia La Nueva",
		"Colonia La Otilia",
		"Colonia La Polaca",
		"Colonia Leiva",
		"Colonia Manuel Belgrano",
		"Colonia Mártir Santa María",
		"Colonia Mártires",
		"Colonia Mondori",
		"Colonia Ñacangazu",
		"Colonia Oro Verde",
		"Colonia Paduan",
		"Colonia Palmera",
		"Colonia Polaca",
		"Colonia Polana",
		"Colonia Primavera",
		"Colonia Profundidad",
		"Colonia Puerto Rosales",
		"Colonia Roca",
		"Colonia Roca Chica",
		"Colonia San Ignacio",
		"Colonia San Javier",
		"Colonia Santa María",
		"Colonia Santa Teresa",
		"Colonia Seguí",
		"Colonia Siete Estrellas",
		"Colonia Taranco",
		"Colonia Tres Marías",
		"Colonia Victoria",
		"Colonia Yabebiri",
		"Colonia Yacutinga",
		"Comandante Andresito",
		"Concepción De La Sierra",
		"Corpus",
		"Costa Portera",
		"Cruce Caballero",
		"Cruce Londero",
		"Cuña Piru",
		"Cuña Pora",
		"Damus",
		"Deseado",
		"Desplayada",
		"Destacamento Bosques",
		"Domingo Barthe",
		"Don Horacio",
		"Doña María",
		"Doradito",
		"Dos Arroyos",
		"Dos Hermanas",
		"El 26",
		"El Alcázar",
		"El Chatón",
		"El Destierro",
		"El Lapacho",
		"El Macaco",
		"El Paraíso",
		"El Persiguero",
		"El Porvenir",
		"El Rancho",
		"El Reposo",
		"El Saltiño",
		"El Saltito",
		"El Soberbio",
		"El Socorro",
		"El Tigre",
		"El Triunfo",
		"El Tropezón",
		"Eldorado",
		"Ensanche Este",
		"Ensanche Norte",
		"Esperanza",
		"Estación Apóstoles",
		"Estación Experimental De Loret",
		"Estancia Itaembe",
		"Estancia Itaembre",
		"Estancia Santa Rita",
		"Fachinal",
		"Filemon Pose",
		"Florentino Ameghino",
		"Fracran",
		"Fraga Cue",
		"Francés",
		"Fray Luis Beltran",
		"Frigo",
		"Fronteras",
		"Garuhape",
		"Garupa",
		"Garupa Norte",
		"General Alvear",
		"General Urquiza",
		"Gobernador Lanusse",
		"Gobernador Lopez",
		"Gobernador Roca",
		"Gral Guemes",
		"Guaibichu",
		"Guaraní",
		"Guaraypo",
		"Guayabera",
		"Guerrero",
		"Hekenan",
		"Hipolito Yrigoyen",
		"Indumar",
		"Integración",
		"Invernada Chica",
		"Invernada De Itacaruare",
		"Invernada Grande",
		"Invernada San Ignacio",
		"Isla Argentina",
		"Isla San Lucas",
		"Ita Curuzu",
		"Itacaruare",
		"Itaembe Mini",
		"Itaembre Mini",
		"Jardín América",
		"Juan Domingo Peron",
		"Kilometro 10",
		"Kilometro 17 Ruta 8",
		"Kilometro 26",
		"Kilometro 286",
		"Kilometro 34",
		"Kilometro 4",
		"Kilometro 538",
		"Kilometro 546",
		"Kilometro 577",
		"Kilometro 595",
		"Kilometro 60",
		"Kilometro 78",
		"Kilometro 8",
		"Km 1230",
		"Km 1246",
		"Km 1247",
		"Km 18",
		"Km1228",
		"La Bonita",
		"La Capilla",
		"La Flor",
		"La Horqueta",
		"La Invernada",
		"La Milagrosa",
		"La Misionera",
		"La Otilia",
		"La Plantadora",
		"La Posta",
		"La Rotonda",
		"Lapacho",
		"Larraque",
		"Las Bananeras",
		"Las Flores",
		"Las Mandarinas",
		"Las Mercedes",
		"Las Quemadas",
		"Las Tunas",
		"Las Vertientes",
		"Leandro N Alem",
		"Lechuza",
		"Libertad",
		"Línea Cuchilla",
		"Línea De Peray",
		"Loma Pora",
		"Loreto",
		"Los Galpones",
		"Los Helechos",
		"Los Teales",
		"Lote 117",
		"Lote 12",
		"Lote 25",
		"Lote 5",
		"Lujan",
		"Macaca",
		"Macaco",
		"Machadiño",
		"Mai Bao",
		"Manantiales",
		"Manis",
		"Manuel Belgrano",
		"María Antonia",
		"María Magdalena",
		"Mariano Moreno",
		"Mbopicua",
		"Mecking",
		"Mesa Redonda",
		"Miguel Guemes",
		"Miguel Lanús",
		"Milagro",
		"Mocona",
		"Mojón Grande",
		"Monte Hermoso",
		"Monteagudo",
		"Montecarlo",
		"Nacientes Del Isabel",
		"Nacientes Del Tunar",
		"Nueva Valencia",
		"Nueve De Julio",
		"Oasis",
		"Obera",
		"Obligado",
		"Ojo De Agua",
		"Olegario Víctor Andrade",
		"Once Vueltas",
		"Otilia",
		"Panambi",
		"Parada Leis",
		"Paraíso",
		"Paraje Azopardo",
		"Paraje Dos Hermanas",
		"Paraje Estelina",
		"Paraje Granado",
		"Paraje Intercontinental",
		"Paraje Lucero",
		"Paraje Villa Unión",
		"Paranay",
		"Paso Del Arroyo Persiguero",
		"Paso Porteño",
		"Pastoreo",
		"Pati Cua",
		"Pedro Nuñez",
		"Persiguero",
		"Picada Belgrano",
		"Picada Bonpland",
		"Picada Española",
		"Picada Finlandesa",
		"Picada Gobernador López",
		"Picada Iglesia",
		"Picada Libertad",
		"Picada Mandarina",
		"Picada Polaca",
		"Picada Portuguesa",
		"Picada Pozo Feo",
		"Picada Rusa",
		"Picada San Javier",
		"Picada San Martín",
		"Picada Sueca",
		"Picada Sur Mecking",
		"Picada Yapeyu",
		"Pindaiti",
		"Pindapoy",
		"Pindayti",
		"Piñalito Norte",
		"Piñalito Sur",
		"Piray",
		"Piray Mini",
		"Planchada Banderita",
		"Posadas",
		"Profundidad",
		"Pueblo Illia",
		"Pueblo Salto",
		"Puente Nacional",
		"Puerto  Concepción",
		"Puerto Aguirre",
		"Puerto Alcázar",
		"Puerto Alicia",
		"Puerto Aurora",
		"Puerto Avellaneda",
		"Puerto Azara",
		"Puerto Bemberg",
		"Puerto Bossetti",
		"Puerto Canoas",
		"Puerto Caraguatay",
		"Puerto Carolina",
		"Puerto Cazador",
		"Puerto Chuño",
		"Puerto Concepcion",
		"Puerto Delicia",
		"Puerto Doce",
		"Puerto El Dorado",
		"Puerto Errecaborde",
		"Puerto España",
		"Puerto Esperanza",
		"Puerto Gisela",
		"Puerto Hardelaste",
		"Puerto Iguazú",
		"Puerto Ingeniero Morandi",
		"Puerto Insua",
		"Puerto La Mina",
		"Puerto Laharrague",
		"Puerto Leoni",
		"Puerto Libertad",
		"Puerto Londero",
		"Puerto Lujan",
		"Puerto Mado",
		"Puerto Mbopicua",
		"Puerto Menochio",
		"Puerto Mineral",
		"Puerto Naranjito",
		"Puerto Nuevo",
		"Puerto Oro Verde",
		"Puerto Paraíso",
		"Puerto Paranay",
		"Puerto Paticaa",
		"Puerto Paulito",
		"Puerto Península",
		"Puerto Pinares",
		"Puerto Piray",
		"Puerto Rico",
		"Puerto Rosario",
		"Puerto Ruben",
		"Puerto Saltiño",
		"Puerto San Alberto",
		"Puerto San Ignacio",
		"Puerto San Lucas",
		"Puerto San Martín",
		"Puerto Tabay",
		"Puerto Tigre",
		"Puerto Uruguay",
		"Puerto Victoria",
		"Puerto Viejo",
		"Puerto Wanda",
		"Puerto Yabebiri",
		"Puerto Yacuy",
		"Rincón De Bonpland",
		"Rincón De Bugres",
		"Rincón De Chimtray",
		"Rincón De López",
		"Rincón Del Guerrero",
		"Río Yabotay",
		"Roca Chica",
		"Ruinas De Loreto",
		"Ruiz De Montoya",
		"Salto Encantado",
		"Samambaya",
		"San Alberto",
		"San Andrés",
		"San Antonio",
		"San Carlos",
		"San Francisco De Asis",
		"San Gotardo",
		"San Ignacio",
		"San Isidro",
		"San Javier",
		"San José",
		"San Juan",
		"San Juan De La Sierra",
		"San Lucas",
		"San Martín",
		"San Miguel",
		"San Pedro",
		"San Sebastián",
		"San Vicente",
		"Santa Ana",
		"Santa Inés",
		"Santa María La Mayor",
		"Santa María Mártir",
		"Santa Rita",
		"Santa Rosa",
		"Santiago De Liniers",
		"Santo Pipo",
		"Segunda Zona",
		"Sierra De Oro",
		"Sierra De San José",
		"Sierras San Juan",
		"Sol De Mayo",
		"Sol Naciente",
		"Tacuara",
		"Tacuaruzu",
		"Taruma",
		"Teyuguare",
		"Tigre",
		"Timbauba",
		"Tirica",
		"Tobunas",
		"Tororo",
		"Torta Quemada",
		"Tratado De Paz",
		"Tres Bocas",
		"Tres Capones",
		"Tres Esquinas",
		"Villa Armonía",
		"Villa Blanquita",
		"Villa Bonita",
		"Villa Don Bosco",
		"Villa Emilia",
		"Villa Errecaborde",
		"Villa Flor",
		"Villa Inta",
		"Villa Lanús",
		"Villa Libertad",
		"Villa Ojo De Agua",
		"Villa Ortiz Pereira",
		"Villa Roulet",
		"Villa Sarubbi",
		"Villa Svea",
		"Villa Unión",
		"Villa Venecia",
		"Villa Vilma",
		"Villafañe",
		"Villalonga",
		"Virgen De Lourdes",
		"Wanda",
		"Yabebiri",
		"Yacutinga",
		"Yapeyu Centro",
		"Yerbal Mamboreta"
	],
	"Neuquén": [
		"Achico",
		"Agrio Balsa",
		"Aguada Chacay Co",
		"Aguada Florencio",
		"Aguada San Roque",
		"Aguas De Las Mulas",
		"Alianza",
		"Alicura",
		"Alumine",
		"Andacollo",
		"Anquinco",
		"Añelo",
		"Arroyito",
		"Arroyito Challaco",
		"Arroyo Blanco",
		"Arroyo Cahunco",
		"Arroyo Quillen",
		"Arroyo Ranquilco",
		"Atreuco",
		"Auca Mahuida",
		"Auca Pan",
		"Bajada Colorada",
		"Bajada De Los Molles",
		"Bajada Del Agrio",
		"Bajada Del Marucho",
		"Balneario Del Río Agrio",
		"Balsa Del Río Agrio",
		"Balsa Senillosa",
		"Barda Anguil",
		"Barda Negra",
		"Bardas Negras",
		"Barrancas",
		"Barrio Peligroso",
		"Batre Lauquen",
		"Bella Vista",
		"Buena Esperanza",
		"Buta Co",
		"Buta Mallin",
		"Buta Ranquil",
		"Butalon",
		"Caepe Malal",
		"Caichihue",
		"Cajón De Almaza",
		"Cajón De Curi Leuvu",
		"Cajón De Los Patos",
		"Cajón De Manzano",
		"Cajón Del Toro",
		"Cajón Grande",
		"Caleofu",
		"Caleufu",
		"Calihue",
		"Camaleones",
		"Caminera",
		"Caminera Traful",
		"Campamento Sol",
		"Cancha Huiganco",
		"Cancha Huinganco",
		"Cañada Seca",
		"Cañadón De Los Indios",
		"Cañadón Del Indio",
		"Carran Cara",
		"Carran Cura",
		"Carreri",
		"Carri Lauquen",
		"Carri Lil",
		"Casa De Piedra",
		"Catan Lil",
		"Caviahue",
		"Cayanta",
		"Centenario",
		"Cerro Colorado",
		"Cerro De La Grasa",
		"Cerro De La Parva",
		"Cerro De Los Pinos",
		"Cerro Del León",
		"Cerro Gato",
		"Cerro Negro Chapua",
		"Cerro Negro Tricao",
		"Chacabuco",
		"Chacay",
		"Chacay Co",
		"Chacay Melehue",
		"Chacayco",
		"Chacoyal",
		"Challaco",
		"Chanquil Quilla",
		"Chapelco",
		"Chapua",
		"Chapua Abajo",
		"Charahuilla",
		"Chenquecura",
		"Chichiguay",
		"Chimehuin",
		"China Muerta",
		"Chinchina",
		"Chiuquillihuin",
		"Chochoy Mallin",
		"Chorriaca",
		"Chos Malal",
		"Churriaca",
		"Cochico",
		"Codihue",
		"Coihueco",
		"Coli Malal",
		"Colipili",
		"Collon Cura",
		"Collun Co",
		"Colonia Valentina",
		"Confluencia Del Aguijón",
		"Copahue",
		"Corral De Piedra",
		"Correntoso",
		"Costa Del Arroyo Salado",
		"Costa Limay",
		"Covunco",
		"Covunco Abajo",
		"Covunco Arriba",
		"Covunco Centro",
		"Coyuco",
		"Coyuco Cochico",
		"Cuchillo Cura",
		"Cullin Manzano",
		"Cura Co",
		"Curu  Leuvu",
		"Cutral Co",
		"El  Tropezón",
		"El Alamito",
		"El Arbolito",
		"El Atravesado",
		"El Bosque",
		"El Cerrito",
		"El Chingue",
		"El Cholar",
		"El Curileo",
		"El Dormido",
		"El Durazno",
		"El Escorial",
		"El Gato",
		"El Huecú",
		"El Machete",
		"El Manzano",
		"El Oasis",
		"El Overo",
		"El Palao",
		"El Peralito",
		"El Pino Andino",
		"El Portón",
		"El Porvenir",
		"El Salado",
		"El Salitral",
		"El Sauce",
		"El Tromen",
		"El Tropezon",
		"Espinazo Del Zorro",
		"Estancia La Primavera",
		"Estancia Newbery",
		"Estancia Tequel Malal",
		"Filmatue",
		"Filo Hua Hum",
		"Flores",
		"Fortín 1 De Mayo",
		"Fortín Guañacos",
		"Franhucura",
		"Gente Grande",
		"Goñi Co",
		"Guañacos",
		"Haichol",
		"Haras Patria",
		"Haycu",
		"Hua Hum",
		"Hualcupen",
		"Huantraico",
		"Huaraco",
		"Huarenchenque",
		"Huarinchenque",
		"Huechahue",
		"Huechulafquen",
		"Huillilon",
		"Huinca Lu",
		"Huinganco",
		"Huitrin",
		"Humigamio",
		"Huncal",
		"Invernada Vieja",
		"Isla Victoria",
		"Jecanasco",
		"Juaranco",
		"Junín De Los Andes",
		"Kilca Casa",
		"La Angostura De Icalma",
		"La Araucaria",
		"La Arboleda",
		"La Argentina",
		"La Atalaya",
		"La Buitrera",
		"La Ciénaga",
		"La Cieneguita",
		"La Estacada",
		"La Fortuna",
		"La Fría",
		"La Isabel",
		"La Lipela",
		"La Negra",
		"La Ofelia",
		"La Patagonia",
		"La Patria",
		"La Picaza",
		"La Pintada",
		"La Pochola",
		"La Porteña",
		"La Primavera",
		"La Rinconada",
		"La Salada",
		"La Susana",
		"La Teresa",
		"La Teresa Piedra Del Aguila",
		"La Unión",
		"La Verdad",
		"Lago Log Log",
		"Lago Lolog",
		"Lago Ñorquinco",
		"Lago Pulmari",
		"Lagotera",
		"Laguna Blanca",
		"Laguna Miranda",
		"Laja",
		"Lapa",
		"Lapachal",
		"Las Abejas",
		"Las Bandurrias",
		"Las Barditas",
		"Las Chacras",
		"Las Coloradas",
		"Las Cortaderas",
		"Las Lagunas",
		"Las Lajas",
		"Las Lajitas",
		"Las Mercedes",
		"Las Ovejas",
		"Las Perlas",
		"Las Saladas",
		"Las Toscas",
		"Las Tres Lagunas",
		"Lascar",
		"Leuto Caballo",
		"Lileo",
		"Limay Centro",
		"Litran",
		"Liu Cullin",
		"Llamuco",
		"Log Log",
		"Lolog",
		"Loma De La Lata",
		"Lonco Luan",
		"Lonco Mula",
		"Loncopue",
		"Los Bolillos",
		"Los Carrizos",
		"Los Catutos",
		"Los Chacales",
		"Los Chihuidos",
		"Los Chinitos",
		"Los Cisnes",
		"Los Entierros",
		"Los Galpones",
		"Los Menucos",
		"Los Miches",
		"Los Molles",
		"Los Muchachos",
		"Los Rodillos",
		"Los Sauces",
		"Los Tres Chorros",
		"Lubeca",
		"Luicoco",
		"Luin Coco",
		"Machico",
		"Malaico",
		"Malalco",
		"Mallin Blanco",
		"Mallin Chileno",
		"Mallin De La Cueva",
		"Mallin De Las Yeguas",
		"Mallin De Los Caballos",
		"Mallin De Mena",
		"Mallin Del Rubio",
		"Mallin Del Toro",
		"Mallin Quemado",
		"Mamul Malal",
		"Manzano Amargo",
		"Mari Menuco",
		"Mariano Moreno",
		"Mayan Mahuida",
		"Media Luna",
		"Meliquina",
		"Milla",
		"Mina Carrascosa",
		"Mina Lileo",
		"Moquehue",
		"Mulichinco",
		"Nahuel Huapi",
		"Nahuel Mape",
		"Nahueve",
		"Nalay Cullin",
		"Nau Nauco",
		"Nereco Norte",
		"Neuquén",
		"Nireco",
		"Nogueira",
		"Ñireco Sud",
		"Ñorquin",
		"Octavio Pico",
		"Ojo De Agua",
		"Palau",
		"Palitue",
		"Pampa Collon Cura",
		"Pampa De Lonco Luan",
		"Pampa De Tril",
		"Pampa Del Malleo",
		"Pampa Del Salado",
		"Pampa Ferreira",
		"Pantanitos",
		"Paso Aguerre",
		"Paso Ancho",
		"Paso Barda",
		"Paso Cata Tun",
		"Paso Coihue",
		"Paso De Los Indios",
		"Paso De San Ignacio",
		"Península Huemul",
		"Peña Colorada",
		"Pichaihue",
		"Piche Ponon",
		"Pichi Neuquen",
		"Picun Leufu",
		"Piedra Del Aguila",
		"Piedra Mala",
		"Piedra Pintada",
		"Piedras Bayas",
		"Pilmatue",
		"Pilo Lil",
		"Pino Hachado",
		"Pino Solo",
		"Planicie Banderita",
		"Plaza Huincul",
		"Plottier",
		"Portada Covunco",
		"Portezuelo Grande",
		"Pozo Hualiches",
		"Primeros Pinos",
		"Pueblo Nuevo",
		"Puente Picun Leufu",
		"Puerto Anchorena",
		"Puerto Manzano",
		"Puesto Hernandez  Baterías",
		"Punta De Sierra",
		"Quebrada Honda",
		"Quempu Leufu",
		"Quemquemtreu",
		"Quentrenquen",
		"Quila Chanquil",
		"Quila Quehue",
		"Quila Quina",
		"Quilca",
		"Quili Malal",
		"Quillen",
		"Quilquihue",
		"Quinineliu",
		"Quinquimitreo",
		"Quintuco",
		"Quita Quina",
		"Rahue",
		"Ramichal",
		"Ramon M Castro",
		"Ranqueles",
		"Ranquil Vega",
		"Ranquilco",
		"Ranquilon",
		"Reñileo",
		"Richoique",
		"Rincón Chico",
		"Rincón De Emilio",
		"Rincón De Los Sauces",
		"Rincón Grande",
		"Río Agrio",
		"Río Barrancas",
		"Ruca Choroy Arriba",
		"Ruca Chorroy Arriba",
		"Sainuco",
		"Salquico",
		"San Bernardo",
		"San Demetrio",
		"San Eduardo",
		"San Ignacio",
		"San Juan Junín De Los Andes",
		"San Juan Rahue",
		"San Martín De Los Andes",
		"San Patricio Del Chañar",
		"Santa Isabel",
		"Santa María",
		"Santo Domingo",
		"Santo Tomas",
		"Sañico",
		"Sauzal Bonito",
		"Senillosa",
		"Taqui Nileu",
		"Taquimilan",
		"Taquimillan Abajo",
		"Tierras Blancas",
		"Tihue",
		"Tipiliuke",
		"Trahuncura",
		"Tralaitue",
		"Tralatue",
		"Tratayen",
		"Tres Chorros",
		"Tres Picos",
		"Tres Piedras",
		"Tricao Malal",
		"Trili",
		"Tromen",
		"Trompul",
		"Vaca Muerta",
		"Varvarco",
		"Villa Curi Leuvu",
		"Villa El Chocon",
		"Villa La Angostura",
		"Villa Lago Meliquina",
		"Villa Mallin",
		"Villa Pehuenia",
		"Villa Raur",
		"Villa Rincon Chico",
		"Villa Traful",
		"Vilu Mallin",
		"Vista Alegre Norte",
		"Vista Alegre Sur",
		"Zaina Yegua",
		"Zápala",
		"Zingone Y Cia M",
		"Zulemita"
	],
	"Río Negro": [
		"6 De Octubre",
		"Aguada Cecilio",
		"Aguada De Guerra",
		"Aguada De Los Pajaritos",
		"Aguada De Piedra",
		"Aguada Del Loro",
		"Aguada Guzmán",
		"Aguara",
		"Alanitos",
		"Allen",
		"Anecon Chico",
		"Anecon Grande",
		"Arroyo Blanco",
		"Arroyo Chacay",
		"Arroyo De La Ventana",
		"Arroyo La Ventana",
		"Arroyo Las Minas",
		"Arroyo Los Berros",
		"Arroyo Salado",
		"Arroyo Tembrado",
		"Arroyo Verde",
		"Atraico",
		"Bahia Creek",
		"Bajo Del Gualicho",
		"Bajo Rico",
		"Balneario El Cóndor",
		"Balneario Las Grutas",
		"Barda Colorada",
		"Barda Del Medio",
		"Barril Niyeo",
		"Barrio Laguna",
		"Barrio Norte",
		"Benjamin Zorrilla",
		"Boca De La Travesía",
		"Buena Parada",
		"Caltrauna",
		"Campana Mahuida",
		"Canllequin",
		"Cañadón Camallo",
		"Cañadón Chileno",
		"Cañadón Del Corral",
		"Carhue",
		"Carri Yegua",
		"Carrilauquen",
		"Casa Quemada",
		"Cascada Los Cantaros",
		"Catriel",
		"Cerro Abanico",
		"Cerro Alto",
		"Cerro De Policía",
		"Cerro Mesa",
		"Cerro Policia",
		"Cervantes",
		"Chacalhua Ruca",
		"Chacay Huarruca",
		"Chacras De Allen",
		"Chaiful",
		"Chasico",
		"Chelforo",
		"Chenqueniyeu",
		"Chichihuao",
		"Chichinales",
		"Chimpay",
		"China Muerta",
		"Chipauquil",
		"Chocori",
		"Choele Choel",
		"Churquiñeo",
		"Cinco Chañares",
		"Cinco Saltos",
		"Cipolletti",
		"Clemente Onelli",
		"Colan Conhue",
		"Coli Toro",
		"Colonia Alte Guerrico",
		"Colonia El Manzano",
		"Colonia General Frías",
		"Colonia Josefa",
		"Colonia Julia Y Echarren",
		"Colonia La Luisa",
		"Colonia Regina",
		"Colonia Rusa",
		"Colonia San Juan",
		"Comallo",
		"Comallo Abajo",
		"Comi Co",
		"Comí Co",
		"Cona Niyeu",
		"Contralmirante Cordero",
		"Contralmirante M Guerrico",
		"Coquelen",
		"Coronel Belisle",
		"Coronel Eugenio Del Busto",
		"Coronel Francisco Sosa",
		"Coronel Juan José Gómez",
		"Coronel Vidal",
		"Corral De Los Pinos",
		"Corralito",
		"Cos Zaures",
		"Costa Del Río Azul",
		"Costas Del Pichi Leufu",
		"Cuatro Esquinas",
		"Cubanea",
		"Cuenca Vidal",
		"Cuesta Del Ternero",
		"Cura Lauquen",
		"Darwin",
		"Dina Huapi",
		"El Bolsón",
		"El Cacique",
		"El Cain",
		"El Camaruro",
		"El Cheiful",
		"El Cuy",
		"El Dique",
		"El Foyel",
		"El Gaucho Pobre",
		"El Jardinero",
		"El Manso",
		"El Manzano",
		"El Moligue",
		"El Pantanoso",
		"El Porvenir",
		"El Salado",
		"Empalme Kilometro 648",
		"Estancia El Cóndor",
		"Estancia Las Julias",
		"Falckner",
		"Ferri",
		"Fita Ruin",
		"Fitalancao",
		"Fitamiche",
		"Fitatimen",
		"Fortín Uno",
		"Ganzu Lauquen",
		"General Conesa",
		"General Enrique Godoy",
		"General Fernández Oro",
		"General Liborio Bernal",
		"General Roca",
		"Guardia Mitre",
		"Hua Miche",
		"Huan Luan",
		"Ingeniero Huergo",
		"Ingeniero Jacobacci",
		"Ingeniero Zimmermann Resta",
		"Ingenio San Lorenzo",
		"Iris",
		"Isla Chica",
		"Isla Grande",
		"Isla Victoria",
		"Jagüel Campo Monte",
		"Janinue",
		"Jita Rusia",
		"Juan De Garay",
		"Kili Malal",
		"Kilometro 1218",
		"La Adela",
		"La Alianza",
		"La Angostura",
		"La Bombilla",
		"La Carolina",
		"La Chilena",
		"La Criollita",
		"La Elvira",
		"La Emilia",
		"La Esmeralda",
		"La Esperanza",
		"La Estancia Vieja",
		"La Estrella",
		"La Excurra",
		"La Flecha",
		"La Granja",
		"La Julia",
		"La Loberia",
		"La Lucinda",
		"La María Inés",
		"La Meseta",
		"La Mimosa",
		"La Porteña",
		"La Primavera",
		"La Quebrada",
		"La Rinconada",
		"La Rubia",
		"La Sara",
		"La Vencedora",
		"Lago Pellegrini",
		"Laguna Blanca",
		"Laguna Cortes",
		"Laguna De La Prueba",
		"Laguna Del Barro",
		"Laguna Del Monte",
		"Laguna Frías",
		"Laguna Los Juncos",
		"Lagunita",
		"Lamarque",
		"Lanquiñeo",
		"Las Bayas",
		"Las Maquinas",
		"Las Mellizas",
		"Las Perlas",
		"Las Piedras",
		"Lenzaniyen",
		"Loma Blanca",
		"Lonco Vaca",
		"Los Costeros",
		"Los Juncos",
		"Los Manantiales",
		"Los Menucos",
		"Los Molinos",
		"Los Pirineos",
		"Los Quebrachos",
		"Los Repollos",
		"Los Sauces",
		"Luis Beltran",
		"Luis M Zagaglia",
		"Mainque",
		"Mallin Ahogado",
		"Mamuel Choique",
		"Mancha Blanca",
		"Mancullique",
		"Maquinchao",
		"María Cristina",
		"Mata Negra",
		"Médanos Negros",
		"Mencue",
		"Menuco Vaca Muerta",
		"Michi Honoca",
		"Michihuao",
		"Ministro Ramos Mexia",
		"Mulanillo",
		"Musters",
		"Nahuel Niyeu",
		"Naupa Huen",
		"Negro Muerto",
		"Neneo Ruca",
		"Niluan",
		"Nueva Carolina",
		"Nuevo León",
		"Ñirihuao Estacion Fcgr",
		"Ñorquinco",
		"Ojo De Agua Embarcadero Fcgb",
		"Ojos De Agua Embarcadero Fcgb",
		"Padre Alejandro Stefanelli",
		"Paja Alta",
		"Pajalta",
		"Palenque Niyeu",
		"Panquehuao",
		"Paso Chacabuco",
		"Paso Cordova",
		"Paso De Los Molles",
		"Paso Del Limay",
		"Paso Flores",
		"Paso Lezcano",
		"Paso Miranda",
		"Paso Piedra",
		"Peñas Blancas",
		"Percy H Scott",
		"Perito Moreno",
		"Perito Moreno Estación Fcgr",
		"Pichi Leufu",
		"Pichi Leufu Abajo",
		"Pichi Leufu Arriba",
		"Pichi Mahuida",
		"Pilahue",
		"Pilcaniyeu",
		"Pilcaniyeu Viejo",
		"Pilqui Niyeu",
		"Pilquiniyeu",
		"Pilquiniyeu Del Limay",
		"Planicie De Jaguelito",
		"Playa Bonita",
		"Playas Doradas",
		"Pomona",
		"Portezuelo",
		"Pozo Moro",
		"Pozo Salado",
		"Prahuaniyeu",
		"Primera Angostura",
		"Puerto Blest",
		"Puerto Ojo De Agua",
		"Puerto San Antonio Este",
		"Puesto Faria",
		"Puesto Gaviña",
		"Punta De Agua",
		"Qirihuao Estación Fcgr",
		"Qorquinco",
		"Quempu Niyeu",
		"Quetrequile",
		"Quinta Panal",
		"Rayhuao",
		"Repollos",
		"Rincón De Gastre",
		"Rinconada",
		"Río Chico",
		"Río Colorado",
		"Río Salado",
		"Río Villegas",
		"Rucu Luan",
		"Saco Viejo",
		"Salitral Negro",
		"San Antonio Oeste",
		"San Carlos De Bariloche",
		"San Javier",
		"San Jorge",
		"San Juan",
		"San León",
		"San Lorenzo",
		"San Pedro",
		"San Ramón",
		"San Simón",
		"Santa Elena",
		"Santa Genoveva",
		"Santa Gregoria",
		"Santa Nicolasa",
		"Sargento Vidal",
		"Sauce Blanco",
		"Segunda Angostura",
		"Sierra Colorada",
		"Sierra De La Ventana",
		"Sierra Grande",
		"Sierra Paileman",
		"Teniente Maza Estación Fcgr",
		"Tercera Zona",
		"Travesía Castro",
		"Treneta",
		"Tres Ojos De Aguas",
		"Tricaco",
		"Tromeniyeu",
		"Tte Gral Eustaquio Frias",
		"Tte Gral Eustoquio Frías",
		"Tunquelen",
		"Vaca Lauquen",
		"Valcheta",
		"Valle Azul",
		"Valle De Los Alamos",
		"Viedma",
		"Villa Alberdi",
		"Villa Llanquin",
		"Villa Manzano",
		"Villa Mascardi",
		"Villa Regina",
		"Villa Turismo",
		"Yaminue",
		"Yuquinche"
	],
	Salta: [
		"20 De Febrero",
		"Ablome",
		"Abra De Araguyoc",
		"Abra Del Gallo",
		"Abra Grande",
		"Acambuco",
		"Acazoque",
		"Acharas",
		"Acosta",
		"Acoyte",
		"Agua Negra",
		"Agua Sucia",
		"Agua Verde",
		"Aguaray",
		"Aguas Blancas",
		"Aguas Calientes",
		"Aguas Muertas",
		"Alejo De Alberro",
		"Alem",
		"Alemania Campos De",
		"Alfarcito",
		"Algarrobal",
		"Algarrobal Viejo",
		"Almirante Brown",
		"Almona",
		"Alto Alegre",
		"Alto De La Sierra",
		"Alto Del Mistol",
		"Alto Verde",
		"Altos Hornos Guemes",
		"Amaicha",
		"Amberes",
		"Amblayo",
		"Ampascachi",
		"Ampata",
		"Angastaco",
		"Angel Peredo",
		"Angélica",
		"Angosto Pescado",
		"Angostura",
		"Animana",
		"Antilla",
		"Antonio Alice",
		"Antonio Quijarro",
		"Apolinario Saravia",
		"Arbol Solo",
		"Arenal",
		"Arenales",
		"Arita",
		"Arjuntas",
		"Arrocero Italiano",
		"Astillero",
		"Atocha",
		"Atudillo",
		"Azul Cuesta",
		"Bacoya",
		"Bajada",
		"Bajada Blanca",
		"Bajada De Gavi",
		"Bajada Grande",
		"Bajo Grande",
		"Bajo Grande Desvío Fcgb",
		"Balboa",
		"Balbuena",
		"Balderrama",
		"Ballenal",
		"Banda Grande",
		"Baños Termales",
		"Baradero",
		"Barbayasco",
		"Baritu",
		"Barrealito",
		"Barrial",
		"Barrio La Loma",
		"Barrio Parabólica",
		"Barrio San Antonio",
		"Barrio San Cayetano",
		"Barro Negro",
		"Belgrano",
		"Belgrano Fortín 2",
		"Bella Vista",
		"Betania",
		"Bodeguita",
		"Brealito",
		"Buen Lugar",
		"Buena Fe",
		"Buena Vista",
		"Burro Yaco",
		"Cabeza De Anta",
		"Cabeza De Buey",
		"Cabra Corral Dique",
		"Cachi",
		"Cachi Adentro",
		"Cachiñal",
		"Cacho Molino",
		"Cafayate",
		"Caipe",
		"Calderilla",
		"Calvimonte",
		"Cámara",
		"Caminera San Pedrito",
		"Campamento Tablilla",
		"Campamento Vespucio",
		"Campichuelo",
		"Campo Alegre",
		"Campo Argentino",
		"Campo Azul",
		"Campo Caseros",
		"Campo Duran",
		"Campo Largo",
		"Campo Libre",
		"Campo Quijano",
		"Campo Santo",
		"Campos De Alemania",
		"Cancillar",
		"Cangrejillos",
		"Cantera Del Sauce",
		"Cañada De La Junta",
		"Cañadón De Las Juntas",
		"Capiazutti",
		"Capilla Fuerte",
		"Capitán Juan Page",
		"Carabajal",
		"Carahuasi",
		"Carapari",
		"Carreras",
		"Casa Grande",
		"Castañares",
		"Castellanos",
		"Cauchari",
		"Cebados",
		"Ceibal",
		"Ceibalito",
		"Cerrillos",
		"Cerro Alemania",
		"Cerro Bayo",
		"Cerro Bravo",
		"Cerro Colorado",
		"Cerro De La Zorra Vieja",
		"Cerro Del Agua De La Falda",
		"Cerro Mal Canto",
		"Cerro Negro",
		"Cevilar",
		"Chacar",
		"Chachapoyas",
		"Chachas",
		"Chacra Experimental",
		"Chaguaral",
		"Chamical",
		"Chañar",
		"Chañar Aguada",
		"Chañar Muyo",
		"Chicoana",
		"Chilcas",
		"Chirete",
		"Chivilme",
		"Chiyayoc",
		"Chorrillitos",
		"Chorrillos",
		"Chorro Blanco",
		"Chorroarin",
		"Chuculaqui",
		"Ciervo Cansado",
		"Cnel Juan Sola Est Morillo",
		"Coba",
		"Cobas",
		"Cobos",
		"Colanzuli",
		"Colgadas",
		"Colmenar",
		"Colome",
		"Colon",
		"Colonia A",
		"Colonia Agrícola San Agustín",
		"Colonia Buenaventura",
		"Colonia D",
		"Colonia El Fuerte",
		"Colonia Hurlingham",
		"Colonia Otomana",
		"Colonia Santa María",
		"Colonia Santa Rosa",
		"Colonia Santa Rosa De Lima",
		"Colonia Zanja Del Tigre",
		"Colorado",
		"Colte",
		"Conchas",
		"Condado",
		"Cóndor",
		"Copo Quile",
		"Coronel Cornejo",
		"Coronel Juan Sola",
		"Coronel Moldes",
		"Coronel Mollinedo",
		"Coronel Olleros",
		"Coronel Vidt",
		"Coropampa",
		"Corral Quemado",
		"Corralito",
		"Corrida De Cori",
		"Cortaderas",
		"Corzuela",
		"Cosme",
		"Cruz Quemada",
		"Cuchiyaco",
		"Cuesta Azul",
		"Cuesta Chica",
		"Cuesta Del Obispo",
		"Curuzu",
		"Damian M Torino",
		"Damián N Torino",
		"Diamante",
		"Diego De Almagro",
		"Dique Embalse Campo Alegre",
		"Dique Itiruyo",
		"Divisadero",
		"Doctor Facundo Zuviria",
		"Dos Yuchanes",
		"Dragones",
		"Duraznito",
		"Durazno",
		"Ebro",
		"El Acheral",
		"El Aguay",
		"El Aguilar",
		"El Alfredito",
		"El Algarrobal",
		"El Algarrobo",
		"El Alisal",
		"El Arenal",
		"El Aybal",
		"El Borde De San Miguel",
		"El Bordo",
		"El Bordo Campo Santo",
		"El Breal",
		"El Brealito",
		"El Brete",
		"El Candado",
		"El Carancho",
		"El Carmen",
		"El Carril",
		"El Carrizal",
		"El Ceibal",
		"El Chorro",
		"El Churcal",
		"El Cienago",
		"El Cienego",
		"El Colegio",
		"El Colgado",
		"El Cóndor",
		"El Corral Viejo",
		"El Corralito",
		"El Crestón",
		"El Cuchillo",
		"El Cuibal",
		"El Cuinco Pozo Del",
		"El Desmonte",
		"El Destierro",
		"El Dorado",
		"El Encon",
		"El Espinal",
		"El Espinillo",
		"El Estanque",
		"El Fraile",
		"El Gallinato",
		"El Galpon",
		"El Galpón Est Foguista J F",
		"El Golgota",
		"El Guanaco",
		"El Huaico",
		"El Jaravi",
		"El Jardín",
		"El Leoncito",
		"El Líbano",
		"El Manantial",
		"El Manzano",
		"El Maray",
		"El Mirador",
		"El Mistol",
		"El Molino",
		"El Mollar",
		"El Molle",
		"El Moranillo",
		"El Moyar",
		"El Naranjo",
		"El Nogalar",
		"El Ñato",
		"El Obelisco",
		"El Ojito",
		"El Ojo",
		"El Oso",
		"El Pacara",
		"El Parque",
		"El Pericote",
		"El Pértigo",
		"El Portezuelo",
		"El Porvenir",
		"El Potrero",
		"El Potrero De Díaz",
		"El Prado",
		"El Pucara",
		"El Puestito",
		"El Puyil",
		"El Qato",
		"El Quebrachal",
		"El Quemado",
		"El Quimilar Carboncito",
		"El Recreo",
		"El Retiro",
		"El Rey",
		"El Rodeo",
		"El Rosal",
		"El Salto",
		"El Sapo",
		"El Sauce",
		"El Sauzal",
		"El Simbolar",
		"El Soldadito",
		"El Sunchal",
		"El Tabacal",
		"El Tala",
		"El Tala Est R De Los Llanos",
		"El Talar",
		"El Tandil",
		"El Tapial",
		"El Tartagal",
		"El Timbo",
		"El Tipal",
		"El Toro",
		"El Trigal",
		"El Tunal",
		"El Tunalito",
		"El Vallecito",
		"El Vencido",
		"El Yacon",
		"El Yeso",
		"El Zanjón",
		"El Zapallar",
		"El Zapallo",
		"Eltunal",
		"Embarcación",
		"Emboscada",
		"Encrucijada",
		"Encrucijada De Tastil",
		"Entre Ríos",
		"Escalchi",
		"Escoipe",
		"Espinillo",
		"Esquina",
		"Est El Bordo",
		"Est Pocitos",
		"Estación Cachiñal",
		"Estación Zuviria",
		"Estancia Vieja",
		"Esteban De Urizar",
		"Esteco Embarcadero Fcgb",
		"Estela",
		"Estola",
		"Federación",
		"Finca Armonía",
		"Finca Belgrano",
		"Finca Camino A Colon",
		"Finca Camino Vallisios",
		"Finca Colon",
		"Finca El Carmen",
		"Finca El Colegio",
		"Finca La China",
		"Finca La Rosa",
		"Finca La Toma",
		"Finca Misión Zenta",
		"Finca Rocca",
		"Finca Santiago",
		"Floresta",
		"Foguista J F Juárez",
		"Fortín Belgrano",
		"Fortín Frías",
		"Frontera 4",
		"Frontera 5",
		"Frontera Tres",
		"Fuerte Alto",
		"Fuerte El Pito",
		"Fuerte Quemado",
		"Gallinato",
		"Gaona",
		"General Alvarado",
		"General Ballivian",
		"General Enrique Mosconi",
		"General Guemes",
		"General Pizarro",
		"Gobernador Manuel Sola",
		"Gobernador Saravia",
		"González",
		"Grandes Pastos",
		"Guachipas",
		"Gualfin",
		"Gualiana",
		"Guamachi",
		"Hickman",
		"Hickmann",
		"Higueras",
		"Higuerillas",
		"Hipolito Yrigoyen",
		"Hito 1",
		"Hombre Muerto Salar De",
		"Horcones",
		"Hornillos",
		"Hostería Juramento",
		"Huaicondo",
		"Huayra Huasy",
		"Huerta",
		"Humaita",
		"Humanas",
		"Incachuli",
		"Incahuasi",
		"Incamayo",
		"Ingeniero Maury",
		"Ingenio San Isidro",
		"Ingenio San Martín",
		"Iruya",
		"Isla De Cañas",
		"Isla De La Candelaria",
		"Isonza",
		"Ituyuro",
		"Jacimana",
		"Jeronimo Matorras",
		"Joaquín V González",
		"Juncal",
		"Juncalito",
		"Juntas De San Antonio",
		"Juramento",
		"Kilometro 1088",
		"Kilometro 1094",
		"Kilometro 1102",
		"Kilometro 1104",
		"Kilometro 1125",
		"Kilometro 1129",
		"Kilometro 1152",
		"Kilometro 1156",
		"Kilometro 1172",
		"Kilometro 1176 300",
		"Kilometro 1280",
		"Kilometro 1281",
		"Kilometro 1291",
		"Kilometro 1298",
		"Kilometro 1306 Fcgb",
		"Kilometro 1369",
		"Kilometro 1373",
		"Kilometro 1398",
		"Kilometro 1424",
		"Kilometro 1448",
		"La Aguadita",
		"La Arcadia",
		"La Argentina",
		"La Armonía",
		"La Asunción",
		"La Banda",
		"La Bodega",
		"La Bodeguita",
		"La Cabaña",
		"La Calavera",
		"La Caldera",
		"La Cancha",
		"La Candelaria",
		"La Cañada",
		"La Carretera",
		"La Casualidad Mina",
		"La China",
		"La Ciénaga",
		"La Cieneguita",
		"La Costa",
		"La Costosa",
		"La Cruz",
		"La Cuestita Anta",
		"La Cuestita Metan",
		"La Curva",
		"La Defensa",
		"La Entrada",
		"La Esperanza",
		"La Esquinita",
		"La Estela",
		"La Estrella",
		"La Falda",
		"La Fama",
		"La Firmeza",
		"La Florida",
		"La Fortuna",
		"La Guardia",
		"La Herradura",
		"La Hoyada",
		"La Huerta",
		"La Isla",
		"La Lagunilla",
		"La Lomita",
		"La Manga",
		"La Maravilla",
		"La Margarita",
		"La Maroma",
		"La Matilde",
		"La Merced",
		"La Mesada Chica",
		"La Mesada Grande",
		"La Montaña",
		"La Mora",
		"La Ofelia",
		"La Oliva",
		"La Pajita",
		"La Palata",
		"La Pampa",
		"La Paya",
		"La Pedrera",
		"La Plata",
		"La Población",
		"La Poma",
		"La Porcelana",
		"La Posta",
		"La Puerta",
		"La Punilla",
		"La Puntilla",
		"La Quena",
		"La Quesera",
		"La Ramada",
		"La Represa",
		"La Silleta",
		"La Soledad",
		"La Tablada",
		"La Toma",
		"La Trampa",
		"La Troja",
		"La Unión",
		"La Viña",
		"La Yesera",
		"Laguna Blanca",
		"Laguna Seca",
		"Laguna Verde",
		"Lagunita",
		"Lagunita Nueva Población",
		"Las Acheras",
		"Las Animas",
		"Las Arcas",
		"Las Arenas",
		"Las Bateas",
		"Las Blancas",
		"Las Bolsas",
		"Las Cañas",
		"Las Cañitas",
		"Las Capillas",
		"Las Catitas",
		"Las Cebadas",
		"Las Conchas",
		"Las Cortaderas",
		"Las Costas",
		"Las Cuestitas",
		"Las Cuevas",
		"Las Curtiembres",
		"Las Delicias",
		"Las Flacas",
		"Las Flechas",
		"Las Flores",
		"Las Garzas",
		"Las Hecheras",
		"Las Higueras",
		"Las Horquetas",
		"Las Juntas",
		"Las Juntas De Alemania",
		"Las Lajitas",
		"Las Lechuzas",
		"Las Llaves",
		"Las Lomitas",
		"Las Maravillas",
		"Las Mercedes",
		"Las Mesadas",
		"Las Mesitas",
		"Las Mojarras",
		"Las Mojarritas",
		"Las Moras",
		"Las Pailas",
		"Las Palmas",
		"Las Piedritas",
		"Las Pircas",
		"Las Rosas",
		"Las Saladas",
		"Las Tienditas",
		"Las Tortugas",
		"Las Trancas",
		"Las Tunillas",
		"Las Varas",
		"Las Vateas",
		"Las Ventanas",
		"Las Vertientes",
		"Las Vertientes Santa Rita De",
		"Las Víboras",
		"Las Viñas",
		"Las Zanjas",
		"Lechiguana",
		"Lesser",
		"Limache",
		"Limoncito",
		"Lipeo",
		"Lizoite",
		"Llucha",
		"Loma De Burro",
		"Lomas De Olmedo",
		"Lorohuasi",
		"Los Alamos",
		"Los Baldes",
		"Los Bañados",
		"Los Baños",
		"Los Blancos",
		"Los Canteros",
		"Los Castillos",
		"Los Chifles",
		"Los Churquis",
		"Los Colorados",
		"Los Corrales",
		"Los Laureles",
		"Los Los",
		"Los Mercados",
		"Los Mogotes",
		"Los Mollinedos",
		"Los Nogales",
		"Los Noques",
		"Los Patos",
		"Los Peñones",
		"Los Pocitos",
		"Los Ranchillos",
		"Los Rosales",
		"Los Sauces",
		"Los Toldos",
		"Los Zanjones",
		"Lote 27",
		"Lote Estela",
		"Lote Josefina",
		"Lote Lucrecia",
		"Lote Marcela",
		"Lote Sarita",
		"Luis Burela",
		"Lumbreras",
		"Luna Muerta",
		"Luracatao",
		"Macapillo",
		"Macho Rastrojo",
		"Macueta",
		"Madariaga",
		"Madre Vieja",
		"Madrejon",
		"Mal Cante",
		"Mal Paso",
		"Manga Vieja",
		"Manuel Elordi",
		"Manuela Pedraza",
		"María José",
		"María Luisa",
		"Martín García",
		"Martínez Del Tinco",
		"Martínez Del Tineo",
		"Matancillas",
		"Matansillas",
		"Mayo Torito",
		"Mecoyita",
		"Media Luna",
		"Merced De Arriba",
		"Meseta",
		"Mesón",
		"Metan",
		"Metan Viejo",
		"Mina Carolina",
		"Mina Don Otto",
		"Mina Julio",
		"Mina La Casualidad",
		"Mina San Esteban",
		"Mina San Guillermo",
		"Mina San Walterio",
		"Mina Tincalaya",
		"Minas Victoria",
		"Minas Ypf",
		"Miraflores",
		"Miraflores M",
		"Misión Chaqueña",
		"Misión Franciscana",
		"Misión La Paz",
		"Misión Santa Lucia",
		"Misiones",
		"Mistol Mareado",
		"Mistolar",
		"Mojotoro",
		"Molino",
		"Molino De Gongora",
		"Molinos",
		"Mollar",
		"Molle Pozo",
		"Mollinedo",
		"Monasterios",
		"Monte",
		"Monte Carmelo",
		"Monte Grande",
		"Monte Viejo",
		"Morales",
		"Morenillo",
		"Morillo",
		"Muñano Kilometro 1308",
		"Nazareno",
		"Nogalito",
		"Nuestra Señora De Talavera",
		"Nuevo Porvenir",
		"Ojo De Agua",
		"Olacapanto Grande",
		"Olacapato Chico",
		"Olacapato Grande",
		"Olmos",
		"Oran",
		"Osma",
		"Otomana",
		"Ovando",
		"Ovejeria",
		"Ovejero",
		"P Salvador Mazza Est Pocito",
		"Pal Tolco",
		"Palermo",
		"Palermo Oeste",
		"Palmarcito",
		"Palmira",
		"Palo A Pique",
		"Palo Pintado",
		"Palo Santo",
		"Palomar",
		"Palomitas",
		"Pampa Grande",
		"Papa Chacra",
		"Paraíso",
		"Paraje Campo Largo",
		"Paraje Cerro Negro",
		"Paraje Cobres",
		"Paraje Cortaderas",
		"Paraje Esquina De Guardia",
		"Paraje Las Cuevas",
		"Paraje Mina Concordia",
		"Paraje Morro Colorado",
		"Paraje Nacimientos",
		"Paraje Olacapato",
		"Paraje Pastos Grandes",
		"Paraje Pircas",
		"Paraje Pizcuno",
		"Paraje Uncuru",
		"Paraje Zanjón",
		"Paramamaya",
		"Parani",
		"Paredes",
		"Pascalla",
		"Pascha",
		"Paso De Balderrama",
		"Paso De La Cruz",
		"Paso De Las Carretas",
		"Paso Del Durazno",
		"Paso Del Río",
		"Paso El Milagro San Aniceto",
		"Paso La Cruz",
		"Paso Verde",
		"Pasteadero",
		"Pastor Sevillosa",
		"Payogasta",
		"Payogastilla",
		"Pedregal",
		"Pedro Lozano",
		"Peñaflor",
		"Peñalva",
		"Peñas Azules",
		"Peñas Blancas",
		"Perú",
		"Pichanal",
		"Pie De La Cuesta",
		"Piedemonte",
		"Piedra Del Molino",
		"Piedra Del Potrillo",
		"Piedras Moradas",
		"Pinal",
		"Piquete Cabado",
		"Piquete De Anta",
		"Piquirenda",
		"Piul",
		"Pizarro",
		"Pluma Del Pato",
		"Población",
		"Población De Ortega",
		"Pocitos",
		"Pocoy",
		"Pompeya",
		"Porongal",
		"Poscaya",
		"Poso De Algarrobo",
		"Potrerillo",
		"Potrerillos",
		"Potrero",
		"Potrero De Castilla",
		"Potrero De Díaz",
		"Potrero De Linares",
		"Potrero De Poyogasta",
		"Potrero De Uriburu",
		"Pozo Azul",
		"Pozo Bermejo",
		"Pozo Blanco",
		"Pozo Bravo",
		"Pozo Cantado",
		"Pozo Cercado",
		"Pozo De La Esquina",
		"Pozo De La Piedra",
		"Pozo Del Chañar",
		"Pozo Del Cuico",
		"Pozo Del Cuinco",
		"Pozo Del Greal",
		"Pozo Del Pato",
		"Pozo Del Sauce",
		"Pozo Del Zorro",
		"Pozo El Algarrobo",
		"Pozo Grande",
		"Pozo Hondo",
		"Pozo Pringles",
		"Pozo Verde",
		"Pozos Largos",
		"Pringles",
		"Pucara",
		"Pueblo Nuevo",
		"Pueblo Viejo",
		"Puente De Díaz",
		"Puente De Plata",
		"Puerta Blanca",
		"Puerta De La Paya",
		"Puerta De Tastil",
		"Puerto Baúles",
		"Puerto De Díaz",
		"Puesto",
		"Puesto De La Viuda",
		"Puesto De Motijo",
		"Puesto Del Medio",
		"Puesto Del Pañuelo",
		"Puesto Grande",
		"Puesto La Paz",
		"Puesto Viejo",
		"Puil",
		"Pulares",
		"Puli",
		"Punca Viscana",
		"Punco Viscana",
		"Punta De Agua",
		"Punta Del Agua",
		"Quebrachal",
		"Quebrada De Escoipe",
		"Quebrada Del Agua",
		"Quebrada Del Toro",
		"Quebrada Muñano",
		"Queñua",
		"Quequa",
		"Quesera",
		"Quisca Grande",
		"Quisca Loro",
		"Quisto",
		"Recaredo",
		"Recreo",
		"Redondo",
		"Resistencia",
		"Retiro",
		"Río Alemania",
		"Río Ancho",
		"Río Blanco",
		"Río Carapan",
		"Río Colorado",
		"Río De Las Piedras",
		"Río Del Valle",
		"Río Lavallen",
		"Río Pescado",
		"Rio Piedras",
		"Río Seco",
		"Río Toro",
		"Río Urueña",
		"Rivadavia",
		"Roca",
		"Rodeo Colorado",
		"Rodeo Grande",
		"Rodeo Pampa",
		"Rodeos",
		"Rosales",
		"Rosario De La Frontera",
		"Rosario De Lerma",
		"Rosario Del Dorado",
		"Rosario Funca",
		"Ruiz De Los Llanos",
		"Rumihuasi",
		"Rumiuarco",
		"S Jollin",
		"Sacha Pera",
		"Saladillo",
		"Saladillo De Juárez",
		"Saladillo De Osma",
		"Salar De Hombre Muerto",
		"Salar De Pocitos",
		"Salar Del Hombre Muerto",
		"Salazar",
		"Salta",
		"Salta Forestal Kilometro 50",
		"Salvador Mazza",
		"San Agustín",
		"San Alejo",
		"San Andrés",
		"San Antonio",
		"San Antonio Chicoana",
		"San Antonio De Iruya",
		"San Antonio De Los Cobres",
		"San Antonio La Viña",
		"San Bernardo",
		"San Bernardo De Las Zorras",
		"San Carlos",
		"San Clemente",
		"San Esteban",
		"San Felipe",
		"San Fernando",
		"San Fernando De Escoipe",
		"San Francisco",
		"San Gabriel",
		"San Geronimo",
		"San Ignacio",
		"San Ignacio De Loyola",
		"San Isidro",
		"San Isidro De Iruya",
		"San Javier",
		"San Joaquín",
		"San Jorge",
		"San José",
		"San José De Colte",
		"San José De Escalchi",
		"San José De La Viña",
		"San José De Orqueras",
		"San Juan",
		"San Juan De Oro",
		"San Laurencio",
		"San León",
		"San Lorenzo",
		"San Lorenzo Horcones",
		"San Lucas",
		"San Luis",
		"San Marcos",
		"San Martín",
		"San Martín La Cuesta",
		"San Miguel",
		"San Nicolás",
		"San Patricio",
		"San Pedro",
		"San Pedro De Aranda",
		"San Pedro De Iruya",
		"San Pedro De Los Corrales",
		"San Pedro De San Alberto",
		"San Rafael",
		"San Ramón",
		"San Ramón De La Nueva Oran",
		"San Roque",
		"San Sebastian",
		"San Vicente",
		"Santa Ana",
		"Santa Barbara",
		"Santa Catalina",
		"Santa Clara",
		"Santa Cruz",
		"Santa Elena",
		"Santa Gertrudis",
		"Santa Lucia",
		"Santa María",
		"Santa Marina",
		"Santa Rita",
		"Santa Rosa",
		"Santa Rosa De Anta",
		"Santa Rosa De Los Patos Grande",
		"Santa Rosa De Tastil",
		"Santa Rufina",
		"Santa Teresa",
		"Santa Victoria",
		"Santa Victoria Este",
		"Santa Victoria Oeste",
		"Santo Domingo",
		"Santo Domingo Anta",
		"Santo Domingo Santa Victoria",
		"Santos Lugares",
		"Sapo Quemado",
		"Sargento Cristóbal",
		"Sauce",
		"Sauce Alegre",
		"Sauce Bajada",
		"Sauce Redondo",
		"Sauce Solo",
		"Saucelito",
		"Sausalito",
		"Sauzal",
		"Schneidewind",
		"Seclanta Adentro",
		"Seclantas",
		"Seclantas Adentro",
		"Senda Hachada Estación Fcgb",
		"Sevillar",
		"Simbol Yaco",
		"Simbolar",
		"Simbolito",
		"Siñunto",
		"Socompa",
		"Solazuti",
		"Soledad",
		"Soledani",
		"Sta Rosa De Los Pastos Grandes",
		"Sumalao",
		"Sunchalito",
		"Suri Micuna",
		"Suri Pintado",
		"Tabacal Ingenio",
		"Tabaco Cimarrón",
		"Taca Taca Estación Fcgb",
		"Taco Pampa",
		"Tacuara",
		"Tacuil",
		"Tala",
		"Tala Muyo",
		"Tala Yaco",
		"Talapampa",
		"Talas",
		"Talavera",
		"Tamas Cortadas",
		"Tartagal",
		"Tilian",
		"Tipa Sola",
		"Tipayoc",
		"Titicoite",
		"Tobantirenda",
		"Tolar Chico",
		"Tolar Grande",
		"Tolloche",
		"Tolombon",
		"Tomuco",
		"Tonco",
		"Tonono",
		"Toro",
		"Toro Pampa",
		"Toro Yaco",
		"Toroyoc",
		"Torzalito",
		"Totoral",
		"Tranquitas",
		"Tres Acequias",
		"Tres Cruces",
		"Tres Morros",
		"Tres Pozos",
		"Tres Yuchanes",
		"Trigal",
		"Trigo Huayco",
		"Trusuca",
		"Tuctuca",
		"Tunalito",
		"Tuyunti",
		"Uchogol",
		"Uchuyoc",
		"Unquillal Embarcadero Fcgb",
		"Urundel",
		"Vado Hondo",
		"Valle Delgado",
		"Valle Encantado",
		"Vallecito",
		"Vaquería",
		"Vaquería Los Sauces",
		"Vaqueros",
		"Vega De Arizaro",
		"Velardes",
		"Vencida",
		"Vera Cruz",
		"Vespucio",
		"Viaducto El Muñal",
		"Victorica",
		"Vieja Pozo",
		"Villa Alem",
		"Villa Aurelia",
		"Villa Corta",
		"Villa Fanny",
		"Villa General Guemes",
		"Villa Los Tarcos",
		"Villa Mayor Zabaleta",
		"Villa Petrona",
		"Villa Saavedra",
		"Villa San Lorenzo",
		"Villa Sola",
		"Villitas",
		"Vinal Pozo",
		"Vinalito",
		"Viñaco",
		"Viñal Pozo",
		"Virgilio Tedin",
		"Virrey Toledo",
		"Viscachani",
		"Vizcacheral",
		"Vizcarra",
		"Volcán Azufre",
		"Volcán Higueras",
		"Vuelta De Las Tobas",
		"Weisburg",
		"Yacara",
		"Yacay",
		"Yacera",
		"Yacimiento Tonono",
		"Yacochuya",
		"Yacones",
		"Yacuy",
		"Yanchuya",
		"Yariguarenda",
		"Yasquiasme",
		"Yatasto",
		"Yuchan",
		"Zanja Honda",
		"Zanjón",
		"Zapallito"
	],
	"San Juan": [
		"9 De Julio",
		"Acerillos",
		"Adán Quiroga",
		"Aeropuerto San Juan",
		"Agua Cercada",
		"Agua De La Zanja",
		"Agua De La Zorra",
		"Agua De Los Caballos",
		"Agua Escondida",
		"Agua Y Energía",
		"Aguada De La Peña",
		"Aguaditas",
		"Aguaditas Del Río Jachal",
		"Aguango",
		"Aguas Del Pájaro",
		"Alamito",
		"Albarracin",
		"Alcaucha",
		"Algarrobo Del Cura",
		"Algarrobo Grande",
		"Algarrobo Verde",
		"Alto De Sierra",
		"Alto Huaco",
		"Amarfil",
		"Ambas Puntillas",
		"Ampacama",
		"Angaco Norte",
		"Angaco Sud",
		"Angualasto",
		"Apeadero Guanacache",
		"Apeadero Las Chimbas",
		"Apeadero Quiroga",
		"Arrequintin",
		"Aschichusca",
		"Astica",
		"Aurora",
		"Azucarera De Cuyo",
		"Balde De Leyes",
		"Balde Del Lucero",
		"Balde Del Norte",
		"Balde Del Rosario",
		"Balde Plumerito",
		"Balde San Carlos",
		"Baldecito",
		"Baldecito Del Morado",
		"Baldes De La Chilca",
		"Baldes Del Sud",
		"Baldes Del Tarabay",
		"Baños Centenario",
		"Baños De La Laja",
		"Baños De Los Despoblados",
		"Baños De San Crispin",
		"Baños Del Cerro",
		"Baños Del Salado",
		"Baños Pismanta",
		"Barranca Colorada",
		"Barranca De Los Loros",
		"Barrancas Blancas",
		"Barreal",
		"Barréales",
		"Barrealito",
		"Barrialitos",
		"Barrio Agua Y Energía",
		"Barrio Colon",
		"Barrio El Tontal",
		"Barrio Graffigna",
		"Barrio Obrero Rawson",
		"Barrio Rawson",
		"Barrio Santa Barbara",
		"Belgrano",
		"Bella Vista",
		"Bermejo",
		"Boca De La Quebrada",
		"Bodega Graffigna",
		"Bodega San Antonio",
		"Buena Esperanza",
		"Cabecera Del Barrial",
		"Cabeza Del Toro",
		"Cacho Ancho",
		"Cajón De Los Tambillos",
		"Calibar",
		"Calingasta",
		"Calle Aguileras",
		"Calle Larga",
		"Calle Nacional",
		"Callecita",
		"Camp D P V La Ciénaga",
		"Campanario Nuevo",
		"Campo Afuera",
		"Campo De Batalla",
		"Campo Del Leoncito",
		"Campo Las Liebres",
		"Campo Los Pozos",
		"Cañada",
		"Cañada De Laguna",
		"Cañada Del Pozo",
		"Cañada Honda",
		"Capitán Lazo",
		"Carbometal",
		"Carpintería",
		"Carrizalito",
		"Casa De Javier",
		"Casa Vieja",
		"Castaño",
		"Castaño Nuevo",
		"Castaño Viejo",
		"Caucete",
		"Centro Aviación Civil San Juan",
		"Cerro  D  L  Bañitos",
		"Cerro Aguaditas",
		"Cerro Aguila",
		"Cerro Alto Del Descubrimiento",
		"Cerro Amarillo",
		"Cerro Asilan",
		"Cerro Aspero",
		"Cerro Bayo",
		"Cerro Blanco",
		"Cerro Bola",
		"Cerro Boleadora",
		"Cerro Bonete",
		"Cerro Bramadero",
		"Cerro Bravo",
		"Cerro Caballo Anca",
		"Cerro Caballo Bayo",
		"Cerro Casa De Piedra",
		"Cerro Chiquero",
		"Cerro Colorado",
		"Cerro Cortadera",
		"Cerro De Conconta",
		"Cerro De Dolores",
		"Cerro De La Cuesta Del Viento",
		"Cerro De La Sepultura",
		"Cerro De Las Vacas",
		"Cerro De Los Burros",
		"Cerro De Los Caballos",
		"Cerro De Los Pozos",
		"Cerro Del Agua De Las Vacas",
		"Cerro Del Alumbre",
		"Cerro Del Cachiyuyal",
		"Cerro Del Coquimbito",
		"Cerro Del Guanaco",
		"Cerro Del Medio",
		"Cerro Del Salado",
		"Cerro Del Tome",
		"Cerro Divisadero",
		"Cerro El Bronce",
		"Cerro El Cepo",
		"Cerro El Durazno",
		"Cerro El Francés",
		"Cerro Espantajo",
		"Cerro Grande",
		"Cerro Guanaquero",
		"Cerro Hediondo",
		"Cerro Hornito",
		"Cerro Imán",
		"Cerro Infiernillo",
		"Cerro Jaguel",
		"Cerro Joaquín",
		"Cerro La Bolsa",
		"Cerro La Cañada Amarilla",
		"Cerro La Ciénaga",
		"Cerro La Colorada",
		"Cerro La Flecha",
		"Cerro La Fortuna",
		"Cerro La Jarilla",
		"Cerro La Ortiga",
		"Cerro La Rinconada",
		"Cerro La Ventanita",
		"Cerro Lagunita",
		"Cerro Lajitas",
		"Cerro Las Barrancas",
		"Cerro Las Mulas",
		"Cerro Las Mulitas",
		"Cerro Las Placetas",
		"Cerro Las Raíces",
		"Cerro Las Yeguas",
		"Cerro Lavaderos",
		"Cerro Los Mogotes",
		"Cerro Los Patos",
		"Cerro Los Pozos",
		"Cerro Mercedario",
		"Cerro Mudadero",
		"Cerro Negro",
		"Cerro Negro De Chita",
		"Cerro Negro Del Corral",
		"Cerro Nico",
		"Cerro Ocucaros",
		"Cerro Pachaco",
		"Cerro Panteón",
		"Cerro Pata De Indio",
		"Cerro Pichereguas",
		"Cerro Pintado",
		"Cerro Pircas",
		"Cerro Potrerito De Agua Blanco",
		"Cerro Potrero",
		"Cerro Puntudo",
		"Cerro Riquiliponche",
		"Cerro Santa Rosa",
		"Cerro Sasito",
		"Cerro Senda Azul",
		"Cerro Silvio",
		"Cerro Silvo",
		"Cerro Tambolar",
		"Cerro Tigre",
		"Cerro Tres Mogotes",
		"Cerro Tres Puntas",
		"Cerro Villa Loncito",
		"Cerro Villicun",
		"Chacritas",
		"Champones",
		"Chanchos",
		"Chañar",
		"Chañar Pintado",
		"Chañar Seco",
		"Chaparro",
		"Chepical",
		"Chica Negra",
		"Chigua De Abajo",
		"Chimbas",
		"Chisnasco",
		"Chucuma",
		"Ciénaga",
		"Cienaguillos",
		"Cienaguita",
		"Cochagual",
		"Colanguil",
		"Colanqui",
		"Coll",
		"Colola",
		"Colon",
		"Colonia Cantoni",
		"Colonia Castro Padin",
		"Colonia Centenario",
		"Colonia El Molino",
		"Colonia Fiorito",
		"Colonia Fiscal Sarmiento",
		"Colonia Florida",
		"Colonia Gutiérrez",
		"Colonia Juan Solari",
		"Colonia Moya",
		"Colonia Richet",
		"Colonia Roca",
		"Colonia Rodas",
		"Colonia Rodríguez Zavalla",
		"Colonia San Antonio",
		"Colonia Yorner",
		"Colonia Zabala",
		"Colonia Zapata",
		"Concota",
		"Cóndor Muerto",
		"Contegrand",
		"Corral De Pirca",
		"Coyon",
		"Cruz De Piedra",
		"Cruz De San Pedro",
		"Cuatro Esquinas",
		"Cuchillazo",
		"Cuesta Viejo",
		"Culebra",
		"Cumiyango",
		"Cuyo",
		"Desamparados",
		"Díaz Velez",
		"Difunta Correa",
		"Dique Cauquenes",
		"Dique Las Crucecitas",
		"Dique Soldano",
		"Dique Toma",
		"Divisadero",
		"Divisadero De La Mujer Helada",
		"Divisoria",
		"Domingo De Oro",
		"Dos Acequias",
		"Dos Mojones",
		"Dos Puentes",
		"El Abanico",
		"El Alamito",
		"El Balde",
		"El Barrialito",
		"El Bosque",
		"El Buen Retiro",
		"El Carrizal",
		"El Chacrero",
		"El Chamizudo",
		"El Chañar",
		"El Chilote",
		"El Chinguillo",
		"El Chupino",
		"El Corralito",
		"El Fical",
		"El Fuerte",
		"El Gigantillo",
		"El Infierno",
		"El Jaboncito",
		"El Lechuzo",
		"El Leoncito",
		"El Medanito",
		"El Médano",
		"El Mogote Chimbas",
		"El Molino",
		"El Plumerito",
		"El Pozo Del 20",
		"El Puerto",
		"El Quemado",
		"El Retiro",
		"El Rincón",
		"El Salado",
		"El Salitre",
		"El Salto",
		"El Tapón",
		"El Treinta",
		"El Volcán",
		"Encon",
		"Entre Ríos",
		"Est Albardon",
		"Est De Herrera Vegas",
		"Est La Ciénaga De Gualila",
		"Est Marayes",
		"Est Niquivil",
		"Estación La Rinconada",
		"Estancia Acequion",
		"Estancia Bajo De Las Tumanas",
		"Estancia Casa Río Blanco",
		"Estancia El Chañar Nuevo",
		"Estancia El Durazno",
		"Estancia El Jumeal",
		"Estancia El Molino",
		"Estancia El Polear",
		"Estancia El Totoral",
		"Estancia Elizondo",
		"Estancia La Escalera",
		"Estancia La Florida",
		"Estancia La Lata",
		"Estancia La Posta",
		"Estancia La Puntilla",
		"Estancia Leoncito",
		"Estancia Maradona",
		"Estancia Quiroga",
		"Estancia Río Verde",
		"Estancia San Roque",
		"Fierro",
		"Fierro Nuevo",
		"Fierro Viejo",
		"Filo Del Mocho",
		"Finca De Izasa",
		"Finca Del Japonés",
		"Finca El Molino",
		"Finca El Toro",
		"Finca Zapata",
		"Gendarmería Nacional",
		"Germanía",
		"Gran China",
		"Guachipampa",
		"Guaja",
		"Guanacache",
		"Guañizul",
		"Guayaguas",
		"Guayamas",
		"Hachango",
		"Hilario",
		"Hostería El Balde",
		"Huaco",
		"Huaicos",
		"Huañizuil",
		"Huerta De Guachi",
		"Hueso Quebrado",
		"Ichigualasto",
		"Iglesia",
		"Imsa",
		"Indio Muerto",
		"Ingeniero Matías G Sánchez",
		"Ischigualasto",
		"Isla Del Sauce",
		"Jachal",
		"Jaguelito",
		"Jarilla Chica",
		"Jarillito",
		"José Marti",
		"Juan Celani",
		"Junta De Santa Rosa",
		"Juntas De La Jarilla",
		"Juntas De La Sal",
		"Juntas Del Frío",
		"Juntas Del Guandacol",
		"Kilometro 10650",
		"Kilometro 810",
		"Kilometro 893",
		"Kilometro 895",
		"Kilometro 905",
		"Kilometro 910",
		"Kilometro 936",
		"La Alumbrera",
		"La Angostura",
		"La Bebida",
		"La Callecita",
		"La Cañada",
		"La Capilla",
		"La Carpa",
		"La Cercada",
		"La Chigua",
		"La Chilca",
		"La Chimbera",
		"La Ciénaga",
		"La Ciénaga De Cumillango",
		"La Cienaguita",
		"La Cieneguita",
		"La Colonia",
		"La Cosechera",
		"La Cruz",
		"La Esquina",
		"La Estaca",
		"La Estrechura",
		"La Falda",
		"La Florida",
		"La Germania",
		"La Huerta",
		"La Isla",
		"La Laja",
		"La Legua",
		"La Majadita",
		"La Maral",
		"La Mesada",
		"La Moral",
		"La Orilla",
		"La Orqueta",
		"La Overa",
		"La Penca",
		"La Puntilla",
		"La Ramada",
		"La Rinconada",
		"La Ripiera",
		"La Rosita",
		"La Sal",
		"La Toma",
		"La Valentina",
		"Laguna Del Rosario",
		"Laguna Seca",
		"Laprida",
		"Las Aguaditas",
		"Las Casitas",
		"Las Casuarinas",
		"Las Chacras",
		"Las Chacritas",
		"Las Chimbas",
		"Las Ciénagas Verdes",
		"Las Cuevas",
		"Las Delicias",
		"Las Espinas",
		"Las Flores",
		"Las Hermanas",
		"Las Higueras",
		"Las Higueritas",
		"Las Hornillas",
		"Las Juntas",
		"Las Lagunas",
		"Las Lajas",
		"Las Liebres",
		"Las Lomitas",
		"Las Peñitas",
		"Las Piedritas",
		"Las Puestas",
		"Las Ramaditas",
		"Las Salinas",
		"Las Tapias",
		"Las Tumanas",
		"Las Yeguas",
		"Lloveras",
		"Loma Ancha",
		"Loma De Cocho",
		"Loma Leones",
		"Loma Negra",
		"Lomas Blancas",
		"Lomas Del Aguaditas",
		"Los Angacos",
		"Los Baldecitos",
		"Los Baldes",
		"Los Baldes De Astica",
		"Los Barriales",
		"Los Berros",
		"Los Chañares",
		"Los Chaves",
		"Los Cogotes",
		"Los Compartos",
		"Los Corredores",
		"Los Diaguitas",
		"Los Hornos",
		"Los Lagares",
		"Los Loros",
		"Los Médanos",
		"Los Mellizos",
		"Los Molles",
		"Los Nogales",
		"Los Papagayos",
		"Los Paramillos",
		"Los Penitentes",
		"Los Porongos",
		"Los Puestos",
		"Los Quillay",
		"Los Quimbaletes",
		"Los Ranchos",
		"Los Rincones",
		"Los Sánchez",
		"Los Sapitos",
		"Los Sombreros",
		"Los Terremotos",
		"Los Viñedos",
		"Lote Alvarado",
		"Lotes De Alvarez",
		"Lotes De Coria",
		"Lotes De Uriburu",
		"Lotes Escuela 138",
		"Lotes Rivera",
		"Luz Del Mundo",
		"Maclacasto",
		"Maipirinqui",
		"Majadita",
		"Maliman",
		"Maliman Arriba",
		"Maliman De Abajo",
		"Manantiales",
		"Marayes",
		"Marquesado",
		"Matagusanos",
		"Médano Colorado",
		"Médano De Oro",
		"Media Agua",
		"Mesada Aguada",
		"Mica",
		"Milagro",
		"Mina De Guachi",
		"Mina De Las Carachas",
		"Mina El Algarrobo",
		"Mina El Pescado",
		"Mina Escondida",
		"Mina General Belgrano",
		"Mina Gualilan",
		"Mina La Abundancia",
		"Mina La Delfina",
		"Mina La Esperanza",
		"Mina La Salamanta",
		"Mina Los Caballos",
		"Mina Montosa",
		"Mina San Antonio",
		"Mina San Jorge",
		"Mogna",
		"Mondaca",
		"Morterito",
		"Naquera",
		"Nikisanga",
		"Niquivil",
		"Niquivil Viejo",
		"Nueva Castilla",
		"Nueva España",
		"Obispo Zapata",
		"Ojos De Agua",
		"Otra Banda",
		"Pachaco",
		"Pajas Blancas",
		"Pampa De Los Caballos",
		"Pampa Del Chañar",
		"Pampa Grande",
		"Pampa Vieja",
		"Panacan",
		"Papagayos",
		"Paquita",
		"Paraje Bebida",
		"Pasleam",
		"Paso De Ferreira",
		"Paso De Lamas",
		"Paso De Otarola",
		"Paso Del Agua Negra",
		"Paso Del Lamar",
		"Pedernal",
		"Pedro Echague",
		"Peñasco Colorado",
		"Peñasquito",
		"Pichagual",
		"Pie De Palo",
		"Piedra Blanca",
		"Piedra Colorada",
		"Piedra Parada",
		"Piedra Rajada",
		"Piedras Blancas",
		"Pila De Macho",
		"Pimpa",
		"Pircas Blancas",
		"Pircas Negras",
		"Pismania",
		"Plumerillo",
		"Plumerillos",
		"Po Cajón De La Brea",
		"Po De Barahona",
		"Po De La Guardia",
		"Po De Las Llaretas",
		"Po De Las Ojotas",
		"Po De Los Piuquenes",
		"Po De Los Teatinos",
		"Po De Usno",
		"Po Del Chollay",
		"Po Del Inca",
		"Po Del Portillo",
		"Po Las Tórtolas",
		"Pocito",
		"Port De La Punilla",
		"Port De Longomiche",
		"Port De Los Sombreros",
		"Port Del Colorado",
		"Port Las Caracachas",
		"Port Las Chilcas",
		"Port Las Francas",
		"Port San Guillermo",
		"Port Santa Rosa",
		"Portón Grande",
		"Potranca",
		"Potrerillos",
		"Potreros Los Amadores",
		"Pozo De Aguadita",
		"Pozo De Los Algarrobos",
		"Pozo Salado",
		"Presbitero Fco Perez Hernadez",
		"Presbítero Francisco Pérez Her",
		"Primer Cuartel",
		"Pto Ag Del Burro",
		"Pto Aguadita",
		"Pto Aguadita De Abajo",
		"Pto Anjulio",
		"Pto Chanquia",
		"Pto Chavez",
		"Pto Cordova",
		"Pto Cumillango",
		"Pto Del Agua De Pinto",
		"Pto Durazno",
		"Pto El Arbol Ligudo",
		"Pto El Molle",
		"Pto El Sarco",
		"Pto El Toro",
		"Pto Figueroa",
		"Pto Gen",
		"Pto Gordillo",
		"Pto Huasi",
		"Pto La Chilca",
		"Pto La Cortadera",
		"Pto La Espina",
		"Pto La Represa",
		"Pto La Tuna",
		"Pto La Virgencita",
		"Pto Las Cuevas",
		"Pto Lima",
		"Pto Los Alamos",
		"Pto Los Papagallos",
		"Pto Los Pozos",
		"Pto Majadita",
		"Pto Pajarito",
		"Pto Pantanito",
		"Pto Perico",
		"Pto Pescado",
		"Pto Pimpa",
		"Pto Portezuelo Hondo",
		"Pto Potrerillo",
		"Pto Punilla",
		"Pto Recreo",
		"Pto Romero",
		"Pto Sabato",
		"Pto San Isidro",
		"Pto Santa Rosa De Abajo",
		"Pto Segovia",
		"Pto Trapiche",
		"Pto Vallecito",
		"Pto Varejón",
		"Pto Vega",
		"Puchuzun",
		"Puente Nacional",
		"Puente Río San Juan",
		"Puente Rufino",
		"Puerta De La Chilca",
		"Puerta Del Infiernillo",
		"Puerto Alegre",
		"Puerto Tapones De Maya",
		"Puesto Angostura",
		"Puesto De Arriba",
		"Puesto La Chilca De Abajo",
		"Puesto Olguin",
		"Puesto Retiro",
		"Puesto Santa Rosa",
		"Punta Blanca",
		"Punta De Agua",
		"Punta De Laguna",
		"Punta Del Médano",
		"Punta Del Monte",
		"Punta Norte",
		"Puntilla",
		"Puntilla Blanca",
		"Puntilla Negra",
		"Quilinquil",
		"Quinto Cuartel",
		"Quiroga",
		"Ramblón",
		"Ranchos De Famacoa",
		"Refugio",
		"Refugio D P V",
		"Refugio Los Gauchos",
		"Retamito",
		"Richard",
		"Rincón",
		"Rincón Chico",
		"Rincón Colorado",
		"Rincón De La Brea",
		"Rincón De La Ollita",
		"Rincón De Los Chinchilleros",
		"Rincón Del Gato",
		"Rincón Grande",
		"Rinconada",
		"Rincones",
		"Río Palo",
		"Río Saso",
		"Rivadavia",
		"Rodeo",
		"Ruinas Indígenas",
		"Ruta 20 Kilometro 114",
		"San Agustin Del Valle Fertil",
		"San Antonio",
		"San Carlos",
		"San Isidro",
		"San Juan",
		"San Juan Bautista Usno",
		"San Martín",
		"San Roque",
		"Sánchez De Loria",
		"Sanjuanino",
		"Santa Barbara",
		"Santa Clara",
		"Santa Lucia",
		"Santa María Del Rosario",
		"Santo Domingo",
		"Sarmiento",
		"Segundo Cuartel",
		"Sierra Billicum",
		"Sierra De Chaves",
		"Sierra De Chavez",
		"Sierra De Elizondo",
		"Sierra De Rivero",
		"Sorocayense",
		"Talacasto",
		"Tamberias",
		"Tap Gallardo",
		"Terma La Laja",
		"Terma Pismanta",
		"Termas Agua Hedionda",
		"Termas Centenario",
		"Termas De Agua Negra",
		"Tierra Adentro",
		"Tira Larga",
		"Tocota",
		"Tontal",
		"Totoralito",
		"Trancas",
		"Travesía De Mogna",
		"Tres Esquinas",
		"Tres Quebraditas",
		"Trinidad",
		"Tucunuco",
		"Tudcum",
		"Tumanas",
		"Tuminico",
		"Tupeli",
		"Tutianca",
		"Ullum",
		"Uriburu",
		"Usina",
		"Usno",
		"Valle Del Cura",
		"Valle Fértil",
		"Vallecito",
		"Venillo",
		"Villa",
		"Villa 20 De Junio",
		"Villa Aberastain",
		"Villa Alem",
		"Villa Barboza",
		"Villa Basilio Nievas",
		"Villa Bermejito",
		"Villa Borjas",
		"Villa Carlota",
		"Villa Carolina",
		"Villa Colon",
		"Villa Corral",
		"Villa Del Carmen",
		"Villa Del Salvador",
		"Villa Dominguito",
		"Villa Estevez",
		"Villa Fleury",
		"Villa Franca",
		"Villa General Acha",
		"Villa General Las Heras",
		"Villa General San Martin",
		"Villa General Sarmiento",
		"Villa Gobernador Chavez",
		"Villa Huasihul",
		"Villa Independencia",
		"Villa J C Sarmiento",
		"Villa Juan Xxiii",
		"Villa Krause",
		"Villa Laprida",
		"Villa Lerga",
		"Villa Lugano",
		"Villa Luz Del Mundo",
		"Villa Marini",
		"Villa Media Agua",
		"Villa Mercedes",
		"Villa Morrones",
		"Villa Muñoz",
		"Villa N Larrain",
		"Villa Nacusi",
		"Villa Nueva",
		"Villa Obrera",
		"Villa P A De Sarmiento",
		"Villa Palermo",
		"Villa Patricias Sanjuaninas",
		"Villa Pueyrredon",
		"Villa Rachel",
		"Villa Rizzo",
		"Villa Rufino Gómez",
		"Villa San Isidro",
		"Villa Santa Anita",
		"Villa Santa Paula",
		"Villa Santa Rosa",
		"Villa Sargento Cabral",
		"Volcán",
		"Yacimiento De Cobre El Pachón",
		"Yerba Buena",
		"Yoca",
		"Zavalla",
		"Zonda"
	],
	"San Luis": [
		"11 De Mayo",
		"13 De Enero",
		"20 De Febrero",
		"3 Esquinas",
		"30 De Octubre",
		"6 De Septiembre",
		"9 De Julio",
		"Acasape",
		"Adolfo Rodríguez Saa",
		"Agua Amarga",
		"Agua Del Portezuelo",
		"Agua Fría",
		"Agua Hedionda",
		"Agua Linda",
		"Agua Salada",
		"Agua Seballe",
		"Aguada",
		"Aguadita",
		"Aguaditas",
		"Aguas De Piedras",
		"Ahí Veremos",
		"Alanices",
		"Alazanas",
		"Alegría",
		"Alfaland",
		"Algarrobal",
		"Algarrobitos",
		"Algarrobos Grandes",
		"Alta Gracia",
		"Altillo",
		"Alto",
		"Alto Blanco",
		"Alto De La Leña",
		"Alto Del León",
		"Alto Del Molle",
		"Alto Del Valle",
		"Alto Grande",
		"Alto Lindo",
		"Alto Negro",
		"Alto Pelado",
		"Alto Pencoso",
		"Alto Verde",
		"Ancamilla",
		"Anchorena",
		"Angelita",
		"Antihuasi",
		"Arbol Solo",
		"Arbol Verde",
		"Arboleda",
		"Arboles Blancos",
		"Arenilla",
		"Arizona",
		"Arroyo De Vilches",
		"Arroyo La Cal",
		"Avanzada",
		"Aviador Origone",
		"Bagual",
		"Bajada",
		"Bajada Nueva",
		"Bajo De Conlara",
		"Bajo De La Cruz",
		"Bajo Grande",
		"Bajo La Laguna",
		"Bajos Hondos",
		"Balcarce",
		"Balda",
		"Balde",
		"Balde Ahumada",
		"Balde De Amira",
		"Balde De Arriba",
		"Balde De Azcurra",
		"Balde De Escudero",
		"Balde De García",
		"Balde De Guardia",
		"Balde De Guiñazú",
		"Balde De La Isla",
		"Balde De La Línea",
		"Balde De Ledesma",
		"Balde De Monte",
		"Balde De Nuevo",
		"Balde De Puertas",
		"Balde De Quines",
		"Balde De Torres",
		"Balde Del Escudero",
		"Balde Del Rosario",
		"Balde El Carril",
		"Balde Hondo",
		"Balde Retamo",
		"Balde Viejo",
		"Baldecito",
		"Baldecito La Pampa",
		"Banda Sud",
		"Bañadito",
		"Bañadito Viejo",
		"Bañado",
		"Bañado De Cautana",
		"Bañado Lindo",
		"Baños Zapallar",
		"Barranca Colorada",
		"Barranquitas",
		"Barrial",
		"Barriales",
		"Barrio Blanco",
		"Barzola",
		"Batavia",
		"Beazley",
		"Bebedero",
		"Bebida",
		"Becerra",
		"Bella Estancia",
		"Bella Vista",
		"Bella Vista Botijas",
		"Billiken",
		"Boca De La Quebrada",
		"Boca Del Río",
		"Botijas",
		"Buena Esperanza",
		"Buena Ventura",
		"Buena Vista",
		"Cabeza De Novillo",
		"Cachi Corral",
		"Cain De Los Tigres",
		"Caldenadas",
		"Calera Argentina",
		"Caleras Cañada Grande",
		"Campanario",
		"Campo De San Pedro",
		"Candelaria",
		"Cantantal",
		"Canteras Santa Isabel",
		"Caña Larga",
		"Cañada",
		"Cañada Angosta",
		"Cañada Blanca",
		"Cañada De Atras",
		"Cañada De La Negra",
		"Cañada De Las Lagunas",
		"Cañada De Los Tigres",
		"Cañada De Vilan",
		"Cañada Del Pasto",
		"Cañada Del Puestito",
		"Cañada Grande",
		"Cañada Honda",
		"Cañada Honda De Guzmán",
		"Cañada La Negra",
		"Cañada La Tienda",
		"Cañada Quemada",
		"Cañada San Antonio",
		"Cañada Verde",
		"Cañaditas",
		"Cañitas",
		"Capelen",
		"Carmelo",
		"Carolina",
		"Carpintería",
		"Casa De Cóndor",
		"Casa De Piedra",
		"Casas Viejas",
		"Casimiro Gómez",
		"Cebollar",
		"Centenario",
		"Cerrito",
		"Cerrito Blanco",
		"Cerrito Negro",
		"Cerro Bayo",
		"Cerro Blanco",
		"Cerro Colorado",
		"Cerro De La Pila",
		"Cerro De Oro",
		"Cerro De Piedra",
		"Cerro Negro",
		"Cerro Várela",
		"Cerro Verde",
		"Cerro Viejo",
		"Cerros Largos",
		"Chacra La Primavera",
		"Chacras Del Cántaro",
		"Chacras Viejas",
		"Chacritas",
		"Chalanta",
		"Chancarita",
		"Chañar De La Legua",
		"Chañaritos",
		"Charlone",
		"Charlones",
		"Chichaquita",
		"Chilcas",
		"Chimbas",
		"Chimborazo",
		"Chipical",
		"Chipiscu",
		"Chischaca",
		"Chischaquita",
		"Chosmes",
		"Chutunsa",
		"Ciudad Jardín De San Luis",
		"Cochenelos",
		"Cochequingan",
		"Colonia Bella Vista",
		"Colonia Calzada",
		"Colonia El Campamento",
		"Colonia La Florida",
		"Colonia Luna",
		"Colonia Santa Virginia",
		"Colonia Urdaniz",
		"Comandante Granville",
		"Concaran",
		"Conlara",
		"Consuelo",
		"Consulta",
		"Coronel Alzogaray",
		"Coronel Segovia",
		"Corral De Piedra",
		"Corral De Torres",
		"Corral Del Tala",
		"Corrales",
		"Cortaderas",
		"Cramer",
		"Crucecitas",
		"Cruz Brillante",
		"Cruz De Caña",
		"Cruz De Piedra",
		"Cuatro Esquinas",
		"Cuchi Corral",
		"Cueva De Tigre",
		"Daniel Donovan",
		"Dique La Florida",
		"Divisadero",
		"Domínguez",
		"Dormida",
		"Duraznito",
		"El  Valle",
		"El Aguila",
		"El Algarrobal",
		"El Alto",
		"El Amparo",
		"El Arenal",
		"El Arroyo",
		"El Bagual",
		"El Bajo",
		"El Balde",
		"El Baldecito",
		"El Bañado",
		"El Barrial",
		"El Blanco",
		"El Burrito",
		"El Cadillo",
		"El Calden",
		"El Campamento",
		"El Cardal",
		"El Carmen",
		"El Cavado",
		"El Cazador",
		"El Cerrito",
		"El Cerro",
		"El Chañar",
		"El Charabón",
		"El Charco",
		"El Chorrillo",
		"El Cinco",
		"El Cóndor",
		"El Coro",
		"El Dichoso",
		"El Dique",
		"El Durazno",
		"El Espinillo",
		"El Fortín",
		"El Hormiguero",
		"El Hornito",
		"El Injerto",
		"El Jarillal",
		"El Lechuzo",
		"El Manantial",
		"El Manantial Escondido",
		"El Mangrullo",
		"El Martillo",
		"El Mataco",
		"El Milagro",
		"El Molino",
		"El Mollar",
		"El Mollarcito",
		"El Molle",
		"El Morro",
		"El Nasao",
		"El Negro",
		"El Oasis",
		"El Olmo",
		"El Pajarete",
		"El Pantanillo",
		"El Pantano",
		"El Paraguay",
		"El Paraíso",
		"El Pasajero",
		"El Payero",
		"El Pedernal",
		"El Peje",
		"El Piche",
		"El Pigue",
		"El Pimpollo",
		"El Plateado",
		"El Plumerito",
		"El Pocito",
		"El Poleo",
		"El Portezuelo",
		"El Porvenir",
		"El Potrerillo",
		"El Potrero De Leyes",
		"El Pozo",
		"El Progreso",
		"El Pueblito",
		"El Puerto",
		"El Puestito",
		"El Puesto",
		"El Quebracho",
		"El Quingual",
		"El Ramblón",
		"El Recuerdo",
		"El Retamo",
		"El Riecito",
		"El Rincón",
		"El Río",
		"El Rodeo",
		"El Rosario",
		"El Salado",
		"El Salado De Amaya",
		"El Salto",
		"El Salvador",
		"El Sarco",
		"El Sauce",
		"El Sembrado",
		"El Socorro",
		"El Tala",
		"El Talita",
		"El Tembleque",
		"El Torcido",
		"El Toro Muerto",
		"El Totoral",
		"El Trapiche",
		"El Valle",
		"El Vallecito",
		"El Verano",
		"El Volcán",
		"El Yacatan",
		"El Zampal",
		"El Zapallar",
		"Eleodoro Lobos",
		"Embalse La Florida",
		"Ensenada",
		"Entre Ríos",
		"Espinillo",
		"Establecimiento Las Flores",
		"Estación Zanjitas",
		"Estancia",
		"Estancia 30 De Octubre",
		"Estancia Don Arturo",
		"Estancia El Chamico",
		"Estancia El Divisadero",
		"Estancia El Médano",
		"Estancia El Quebrachal",
		"Estancia El Salado",
		"Estancia El Saucecito",
		"Estancia Grande",
		"Estancia La Blanca",
		"Estancia La Guardia",
		"Estancia La Guillermina",
		"Estancia La Morena",
		"Estancia La Reserva",
		"Estancia La Unión",
		"Estancia La Zulemita",
		"Estancia Las Bebidas",
		"Estancia Los Hermanos",
		"Estancia Los Nogales",
		"Estancia Rivadavia",
		"Estancia San Alberto",
		"Estancia San Antonio",
		"Estancia San Francisco",
		"Estancia San Roque",
		"Estancia Tres Arboles",
		"Estanzuela",
		"Favelli",
		"Fenoglio",
		"Florida",
		"Fortín El Patria",
		"Fortín Salto",
		"Fortuna",
		"Fortuna De San Juan",
		"Fraga",
		"Frisia",
		"General Pedernera",
		"General Urquiza",
		"Gigante",
		"Gloria A Dios",
		"Gorgonta",
		"Gruta De Intihuasi",
		"Gualtaran",
		"Guanaco",
		"Guanaco Pampa",
		"Guasquita",
		"Guzmán",
		"Hinojito",
		"Hinojos",
		"Hipolito Yrigoyen",
		"Hornito",
		"Hualtaran",
		"Huchisson",
		"Huejeda",
		"Huertas",
		"Intihuasi",
		"Invernada",
		"Isla",
		"Islitas",
		"Isondu",
		"Jarilla",
		"Juan Jorba",
		"Juan Llerena",
		"Juan W Gez",
		"Juana Koslay",
		"Juante",
		"Justo Daract",
		"Kilometro 656",
		"La Adela",
		"La Agua Nueva",
		"La Aguada",
		"La Aguada De Las Animas",
		"La Agueda",
		"La Alameda",
		"La Alcorteña",
		"La Alegría",
		"La Alianza",
		"La Amalia",
		"La Amarga",
		"La Angelina",
		"La Angostura",
		"La Arboleda",
		"La Argentina",
		"La Armonía",
		"La Aroma",
		"La Atalaya",
		"La Aurora",
		"La Bajada",
		"La Bava",
		"La Bavaria",
		"La Bertita",
		"La Bolivia",
		"La Bonita",
		"La Brea",
		"La Cabra",
		"La Calaguala",
		"La Caldera",
		"La Calera",
		"La Cañada",
		"La Carmen",
		"La Carmencita",
		"La Cautiva",
		"La Celia",
		"La Chañarienta",
		"La Cherindu",
		"La Chilca",
		"La Chilla",
		"La Ciénaga",
		"La Cocha",
		"La Colina",
		"La Colonia",
		"La Cora",
		"La Corina",
		"La Cortadera",
		"La Costa",
		"La Cristina",
		"La Crucecita",
		"La Crucesita",
		"La Cumbre",
		"La Delia",
		"La Donostia",
		"La Dora",
		"La Duda",
		"La Dulce",
		"La Elena",
		"La Elenita",
		"La Elida",
		"La Elisa",
		"La Elvira",
		"La Emilia",
		"La Emma",
		"La Empajada",
		"La Ernestina",
		"La Escondida",
		"La Esmeralda",
		"La Esperanza",
		"La Espesura",
		"La Esquina",
		"La Esquina Del Río",
		"La Estancia",
		"La Estanzuela",
		"La Estrella",
		"La Ethel",
		"La Eulogia",
		"La Felisa",
		"La Finca",
		"La Flecha",
		"La Florida",
		"La Fragua",
		"La Gama",
		"La Garrapata",
		"La Garza",
		"La Gaviota",
		"La Germania",
		"La Gitana",
		"La Gramilla",
		"La Guardia",
		"La Hermosura",
		"La Higuerita",
		"La Holanda",
		"La Hortensia",
		"La Huerta",
		"La Huertita",
		"La Iberia",
		"La Invernada",
		"La Irene",
		"La Isabel",
		"La Isla",
		"La Javiera",
		"La Jerga",
		"La Josefa",
		"La Josefina",
		"La Juana",
		"La Juanita",
		"La Julia",
		"La Justa",
		"La Laura",
		"La Lechuga",
		"La Legua",
		"La Linda",
		"La Línea",
		"La Loma",
		"La Luisa",
		"La Magdalena",
		"La Majada",
		"La Maravilla",
		"La Margarita",
		"La Margarita Carlota",
		"La María",
		"La María Esther",
		"La María Luisa",
		"La Maroma",
		"La Mascota",
		"La Media Legua",
		"La Medula",
		"La Melina",
		"La Merced",
		"La Mesilla",
		"La Mina",
		"La Moderna",
		"La Negra",
		"La Negrita",
		"La Nelida",
		"La Nutria",
		"La Palmira",
		"La Pampa",
		"La Patria",
		"La Peregrina",
		"La Petra",
		"La Plata",
		"La Porfía",
		"La Portada",
		"La Primavera",
		"La Providencia",
		"La Puerta",
		"La Punilla",
		"La Punta",
		"La Quebrada",
		"La Ramada",
		"La Realidad",
		"La Reforma",
		"La Reina",
		"La Represa",
		"La Represita",
		"La Reserva",
		"La Resistencia",
		"La Ribera",
		"La Rinconada",
		"La Riojita",
		"La Rosada",
		"La Rosalia",
		"La Rosina",
		"La Sala",
		"La Salud",
		"La Salvadora",
		"La Sandia",
		"La Segunda",
		"La Selva",
		"La Seña",
		"La Serrana",
		"La Silesia",
		"La Sirena",
		"La Suiza",
		"La Tigra",
		"La Toma",
		"La Tosca",
		"La Totora",
		"La Tranca",
		"La Travesía",
		"La Tula",
		"La Tusca",
		"La Ulbara",
		"La Unión",
		"La Uruguaya",
		"La Vaca",
		"La Venecia",
		"La Verde",
		"La Vertiente",
		"La Yerba Buena",
		"La Yesera",
		"Lafinur",
		"Laguna Brava",
		"Laguna Capelen",
		"Laguna De La Cañada",
		"Laguna De Los Patos",
		"Laguna De Patos",
		"Laguna Larga",
		"Laguna Sayape",
		"Laguna Seca",
		"Las Aguadas",
		"Las Aromas",
		"Las Bajadas",
		"Las Barrancas",
		"Las Barranquitas",
		"Las Cabras",
		"Las Canteras",
		"Las Cañas",
		"Las Cañitas",
		"Las Caritas",
		"Las Carolinas",
		"Las Carretas",
		"Las Chacras",
		"Las Chacras De San Martín",
		"Las Chacritas",
		"Las Chilcas",
		"Las Chimbas",
		"Las Claritas",
		"Las Colonias",
		"Las Cortaderas",
		"Las Delicias",
		"Las Encadenadas",
		"Las Flores",
		"Las Galeras",
		"Las Gamas",
		"Las Gitanas",
		"Las Higueras",
		"Las Isletas",
		"Las Islitas",
		"Las Lagunas",
		"Las Lagunitas",
		"Las Lajas",
		"Las Lomas",
		"Las Mangas",
		"Las Martinetas",
		"Las Meladas",
		"Las Mesías",
		"Las Mestizas",
		"Las Nieves",
		"Las Palmas",
		"Las Palomas",
		"Las Pampitas",
		"Las Peñas",
		"Las Piedritas",
		"Las Playas",
		"Las Playas Argentinas",
		"Las Praderas",
		"Las Puertas",
		"Las Raíces",
		"Las Rosadas",
		"Las Rosas",
		"Las Salinas",
		"Las Tigras",
		"Las Toscas",
		"Las Totoritas",
		"Las Tres Cañadas",
		"Las Vertientes",
		"Las Vizcacheras",
		"Laura Elisa",
		"Lavaisse",
		"Leandro N Alem",
		"Liborio Luna",
		"Lince",
		"Lindo",
		"Loma Del Medio",
		"Lomas Blancas",
		"Lomitas",
		"Longari",
		"Los Aguados",
		"Los Alamos",
		"Los Algarrobitos",
		"Los Algarrobos",
		"Los Almácigos",
		"Los Araditos",
		"Los Arces",
		"Los Arguellos",
		"Los Arroyos",
		"Los Barriales",
		"Los Cajones",
		"Los Carricitos",
		"Los Cerrillos",
		"Los Cerritos",
		"Los Cesares",
		"Los Chancaros",
		"Los Chañares",
		"Los Chañaritos",
		"Los Chenas",
		"Los Cisnes",
		"Los Claveles",
		"Los Comederos",
		"Los Comedores",
		"Los Cóndores",
		"Los Coros",
		"Los Corrales",
		"Los Corralitos",
		"Los Cuadros",
		"Los Dos Ríos",
		"Los Dueros",
		"Los Duraznitos",
		"Los Duraznos",
		"Los Espinillos",
		"Los Esquineros",
		"Los Hinojos",
		"Los Huaycos",
		"Los Jagueles",
		"Los Lechuzones",
		"Los Lobos",
		"Los Manantiales",
		"Los Medanitos",
		"Los Médanos",
		"Los Membrillos",
		"Los Mendocinos",
		"Los Mollecitos",
		"Los Molles",
		"Los Montes",
		"Los Noques",
		"Los Oscuros",
		"Los Pasitos",
		"Los Pejes",
		"Los Peros",
		"Los Poleos",
		"Los Pozos",
		"Los Puestos",
		"Los Puquios",
		"Los Quebrachos",
		"Los Ramblones",
		"Los Roldanes",
		"Los Sauces",
		"Los Talas",
		"Los Tamariños",
		"Los Tapiales",
		"Los Telarios",
		"Los Tigres",
		"Los Valles",
		"Lujan",
		"Machao",
		"Manantial",
		"Manantial Blanco",
		"Manantial De Flores",
		"Manantial De Renca",
		"Manantial Grande",
		"Manantial Lindo",
		"Manantiales",
		"Mantilla",
		"Maravilla",
		"Maray",
		"Marlito",
		"Marmol Verde",
		"Martín De Loyola",
		"Mataco",
		"Médano Ballo",
		"Medano Bello",
		"Médano Chico",
		"Médano Grande",
		"Médanos",
		"Media Luna",
		"Mercedes",
		"Merlo",
		"Milagro",
		"Mina Carolina",
		"Mina Los Cóndores",
		"Mina Santo Domingo",
		"Mollecito",
		"Monte Carmelo",
		"Monte Chiquito",
		"Monte Cochequingan",
		"Monte Verde",
		"Mosmota",
		"Moyar",
		"Moyarcito",
		"Nahuel Mapa",
		"Naranjo",
		"Naschel",
		"Navia",
		"Negro Muerto",
		"Nilinast",
		"No Es Mía",
		"Nogoli",
		"Nossar",
		"Nueva Constitución",
		"Nueva Escocia",
		"Nueva Esperanza",
		"Nueva Galia",
		"Ñurilay",
		"Ojo De Agua",
		"Ojo Del Río",
		"Once De Mayo",
		"Otra Banda",
		"Paines",
		"Paje",
		"Paliguanta",
		"Palomar",
		"Pampa",
		"Pampa De Los Gobernadores",
		"Pampa Del Bajo",
		"Pampa Del Tamborero",
		"Pampa Grande",
		"Pampa Invernada",
		"Pampita",
		"Pantanillo",
		"Pantanillos",
		"Papagayos",
		"Paraíso",
		"Paso Ancho",
		"Paso De Cuero",
		"Paso De La Cruz",
		"Paso De La Tierra",
		"Paso De Las Carretas",
		"Paso De Las Salinas",
		"Paso De Las Sierras",
		"Paso De Las Toscas",
		"Paso De Las Vacas",
		"Paso De Los Algarrobos",
		"Paso De Los Bayos",
		"Paso De Los Gauchos",
		"Paso De Piedra",
		"Paso Del Medio",
		"Paso Del Rey",
		"Paso Grande",
		"Paso Juan Gómez",
		"Paso Los Algarrobos",
		"Pastal",
		"Patio Limpio",
		"Pedernera",
		"Penice",
		"Peñón Colorado",
		"Pescadores",
		"Picos Yacu",
		"Pie De La Cuesta",
		"Piedra Blanca",
		"Piedra Bola",
		"Piedra Larga",
		"Piedra Rosada",
		"Piedra Sola",
		"Piedras Anchas",
		"Piedras Blancas",
		"Piedras Chatas",
		"Piquillines",
		"Piscoyaco",
		"Pizarras Bajo Velez",
		"Placilla",
		"Planta De Sandia",
		"Plumerito",
		"Pocitos",
		"Polledo",
		"Portada Del Sauce",
		"Portezuelo",
		"Porvenir",
		"Posta De Fierro",
		"Posta Del Portezuelo",
		"Potrerillo",
		"Potrero De Los Funes",
		"Pozo Cavado",
		"Pozo Cercado",
		"Pozo De Las Raíces",
		"Pozo De Los Rayos",
		"Pozo Del Carril",
		"Pozo Del Espinillo",
		"Pozo Del Medio",
		"Pozo Del Molle",
		"Pozo Del Tala",
		"Pozo Escondido",
		"Pozo Frío",
		"Pozo Santiago",
		"Pozo Seco",
		"Pozo Simón",
		"Primer Agua",
		"Puente Hierro",
		"Puente La Orqueta",
		"Puerta Colorada",
		"Puerta De La Isla",
		"Puerta De Palo",
		"Puerto Alegre",
		"Puerto Rico",
		"Puestito",
		"Puesto Balzora",
		"Puesto Bella Vista",
		"Puesto De Los Jumes",
		"Puesto De Tabares",
		"Puesto El Tala",
		"Puesto Pampa Invernada",
		"Puesto Quebrada Cal",
		"Puesto Roberto",
		"Puesto Talar",
		"Punilla",
		"Punta De Agua",
		"Punta De La Loma",
		"Punta De La Sierra",
		"Punta Del Agua",
		"Punta Del Alto",
		"Punta Del Cerro",
		"Puntos De Agua",
		"Puntos De La Línea",
		"Quebrachito",
		"Quebrada De La Burra",
		"Quebrada De La Mora",
		"Quebrada De Los Barrosos",
		"Quebrada De San Vicente",
		"Quebrada Del Tigre",
		"Quebrada Honda",
		"Quines",
		"Ramadita",
		"Ramblones",
		"Ranquelco",
		"Real",
		"Reconquista",
		"Recreo",
		"Reforma Chica",
		"Renca",
		"Represa Del Carmen",
		"Represa Del Chañar",
		"Represa Del Monte",
		"Retamo",
		"Retazo Del Monte",
		"Retiro",
		"Riecito",
		"Rincón Del Carmen",
		"Rincón Del Este",
		"Río Grande",
		"Río Juan Gómez",
		"Río Quinto",
		"Riojita",
		"Rodeo Cadenas",
		"Romance",
		"Rosales",
		"Rumiguasi",
		"Saladillo",
		"Salado",
		"Salado De Amaya",
		"Salinas",
		"Salinas Del Bebedero",
		"Salitral",
		"Salto Chico",
		"San Agustín",
		"San Alberto",
		"San Alejandro",
		"San Antonio",
		"San Camilo",
		"San Carlos",
		"San Celestino",
		"San Fco Del Monte De Oro",
		"San Felipe",
		"San Fernando",
		"San Francisco Del Monte De Oro",
		"San Geronimo",
		"San Gregorio",
		"San Ignacio",
		"San Isidro",
		"San Jorge",
		"San José",
		"San José De Los Chañares",
		"San José Del Durazno",
		"San Jose Del Morro",
		"San Juan",
		"San Juan De Tastu",
		"San Lorenzo",
		"San Luis",
		"San Martín",
		"San Miguel",
		"San Nicolás Punilla",
		"San Pablo",
		"San Pedro",
		"San Rafael",
		"San Raimundo",
		"San Ramón",
		"San Ramón Sud",
		"San Roque",
		"San Rufino",
		"San Salvador",
		"San Vicente",
		"Santa Ana",
		"Santa Ana Quines",
		"Santa Catalina",
		"Santa Cecilia",
		"Santa Clara",
		"Santa Dionisia",
		"Santa Felisa",
		"Santa Isabel",
		"Santa Lucia",
		"Santa Lucinda",
		"Santa María",
		"Santa Martina",
		"Santa Rita",
		"Santa Rosa",
		"Santa Rosa De Conlara",
		"Santa Rosa Del Chipiscu",
		"Santa Rosa Del Gigante",
		"Santa Rufina",
		"Santa Simona",
		"Santa Teresa",
		"Santa Teresita",
		"Santa Victoria",
		"Santo Domingo",
		"Sauce",
		"Saucesito",
		"Selci",
		"Serafina",
		"Socoscora",
		"Sol De Abril",
		"Sol De Abril (Dpto-San Martín)",
		"Sol De Abril San Martin",
		"Solobasta",
		"Sololosta",
		"Tala Verde",
		"Talarcito",
		"Talita",
		"Tamascanes",
		"Tamboreo",
		"Tasto",
		"Taza Blanca",
		"Temeraria",
		"Tilisarao",
		"Tintitaco",
		"Toigus",
		"Toingua",
		"Toro Bayo",
		"Toro Negro",
		"Toscal",
		"Totoral",
		"Totorilla",
		"Transval",
		"Trapiche",
		"Travesía",
		"Trece De Enero",
		"Treinta De Octubre",
		"Tres Cañadas",
		"Tres Esquinas",
		"Tres Lomas",
		"Tres Marías",
		"Tres Puertas",
		"Tukiros",
		"Uchaima",
		"Unión",
		"Unquillo",
		"Usiyal",
		"Uspara",
		"Vacas Muertas",
		"Valle De La Pancanta",
		"Valle Hermoso",
		"Valle San Agustín",
		"Valle San José",
		"Vallecito",
		"Várela",
		"Venta De Los Ríos",
		"Vieja Estancia",
		"Villa De La Quebrada",
		"Villa De Praga",
		"Villa Del Carmen",
		"Villa Dolores",
		"Villa Elena",
		"Villa General Roca",
		"Villa Larca",
		"Villa Luisa",
		"Villa Mercedes",
		"Villa Reynolds",
		"Villa Santiago",
		"Virarco",
		"Viscacheras",
		"Vista Alegre",
		"Vista Hermosa",
		"Viva La Patria",
		"Vizcacheras",
		"Volcán Estanzuela",
		"Yacoro",
		"Zampal"
	],
	"Santa Cruz": [
		"28 De Noviembre",
		"Aguada A Pique",
		"Aguada Alegre",
		"Aguada Escondida",
		"Aguada Grande",
		"Aguada La Oveja",
		"Alma Grande",
		"An Aike",
		"Bahía Langara",
		"Bahía Laura",
		"Bahía Tranquila",
		"Bajo Caracoles",
		"Bajo Fuego",
		"Bella Vista",
		"Cabo Blanco",
		"Cabo De Las Vírgenes",
		"Cabo Tres Puntas",
		"Caleta Olivia",
		"Cameron",
		"Campamento Dorotea",
		"Camuzu Aike",
		"Cancha Carrera",
		"Cañada De Las Vacas",
		"Cañadón 11 De Setiembre",
		"Cañadón Botello",
		"Cañadón De Las Vacas",
		"Cañadón Del Rancho",
		"Cañadón Del Toro",
		"Cañadón Fabre",
		"Cañadón León",
		"Cañadón Molinari",
		"Cañadón Pluma",
		"Cañadón Seco",
		"Cap",
		"Cara Mala",
		"Cerro Alto",
		"Cerro La Setenta",
		"Cerro Mangrullo",
		"Cerro Moro",
		"Cerro Negro",
		"Cerro Palique",
		"Cerro Puntudo",
		"Cerro Redondo",
		"Cerro Renzel",
		"Cerro Silva",
		"Chall Aike",
		"Charles Fuhr",
		"Chimen Aike",
		"Chonque",
		"Colonia Carlos Pellegrini",
		"Colonia Leandro N Alem",
		"Comandante Luis Piedrabuena",
		"Cóndor",
		"Cóndor Clif",
		"Coronel Guarumba",
		"Coronel Martín Irigoyen",
		"Cueva De Las Manos",
		"Desamparados",
		"El Baile",
		"El Barbucho",
		"El Calafate",
		"El Cerrito",
		"El Chalten",
		"El Chara",
		"El Guadal",
		"El Hueco",
		"El Loro",
		"El Pan De Azúcar",
		"El Paso",
		"El Pluma",
		"El Polvorín",
		"El Portezuelo",
		"El Salado",
		"El Turbio",
		"El Zurdo",
		"Estación Ing Atilio Cappa",
		"Faro Cabo Guardián",
		"Faro Campana",
		"Fitz Roy",
		"Floradora",
		"Fortaleza",
		"Fuentes De Coyle",
		"Garminue",
		"Gaypon",
		"Glencross",
		"Gobernador Gregores",
		"Gobernador Mayer",
		"Gobernador Moyano",
		"Guardaparque Fitz Roy",
		"H Yrigoyen Lago Posadas",
		"Hotel Las Horquetas",
		"India Muerta",
		"Ingeniero Atilio Cappa",
		"Ingeniero Pallavicini",
		"Jaramillo",
		"Jelaina",
		"Julia Dufour",
		"Kilometro 8",
		"Koluel Kaike",
		"La Aguada",
		"La Antonia",
		"La Argentina",
		"La Asturiana",
		"La Barreta",
		"La Central",
		"La Esperanza",
		"La Estela",
		"La Esther",
		"La Fecundidad",
		"La Federica",
		"La Florida",
		"La Guardia",
		"La Julia",
		"La Leona",
		"La Madrugada",
		"La Manchuria",
		"La Margarita",
		"La María",
		"La Península",
		"La Pigmea",
		"La Porteña",
		"La Protegida",
		"La Rosa",
		"La Rosada",
		"La Victoria",
		"La Violeta",
		"Lago Argentino",
		"Lago Buenos Aires",
		"Lago Cardiel",
		"Lago Posadas",
		"Lago Pueyrredon",
		"Lago Roca",
		"Lago San Martín",
		"Lago Strobel",
		"Lago Tar",
		"Laguna Colorada",
		"Laguna Grande",
		"Las Heras",
		"Las Horquetas",
		"Las Masitas",
		"Las Mercedes",
		"Las Pirámides",
		"Leandro Niceforo Alem",
		"Los Antiguos",
		"Los Manantiales",
		"Los Perales",
		"Mata Magallanes",
		"Mazaredo",
		"Meseta Guengue",
		"Mina 3",
		"Minerales",
		"Monte Aymond",
		"Monte Ceballos",
		"Monte Verde",
		"Morro Chico",
		"Nacimientos Del Pluma",
		"Palermo Aike",
		"Pali Aike",
		"Pampa Verdum",
		"Paso Charles Fhur",
		"Paso De Los Indios",
		"Paso Del Aguila",
		"Paso Del Medio",
		"Paso Del Río Santa Cruz",
		"Paso Gregores",
		"Paso Ibañez",
		"Paso Río La Leona",
		"Paso Roballo",
		"Pellegrini",
		"Península Maipu",
		"Perito Moreno",
		"Pico Truncado",
		"Piedra Clavada",
		"Pueblo Nuevo",
		"Puente Blanco",
		"Puerto Deseado",
		"Puerto San Julián",
		"Puerto Santa Cruz",
		"Punta Bandera",
		"Punta Del Lago Viedma",
		"Punta Del Monte",
		"Punta Loyola",
		"Punta Mercedes",
		"Quien Sabe",
		"Rincón De Los Morros",
		"Río Bote",
		"Río Calafate",
		"Río Chico",
		"Río Fénix",
		"Río Gallegos",
		"Río Mitre",
		"Río Turbio",
		"Rospentek",
		"Rospentek Aike",
		"San Benito",
		"Sarai",
		"Sierra De La Ventana",
		"Tamel Aike",
		"Tapi Aike",
		"Tauel Aike",
		"Tehuelches",
		"Tellier",
		"Tres Cerros",
		"Tres Lagos",
		"Tres Puntas",
		"Tucu Tucu",
		"Ventisquero Moreno",
		"Yacimiento Cerro Vanguardia",
		"Yegua Muerta",
		"Zanjón Del Pescado"
	],
	"Santa Fé": [
		"29",
		"22 De Mayo",
		"4 De Febrero",
		"Aaron Castellanos",
		"Abipones",
		"Acebal",
		"Achaval Rodríguez",
		"Adolfo Alsina",
		"Aero Club Rosario",
		"Aguara",
		"Aguara Grande",
		"Albarellos",
		"Alcorta",
		"Aldao",
		"Alejandra",
		"Allende",
		"Alto Verde",
		"Alvarez",
		"Alvear",
		"Ambrosetti",
		"Amenabar",
		"Andino",
		"Angel Gallardo",
		"Angélica",
		"Angeloni",
		"Antonio Pini",
		"Arequito",
		"Arijon",
		"Arminda",
		"Armstrong",
		"Arocena",
		"Aromos",
		"Aron Castellanos",
		"Arrascaeta",
		"Arroyo Aguiar",
		"Arroyo Ceibal",
		"Arroyo Del Rey",
		"Arroyo Leyes",
		"Arroyo Seco",
		"Arrufo",
		"Arsenal De Guerra San Lorenzo",
		"Arteaga",
		"Ascochingas",
		"Asunción María",
		"Ataliva",
		"Aurelia",
		"Aurelia Norte",
		"Aurelia Sud",
		"Avellaneda",
		"Avena",
		"Avichuncho",
		"Bajo Las Tunas",
		"Barlett",
		"Barrancas",
		"Barranquitas",
		"Barrio Belgrano Ortíz",
		"Barrio Caima",
		"Barros Pazos",
		"Bauer Y Sigel",
		"Bealistock",
		"Bella Italia",
		"Berabevu",
		"Berabevu 1",
		"Berna",
		"Bernard",
		"Bernardo De Irigoyen",
		"Berretta",
		"Bigand",
		"Boca P 25",
		"Bombal",
		"Borghi",
		"Bossi",
		"Bouquet",
		"Bustinza",
		"Cabal",
		"Cabaña El Cisne",
		"Cabeza De Chancho",
		"Cacique Ariacaiquin",
		"Cafferata",
		"Calchaquí",
		"Calchines",
		"Caminera General López",
		"Camino Monte Flores",
		"Campo Andino",
		"Campo Berraz",
		"Campo Botto",
		"Campo Brarda",
		"Campo Calvo",
		"Campo Carignano",
		"Campo Castro",
		"Campo Charo",
		"Campo Clucellas",
		"Campo Coubert",
		"Campo Crenna",
		"Campo Crespo",
		"Campo Daratti",
		"Campo Del Medio",
		"Campo El Araza",
		"Campo El Mataco",
		"Campo Faggiano",
		"Campo Furrer",
		"Campo Galloso",
		"Campo Garabato",
		"Campo Garay",
		"Campo García",
		"Campo Genero",
		"Campo Gimbatti",
		"Campo Giménez",
		"Campo Gola",
		"Campo Grande",
		"Campo Hardy",
		"Campo Horquesco",
		"Campo Huber",
		"Campo Iturraspe",
		"Campo La Amistad",
		"Campo La Paz",
		"Campo La Riviere",
		"Campo Lehman",
		"Campo Magnin",
		"Campo Medina",
		"Campo Monte La Viruela",
		"Campo Moure",
		"Campo Nuevo",
		"Campo Paletta",
		"Campo Pesoa",
		"Campo Quiñones",
		"Campo Quirno",
		"Campo Raffo",
		"Campo Ramseyer",
		"Campo Redondo",
		"Campo Rodríguez",
		"Campo Romero",
		"Campo Rueda",
		"Campo San José",
		"Campo Santa Isabel",
		"Campo Santo Domingo",
		"Campo Siete Provincias",
		"Campo Torquinston",
		"Campo Ubajo",
		"Campo Urdaniz",
		"Campo Verge",
		"Campo Yaguarete",
		"Campo Zavalla",
		"Campo Zurbriggen",
		"Candelaria Sud",
		"Candioti",
		"Cañada De Gómez",
		"Cañada Del Ucle",
		"Cañada Ombu",
		"Cañada Rica",
		"Cañada Rosquin",
		"Cañadita",
		"Capilla Guadalupe Norte",
		"Capilla San José",
		"Capitán Bermúdez",
		"Capivara",
		"Caraguatay",
		"Carcaraña",
		"Cárcel Modelo Coronda",
		"Carlos Dose",
		"Carlos Pellegrini",
		"Carmen",
		"Carmen Del Sauce",
		"Carreras",
		"Carrizales",
		"Casablanca",
		"Casalegno",
		"Casas",
		"Casilda",
		"Castelar",
		"Cavour",
		"Cayasta",
		"Cayastacito",
		"Centeno",
		"Cepeda",
		"Cerana",
		"Ceres",
		"Cerrito",
		"Chabas",
		"Chañar Ladeado",
		"Chapuy",
		"Chateaubriand",
		"Chovet",
		"Cicarelli",
		"Clarke",
		"Clason",
		"Clucellas",
		"Colastine",
		"Colastine Norte",
		"Colmena",
		"Colonia Adolfo Alsina",
		"Colonia Aldao",
		"Colonia Althuaus",
		"Colonia Ana",
		"Colonia Angeloni",
		"Colonia Belgrano",
		"Colonia Bella Italia",
		"Colonia Berlín",
		"Colonia Bicha",
		"Colonia Bigand",
		"Colonia Bossi",
		"Colonia California",
		"Colonia Campo Botto",
		"Colonia Campo Piaggio",
		"Colonia Candelaria",
		"Colonia Castelar",
		"Colonia Castellanos",
		"Colonia Cello",
		"Colonia Clara",
		"Colonia Clodomira",
		"Colonia Corondina",
		"Colonia Dolores",
		"Colonia Dos Rosas",
		"Colonia Dos Rosas Y La Legua",
		"Colonia Duran",
		"Colonia El Carmen",
		"Colonia El Ochenta",
		"Colonia El Simbol",
		"Colonia El Toba",
		"Colonia El Veinticinco",
		"Colonia Ella",
		"Colonia Escribano",
		"Colonia Fernández",
		"Colonia Fidela",
		"Colonia Francesa",
		"Colonia Gómez",
		"Colonia Hansen",
		"Colonia Hardy",
		"Colonia Independencia",
		"Colonia Josefina",
		"Colonia La  Catalana",
		"Colonia La  Palencia",
		"Colonia La  Pellegrini",
		"Colonia La Blanca",
		"Colonia La Costa",
		"Colonia La María",
		"Colonia La Mora",
		"Colonia La Negra",
		"Colonia La Nicolasa",
		"Colonia La Nueva",
		"Colonia La Penca",
		"Colonia La Yerba",
		"Colonia Lago Di Como",
		"Colonia Los Zapallos",
		"Colonia Mackinlay",
		"Colonia Malhman Sud",
		"Colonia Manuel Menchaca",
		"Colonia Margarita",
		"Colonia Mascias",
		"Colonia Matilde",
		"Colonia Maua",
		"Colonia Medici",
		"Colonia Montefiore",
		"Colonia Morgan",
		"Colonia Nueva Narciso",
		"Colonia Ortiz",
		"Colonia Piaggio",
		"Colonia Piamontesa",
		"Colonia Pujol",
		"Colonia Reina Margarita",
		"Colonia Ripamonti",
		"Colonia Rosa",
		"Colonia Sager",
		"Colonia San Antonio",
		"Colonia San Francisco",
		"Colonia San Joaquín",
		"Colonia San José",
		"Colonia San Manuel",
		"Colonia San Roque",
		"Colonia Santa Anita",
		"Colonia Santa Catalina",
		"Colonia Santa Lucia",
		"Colonia Santa Natalia",
		"Colonia Silva",
		"Colonia Sol De Mayo",
		"Colonia Tacurales",
		"Colonia Teresa",
		"Colonia Toscana Primera",
		"Colonia Toscana Segunda",
		"Colonia Tres Marias",
		"Colonia Tres Reyes",
		"Colonia Urdaniz",
		"Colonia Valdez",
		"Colonia Valencia",
		"Colonia Yaguarete",
		"Constanza",
		"Constituyentes",
		"Copacabana",
		"Cora",
		"Coronda",
		"Coronel Aguirre",
		"Coronel Arnold",
		"Coronel Bogado",
		"Coronel Domínguez",
		"Coronel Fraga",
		"Coronel Rodríguez",
		"Coronel Roseti",
		"Correa",
		"Costa Del Toba",
		"Cresta",
		"Crispi",
		"Cristolia",
		"Cuatro Casas",
		"Cuatro De Febrero",
		"Cuatro Esquinas",
		"Cullen",
		"Cululu",
		"Curupaity",
		"Curupayti",
		"Dest Aeronautico Milit Reconqu",
		"Desvío Arauz",
		"Desvío Arijon",
		"Desvío Boero",
		"Desvío Dr Barros Pazos",
		"Desvío Kilometro 282",
		"Desvío Kilometro 392",
		"Dho",
		"Díaz",
		"Diego De Alvear",
		"Distrito 3 Isletas",
		"Doce Casas",
		"Durham",
		"Egusquiza",
		"El 38",
		"El 44",
		"El Aguara",
		"El Alberdon",
		"El Amargo",
		"El Araza",
		"El Bagual",
		"El Bayo",
		"El Bonete",
		"El Cantor",
		"El Caramelo",
		"El Carmen De Avellaneda",
		"El Ceibalito",
		"El Ceibo",
		"El Cincuenta",
		"El Diecisiete",
		"El Galpón",
		"El Gusano",
		"El Jardín",
		"El Laurel",
		"El Mariano",
		"El Nochero",
		"El Pájaro Blanco",
		"El Para",
		"El Pozo",
		"El Rabón",
		"El Refugio",
		"El Ricardito",
		"El Sombrerero",
		"El Sombrerito",
		"El Tajamar",
		"El Tapialito",
		"El Timbo",
		"El Transito",
		"El Trébol",
		"El Triángulo",
		"El Tropezón",
		"Elisa",
		"Elortondo",
		"Emilia",
		"Empalme San Carlos",
		"Empalme Villa Constitución",
		"Encadenadas",
		"Esmeralda",
		"Esmeraldita",
		"Esperanza",
		"Espín",
		"Esquina Grande",
		"Estación Christophersen",
		"Estación Clucellas",
		"Estación Erasto",
		"Estación Josefina",
		"Estación María Juana",
		"Estación Matilde",
		"Estación Saguier",
		"Estación Teodelina",
		"Estación Villa Constitución",
		"Estancia Achala",
		"Estancia La Cigueña",
		"Estancia La Constancia",
		"Estancia La María",
		"Estancia Las Gamas",
		"Estancia Los Palmares",
		"Estancia Pavenhan",
		"Estancia Prusia",
		"Estancia San Antonio",
		"Estancia San Francisco",
		"Esteban Rams",
		"Esther",
		"Estrada",
		"Eusebia",
		"Eustolia",
		"Ewald",
		"Fabrica Militar San Lorenzo",
		"Fassi",
		"Felicia",
		"Fidela",
		"Fighiera",
		"Firmat",
		"Fives Lille",
		"Flor De Oro",
		"Florencia",
		"Florida",
		"Fortín Alerta",
		"Fortín Almagro",
		"Fortín Argentina",
		"Fortín Atahualpa",
		"Fortín Cacique",
		"Fortín Charrua",
		"Fortín Chilcas",
		"Fortín Olmos",
		"Fortín Seis De Caballería",
		"Fortín Tacuru",
		"Fortín Tostado",
		"Francisco Paz",
		"Franck",
		"Fray Luis Beltran",
		"Frontera",
		"Fuentes",
		"Funes",
		"Gaboto",
		"Galisteo",
		"Galvez",
		"Garabato",
		"Garibaldi",
		"Gato Colorado",
		"General Gelly",
		"General Lagos",
		"Gessler",
		"Gobernador Crespo",
		"Godeken",
		"Godoy",
		"Golondrina",
		"Granadero B Bargas",
		"Granadero Baigorria",
		"Granadero Brasilio Bustos",
		"Granaderos",
		"Granja San Manuel",
		"Gregoria Pérez De Denis",
		"Grutly",
		"Grutly Norte",
		"Guadalupe Norte",
		"Guaraníes",
		"Guasuncho",
		"Guaycuru",
		"Helvecia",
		"Hersilia",
		"Hipatia",
		"Huanqueros",
		"Hugentobler",
		"Hughes",
		"Humberto Primero",
		"Humboldt",
		"Humboldt Chico",
		"Ibarlucea",
		"Independencia",
		"Ingeniero Boasi",
		"Ingeniero Chanourdie",
		"Ingeniero Garmendia",
		"Ingeniero Germanía",
		"Intiyaco",
		"Irigoyen",
		"Iriondo",
		"Isla Del Porteño",
		"Isla Tigre",
		"Isleta",
		"Iturraspe",
		"Ituzaingo",
		"Jacinto L Arauz",
		"Jesús María",
		"José Macias",
		"José Manuel Estrada",
		"Juan B Molina",
		"Juan Ortiz",
		"Juncal",
		"Kilometro 113",
		"Kilometro 17",
		"Kilometro 213",
		"Kilometro 23",
		"Kilometro 235",
		"Kilometro 28",
		"Kilometro 293",
		"Kilometro 30",
		"Kilometro 302",
		"Kilometro 319",
		"Kilometro 320",
		"Kilometro 323",
		"Kilometro 35",
		"Kilometro 389",
		"Kilometro 392",
		"Kilometro 396",
		"Kilometro 403",
		"Kilometro 408",
		"Kilometro 41",
		"Kilometro 421",
		"Kilometro 443",
		"Kilometro 465",
		"Kilometro 468",
		"Kilometro 483",
		"Kilometro 49",
		"Kilometro 501",
		"Kilometro 54",
		"Kilometro 67",
		"Kilometro 85",
		"Kilometro 9",
		"Kilometro 95",
		"La Adelaida",
		"La Asturiana",
		"La Blanca",
		"La Bombilla",
		"La Brava",
		"La Cabral",
		"La California",
		"La Calma",
		"La Camila",
		"La Capilla",
		"La Carolina",
		"La Catalina",
		"La Celia",
		"La Ceramica Y Cuyo",
		"La Chispa",
		"La Cigueña",
		"La Clara",
		"La Clarita",
		"La Clorinda",
		"La Constancia",
		"La Criolla",
		"La Diamela",
		"La Elsa",
		"La Esmeralda",
		"La Gallareta",
		"La Gama",
		"La Guampita",
		"La Guardia",
		"La Hosca",
		"La Inés",
		"La Inglesita",
		"La Josefina",
		"La Julia",
		"La Lata",
		"La Lola",
		"La Loma",
		"La Lucila",
		"La Marina",
		"La Merced",
		"La Morocha",
		"La Noria",
		"La Oriental",
		"La Orilla",
		"La Othila",
		"La Othilia",
		"La Pelada",
		"La Picasa",
		"La Polvareda",
		"La Potasa",
		"La Reserva",
		"La Rosa",
		"La Rubia",
		"La Salada",
		"La Sarita",
		"La Sarnosa",
		"La Selva",
		"La Sementera",
		"La Vanguardia",
		"La Verde",
		"La Viuda",
		"La Zulema",
		"Labordeboy",
		"Laguna Paiva",
		"Laguna Verde",
		"Landeta",
		"Lanteri",
		"Larguia",
		"Larrechea",
		"Las Anintas",
		"Las Arenas",
		"Las Avispas",
		"Las Bandurrias",
		"Las Cañas",
		"Las Catalinas",
		"Las Chuñas",
		"Las Delicias",
		"Las Dos Angelitas",
		"Las Encadenadas",
		"Las Garsitas",
		"Las Garzas",
		"Las Higueritas",
		"Las Liebres",
		"Las Mercedes",
		"Las Palmas",
		"Las Palmeras",
		"Las Parejas",
		"Las Petacas",
		"Las Quintas",
		"Las Rosas",
		"Las Siete Provincias",
		"Las Toscas",
		"Las Tres Marías",
		"Las Trojas",
		"Las Tunas",
		"Lassaga",
		"Lazzarino",
		"Lehmann",
		"Liceo Aeronáutico Militar",
		"Links",
		"Llambi Campbell",
		"Logroño",
		"Loma Alta",
		"Loma Verde",
		"López",
		"Los Amores",
		"Los Arcos",
		"Los Cardenales",
		"Los Cardos",
		"Los Cerrillos",
		"Los Charabones",
		"Los Claros",
		"Los Corralitos",
		"Los Cuervos",
		"Los Galpones",
		"Los Hornos",
		"Los Lapachos",
		"Los Laureles",
		"Los Leones",
		"Los Molinos",
		"Los Molles",
		"Los Muchachos",
		"Los Nogales",
		"Los Olivos",
		"Los Osos",
		"Los Palmares",
		"Los Quirquinchos",
		"Los Saladillos",
		"Los Sembrados",
		"Los Tábanos Desvío Km 366",
		"Luciano Leiva",
		"Lucio V López",
		"Luis Palacios",
		"Maciel",
		"Maggiolo",
		"Maizales",
		"Malabrigo",
		"Mangore",
		"Manucho",
		"Marcelino Escalada",
		"Margarita",
		"María Eugenia",
		"María Juana",
		"María Luisa",
		"María Luisa Correa",
		"María Susana",
		"María Teresa",
		"Mariano Saavedra",
		"Marini",
		"Mascias",
		"Máximo Paz",
		"Melincue",
		"Merceditas",
		"Miguel Escalada",
		"Miguel Torres",
		"Miramar",
		"Mocovi",
		"Moisés Ville",
		"Monigotes",
		"Monje",
		"Monte Flores",
		"Monte Obscuridad",
		"Monte Oscuridad",
		"Monte Vera",
		"Montes De Oca",
		"Moussy",
		"Murphy",
		"Mutchnik",
		"Nare",
		"Nelson",
		"Nicanor E Molinas",
		"Nueva Italia",
		"Nueva Pompeya",
		"Nueva Ukrania",
		"Nuevo Torino",
		"Ñandu",
		"Ñandubay",
		"Ñanducita",
		"Obraje Indio Muerto",
		"Obraje San Juan",
		"Ogilive",
		"Ogilvie",
		"Oliveros",
		"Ombu Norte",
		"Oratorio Morante",
		"Oroño",
		"Otto Bemberg",
		"Padre Pedro Iturralde",
		"Paganini",
		"Paikin",
		"Palacios",
		"Paraje 29",
		"Paraje Kilometro 12",
		"Paraje Tragnaghi",
		"Paso Vinal",
		"Paul Groussac",
		"Pavenhan",
		"Pavón",
		"Pavón Arriba",
		"Pedro Gómez Cello",
		"Pereyra Lucena",
		"Pérez",
		"Pericota",
		"Petronila",
		"Peyrano",
		"Piamonte",
		"Pilar",
		"Pino De San Lorenzo",
		"Piñero",
		"Piquete",
		"Plaza Clucellas",
		"Pompeya",
		"Portalis",
		"Portugalete",
		"Potrero Guasuncho",
		"Pozo Borrado",
		"Pozo De Los Indios",
		"Presidente Roca",
		"Progreso",
		"Providencia",
		"Pueblo Abc",
		"Pueblo Alcorta",
		"Pueblo Arequito",
		"Pueblo Candioti",
		"Pueblo Esther",
		"Pueblo Golondrina",
		"Pueblo Kirston",
		"Pueblo María Juana",
		"Pueblo Marini",
		"Pueblo Miguel Torres",
		"Pueblo Muñoz",
		"Pueblo Nuevo",
		"Pueblo Ramona",
		"Pueblo San Antonio",
		"Pueblo San Bernardo",
		"Pueblo Terragni",
		"Puente Colastine",
		"Puerto Aragón",
		"Puerto De San Lorenzo",
		"Puerto Gaboto",
		"Puerto Gral San Martín",
		"Puerto Ocampo",
		"Puerto Piracua",
		"Puerto Piracuacito",
		"Puerto Reconquista",
		"Pujato",
		"Pujato Norte",
		"Rabiola",
		"Rafaela",
		"Ramayon",
		"Ramona",
		"Raquel",
		"Rastreador Fournier",
		"Reconquista",
		"Reconquista Dest Aer Militar",
		"Recreo",
		"Recreo Sur",
		"Reina Margarita",
		"Reynaldo Cullen",
		"Ricardone",
		"Rigby",
		"Rincón De Grondona",
		"Rincón De San Antonio",
		"Rincón De Tacurales",
		"Rincón Del Pintado",
		"Rincón Del Quebracho",
		"Rincón Norte",
		"Rincón Potreros",
		"Rinlon De Avila",
		"Río Salado",
		"Rivadavia",
		"Rodolfo Alcorta",
		"Roldan",
		"Romang",
		"Rosário",
		"Rueda",
		"Rufino",
		"Ruinas Santa Fe La Vieja",
		"Runciman",
		"Sa Pereyra",
		"Saguier",
		"Saladero M Cabal",
		"Salto Grande",
		"San Agustín",
		"San Alberto",
		"San Antonio De Obligado",
		"San Bernardo",
		"San Carlos",
		"San Carlos Centro",
		"San Carlos Norte",
		"San Carlos Sud",
		"San Cristóbal",
		"San Eduardo",
		"San Estanislao",
		"San Eugenio",
		"San Fabián",
		"San Francisco De Santa Fe",
		"San Genaro",
		"San Genaro Norte",
		"San Geronimo",
		"San Gregorio",
		"San Guillermo",
		"San Javier",
		"San Jerónimo Del Sauce",
		"San Jerónimo Norte",
		"San Jerónimo Sud",
		"San Joaquín",
		"San Jorge",
		"San José",
		"San José De La Esquina",
		"San José Del Rincón",
		"San José Frontera",
		"San Justo",
		"San Lorenzo",
		"San Marcelo",
		"San Marcos De Venado Tuerto",
		"San Mariano",
		"San Martín De Las Escobas",
		"San Martín De Tours",
		"San Martín Norte",
		"San Miguel",
		"San Pedro",
		"San Pedro Norte",
		"San Pedro Sur",
		"San Ricardo",
		"San Roque",
		"San Sebastián",
		"San Urbano",
		"San Vicente",
		"Sancti Spiritu",
		"Sanford",
		"Santa Ana",
		"Santa Clara",
		"Santa Clara De Buena Vista",
		"Santa Clara De Saguier",
		"Santa Emilia",
		"Santa Eusebia",
		"Santa Fe",
		"Santa Felicia",
		"Santa Isabel",
		"Santa Lucia",
		"Santa Margarita",
		"Santa María",
		"Santa Maria Centro",
		"Santa Maria Norte",
		"Santa Natalia",
		"Santa Paula",
		"Santa Rosa De Calchines",
		"Santa Teresa",
		"Santo Domingo",
		"Santo Tome",
		"Santurce",
		"Sargento Cabral",
		"Sarmiento",
		"Sastre",
		"Sauce Viejo",
		"Schiffner",
		"Semino",
		"Serodino",
		"Setúbal",
		"Sierra Pereyra",
		"Sin Pereza",
		"Sol De Mayo",
		"Soldini",
		"Soledad",
		"Souto Mayor",
		"Soutomayor",
		"Stephenson",
		"Suardi",
		"Sunchales",
		"Susana",
		"Tacuarendi",
		"Tacural",
		"Tais",
		"Talleres",
		"Tarragona",
		"Tartagal",
		"Teodelina",
		"Theobald",
		"Timbues",
		"Timbues José María",
		"Toba",
		"Tomas Alva Edison",
		"Tortugas",
		"Tostado",
		"Totoras",
		"Traill",
		"Tres Bocas",
		"Tres Colonias",
		"Tres Esquinas",
		"Tres Pozos",
		"Tte Hipolito Bouchard",
		"Uranga",
		"Veinticuatro Casas",
		"Velázquez",
		"Venado Tuerto",
		"Vera",
		"Vera Mujica",
		"Vera Y Pintado",
		"Vicente Echevarria",
		"Vicente Echeverria",
		"Víctor Manuel Segundo",
		"Videla",
		"Vila",
		"Villa Adela",
		"Villa Amelia",
		"Villa América",
		"Villa Ana",
		"Villa Biota",
		"Villa Cañas",
		"Villa Cassini",
		"Villa Constitución",
		"Villa Divisa De Mayo",
		"Villa Don Bosco",
		"Villa Eloisa",
		"Villa Estela",
		"Villa Fredickson",
		"Villa Garibaldi",
		"Villa Gobernador Galvez",
		"Villa Guastalla",
		"Villa Guillermina",
		"Villa La Ribera",
		"Villa Lastenia",
		"Villa Lujan",
		"Villa Lyly Talleres",
		"Villa Margarita",
		"Villa María Selva",
		"Villa Minetti",
		"Villa Mugueta",
		"Villa Ocampo",
		"Villa Porucci",
		"Villa Regules",
		"Villa Rosello",
		"Villa San Diego",
		"Villa San José",
		"Villa Saralegui",
		"Villa Trinidad",
		"Villa Viveros",
		"Villa Yapeyu",
		"Villada",
		"Villani",
		"Virginia",
		"Vuelta Del Pirata",
		"Walvelberg",
		"Wheelwright",
		"Wildermuth",
		"Yaguarete",
		"Yamandu",
		"Zadockhan",
		"Zamponi",
		"Zanetti",
		"Zavalla",
		"Zenon Pereyra"
	],
	"Santiago Del Estero": [
		"25 De Mayo",
		"25 De Mayo De Barnegas",
		"25 De Mayo Sud",
		"3 De Marzo",
		"7 De Abril",
		"9 De Julio",
		"Abra De La Cruz",
		"Abra De Quimil",
		"Abra Grande",
		"Abras Del Martirizado",
		"Abras Del Medio",
		"Abrita",
		"Abrita Chica",
		"Abrita Grande",
		"Acos",
		"Acosta",
		"Aerolito",
		"Agua Amarga",
		"Agua Azul",
		"Agua Blanca",
		"Agua Caliente",
		"Agua Dulce",
		"Agua Salada",
		"Agua Turbia",
		"Aguada",
		"Aguadita",
		"Aguas Coloradas",
		"Agujereado",
		"Agustina Libarona",
		"Ahí Veremos",
		"Aibal",
		"Aibalito",
		"Alarcon",
		"Albardon",
		"Albardon Chuña",
		"Alberdi",
		"Alejito",
		"Algarrobal Viejo",
		"Algarrobales",
		"Algarrobo",
		"Alhuampa",
		"Alpa Puca",
		"Alpapuca",
		"Alta Gracia",
		"Alto Alegre",
		"Alto Bello",
		"Alto Pozo",
		"Alza Nueva",
		"Amama",
		"Amapola",
		"Ambargasta",
		"Amicha",
		"Amiman",
		"Amoladeras",
		"Ampa",
		"Anca",
		"Ancajan",
		"Anchanga",
		"Anchilo",
		"Anchoriga",
		"Ancocha",
		"Ancoche",
		"Anga",
		"Animas",
		"Anjuli",
		"Antaje",
		"Antilo",
		"Antuco",
		"Añatuya",
		"Añil",
		"Aragonés",
		"Arbol Blanco",
		"Arbol Negro",
		"Arbol Solo",
		"Arbolitos",
		"Ardiles",
		"Ardiles De La Costa",
		"Areas",
		"Arenales",
		"Argentina",
		"Armonía",
		"Arraga",
		"Arroyo Tala",
		"Aspa Sinchi",
		"Atahualpa",
		"Atoj Pozo",
		"Ave María",
		"Averías",
		"Ayuncha",
		"Azogasta",
		"Azucena",
		"Babilonia",
		"Báez",
		"Bagual Muerto",
		"Bahía Blanca",
		"Bahoma",
		"Bajadita",
		"Bajo Grande",
		"Bajo Hondo",
		"Bajo Las Piedras",
		"Bajo Verde",
		"Balbuena",
		"Balde Pozo",
		"Bandera",
		"Bandera Bajada",
		"Banegas",
		"Barranca Colorada",
		"Barrancas",
		"Barrial Alto",
		"Barrialito",
		"Barrio Este",
		"Barrio Jardín",
		"Barrio La Leñera",
		"Barrio Obrero",
		"Barrio Villa Cohesa",
		"Barrio Villa Fernández",
		"Bauman",
		"Bayo Muerto",
		"Bebidas",
		"Bejan",
		"Bélgica",
		"Belgrano",
		"Bella Vista",
		"Beltran",
		"Beltran Loreto",
		"Binal Esquina",
		"Blanca",
		"Blanca Pozo",
		"Blanco Pozo",
		"Bobadal",
		"Boca Del Tigre",
		"Boquerón",
		"Bordo Pampa",
		"Botija",
		"Bracho",
		"Brandan",
		"Brea Pozo",
		"Brea Pozo Viejo",
		"Brea Puñuna",
		"Brealoj",
		"Buen Lugar",
		"Buena Esperanza",
		"Buena Vista",
		"Buenos Aires",
		"Buey Muerto",
		"Buey Rodeo",
		"Burra Huañuna",
		"Burra Huaquna",
		"Burro Pozo",
		"Cabra",
		"Cachi",
		"Cachico",
		"Cajón",
		"Calderón",
		"Caleras",
		"Callejón Bajada",
		"Caloj",
		"Campo Alegre",
		"Campo Amarillo",
		"Campo Belgrano",
		"Campo De Amor",
		"Campo Del Aguila",
		"Campo Del Cielo",
		"Campo Del Cisne",
		"Campo Del Infierno",
		"Campo El Rosario",
		"Campo Gallo",
		"Campo Grande",
		"Campo La Angelita",
		"Campo Limpio",
		"Campo Nuevo",
		"Campo Ramón Laplace",
		"Campo Rico",
		"Campo Verde",
		"Canario",
		"Cancinos",
		"Candelaria",
		"Caneinos",
		"Cantamampa",
		"Canteros",
		"Cañada",
		"Cañada De La Costa",
		"Cañada De La Cruz",
		"Cañada Del Medio",
		"Cañada Escobar",
		"Cañada Honda",
		"Cañada Limpia",
		"Cañada Rica",
		"Cañada San Ramón",
		"Cañada Tala Pozo",
		"Cañas Paso",
		"Cañitas",
		"Capilla",
		"Caranchi Yaco",
		"Carbón Pozo",
		"Cardajal",
		"Cardon Esquina",
		"Cardozos",
		"Carrera Vieja",
		"Carretero",
		"Cartavio",
		"Casa Alta",
		"Casa De Dios",
		"Casa Verde",
		"Casares",
		"Cashico",
		"Casilla Del Medio",
		"Caspi Corral",
		"Catorce Quebrachos",
		"Cavadito",
		"Cavado",
		"Cazadores",
		"Ceja Pozo",
		"Cejas",
		"Cejolao",
		"Celestina",
		"Central Dolores",
		"Cerrillo",
		"Cerrillos",
		"Cerrillos De San Isidro",
		"Cerrito",
		"Cerro Rico",
		"Chacras",
		"Chaguar Puncu",
		"Chainima",
		"Chanchillos",
		"Chañar Aguada",
		"Chañar Bajada",
		"Chañar Esquina",
		"Chañar Laguna",
		"Chañar Pocito",
		"Chañar Pozo",
		"Chañar Pozo De Abajo",
		"Chañar Pujio",
		"Chañar Sunichaj",
		"Chañar Yaco",
		"Chañares Altos",
		"Chañaritos",
		"Charco Viejo",
		"Charquina",
		"Chauchillas",
		"Chaupi Pozo",
		"Chaves",
		"Cheej",
		"Chilca",
		"Chilca Albardon",
		"Chilca Juliana",
		"Chilcas La Loma",
		"Chile",
		"Chileno",
		"Chillimo",
		"Chilpa Macho",
		"Chilpa Mayo",
		"Chilquita",
		"Chilquita I",
		"Chilquitas",
		"Chimpa Macho",
		"Chira",
		"Choya",
		"Chuchi",
		"Chuiqui",
		"Chuña Albardon",
		"Chuña Palma",
		"Churqui",
		"Churqui Esquina",
		"Clavel Blanco",
		"Cleveland",
		"Clodomira",
		"Codillo",
		"Codo",
		"Codo Bajada",
		"Codo Pozo",
		"Codo Viejo",
		"Collera Huircuna",
		"Collera Huiri",
		"Collera Hurcuna",
		"Collujlioj",
		"Collun Lioj",
		"Collun-Lioj",
		"Colombia",
		"Colonia Alpina",
		"Colonia Alsina",
		"Colonia Dora",
		"Colonia El Peligro",
		"Colonia El Simbolar",
		"Colonia Ermelinda",
		"Colonia España",
		"Colonia Geraldina",
		"Colonia Isla",
		"Colonia La Victoria",
		"Colonia Mackinlay",
		"Colonia María Luisa",
		"Colonia Media",
		"Colonia Mercedes",
		"Colonia Paula",
		"Colonia Paz",
		"Colonia Pinto",
		"Colonia San Juan",
		"Colonia Santa Rosa Aguirre",
		"Colonia Siegel",
		"Colonia Tinco",
		"Colonias",
		"Concepción",
		"Conchayos",
		"Cóndor Huasi",
		"Consulñoj",
		"Contreras Establecimiento",
		"Conzo",
		"Copo Viejo",
		"Coraspino",
		"Coro Abra",
		"Coronel Barros",
		"Coronel Fernández",
		"Coronel Manuel Leoncio Rico",
		"Coropampa",
		"Corral De Carcos",
		"Corral Del Rey",
		"Corral Grande",
		"Corral Quemado",
		"Corralito",
		"Cortadera",
		"Cortaderas",
		"Corvalanes",
		"Costa Rica",
		"Costa Vieja",
		"Cruz Bajada",
		"Cruz Chula",
		"Cruz Grande",
		"Cruz Loma",
		"Cruz Pozo",
		"Cuatro Bocas",
		"Cuchi Corral",
		"Cuichicaña",
		"Cúquenos",
		"Cuquero",
		"Cuyoj",
		"Desvío Kilometro 1342",
		"Desvío Pozo Dulce",
		"Diaspa",
		"Diente Del Arado",
		"Dique Chico",
		"Dique Figueroa",
		"Dique Los Quiroga",
		"Divisadero",
		"Doble Tero",
		"Dolores",
		"Dolores Central",
		"Don Bartolo",
		"Don Pietro",
		"Donadeu",
		"Doña Lorenza",
		"Doña Luisa",
		"Dormida",
		"Dos Arboles",
		"Dos Eulacias",
		"Dos Eulalias",
		"Dos Hermanas",
		"Dos Hermanos",
		"Dos Represas",
		"Dos Varones",
		"Ea La Verde",
		"El 21",
		"El Abra",
		"El Aerolito",
		"El Agricultor",
		"El Aguila",
		"El Aibal",
		"El Aibalito",
		"El Aibe",
		"El Alambrado",
		"El Algarrobo",
		"El Añil",
		"El Arbol De Piedra",
		"El Arbolito",
		"El Arenal",
		"El Aspirante",
		"El Bagual",
		"El Bajo",
		"El Balde",
		"El Baldecito",
		"El Bañadero",
		"El Barrial",
		"El Bobadal",
		"El Bordito",
		"El Bosque",
		"El Bragado",
		"El Bravo",
		"El Cabure",
		"El Cachi",
		"El Cadillo",
		"El Cajón",
		"El Cambiado",
		"El Canal",
		"El Candelero",
		"El Cañón",
		"El Carmen",
		"El Cebolliin",
		"El Cebollin",
		"El Cercado",
		"El Cerrito",
		"El Cerrito Monte Quemado",
		"El Cerro",
		"El Chañar",
		"El Charabón",
		"El Charco",
		"El Chinchillar",
		"El Churqui",
		"El Cincuenta",
		"El Colmenar",
		"El Colorado",
		"El Corrido",
		"El Crece",
		"El Cruce Kilometro 659",
		"El Crucero",
		"El Cuadrado",
		"El Cuarenta Y Nueve",
		"El Cuello",
		"El Deán",
		"El Descanso",
		"El Destino",
		"El Diablo",
		"El Diamante",
		"El Divisadero",
		"El Dorado",
		"El Durazno",
		"El Empachado",
		"El Escondido",
		"El Favorito",
		"El Fisco",
		"El Fisco De Fátima",
		"El Florido",
		"El Fraile",
		"El Fuerte",
		"El Galpón",
		"El Gramillar",
		"El Guayacan",
		"El Hoyo",
		"El Huaico",
		"El Jardín",
		"El Jume",
		"El Juncal",
		"El Malacara",
		"El Manantial",
		"El Marne",
		"El Mataco",
		"El Milagro",
		"El Mistol",
		"El Mojón",
		"El Molar",
		"El Molle",
		"El Mulato",
		"El Naranjo",
		"El Negrito",
		"El Nerio",
		"El Noventa",
		"El Ojo De Agua",
		"El Olivar",
		"El Once",
		"El Oscuro",
		"El Oso",
		"El Pacara",
		"El Palmar",
		"El Palomar",
		"El Paraíso",
		"El Paraná",
		"El Peral",
		"El Perseguido",
		"El Pértigo",
		"El Perú",
		"El Pilar",
		"El Pinto",
		"El Pirucho",
		"El Porvenir",
		"El Potrero",
		"El Prado",
		"El Pueblito",
		"El Puente",
		"El Puestito",
		"El Puesto",
		"El Quebrachal",
		"El Quemado",
		"El Quillin",
		"El Rajo",
		"El Real",
		"El Recreo",
		"El Remanso",
		"El Remate",
		"El Retiro",
		"El Rincón",
		"El Rodeo",
		"El Rosario",
		"El Saladillo",
		"El Salvador",
		"El Sauce",
		"El Segundo",
		"El Señuelo",
		"El Setenta",
		"El Silencio",
		"El Simbol",
		"El Simbolar",
		"El Solitario",
		"El Tacial",
		"El Tala",
		"El Tanque",
		"El Tobiano",
		"El Traslado",
		"El Trece",
		"El Ucle",
		"El Unco",
		"El Urunday",
		"El Valle",
		"El Valle De Oriente",
		"El Veinte",
		"El Veinticinco",
		"El Veinticinco  Sumampa",
		"El Veinticinco De Mayo",
		"El Veintisiete",
		"El Venticinco",
		"El Vinalar",
		"El Viñalito",
		"El Vizcacheral",
		"Ensenada",
		"Envidia",
		"Escalera",
		"Escuela 1050",
		"Escuela 1080",
		"Escuela 109",
		"Escuela 20",
		"Escuela 57",
		"Escuela 665",
		"Escuela 708",
		"Escuela 879",
		"Esperanza",
		"Espinal",
		"Espinillo",
		"Establecimiento 14 De Setiembr",
		"Estación Atamisqui",
		"Estación Pampa Muyoj",
		"Estados Unidos",
		"Estancia El Carmen",
		"Estancia La Agustina",
		"Estancia La Elsita",
		"Estancia La Invernada",
		"Estancia Nueva Esperanza",
		"Estancia Vieja",
		"Esteco",
		"Esteros",
		"Ezcurra",
		"Famatina",
		"Farol",
		"Favorina",
		"Favorita",
		"Fernández",
		"Fierro",
		"Fivialtos",
		"Floresta",
		"Florida",
		"Fortín Inca",
		"Fortín La Viuda",
		"Fortuna",
		"Frías",
		"Galeano",
		"Gallegos",
		"Garceano",
		"Garza",
		"Gaspar Suarez",
		"Genoveva",
		"Gibialto",
		"Girardet",
		"Gramilla",
		"Gramillal",
		"Granadero Gatica",
		"Guaipi",
		"Gualamba",
		"Guampacha",
		"Guanaco Sombriana",
		"Guanacuyoj",
		"Guañagasta",
		"Guarcan",
		"Guardia",
		"Guardia De La Esquina",
		"Guardia Del Norte",
		"Guardia Escolta",
		"Guardia Vieja",
		"Guatana",
		"Guayacan",
		"Guaycuru",
		"Guaype",
		"Guerra",
		"Guiñao",
		"Haase",
		"Hahuancuyos",
		"Hazan Villa",
		"Hernán Mejía Miraval",
		"Herrera",
		"Higuera Chaqui",
		"Higuerillas",
		"Hilumampa",
		"Horcos Tucucuna",
		"Hornillos",
		"Hoyo Cerco",
		"Hoyo Con Agua",
		"Hoyon",
		"Huacanitas",
		"Huachana",
		"Huajia",
		"Hualo Cáncana",
		"Huascan",
		"Huascho  Patilla",
		"Huascho Patilla",
		"Huchupayana",
		"Huilla Catina",
		"Humaita",
		"Huñajcito",
		"Huritu Huasi",
		"Hutcu Chacra",
		"Huturungo",
		"Huyamampa",
		"Icaño",
		"Ichagon",
		"Iliages",
		"Industria Nueva",
		"Ingeniero Carlos Christiernson",
		"Ingeniero Ezcurra",
		"Ingeniero Forres",
		"Inti Huasi",
		"Isca Yacu",
		"Isca Yacu Semaul",
		"Isla Baja",
		"Isla De Aragones",
		"Isla De Los Castillos",
		"Isla De Los Sotelos",
		"Isla Mota",
		"Isla Verde",
		"Iuchan",
		"Jacimampa",
		"Janta",
		"Jardín De Las Delicias",
		"Jiménez",
		"Juanillo",
		"Jume",
		"Jume Esquina",
		"Jumeal O Jumial",
		"Jumi Pozo",
		"Jumi Viejo",
		"Jumial",
		"Jumial Grande",
		"Jumialito",
		"Junalito",
		"Juncal Grande",
		"Kenti Tacko",
		"Kenti Taco",
		"Kilometro 10",
		"Kilometro 1033",
		"Kilometro 1073",
		"Kilometro 1098",
		"Kilometro 112",
		"Kilometro 1121",
		"Kilometro 117",
		"Kilometro 118",
		"Kilometro 120",
		"Kilometro 1210",
		"Kilometro 1255",
		"Kilometro 1297",
		"Kilometro 1314",
		"Kilometro 1338",
		"Kilometro 135",
		"Kilometro 1362",
		"Kilometro 1380",
		"Kilometro 1391",
		"Kilometro 153",
		"Kilometro 18",
		"Kilometro 20",
		"Kilometro 3",
		"Kilometro 301",
		"Kilometro 364",
		"Kilometro 390",
		"Kilometro 433",
		"Kilometro 436",
		"Kilometro 437",
		"Kilometro 443",
		"Kilometro 443 Taboada",
		"Kilometro 450",
		"Kilometro 454",
		"Kilometro 473",
		"Kilometro 477",
		"Kilometro 48",
		"Kilometro 49",
		"Kilometro 494",
		"Kilometro 499",
		"Kilometro 515",
		"Kilometro 546",
		"Kilometro 55",
		"Kilometro 606",
		"Kilometro 613",
		"Kilometro 629",
		"Kilometro 645",
		"Kilometro 651",
		"Kilometro 659",
		"Kilometro 661",
		"Kilometro 665",
		"Kilometro 694",
		"Kilometro 719",
		"Kilometro 735",
		"Kilometro 764",
		"Kilometro 88",
		"Kiska Hurmana",
		"Kiska Loro",
		"La Abra",
		"La Abrita",
		"La Aguada",
		"La Aguadita",
		"La Aída",
		"La Alemana",
		"La Aloja",
		"La América",
		"La Angelita",
		"La Argentina",
		"La Armonía",
		"La Aurora",
		"La Balanza",
		"La Banda",
		"La Barrosa",
		"La Bella Criolla",
		"La Blanca",
		"La Bota",
		"La Brea",
		"La Calera",
		"La Cañada",
		"La Capilla",
		"La Carolina",
		"La Casimira",
		"La Centella",
		"La Chejchilla",
		"La Chilca",
		"La Clemira",
		"La Codicia",
		"La Colina",
		"La Colonia",
		"La Concepción",
		"La Cortadera",
		"La Costa",
		"La Costosa",
		"La Cruz",
		"La Cuarteada",
		"La Cuesta",
		"La Curva",
		"La Dársena",
		"La Defensa",
		"La Delia",
		"La Dolores",
		"La Donosa",
		"La Dora",
		"La Dormida",
		"La Encalada",
		"La Ensenada",
		"La Esmeralda",
		"La Esperanza",
		"La Esquina",
		"La Estancia",
		"La Eulalia",
		"La Falda",
		"La Feliciana",
		"La Firmeza",
		"La Florida",
		"La Fortuna",
		"La Fragua",
		"La Francisca",
		"La Geraldina",
		"La Germania",
		"La Golondrina",
		"La Grama",
		"La Grana",
		"La Granada",
		"La Granja",
		"La Gringa",
		"La Griteria",
		"La Guardia",
		"La Hiedra",
		"La Higuera",
		"La Huerta",
		"La Invernada",
		"La Isla",
		"La Isleta",
		"La Juliana",
		"La Laguna",
		"La Laura",
		"La Libia",
		"La Loma",
		"La Lomada",
		"La Luna",
		"La Magdalena",
		"La Manga",
		"La Maravilla",
		"La Marta",
		"La Melada",
		"La Mesada",
		"La Nena",
		"La Noria",
		"La Overa",
		"La Paciencia",
		"La Paliza",
		"La Palma",
		"La Paloma",
		"La Pampa",
		"La Panchita",
		"La Paz",
		"La Perlita",
		"La Petronila",
		"La Pintada",
		"La Polvareda",
		"La Porfía",
		"La Porteña",
		"La Potocha",
		"La Primavera",
		"La Primitiva",
		"La Protegida",
		"La Providencia",
		"La Puerta",
		"La Puerta Del Monte",
		"La Punta",
		"La Ramada",
		"La Ramadita",
		"La Recompensa",
		"La Reconquista",
		"La Reducción",
		"La Represa",
		"La Resbalosa",
		"La Revancha",
		"La Rinconada",
		"La Rivera",
		"La Romelia",
		"La Rosilla",
		"La Santafecina",
		"La Sarita",
		"La Selva",
		"La Simona",
		"La Soledad",
		"La Susana",
		"La Tala",
		"La Tapa",
		"La Teresa",
		"La Totorilla",
		"La Trampa",
		"La Tusca",
		"La Unión",
		"La Verde",
		"La Victoria",
		"La Virtud",
		"La Viuda",
		"La Vuelta",
		"La Yerba",
		"Lago Muyoj",
		"Laguna",
		"Laguna Baya",
		"Laguna Blanca",
		"Laguna Del Suncho",
		"Laguna Larga",
		"Lagunilla",
		"Lagunitas",
		"Lapa",
		"Laprida",
		"Las Abras",
		"Las Abras De San Antonio",
		"Las Aguadas",
		"Las Aguilas",
		"Las Almas",
		"Las Cantinas",
		"Las Cañas",
		"Las Carpas",
		"Las Cejas",
		"Las Chacras",
		"Las Chilcas",
		"Las Ciénagas",
		"Las Colinas",
		"Las Colonias",
		"Las Cruces",
		"Las Delicias",
		"Las Dos Flores",
		"Las Flores",
		"Las Gamas",
		"Las Hermanas",
		"Las Horquetas",
		"Las Islas",
		"Las Isletas",
		"Las Juntas",
		"Las Lajas",
		"Las Lomas",
		"Las Lomitas",
		"Las Maravillas",
		"Las Mochas",
		"Las Mostazas",
		"Las Orellanas",
		"Las Palmas",
		"Las Palmeras",
		"Las Palmitas",
		"Las Palomitas",
		"Las Parvas",
		"Las Peñas",
		"Las Perforaciones",
		"Las Porteñas",
		"Las Puertas",
		"Las Quebradas",
		"Las Ramaditas",
		"Las Randas",
		"Las Rosas",
		"Las Salinas",
		"Las Talas",
		"Las Talitas",
		"Las Tejas",
		"Las Teresas",
		"Las Tigreras",
		"Las Tinajas",
		"Las Trincheras",
		"Las Viboritas",
		"Las Zanjas",
		"Laspa",
		"Laureles",
		"Lavalle",
		"Lechuzas",
		"Ledesma",
		"Leiva",
		"Lescano",
		"Lescanos",
		"Lezcanos",
		"Libanesa",
		"Libertad",
		"Lilo Viejo",
		"Limache",
		"Lincho",
		"Linton",
		"Llajta Mauca",
		"Llama Pampa",
		"Lojlo",
		"Loma Blanca",
		"Loma Colorada",
		"Loma De Yeso",
		"Loma Del Medio",
		"Loma Grande",
		"Loma Negra",
		"Lomas Blancas",
		"Lomitas",
		"Lomitas Blancas",
		"Loreto",
		"Loro Huasi",
		"Los Alderete",
		"Los Alderetes",
		"Los Algarrobos",
		"Los Angeles",
		"Los Arbolitos",
		"Los Arias",
		"Los Caños",
		"Los Carrizos",
		"Los Castillos",
		"Los Cerrillos",
		"Los Cerros",
		"Los Chañares",
		"Los Cobres",
		"Los Colorados",
		"Los Correas",
		"Los Cruces",
		"Los Décimas",
		"Los Díaz",
		"Los Doce Quebrachos",
		"Los Encantos",
		"Los Fierros",
		"Los Gallardos",
		"Los Gatos",
		"Los Guerreros",
		"Los Herreras",
		"Los Herreros",
		"Los Juries",
		"Los Linares",
		"Los Marcos",
		"Los Milagros",
		"Los Mollares",
		"Los Molles",
		"Los Monteros",
		"Los Morteros",
		"Los Moyas",
		"Los Naranjos",
		"Los Nuñez",
		"Los Ovejeros",
		"Los Paraísos",
		"Los Paredones",
		"Los Pecariel",
		"Los Pensamientos",
		"Los Pereyra",
		"Los Pirpintos",
		"Los Pocitos",
		"Los Porongos",
		"Los Porteños",
		"Los Pozos",
		"Los Puentes",
		"Los Puestos",
		"Los Puntos",
		"Los Quebrachos",
		"Los Quiroga",
		"Los Ralos",
		"Los Remansos",
		"Los Robles",
		"Los Santillan",
		"Los Sauces",
		"Los Sunchos",
		"Los Tableros",
		"Los Telares",
		"Los Tigres",
		"Lote 15",
		"Lote 27 Escuela 286",
		"Lote 29",
		"Lote 42",
		"Lote F",
		"Lote S",
		"Lugones",
		"Lujan",
		"Macó",
		"Macó Yanda",
		"Maderas",
		"Magdalena",
		"Maguito",
		"Maidana",
		"Mailin",
		"Majadas",
		"Majadas Sud",
		"Majancito",
		"Mal Paso",
		"Malbran",
		"Mallin Viejo",
		"Malota",
		"Manantiales",
		"Manchin",
		"Manfloa",
		"Manga Bajada",
		"Mangrullo",
		"Manogasta",
		"Mansupa",
		"Maquijata",
		"Maquita",
		"Maquitis",
		"Maquito",
		"Maravilla",
		"María",
		"María Delicia",
		"Martín Paso",
		"Martínez",
		"Masumpa",
		"Matara",
		"Mate Pampa",
		"Médanos",
		"Medellín",
		"Media Flor",
		"Media Luna",
		"Medio Mundo",
		"Melero",
		"Mendoza",
		"Mercedes",
		"Miel De Palo",
		"Milagro",
		"Mili",
		"Minerva",
		"Miramonte",
		"Mirandas",
		"Mirca",
		"Mistol Loma",
		"Mistol Muyoj",
		"Mistol Pampa",
		"Mistol Pozo",
		"Mistoles",
		"Mistolito",
		"Moconza",
		"Mojón",
		"Mojoncito",
		"Molle",
		"Molle Pozo",
		"Molleoj",
		"Molles",
		"Monte Alto",
		"Monte Crecido",
		"Monte Cristo",
		"Monte Potrero",
		"Monte Quemado",
		"Monte Redondo",
		"Monte Rico",
		"Monte Verde",
		"Monteagudo",
		"Montesino",
		"Montevideo",
		"Moradito",
		"Morales",
		"Morampa",
		"Morayos",
		"Morcillo",
		"Morello",
		"Morón",
		"Nanda",
		"Naquito",
		"Naranjito",
		"Naranjitos",
		"Nasalo",
		"Navarro",
		"Negra Muerta",
		"Nogales",
		"Noge",
		"Norqueoj",
		"Novillo",
		"Nueva Alza",
		"Nueva Antaje",
		"Nueva Aurora",
		"Nueva Ceres",
		"Nueva Colonia",
		"Nueva Esperanza",
		"Nueva Francia",
		"Nueva Granada",
		"Nueva Industria",
		"Nueva Trinidad",
		"Nueve Mistoles",
		"Nuevo Líbano",
		"Nuevo Lujan",
		"Nuevo Simbolar",
		"Obraje Iriondo",
		"Obraje Los Tigres",
		"Obraje Mailin",
		"Obraje María Angélica",
		"Octavia",
		"Ojo De Agua",
		"Oncajan",
		"Oncan",
		"Oratorio",
		"Oro Pampa",
		"Otumpa",
		"Ovejeros",
		"Paaj Muyo",
		"Paaj Pozo",
		"Paaj Rodeo",
		"Paciencia",
		"Padua",
		"Pájaro Blanco",
		"Palermo",
		"Palizas",
		"Palma Flor",
		"Palma Larga",
		"Palma Pozo",
		"Palma Redonda",
		"Palmares",
		"Palmas",
		"Palmitas",
		"Palmitas De Jerez",
		"Palo A Pique",
		"Palo Lindo",
		"Palo Negro",
		"Palo Parado",
		"Palomar",
		"Palos Quemados",
		"Pampa Atún",
		"Pampa De Los Guanacos",
		"Pampa Grande",
		"Pampa Mayo",
		"Pampa Muyoj",
		"Pampa Pozo",
		"Pampallajta",
		"Parada Kilometro 101",
		"Paraje El Prado",
		"Paraje Gauna",
		"Paraje La Bajada",
		"Paraje La Pampa",
		"Paraje Lilo Viejo",
		"Paraje Milagro",
		"Paraje Obraje Maria Angelica",
		"Paraje Villa Yolanda",
		"Paraná",
		"Paso De Oscares",
		"Paso Del Saladillo",
		"Paso Grande",
		"Paso Mosoj",
		"Paso Reducido",
		"Patay",
		"Patillo",
		"Peludo Warcuna",
		"Penal Provincial",
		"Peralta",
		"Percas",
		"Perchil Bajo",
		"Pérez De Zurita",
		"Picos De Amor",
		"Picos De Arroz",
		"Piedra Blanca",
		"Piedra Buena",
		"Piedritas",
		"Pineda",
		"Pinedo",
		"Pinto Villa General Mitre",
		"Pirhuas",
		"Piruitas",
		"Platero",
		"Pocito De La Loma",
		"Pocitos",
		"Poleo Pozo",
		"Polvareda",
		"Polvaredas",
		"Porongal",
		"Porongos",
		"Portalis",
		"Portezuelo",
		"Posta Sanitaria Pocitos",
		"Potrero Bajada",
		"Pozancon",
		"Pozancones",
		"Pozo",
		"Pozo Betbeder",
		"Pozo Cabado",
		"Pozo Castaño",
		"Pozo Cercado",
		"Pozo Ciego",
		"Pozo Colorado",
		"Pozo De La Puerta",
		"Pozo Del Algarrobo",
		"Pozo Del Arbolito",
		"Pozo Del Campo",
		"Pozo Del Castaño",
		"Pozo Del Chañar",
		"Pozo Del Garabato",
		"Pozo Del Macho",
		"Pozo Del Monte",
		"Pozo Del Simbol",
		"Pozo Del Toba",
		"Pozo Dulce",
		"Pozo Escondido",
		"Pozo Grande",
		"Pozo Herrera",
		"Pozo Hondo",
		"Pozo Huascho",
		"Pozo Lerdo",
		"Pozo Limpio",
		"Pozo Lindo",
		"Pozo Marcado",
		"Pozo Moro",
		"Pozo Mosoj",
		"Pozo Muerto",
		"Pozo Nuevo",
		"Pozo Redondo",
		"Pozo Salado",
		"Pozo Verde",
		"Pozo Vil",
		"Pozuelos",
		"Primavera",
		"Progreso De Jume",
		"Providencia",
		"Proviru",
		"Pueblito",
		"Pueblo Nuevo",
		"Pueda Ser",
		"Puente Bajada",
		"Puente Del Saladillo",
		"Puente Del Salado",
		"Puente Negro",
		"Puente Río Salado",
		"Puerta Chiquita",
		"Puerta De Las Piedras",
		"Puerta De Los Ríos",
		"Puerta Del Cielo",
		"Puerta Del Monte",
		"Puerta Grande",
		"Puestito",
		"Puestito De San Antonio",
		"Puesto",
		"Puesto Córdoba",
		"Puesto De Arriba",
		"Puesto De Díaz",
		"Puesto De Juanes",
		"Puesto De Mena",
		"Puesto De Vieyra",
		"Puesto Del Medio",
		"Puesto Del Retiro",
		"Puesto Del Rosario",
		"Puesto Del Simbol",
		"Puesto Los Marcos",
		"Puesto Nuevo",
		"Puma",
		"Pumitayoj",
		"Puna",
		"Punco",
		"Puni Tajo",
		"Punita Norte",
		"Punita Sud",
		"Punta Corral",
		"Punta De Rieles",
		"Punta Del Agua",
		"Punta Del Garabato",
		"Punta Del Monte",
		"Punta Pozo",
		"Punta Rieles",
		"Quebrachal",
		"Quebrachito",
		"Quebrachitos",
		"Quebracho Coto",
		"Quebracho Herrado",
		"Quebracho Pintado",
		"Quebracho Yacu",
		"Quebrachos",
		"Quebrada Esquina",
		"Quemadito",
		"Quenti Taco",
		"Quera",
		"Quilumpa",
		"Quimili",
		"Quimili Paso",
		"Quimilioj",
		"Quimilloj",
		"Quishca",
		"Quisña Loro",
		"Quita Punco",
		"Rama Paso",
		"Ramadita",
		"Ramaditas",
		"Rami Yacu",
		"Ramírez De Velazco",
		"Ranchitos",
		"Rapelli",
		"Real Sayana",
		"Remansito",
		"Remanso",
		"Remansos",
		"Remedios De Escalada",
		"Remes",
		"Reparo",
		"Repecho Díaz",
		"Repecho Montenegro",
		"Represa",
		"Retiro",
		"Rey Viejo",
		"Rincón",
		"Rincón De La Esperanza",
		"Rincón Esperanza",
		"Río De Gallo",
		"Río Muerto",
		"Río Nambi",
		"Río Saladillo",
		"Río Viejo",
		"Rivadavia",
		"Robles",
		"Rodeito",
		"Rodeo",
		"Rodeo Bajada",
		"Rodeo De Soria",
		"Rodeo De Valdez",
		"Roldan",
		"Roma",
		"Romanos",
		"Rosada",
		"Rosario",
		"Rosiyulloj",
		"Roversi",
		"Rubia Moreno",
		"Rumí",
		"Rumí Esquina",
		"Rumí Huasi",
		"Rumí Jaco",
		"Rumiarco",
		"Rumios",
		"Ruta Nacional 34",
		"Ruta Provincial 11",
		"Ruta Provincial 130",
		"Ruta Provincial 17",
		"Ruta Provincial 40",
		"Ruta Provincial 5",
		"Ruta Provincial 8",
		"Sabagasta",
		"Sachayoj",
		"Sainquen Punco",
		"Saladillo",
		"Salavina",
		"Saldivar",
		"Salinas",
		"Salviaioj Gaitan",
		"San Agustín",
		"San Alberto",
		"San Andrés",
		"San Antonio",
		"San Antonio De Copo",
		"San Antonio De Las Flores",
		"San Antonio De Los Cáceres",
		"San Benito",
		"San Carlos",
		"San Cayetano",
		"San Cosme",
		"San Cristóbal",
		"San Delfín",
		"San Dionisio",
		"San Enrique",
		"San Felipe",
		"San Felix",
		"San Fernando",
		"San Francisco",
		"San Francisco Lavalle",
		"San Germán",
		"San Gregorio",
		"San Guillermo",
		"San Horacio",
		"San Ignacio",
		"San Ignacio P Blanca",
		"San Isidro",
		"San Javier",
		"San Jerónimo",
		"San Jorge",
		"San José",
		"San José De Flores",
		"San José Del Boquerón",
		"San José Dto Figueroa",
		"San Jose Este",
		"San Jose Oeste",
		"San Juan",
		"San Juancito",
		"San Justo",
		"San Lorenzo",
		"San Luis",
		"San Manuel",
		"San Marcos",
		"San Martín",
		"San Mateo",
		"San Miguel",
		"San Miguel Del Matara",
		"San Nicolás",
		"San Pablo",
		"San Pascual",
		"San Pastor",
		"San Patricio",
		"San Pedro",
		"San Pedro Kilometro 49",
		"San Ramón",
		"San Ramón Quebrachos",
		"San Romano",
		"San Roque",
		"San Rufino",
		"San Salvador",
		"San Sebastián",
		"San Simón",
		"San Vicente",
		"Sanavirones",
		"Sandia Huajchu",
		"Sansioj",
		"Santa Ana",
		"Santa Barbara",
		"Santa Barbara Ferreira",
		"Santa Brigida",
		"Santa Catalina",
		"Santa Cruz",
		"Santa Elena",
		"Santa Felisa",
		"Santa Inés",
		"Santa Isabel",
		"Santa Justina",
		"Santa Lucia",
		"Santa María",
		"Santa María De Las Chacras",
		"Santa María Dto Figueroa",
		"Santa Paula",
		"Santa Rita",
		"Santa Rosa",
		"Santa Rosa  Arraga",
		"Santa Rosa Arraga",
		"Santa Rosa Copo",
		"Santa Rosa De Coronel",
		"Santa Rosa De Vitervo",
		"Santiago Del Estero",
		"Santo Domingo",
		"Santo Domingo Chico",
		"Santo Domingo Copo",
		"Santo Domingo Pellegrini",
		"Santo Domingo Robles",
		"Santos Lugares",
		"Sarmiento",
		"Sauce Bajada",
		"Sauce Esquina",
		"Sauce Solo",
		"Saucen",
		"Sauces",
		"Saucioj",
		"Sauzal",
		"Sayaco",
		"Segundo Pozo",
		"Selva",
		"Selva Blanca",
		"Señora Pujio",
		"Sepultura",
		"Sepulturas",
		"Serrano Muerto",
		"Sesteadero",
		"Shishi Pozo",
		"Siempre Verde",
		"Siete Arboles",
		"Silipica",
		"Simbol",
		"Simbol Bajo",
		"Simbol Cañada",
		"Simbol Huasi",
		"Simbol Pozo",
		"Simbolar",
		"Sin Descanso",
		"Sinchi Caña",
		"Sinquen Punco",
		"Soconcho",
		"Sol De Julio",
		"Sol De Mayo",
		"Soledad",
		"Soria Bajada",
		"Sotelillos",
		"Sotelos",
		"Stayle",
		"Sumamao",
		"Sumampa",
		"Sumampa Viejo",
		"Sunchituyoj",
		"Suncho Corral",
		"Suncho Pozo",
		"Suncho Pujio",
		"Superintendente Ledesma",
		"Suri",
		"Suri Pozo",
		"Surihuaya",
		"Tabeanita",
		"Tabiana",
		"Tablada Del Boquerón",
		"Tableado",
		"Taboada Estación",
		"Tacamampa",
		"Tacanas",
		"Tacanitas",
		"Tacañitas",
		"Tacioj",
		"Taco Atún",
		"Taco Bajada",
		"Taco Esquina",
		"Taco Fura",
		"Taco Huaco",
		"Taco Isla",
		"Taco Misqui",
		"Taco Palta",
		"Taco Pozo",
		"Taco Pujio",
		"Taco Punco",
		"Taco Quinka",
		"Taco Suyo",
		"Taco Totarayol",
		"Tacón Esquina",
		"Tacoyoj",
		"Tagan",
		"Tajamar",
		"Tala",
		"Tala Atún",
		"Tala Pozo",
		"Tala Yacu",
		"Taperas",
		"Tapso",
		"Taquello",
		"Taquetuyoj",
		"Tarpuna",
		"Taruy",
		"Tenene",
		"Tenti Taco",
		"Termas De Río Hondo",
		"Tibilar",
		"Tiestituyos",
		"Tigre Muerto",
		"Tinajeraloj",
		"Tinap Jerayoj",
		"Tinco Colonia",
		"Tintina",
		"Tío Alto",
		"Tío Chacra",
		"Tío Pozo",
		"Tipiro",
		"Tiun Punco",
		"Tobas",
		"Tolosa",
		"Tolozas",
		"Tomas Young",
		"Tome Y Traiga",
		"Tontola",
		"Tonzu",
		"Toro Charquina",
		"Toro Human",
		"Toro Pampa",
		"Toro Pozo",
		"Toropan",
		"Totora",
		"Totora Pampa",
		"Totoras",
		"Totorilla Nuevo",
		"Totorillas",
		"Tramo 16",
		"Tramo 20",
		"Tramo 26",
		"Tramo Veintiséis",
		"Trancas",
		"Traslado",
		"Tres Bajadas",
		"Tres Bajos",
		"Tres Cerros",
		"Tres Chañares",
		"Tres Cruces",
		"Tres De Marzo",
		"Tres Flores",
		"Tres Hermanas",
		"Tres Jazmines",
		"Tres Lagunas",
		"Tres Mojones",
		"Tres Pozos",
		"Tres Quebrachos",
		"Tres Varones",
		"Trinidad",
		"Troncal",
		"Tronco Blanco",
		"Tronco Juras",
		"Tronco Quemado",
		"Troncos Quemados",
		"Trozo Pozo",
		"Tulum",
		"Tulun",
		"Tunales",
		"Tunas Punco",
		"Turena",
		"Tusca Bajada",
		"Tusca Pozo",
		"Tusca Pozo San Vicente",
		"Tuscayoj",
		"Uclar",
		"Upianita",
		"Urundel",
		"Urutau",
		"Utrunjos",
		"Uturunco",
		"Vaca Huañuna",
		"Vaca Human",
		"Valdivia",
		"Varas Cuchuna",
		"Veintiocho De Marzo",
		"Ventura Pampa",
		"Veron",
		"Vila Isla",
		"Vilelas",
		"Villa Abregu",
		"Villa Adela",
		"Villa Atamisqui",
		"Villa Balnearia",
		"Villa Brana",
		"Villa Coinor",
		"Villa Constantina",
		"Villa De La Barraca",
		"Villa De La Barranca",
		"Villa Elena",
		"Villa Elvira",
		"Villa Esquina",
		"Villa Fanny",
		"Villa Figueroa",
		"Villa Grimanesa",
		"Villa Guañuna",
		"Villa Guasayan",
		"Villa Hazan",
		"Villa Hipolita",
		"Villa Huañuna",
		"Villa Isla",
		"Villa Jiménez",
		"Villa La Punta",
		"Villa Matara",
		"Villa Matilde",
		"Villa Matoque",
		"Villa Mercedes",
		"Villa Nueva",
		"Villa Ojo De Agua",
		"Villa Palmar",
		"Villa Quebrachos",
		"Villa Río Hondo",
		"Villa Rivadavia",
		"Villa Robles",
		"Villa Salavina",
		"Villa Tolojna",
		"Villa Unión",
		"Villa Vieja",
		"Villa Yolanda",
		"Villa Zanjón",
		"Villares",
		"Vilmer",
		"Vinal Macho",
		"Vinal Pozo",
		"Vinal Viejo",
		"Vinalito",
		"Vinara",
		"Viteaca",
		"Viva Mercedes",
		"Vizcacheral",
		"Vuelta De La Barranca",
		"Weisburd",
		"Wiñano",
		"Yacano",
		"Yacasnioj",
		"Yaco Misqui",
		"Yacu Hichacuna",
		"Yacu Hurmana",
		"Yacuchiri",
		"Yalan",
		"Yanda",
		"Yanta",
		"Yaso",
		"Yeso Alto",
		"Ylumampa",
		"Yolohuasi",
		"Yuchan",
		"Yuchancito",
		"Yulu Huasi",
		"Yumampa",
		"Yunta Pozo",
		"Yuto Yaca",
		"Yutu Yaco",
		"Zanja",
		"Zanjón",
		"Zapi Pozo",
		"Zorro Huarcuna"
	],
	"Tierra Del Fuego": [
		"Aserradero Arroyo",
		"Bahía Lapataia",
		"Base Aérea Teniente Matienzo",
		"Base Aérea Vicecomod Marambio",
		"Base Belgrano",
		"Base Belgrano 2",
		"Base Belgrano 3",
		"Base Cientifica Tte Jubany",
		"Base Ejercito Esperanza",
		"Base Ejercito Gral Belgrano 3",
		"Base Ejercito Gral San Martin",
		"Base Ejercito Gral. Belgrano",
		"Base Ejercito Primavera",
		"Base Ejercito Sobral",
		"Base Orcadas",
		"Cabaña Ruby",
		"Cabo San Pablo",
		"Campamento Central Y P F",
		"Campamento Central Ypf",
		"Campamento Los Chorrillos",
		"Comisaria Radman",
		"Destacamento Melchior",
		"El Páramo",
		"Estación Aeronaval",
		"Estación Cientifica Alte Brown",
		"Estación Osn",
		"Estancia Aurelia",
		"Estancia Buenos Aires",
		"Estancia Carmen",
		"Estancia Cauchico",
		"Estancia Costancia",
		"Estancia Cullen",
		"Estancia Despedida",
		"Estancia Dos Hemanas",
		"Estancia El Roble",
		"Estancia El Rodeo",
		"Estancia El Salvador",
		"Estancia Guazu Cue",
		"Estancia Harberton",
		"Estancia Herminita",
		"Estancia Inés",
		"Estancia José Menéndez",
		"Estancia La Criolla",
		"Estancia La Fueguina",
		"Estancia La Indiana",
		"Estancia La Porteña",
		"Estancia Las Hijas",
		"Estancia Las Violetas",
		"Estancia Laura",
		"Estancia Libertad",
		"Estancia Los Cerros",
		"Estancia Los Flamencos",
		"Estancia María Behety",
		"Estancia María Cristina",
		"Estancia María Luisa",
		"Estancia Marina",
		"Estancia Miramonte",
		"Estancia Pirinaica",
		"Estancia Policarpo",
		"Estancia Río Claro",
		"Estancia Río Ewan",
		"Estancia Río Irigoyen",
		"Estancia Rivadavia",
		"Estancia Rolito",
		"Estancia Rosita",
		"Estancia Ruby",
		"Estancia San José",
		"Estancia San Julio",
		"Estancia San Justo",
		"Estancia San Martín",
		"Estancia San Pablo",
		"Estancia Santa Ana",
		"Estancia Sara",
		"Estancia Tepi",
		"Estancia Viamonte",
		"Frigorífico Cap",
		"Hostería Kaiken",
		"Isla De Los Estados",
		"Isla Gran Malvina",
		"Isla Joinville",
		"Isla Shetland Del Sur",
		"Isla Soledad",
		"Islas Georgias",
		"Islas Georgias Del Sur",
		"Islas Orcadas",
		"Islas Orcadas Del Sur",
		"Islas Sandwich Del Sur",
		"Lago Khami",
		"Misión Salesiana Mñor Fagnano",
		"Punta María",
		"Río Grande",
		"San Sebastián",
		"Santa Inés",
		"Sección Avilés Estancia San J",
		"Tolhuin",
		"Ushuaia"
	],
	"Tucumán": [
		"25 De Mayo",
		"7 De Abril",
		"9 De Julio",
		"Abra Baya",
		"Abra De La Picaza",
		"Abra De Yareta",
		"Abra Del Infiernillo",
		"Abra Del Tafi",
		"Abra El Candado",
		"Abra Rica",
		"Acequiones",
		"Acheral",
		"Aconquija",
		"Acostilla",
		"Agua Azul",
		"Agua Blanca",
		"Agua Colorada",
		"Agua Dulce",
		"Agua El Simbo",
		"Agua Negra",
		"Agua Rosada",
		"Agua Salada",
		"Aguada",
		"Aguada De Jorge",
		"Aguadita",
		"Aguas Blancas",
		"Aguilares",
		"Ahí Veremos",
		"Alabama",
		"Alabama Nueva",
		"Alderetes",
		"Alisos",
		"Alizal",
		"Alongó",
		"Alpachiri",
		"Alta Gracia De Villa Burruyacu",
		"Alto Cazadera",
		"Alto De Anfama",
		"Alto De La Angostura",
		"Alto De Leiva",
		"Alto De Los Giménez",
		"Alto De Los Reales",
		"Alto De Medina",
		"Alto Del Huascho",
		"Alto Del Lampazo",
		"Alto Del Puesto",
		"Alto El Puesto",
		"Alto La Totora",
		"Alto Las Flores",
		"Alto Las Lechuzas",
		"Alto Los Cardones",
		"Alto Nuestra Señora Del Valle",
		"Alto Verde",
		"Alurralde",
		"Amaicha Del Llano",
		"Amaicha Del Valle",
		"Amberes",
		"Amimpa",
		"Ampata",
		"Ampatilla",
		"Ampimpa",
		"Amunpa",
		"Anca Juli",
		"Anchillos",
		"Andrés Ferreyra",
		"Anegados",
		"Anfana",
		"Angostura",
		"Animas",
		"Anjuana",
		"Anta",
		"Anta Chica",
		"Antama",
		"Antiguo Quilmes",
		"Antillas",
		"Antu Mapu",
		"Aparadero Militar Gral Muñoz",
		"Aragón",
		"Aragonés",
		"Aran",
		"Aranilla",
		"Araoz",
		"Arbol Solo",
		"Arboles Grandes",
		"Arboles Verdes",
		"Arcadia",
		"Arenilla",
		"Arocas",
		"Arroyo Atahona",
		"Arroyo Barriento",
		"Arroyo De La Cruz",
		"Arroyo Mal Paso",
		"Aserradero",
		"Asna Yaco",
		"Atahona",
		"Avestilla",
		"B Zorrilla",
		"Bajastine",
		"Bajo De Los Sueldos",
		"Bajo De Raco",
		"Bajo Grande",
		"Balderrama",
		"Balderrama Sur",
		"Banda",
		"Banda Del Río Salí",
		"Bañado Del Valle",
		"Barborin",
		"Barrancas",
		"Barrancas Coloradas",
		"Barranqueras",
		"Barrealito",
		"Barrio Belgrano",
		"Barrio Casino",
		"Barrio Diagonal",
		"Barrio Rivadavia",
		"Barrio Textil",
		"Barrosa",
		"Batiruana",
		"Belicha Huaico",
		"Bella Vista",
		"Bello Horizonte",
		"Beltran",
		"Benjamin Araoz",
		"Benjamin Paz",
		"Bilca Pozo",
		"Blanco Pozo",
		"Boba Yacu",
		"Boca De La Quebrada",
		"Boca Del Tigre",
		"Bracho Viejo",
		"Buen Retiro",
		"Buena Vista",
		"Buena Vista Oeste",
		"Buena Yerba",
		"Burruyacu",
		"Bustamante",
		"Cachi Huasi",
		"Cachi Yaco",
		"Cachi Yaco Apeadero Fcgb",
		"Cachiyaco",
		"Cajas Viejas",
		"Calera Aconquija",
		"Calera De Chirimayo",
		"California",
		"Calimayo",
		"Calimonte",
		"Camas Amontonadas",
		"Camino Del Perú",
		"Campana",
		"Campo Alegre",
		"Campo Azul",
		"Campo Bello",
		"Campo Blanco",
		"Campo De Las Gallinas",
		"Campo De Los Cardones",
		"Campo De Los Chañares",
		"Campo De Talamayo",
		"Campo El Luisito",
		"Campo El Mollar",
		"Campo Grande",
		"Campo Herrera",
		"Campo La Cruz",
		"Campo La Flor",
		"Campo La Flor Los Ralos",
		"Campo Redondo",
		"Campo Solco Los Cochamolles",
		"Campo Volante",
		"Campo Zauzal",
		"Candelillal",
		"Cañada",
		"Cañada Alegre",
		"Cañada Angosta",
		"Cañada De Alzogaray",
		"Cañada De La Cruz",
		"Cañada De Los Negros",
		"Cañada De Viclos",
		"Cañada Del Arenal",
		"Cañada El Arenal",
		"Cañada Honda",
		"Cañada Larga",
		"Cañada Yerba Buena",
		"Cañadas",
		"Cañete",
		"Capilla",
		"Capitán Cáceres",
		"Carancho Pozo",
		"Carapunco",
		"Carbón Pozo",
		"Carolinas Bajas",
		"Carreta Quemada",
		"Carrichango",
		"Casa De Campo",
		"Casa De Piedra",
		"Casa De Piedras",
		"Casa De Zinc",
		"Casa Del Alto",
		"Casa Rosada",
		"Casa Santa",
		"Casa Vieja",
		"Cásales",
		"Casas Viejas",
		"Caspichango Viejo",
		"Caspinchango",
		"Castillas",
		"Ceja Pozo",
		"Cejas De Aroca",
		"Cejas De Beñachillos",
		"Cerco Cuatro",
		"Cervalito",
		"Cevil Grande",
		"Cevil Pozo",
		"Cevil Redondo",
		"Cevil Solo",
		"Cevilarcito",
		"Chabela",
		"Chalchacito",
		"Chamico",
		"Chañar",
		"Chañar Muya",
		"Chañar Pago",
		"Chañar Pozo",
		"Chañar Taqueño",
		"Chañar Vía",
		"Chañar Viejo",
		"Chañarito",
		"Chañaritos",
		"Chasquivil",
		"Chavarria",
		"Chicligasta",
		"Chigligasta",
		"Chilca",
		"Chilcal",
		"Chilcar",
		"Chilcas",
		"Choromoro",
		"Chorrillos",
		"Chulca",
		"Churqui",
		"Chusca",
		"Chuscha",
		"Cienaguita",
		"Ciudacita",
		"Cochamolle",
		"Cochuna",
		"Coco",
		"Cohigac",
		"Colalao Del Valle",
		"Colmena Lolita",
		"Colombres",
		"Colonia 4",
		"Colonia 4 De Colombres",
		"Colonia 6",
		"Colonia Acevedo",
		"Colonia Agrícola",
		"Colonia Argentina",
		"Colonia Bascary",
		"Colonia El Puesto",
		"Colonia El Sunchal",
		"Colonia El Tarco",
		"Colonia Fara",
		"Colonia Felipe",
		"Colonia Humaita Primera",
		"Colonia Juan José Iramain",
		"Colonia La Bonaria",
		"Colonia La Ortiz",
		"Colonia La Roca",
		"Colonia Lolita Norte",
		"Colonia Los Chasales",
		"Colonia Los Hills",
		"Colonia María Elena",
		"Colonia Marull",
		"Colonia Mercedes",
		"Colonia Mistol",
		"Colonia Monteros",
		"Colonia Naschi",
		"Colonia Nro 2",
		"Colonia Nueva Trinidad",
		"Colonia Pacara",
		"Colonia Pedro León Cornet",
		"Colonia San Luis",
		"Colonia San Miguel",
		"Colonia San Ramón",
		"Colonia Santa Catalina",
		"Colonia Santa Clara",
		"Colonia Santa Lucia",
		"Colonia Santa Marina",
		"Colonia Santa Rita",
		"Colonia Sarmiento",
		"Colonia Sobrecasa",
		"Colonia Tacapunco",
		"Comuna La Esperanza",
		"Concepción",
		"Cóndor Huasi",
		"Consimo",
		"Cooperativa Agronómica",
		"Coromama",
		"Corona",
		"Corral Blanco",
		"Corral Grande",
		"Corral Viejo",
		"Cortaderal",
		"Cortaderas",
		"Cossio",
		"Costa Arroyo Esquina",
		"Costa Del Río Seco",
		"Costilla",
		"Criollas",
		"Cruz Alta",
		"Cruz De Abajo",
		"Cruz Del Norte Estación Fcgm",
		"Cuatro Gatos",
		"Cuatro Sauces",
		"Cuchillas",
		"Cuesta De Chilca",
		"Cuesta De La Chilca",
		"Curuzú Cuatía",
		"Curva De Los Vegas",
		"Delfín Gallo",
		"Descanso",
		"Desmonte",
		"Dique Escaba",
		"Dolavon",
		"Domingo Millán",
		"Donato Alvarez",
		"Dos Pozos",
		"Durazno",
		"Duraznos Blancos",
		"El Aguilar",
		"El Alpizar",
		"El Antigal",
		"El Arbolar",
		"El Arbolito",
		"El Arenal",
		"El Arqueal",
		"El Aserradero",
		"El Atacal",
		"El Atacat",
		"El Azul",
		"El Bachi",
		"El Bagual",
		"El Bajo",
		"El Bañado",
		"El Barco",
		"El Barranquero",
		"El Barrialito",
		"El Batiruano",
		"El Boyero",
		"El Bracho",
		"El Brete",
		"El Cadillal",
		"El Cajón",
		"El Campo",
		"El Carbón",
		"El Cardenal",
		"El Carmen",
		"El Carmen Puente Alto",
		"El Carrizal",
		"El Casial",
		"El Casialito",
		"El Castoral",
		"El Catorce",
		"El Cebil",
		"El Cedro",
		"El Ceibal",
		"El Cercado",
		"El Cevilar",
		"El Cevilar Colombres",
		"El Chañar",
		"El Chilcar",
		"El Chorro",
		"El Churqui",
		"El Churquis",
		"El Cochuchal",
		"El Colcolar",
		"El Colmenar",
		"El Corralito",
		"El Cortaderal",
		"El Corte",
		"El Cruce",
		"El Cuadro",
		"El Cuarteadero",
		"El Divisadero",
		"El Duraznillo",
		"El Duraznito",
		"El Durazno",
		"El Espinal",
		"El Espinillo",
		"El Establo",
		"El Frasquillo",
		"El Guardamonte",
		"El Guayacan",
		"El Huaico",
		"El Indio",
		"El Infiernillo",
		"El Interés",
		"El Jardín",
		"El Junquillar",
		"El Lamedero",
		"El Lamparazo",
		"El Manantial",
		"El Matadero",
		"El Matal",
		"El Melón",
		"El Milagro",
		"El Mistol",
		"El Mistolar",
		"El Mojón",
		"El Molino",
		"El Mollar",
		"El Molle",
		"El Molle Viejo",
		"El Morado",
		"El Moyar",
		"El Mutul",
		"El Naranjal",
		"El Naranjito",
		"El Naranjo",
		"El Nial",
		"El Nogal",
		"El Nogalar",
		"El Nogalito",
		"El Obraje",
		"El Ojo",
		"El Once",
		"El Pabellón",
		"El Pajal",
		"El Palancho",
		"El Palcara",
		"El Palomar",
		"El Paraíso",
		"El Paso",
		"El Pavón",
		"El Payanal",
		"El Pelado",
		"El Pelado De Paranillo",
		"El Pila",
		"El Polear",
		"El Portezuelo",
		"El Porvenir",
		"El Potrerillo",
		"El Potrero",
		"El Pozo",
		"El Prado",
		"El Puerto",
		"El Puestito",
		"El Puesto",
		"El Puesto Del Medio",
		"El Quebrachal",
		"El Quebrachito",
		"El Quimil",
		"El Remate",
		"El Rincón",
		"El Rodeo",
		"El Rosario",
		"El Sauzal",
		"El Sesteadero",
		"El Siambon",
		"El Sinquial",
		"El Suncal",
		"El Sunchal",
		"El Suncho",
		"El Tajamar",
		"El Talar",
		"El Timbo",
		"El Timbo Nuevo",
		"El Timbo Viejo",
		"El Tipal",
		"El Tiro Argentino",
		"El Tobar",
		"El Toro",
		"El Tostado",
		"El Triunfo",
		"El Tropezón",
		"El Tuscal",
		"El Vallecito",
		"El Zanjón",
		"El Zapallar",
		"El Zauzal",
		"Embalse El Cadillal",
		"Embalse Río Hondo",
		"Empalme Agua Dulce",
		"Encrucijada",
		"Ensenada",
		"Entre Ríos",
		"Escaba",
		"Escaba De Abajo",
		"Escaba De Arriba",
		"Escobas",
		"Escuela",
		"Escuela 1",
		"Escuela 1 Junta",
		"Escuela 100",
		"Escuela 101",
		"Escuela 102",
		"Escuela 103",
		"Escuela 104",
		"Escuela 105",
		"Escuela 106",
		"Escuela 107",
		"Escuela 108",
		"Escuela 109",
		"Escuela 11",
		"Escuela 110",
		"Escuela 111",
		"Escuela 112",
		"Escuela 113",
		"Escuela 114",
		"Escuela 115",
		"Escuela 116",
		"Escuela 118",
		"Escuela 12",
		"Escuela 12 De Octubre",
		"Escuela 121",
		"Escuela 122",
		"Escuela 123",
		"Escuela 124",
		"Escuela 125",
		"Escuela 126",
		"Escuela 128",
		"Escuela 129",
		"Escuela 13",
		"Escuela 130",
		"Escuela 131",
		"Escuela 132",
		"Escuela 133",
		"Escuela 134",
		"Escuela 135",
		"Escuela 137",
		"Escuela 138",
		"Escuela 139",
		"Escuela 14",
		"Escuela 140",
		"Escuela 141",
		"Escuela 142",
		"Escuela 143",
		"Escuela 144",
		"Escuela 145",
		"Escuela 146",
		"Escuela 147",
		"Escuela 148",
		"Escuela 149",
		"Escuela 15",
		"Escuela 150",
		"Escuela 151",
		"Escuela 152",
		"Escuela 153",
		"Escuela 154",
		"Escuela 156",
		"Escuela 157",
		"Escuela 158",
		"Escuela 159",
		"Escuela 16",
		"Escuela 160",
		"Escuela 162",
		"Escuela 163",
		"Escuela 164",
		"Escuela 165",
		"Escuela 166",
		"Escuela 167",
		"Escuela 168",
		"Escuela 17",
		"Escuela 170",
		"Escuela 171",
		"Escuela 172",
		"Escuela 173",
		"Escuela 174",
		"Escuela 175",
		"Escuela 176",
		"Escuela 177",
		"Escuela 178",
		"Escuela 179",
		"Escuela 18",
		"Escuela 180",
		"Escuela 182",
		"Escuela 183",
		"Escuela 184",
		"Escuela 185",
		"Escuela 186",
		"Escuela 187",
		"Escuela 188",
		"Escuela 189",
		"Escuela 19",
		"Escuela 190",
		"Escuela 191",
		"Escuela 192",
		"Escuela 193",
		"Escuela 194",
		"Escuela 195",
		"Escuela 197",
		"Escuela 198",
		"Escuela 199",
		"Escuela 20",
		"Escuela 200",
		"Escuela 201",
		"Escuela 202",
		"Escuela 203",
		"Escuela 204",
		"Escuela 205",
		"Escuela 206",
		"Escuela 207",
		"Escuela 208",
		"Escuela 209",
		"Escuela 21",
		"Escuela 210",
		"Escuela 211",
		"Escuela 212",
		"Escuela 213",
		"Escuela 214",
		"Escuela 215",
		"Escuela 216",
		"Escuela 217",
		"Escuela 218",
		"Escuela 219",
		"Escuela 22",
		"Escuela 220",
		"Escuela 221",
		"Escuela 222",
		"Escuela 224",
		"Escuela 225",
		"Escuela 226",
		"Escuela 227",
		"Escuela 228",
		"Escuela 229",
		"Escuela 23",
		"Escuela 231",
		"Escuela 232",
		"Escuela 233",
		"Escuela 234",
		"Escuela 235",
		"Escuela 236",
		"Escuela 237",
		"Escuela 238",
		"Escuela 239",
		"Escuela 24",
		"Escuela 241",
		"Escuela 242",
		"Escuela 243",
		"Escuela 244",
		"Escuela 245",
		"Escuela 246",
		"Escuela 247",
		"Escuela 25",
		"Escuela 25 De Mayo",
		"Escuela 250",
		"Escuela 251",
		"Escuela 253",
		"Escuela 254",
		"Escuela 255",
		"Escuela 256",
		"Escuela 257",
		"Escuela 258",
		"Escuela 26",
		"Escuela 260",
		"Escuela 261",
		"Escuela 262",
		"Escuela 263",
		"Escuela 264",
		"Escuela 265",
		"Escuela 266",
		"Escuela 267",
		"Escuela 268",
		"Escuela 269",
		"Escuela 27",
		"Escuela 270",
		"Escuela 272",
		"Escuela 273",
		"Escuela 274",
		"Escuela 275",
		"Escuela 276",
		"Escuela 277",
		"Escuela 278",
		"Escuela 279",
		"Escuela 28",
		"Escuela 280",
		"Escuela 281",
		"Escuela 282",
		"Escuela 283",
		"Escuela 284",
		"Escuela 285",
		"Escuela 286",
		"Escuela 287",
		"Escuela 288",
		"Escuela 289",
		"Escuela 29",
		"Escuela 290",
		"Escuela 291",
		"Escuela 292",
		"Escuela 293",
		"Escuela 294",
		"Escuela 297",
		"Escuela 298",
		"Escuela 299",
		"Escuela 3",
		"Escuela 30",
		"Escuela 300 La Picada",
		"Escuela 302",
		"Escuela 303",
		"Escuela 306",
		"Escuela 307",
		"Escuela 308",
		"Escuela 309",
		"Escuela 31",
		"Escuela 310",
		"Escuela 311",
		"Escuela 312",
		"Escuela 313",
		"Escuela 314",
		"Escuela 315",
		"Escuela 316",
		"Escuela 317",
		"Escuela 318",
		"Escuela 319",
		"Escuela 320",
		"Escuela 321",
		"Escuela 322",
		"Escuela 323",
		"Escuela 324",
		"Escuela 325",
		"Escuela 326",
		"Escuela 327",
		"Escuela 328",
		"Escuela 329",
		"Escuela 33",
		"Escuela 330",
		"Escuela 331",
		"Escuela 332",
		"Escuela 333",
		"Escuela 334",
		"Escuela 335",
		"Escuela 336",
		"Escuela 337",
		"Escuela 338",
		"Escuela 339",
		"Escuela 34",
		"Escuela 340",
		"Escuela 341",
		"Escuela 342",
		"Escuela 343",
		"Escuela 344",
		"Escuela 345",
		"Escuela 346",
		"Escuela 347",
		"Escuela 348",
		"Escuela 349",
		"Escuela 35",
		"Escuela 350",
		"Escuela 352",
		"Escuela 353",
		"Escuela 354",
		"Escuela 355",
		"Escuela 356",
		"Escuela 357",
		"Escuela 36",
		"Escuela 361",
		"Escuela 362",
		"Escuela 363",
		"Escuela 364",
		"Escuela 365",
		"Escuela 366",
		"Escuela 368",
		"Escuela 369",
		"Escuela 37",
		"Escuela 370",
		"Escuela 371",
		"Escuela 373",
		"Escuela 374",
		"Escuela 375",
		"Escuela 376",
		"Escuela 379",
		"Escuela 38",
		"Escuela 380",
		"Escuela 385",
		"Escuela 386",
		"Escuela 387",
		"Escuela 389",
		"Escuela 39",
		"Escuela 390",
		"Escuela 391",
		"Escuela 392",
		"Escuela 393",
		"Escuela 4",
		"Escuela 41",
		"Escuela 42",
		"Escuela 43",
		"Escuela 44",
		"Escuela 45",
		"Escuela 47",
		"Escuela 48",
		"Escuela 5",
		"Escuela 50",
		"Escuela 51",
		"Escuela 52",
		"Escuela 53",
		"Escuela 55",
		"Escuela 56",
		"Escuela 57",
		"Escuela 59",
		"Escuela 6",
		"Escuela 60",
		"Escuela 61",
		"Escuela 62",
		"Escuela 63",
		"Escuela 64",
		"Escuela 65",
		"Escuela 66",
		"Escuela 67",
		"Escuela 68",
		"Escuela 69",
		"Escuela 7",
		"Escuela 70",
		"Escuela 72",
		"Escuela 73",
		"Escuela 74",
		"Escuela 75",
		"Escuela 76",
		"Escuela 77",
		"Escuela 78",
		"Escuela 79",
		"Escuela 80",
		"Escuela 81",
		"Escuela 82",
		"Escuela 83",
		"Escuela 84",
		"Escuela 85",
		"Escuela 86",
		"Escuela 88",
		"Escuela 89",
		"Escuela 9",
		"Escuela 90",
		"Escuela 91",
		"Escuela 92",
		"Escuela 93",
		"Escuela 94",
		"Escuela 95",
		"Escuela 96",
		"Escuela 97",
		"Escuela 99",
		"Escuela Adolfo Alsina",
		"Escuela Agueda De Posse",
		"Escuela Alberto Soldati",
		"Escuela Alejandro Heredia",
		"Escuela Alfonsina Storni",
		"Escuela Almafuerte",
		"Escuela Almirante Brown",
		"Escuela Alvarez Condarco",
		"Escuela Angel Padilla",
		"Escuela Antonio Medina",
		"Escuela Araoz Alfaro",
		"Escuela Arenales",
		"Escuela Batalla De Tucumán",
		"Escuela Blas Parera",
		"Escuela Cacique Manamico",
		"Escuela Campamento El Plumeril",
		"Escuela Cap Candelaria",
		"Escuela Cap Diego Fco Pereyra",
		"Escuela Capitán Gaspar De Medi",
		"Escuela Carlos Pellegrini",
		"Escuela Caupolican Molina",
		"Escuela Cnel Geronimo Helguera",
		"Escuela Cnel Ignacio Murga",
		"Escuela Congresales Tucumanos",
		"Escuela Cornelio Saavedra",
		"Escuela Coronel Roca",
		"Escuela Cristóbal Colon",
		"Escuela De Manualidades",
		"Escuela De Manualidades Ouanta",
		"Escuela Deán Salcedo",
		"Escuela Diego De Villafañe",
		"Escuela Domingo García",
		"Escuela E Cantón",
		"Escuela E De Lucas",
		"Escuela Ee Uu",
		"Escuela Estanislao Zeballos",
		"Escuela F N Laprida",
		"Escuela F Nogues",
		"Escuela Florencio Várela",
		"Escuela Fortunata García",
		"Escuela Fray M Esquiu",
		"Escuela G De Vega",
		"Escuela Gdor López",
		"Escuela Gob José Manuel Silva",
		"Escuela Gobernador Miguel Nogu",
		"Escuela Gómez",
		"Escuela Granaderos De San Mart",
		"Escuela Granillo",
		"Escuela Gregoria Lamadrid",
		"Escuela Guido Spano",
		"Escuela Guillermina Moreira",
		"Escuela Hernán Miraval",
		"Escuela Ibatin",
		"Escuela Ignacio Bas",
		"Escuela Ignacio Colombres",
		"Escuela Ing Bertre",
		"Escuela Ingeniero Bascary",
		"Escuela J Castellano",
		"Escuela J J Thames",
		"Escuela Joaquín V González",
		"Escuela José Colombres",
		"Escuela José Posse",
		"Escuela Juan José Paso",
		"Escuela Juana Manso",
		"Escuela L Blanco",
		"Escuela La Asunción",
		"Escuela Leo Huasi",
		"Escuela López Mañar",
		"Escuela López Y Planes",
		"Escuela Lugones",
		"Escuela Luis Gianneo",
		"Escuela M Ariza",
		"Escuela M De Pueyrredon",
		"Escuela Malvinas",
		"Escuela Manuel Borda",
		"Escuela Manuel Cossio",
		"Escuela Manuel Domingo Bassail",
		"Escuela Manuel Savio",
		"Escuela Manuela Pedraza",
		"Escuela Mariano Salas",
		"Escuela Mario Bravo",
		"Escuela Matienzo",
		"Escuela Mercedes Pacheco",
		"Escuela Miguel Azcuenaga",
		"Escuela Miguel Cervantes",
		"Escuela Monte Grande",
		"Escuela N Vergara",
		"Escuela Olegario Andrade",
		"Escuela Otilde De Toro",
		"Escuela P De Mendoza",
		"Escuela Pedro Araoz",
		"Escuela Pedro Echeverry",
		"Escuela Pedro Medrano",
		"Escuela Puestito De Arriba",
		"Escuela R J Freyre",
		"Escuela R Rojas",
		"Escuela Ramón Carrillo",
		"Escuela Salvador Alonso",
		"Escuela Santiago Gallo",
		"Escuela Sargento Cabral",
		"Escuela Tambor De Tacuari",
		"Escuela V Genérala",
		"Escuela Velez Sarsfield",
		"Escuela W Posse",
		"Espiadero",
		"Esquina",
		"Esquina Del Llano",
		"Esquina Del Valle",
		"Esquina Norte",
		"Establecimiento Esquina",
		"Establecimiento Las Colonias",
		"Estación Araoz",
		"Estación De Zootecnia B",
		"Estación Experimental Agrícola",
		"Estación Superior Agrícola",
		"Estancia El Diamante",
		"Estancia La Princesa",
		"Estancia Suri Yaco",
		"Estanque",
		"Fagsa",
		"Falda De Arcadia",
		"Famailla",
		"Favorina",
		"Fin Del Mundo",
		"Finca Anchorena",
		"Finca Araoz",
		"Finca Cristina",
		"Finca El Ceibo",
		"Finca Elisa",
		"Finca Entre Ríos",
		"Finca Leila",
		"Finca López",
		"Finca Los Llanos",
		"Finca Mayo",
		"Finca Pacara",
		"Finca Pereyra",
		"Finca Piedra Blanca",
		"Finca San Luis",
		"Finca Tina",
		"Finca Tinta",
		"Finca Tulio",
		"Fronteritas",
		"Fuerte Alto",
		"Fuerte Quemado",
		"G Anselmo Rojo",
		"Garmendia",
		"Gastona",
		"Gastonilla",
		"Gobernador Nouges",
		"Gobernador Piedrabuena",
		"Gómez Chico",
		"Gonzalo",
		"Gral Anselmo Rojo",
		"Gramajos",
		"Gramilla",
		"Graneros",
		"Granja Modelo",
		"Guanaco Muerto",
		"Guemes",
		"Guzmán Estación Fcgb",
		"Higueritas",
		"Hitachi",
		"Horco Molle",
		"Hoyada",
		"Huacra",
		"Hualinchay",
		"Huasa Pampa",
		"Huasa Pampa Norte",
		"Huasa Pampa Sur",
		"Huasa Rincón",
		"Huasamayo",
		"Huasamayo Sud",
		"Humaita 1",
		"Humaita 2",
		"Ibatin",
		"Ichipuca",
		"Iglesias",
		"Iguana",
		"Iltico",
		"Independencia",
		"India Muerta",
		"Ing Mercedes",
		"Ingas",
		"Ingeniero Santa Lucia",
		"Ingenio Bella Vista",
		"Ingenio Concepción",
		"Ingenio Cruz Alta",
		"Ingenio Esperanza",
		"Ingenio La Corona",
		"Ingenio La Florida",
		"Ingenio La Fronterita",
		"Ingenio La Providencia",
		"Ingenio La Trinidad",
		"Ingenio Leales",
		"Ingenio Los Ralos",
		"Ingenio Lules",
		"Ingenio Marapa",
		"Ingenio Ñuñorco",
		"Ingenio San Juan",
		"Ingenio Santa Ana",
		"Ingenio Santa Barbara",
		"Ingenio Santa Lucia",
		"Ingenio Santa Rosa",
		"Invernada",
		"Ischillon",
		"Isla San José",
		"Isla San José Sud",
		"Jaguel",
		"Java",
		"Jaya",
		"Juan Bautista Alberdi",
		"Juan Posse",
		"Juliana",
		"Julipao",
		"Junta",
		"Jusco Pozo",
		"Kilometro 10 Fcgb",
		"Kilometro 102",
		"Kilometro 1025",
		"Kilometro 1041",
		"Kilometro 108",
		"Kilometro 118",
		"Kilometro 1185",
		"Kilometro 1194",
		"Kilometro 12",
		"Kilometro 1207",
		"Kilometro 1213",
		"Kilometro 1220",
		"Kilometro 1231",
		"Kilometro 1235",
		"Kilometro 1240",
		"Kilometro 1244",
		"Kilometro 1248",
		"Kilometro 1256",
		"Kilometro 1260",
		"Kilometro 1270",
		"Kilometro 1340",
		"Kilometro 1402",
		"Kilometro 1412",
		"Kilometro 1438",
		"Kilometro 1455",
		"Kilometro 1500",
		"Kilometro 180",
		"Kilometro 19",
		"Kilometro 29",
		"Kilometro 34",
		"Kilometro 35",
		"Kilometro 36",
		"Kilometro 37",
		"Kilometro 46",
		"Kilometro 5",
		"Kilometro 52",
		"Kilometro 55",
		"Kilometro 62",
		"Kilometro 66",
		"Kilometro 771",
		"Kilometro 781",
		"Kilometro 784",
		"Kilometro 792",
		"Kilometro 794",
		"Kilometro 80",
		"Kilometro 808",
		"Kilometro 847",
		"Kilometro 925",
		"Kilometro 93",
		"Kilometro 94",
		"Kilometro 99",
		"Km 12",
		"La Aguada",
		"La Aguadita",
		"La Aguita",
		"La Angostura",
		"La Argentina",
		"La Banda",
		"La Banderita",
		"La Bolsa",
		"La Bomba",
		"La Brama",
		"La Calera",
		"La Cantina",
		"La Cañada",
		"La Cañada Parada",
		"La Capilla",
		"La Cautiva",
		"La Cavera",
		"La Chilca",
		"La Ciénaga",
		"La Cocha",
		"La Colonia",
		"La Combada",
		"La Concepción",
		"La Cornelia",
		"La Corzuela",
		"La Costa Palampa",
		"La Cruz",
		"La Cruz De Arriba",
		"La Cuesta",
		"La Cueva",
		"La Donosa",
		"La Dorita",
		"La Empatada",
		"La Encantada",
		"La Ercilia",
		"La Esperanza",
		"La Esquina",
		"La Estrella",
		"La Falda",
		"La Favorita",
		"La Flor",
		"La Florida",
		"La Fortuna",
		"La Fronterita",
		"La Grama",
		"La Guillermina",
		"La Heladera",
		"La Higuera",
		"La Hoyada",
		"La Huerta",
		"La Iguana",
		"La Invernada",
		"La Isla",
		"La Junta",
		"La Laguna",
		"La Lagunilla",
		"La Lagunita",
		"La Libertad",
		"La Loma",
		"La Manga",
		"La Maravilla",
		"La Marta",
		"La Media Agua",
		"La Mesada",
		"La Picada",
		"La Pinta Y La Cuarenta",
		"La Planta",
		"La Pola",
		"La Posta",
		"La Princesa",
		"La Puerta",
		"La Puerta De Luca",
		"La Puerta De Marapa",
		"La Puntilla",
		"La Quebrada",
		"La Quesería",
		"La Quinta",
		"La Ramada",
		"La Ramada De Abajo",
		"La Ramadita",
		"La Reducción",
		"La Reina",
		"La Rinconada",
		"La Rinconada Parada",
		"La Ruda",
		"La Sala",
		"La Salamanca",
		"La Salvacion",
		"La Silla",
		"La Soledad",
		"La Tala",
		"La Tapia",
		"La Tipa",
		"La Toma",
		"La Tranca",
		"La Trinidad",
		"La Tuna",
		"La Unión",
		"La Verde",
		"La Viñita",
		"La Zanja",
		"Lacavera",
		"Lachico",
		"Lagarte",
		"Laguna Blanca",
		"Laguna De Robles",
		"Laguna Grande",
		"Laguna Larga",
		"Lamadrid",
		"Lamparcito",
		"Lapachitos",
		"Lara",
		"Las Abras",
		"Las Acostillas",
		"Las Animas",
		"Las Arcas",
		"Las Banderitas",
		"Las Barrancas",
		"Las Bolsas",
		"Las Botijas",
		"Las Brisas",
		"Las Burras",
		"Las Cañadas",
		"Las Cañas",
		"Las Cañitas",
		"Las Carreras",
		"Las Cejas",
		"Las Celayas",
		"Las Chacras",
		"Las Ciénagas",
		"Las Colas",
		"Las Colonias",
		"Las Criollas",
		"Las Cuatro Esquinas",
		"Las Cuevas",
		"Las Encrucijadas",
		"Las Faldas",
		"Las Guchas Los Guchea",
		"Las Higuerillas",
		"Las Higueritas",
		"Las Juntas",
		"Las Leguas",
		"Las Lenguas Las Leguas",
		"Las Lomitas",
		"Las Mellizas",
		"Las Mercedes",
		"Las Mesadas",
		"Las Moreras",
		"Las Moritas",
		"Las Palmitas",
		"Las Palomitas",
		"Las Pampitas",
		"Las Parritas",
		"Las Pavas",
		"Las Pechosas",
		"Las Piedritas",
		"Las Pircas",
		"Las Pirvas",
		"Las Ratas",
		"Las Salinas",
		"Las Tablas",
		"Las Tablitas",
		"Las Tacanas",
		"Las Talas",
		"Las Talitas",
		"Las Tipas",
		"Las Tipas De Colalao",
		"Las Trancas Tranquitas",
		"Las Tres Flores",
		"Las Tuscas Tuscal",
		"Las Zanjas",
		"Las Zanjitas",
		"Las Zorras",
		"Lastenia",
		"Laurel Yaco",
		"Laureles",
		"Laureles Norte",
		"Laureles Sur",
		"Lazarte",
		"Leales",
		"Leo Huasi",
		"Leocadio Paz",
		"León Rouges",
		"Lescano",
		"Loa Díaz",
		"Lolita",
		"Lolita Nueva",
		"Loma Colorada",
		"Loma Del Medio",
		"Loma Grande",
		"Loma Negra",
		"Loma Redonda",
		"Loma Verde",
		"Lomas De Imbaud",
		"López Domínguez",
		"Los Agudos",
		"Los Agueros",
		"Los Aguirre",
		"Los Alamitos",
		"Los Alamos",
		"Los Alcaraces",
		"Los Alisos",
		"Los Amaya",
		"Los Angeles",
		"Los Arrietas",
		"Los Arroyo",
		"Los Bajos",
		"Los Bateones",
		"Los Bordos",
		"Los Britos",
		"Los Bulacio",
		"Los Bulacios",
		"Los Callejones",
		"Los Camperos",
		"Los Cercos",
		"Los Chamicos",
		"Los Chañares",
		"Los Chañaritos",
		"Los Chorrillos",
		"Los Colorados",
		"Los Córdoba",
		"Los Cordones",
		"Los Corpitos",
		"Los Crespo",
		"Los Cuartos",
		"Los Décima",
		"Los Díaz",
		"Los Estanques",
		"Los Eucaliptos",
		"Los Galpones",
		"Los Godos",
		"Los Godoy",
		"Los Gómez",
		"Los Gonzales",
		"Los González",
		"Los Gramajo",
		"Los Gramajos",
		"Los Guayacanes",
		"Los Guchea",
		"Los Gutiérrez",
		"Los Hardoy",
		"Los Herreras",
		"Los Hilos",
		"Los Juárez",
		"Los Lescanos",
		"Los Lunas",
		"Los Mendozas",
		"Los Mistoles",
		"Los Molles",
		"Los Moyes",
		"Los Nogales",
		"Los Ocho Cuartos",
		"Los Panchillos",
		"Los Paraísos",
		"Los Pedraza",
		"Los Pereyra",
		"Los Peréz",
		"Los Pinos B",
		"Los Pizarro",
		"Los Planchones",
		"Los Pocitos",
		"Los Porceles",
		"Los Puestos",
		"Los Quemados",
		"Los Ralos",
		"Los Reyes",
		"Los Ríos",
		"Los Rizos",
		"Los Robles",
		"Los Rodríguez",
		"Los Rojos",
		"Los Romanos",
		"Los Ruiz",
		"Los Saracho",
		"Los Sarmientos",
		"Los Sauces",
		"Los Sifones",
		"Los Soraire",
		"Los Sosa",
		"Los Sosas",
		"Los Sotelo",
		"Los Sueldos",
		"Los Timbos",
		"Los Timbres",
		"Los Trejos",
		"Los Tres Bajos",
		"Los Valdés",
		"Los Vallistos",
		"Los Vázquez",
		"Los Vega",
		"Los Villagra",
		"Los Villegas",
		"Los Zaragoza",
		"Los Zazos",
		"Los Zelayas",
		"Lovar",
		"Luis Pasteur",
		"Luisiana Estación Fcgm",
		"Lujan",
		"Lules",
		"Lunarejos",
		"Luz Y Fuerza",
		"Macho Huañusca",
		"Macio",
		"Macomita",
		"Mal Paso",
		"Malvinas",
		"Managua",
		"Manantial De Ovanta",
		"Manantiales",
		"Mánchala",
		"Mancopa",
		"Mancopa Chico",
		"Manuel García Fernández",
		"Manuela Pedraza",
		"Marapa",
		"María Blanca",
		"María Elena",
		"María Luisa",
		"Mariño",
		"Marta",
		"Mascio Pilco",
		"Mascio Sur",
		"Mato Yaco",
		"Matul",
		"Mayo",
		"Medina",
		"Medinas",
		"Membrillo",
		"Mercedes",
		"Mesada De Encima",
		"Miguel Lillo",
		"Mimillo",
		"Mimilto",
		"Miranda",
		"Misky",
		"Mistol",
		"Mixta",
		"Mojón",
		"Molinos",
		"Molle Chato",
		"Molle De Abajo",
		"Molle Pozo",
		"Molle Yaco",
		"Molles",
		"Monasterio",
		"Monte Bello",
		"Monte Cristo",
		"Monte Grande",
		"Monte Largo",
		"Monte Redomon",
		"Monte Redondo",
		"Monte Rico",
		"Monteagudo",
		"Monteros",
		"Monteros Viejo",
		"Montuoso",
		"Moras Minucas",
		"Morón",
		"Mothe",
		"Moya",
		"Moyar",
		"Mujer Muerta",
		"Multiflores",
		"Mundo Nuevo",
		"Muyo",
		"Naranjito",
		"Naranjo Esquina",
		"Nasche",
		"Negro Potrero",
		"Nio El Puestito",
		"Nio Villa Padre Monti",
		"Niogasta",
		"Noario",
		"Nogalita",
		"Nogalito",
		"Nueva Baviera",
		"Nueva España",
		"Nueva Esperanza",
		"Nueva Esquina",
		"Nueva Rosa",
		"Nueva Trinidad",
		"Nuevo Pueblo La Florida",
		"Nuevos Mataderos",
		"Ñorco",
		"Ñoreo",
		"Obraje",
		"Ojo",
		"Ojo De Agua",
		"Oran",
		"Ovejeria",
		"Overo Pozo",
		"P G Mendez",
		"Pacara",
		"Pacara Marcado",
		"Pacara Pintado",
		"Padilla",
		"Paez",
		"Paja Blanca",
		"Paja Colorada",
		"Pala Pala",
		"Palmas Redondas",
		"Palmitas",
		"Palo Blanco",
		"Palo Gacho",
		"Palo Seco",
		"Palomas",
		"Palominos",
		"Palominos Banda De",
		"Palomitas",
		"Palos Quemados",
		"Pampa Larga",
		"Pampa Mayo",
		"Pampa Mayo Noroeste",
		"Pampa Muyo",
		"Pampa Pozo",
		"Pampa Rosa",
		"Pantanillo",
		"Parada De Ohuanta",
		"Paraíso",
		"Paso De La Patria",
		"Paso De Las Lanzas",
		"Paso De Los Nievas",
		"Paso Grande",
		"Pasteur Luis",
		"Peña Overa",
		"Peña Picaza",
		"Pereyra Norte",
		"Pereyra Sur",
		"Perucho",
		"Pichao",
		"Pie De La Cuesta",
		"Pie Del Aconquija",
		"Piedra Blanca",
		"Piedra Grande",
		"Piedra Tendida",
		"Piedras Blancas",
		"Piedras Coloradas",
		"Pilco",
		"Pingollar",
		"Pirhuas",
		"Planta Compresora Ypf",
		"Planta De Bombeo De Ypf",
		"Playa Larga",
		"Poliar",
		"Polito",
		"Ponzacon",
		"Port De Las Animas",
		"Port De Tomas",
		"Portezuelo",
		"Porvenir",
		"Posse Desvío Particular Fcgm",
		"Posta",
		"Posta Vieja",
		"Potrerillo",
		"Potrerillos",
		"Potrero",
		"Potrero De Las Cabras",
		"Potrero De Las Tablas",
		"Potrero De Los Alamos",
		"Potrero Grande",
		"Potro Yaco",
		"Pozo Alto",
		"Pozo Cavado",
		"Pozo Del Algarrobo",
		"Pozo Del Alto",
		"Pozo El Quebracho",
		"Pozo Grande",
		"Pozo Hondo",
		"Pozo Lapacho",
		"Pozo Largo",
		"Pozo Suncho",
		"Pozo Verde",
		"Pradera Alegre",
		"Pueblo Nuevo",
		"Pueblo Obrero",
		"Pueblo Viejo",
		"Puente El Manantial",
		"Puente Río Sali",
		"Puerta Alegre",
		"Puerta De Julipao",
		"Puerta De Palavecino",
		"Puerta Grande",
		"Puerta Quemada",
		"Puerta San Javier",
		"Puerta Vieja",
		"Puertas",
		"Puertas Grandes",
		"Puerto Cochucho",
		"Puestito De Arriba",
		"Puesto 9 De Julio",
		"Puesto Belén",
		"Puesto Cevil Con Agua",
		"Puesto Chico",
		"Puesto Ciénaga Amarilla",
		"Puesto De Alumbre",
		"Puesto De Avila",
		"Puesto De Encalillo",
		"Puesto De Galvanes",
		"Puesto De Julipao",
		"Puesto De Los Valdés",
		"Puesto De Uncos",
		"Puesto De Zarzo",
		"Puesto Del Medio",
		"Puesto Grande",
		"Puesto La Ramadita",
		"Puesto Los Avilas",
		"Puesto Los Barraza",
		"Puesto Los Galvez",
		"Puesto Los Pérez",
		"Puesto Los Robles",
		"Puesto Nuevo",
		"Puesto Várela",
		"Puesto Viejo",
		"Puesto Villagra",
		"Puma Pozo",
		"Punta De Rieles",
		"Punta Del Agua",
		"Punta Del Monte",
		"Punta Rieles",
		"Quebrachito",
		"Quebrada De Lules",
		"Quilmes",
		"Quinteros 1",
		"Quinteros 2",
		"Quisca Chica",
		"Raco",
		"Rafaela Pozo",
		"Ramaditas",
		"Ramos",
		"Ranchillos",
		"Ranchillos Viejos",
		"Rancho De Cascada",
		"Rearte",
		"Requelme",
		"Rescate",
		"Retiro",
		"Riarte",
		"Riegasta",
		"Rincón",
		"Rincón De Balderrama",
		"Rincón De Las Tacanas",
		"Rincón De Quilmes",
		"Rincón Grande",
		"Rincón Huasa",
		"Río Blanco",
		"Río Chico",
		"Río Colorado",
		"Río Del Nio",
		"Río Hondito",
		"Río Loro",
		"Río Lules",
		"Río Seco",
		"Río Seco Kilometro 1207",
		"Río Vipos",
		"Rodeo",
		"Rodeo Del Algarrobo",
		"Rodeo Grande",
		"Rodeo Toro",
		"Roma",
		"Romera Pozo",
		"Romerello",
		"Rosario",
		"Rosario Oeste",
		"Rumí Cocha",
		"Rumí Punco",
		"Rumí Yura",
		"Ruta Nacional 157",
		"Ruta Nacional 38",
		"Ruta Nacional 64",
		"Ruta Nacional 9",
		"Ruta Provincial 301",
		"Ruta Provincial 302",
		"Ruta Provincial 303",
		"Ruta Provincial 304",
		"Ruta Provincial 306",
		"Ruta Provincial 308",
		"Ruta Provincial 319",
		"Ruta Provincial 320",
		"Ruta Provincial 322",
		"Ruta Provincial 323",
		"Ruta Provincial 333",
		"Ruta Provincial 334",
		"Ruta Provincial 335",
		"Ruta Provincial 338",
		"Ruta Provincial 366",
		"Ruta Provincial 374",
		"Ruta Provincial 375",
		"Ruta Provincial 380",
		"Sacrificio",
		"Sala Vieja",
		"Saladillo",
		"Salamanca",
		"Salas",
		"Salinas",
		"San Agustín",
		"San Alberto",
		"San Andrés",
		"San Antonio",
		"San Antonio De Padua",
		"San Antonio De Quisca",
		"San Arturo",
		"San Bernardo B",
		"San Carlitos",
		"San Carlos",
		"San Eusebio",
		"San Federico",
		"San Felipe",
		"San Fernando",
		"San Francisco",
		"San Gabriel",
		"San Gabriel Del Monte",
		"San Germán",
		"San Geronimo",
		"San Ignacio",
		"San Isidro",
		"San Javier",
		"San Jenaro",
		"San José",
		"San José De Buena Vista",
		"San José De Chasquivil",
		"San José De Flores",
		"San José De La Cocha",
		"San José De Leales",
		"San José De Lules",
		"San José De Macomita",
		"San José De San Martín",
		"San Juancito",
		"San Julián Yaco",
		"San Lorenzo",
		"San Luis",
		"San Luis De Las Casas Viejas",
		"San Miguel",
		"San Miguel De Tucumán",
		"San Miguelito",
		"San Nicolás",
		"San Pablo",
		"San Patricio",
		"San Pedro",
		"San Pedro De Colalao",
		"San Pedro Mártir",
		"San Pereyra",
		"San Rafael",
		"San Ramón",
		"San Ramón Chicligasta",
		"San Vicente",
		"Sandis",
		"Sandovales",
		"Santa Ana",
		"Santa Barbara",
		"Santa Catalina",
		"Santa Clara Sud",
		"Santa Cruz",
		"Santa Elena",
		"Santa Felisa",
		"Santa Isabel",
		"Santa Lucia",
		"Santa Luisa",
		"Santa Mónica",
		"Santa Rita",
		"Santa Rosa",
		"Santa Rosa De Leales",
		"Santa Teresa",
		"Santillan",
		"Santo Domingo",
		"Santos Lugares",
		"Sargento Moya",
		"Sauce Gaucho",
		"Sauce Huacho",
		"Sauce Partido",
		"Sauce Seco",
		"Sauce Yaco",
		"Sauce Yacu",
		"Sauzal",
		"Sepultura",
		"Sesteadero",
		"Simbol",
		"Simbolar",
		"Simoca",
		"Sinqueal",
		"Sinquial",
		"Sol De Mayo",
		"Soldado Maldonado",
		"Soledad",
		"Soraire",
		"Sud De Lazarte",
		"Sud De Sandovales",
		"Sud De Trejos",
		"Sueldo",
		"Sueldos",
		"Sunchal",
		"Suncho Punta",
		"Superintendente Ledesma",
		"Suriyaco",
		"Suriyacu",
		"Tacanas",
		"Taco",
		"Taco Llano",
		"Taco Palta",
		"Taco Punco",
		"Taco Ralo",
		"Taco Rodeo",
		"Taco Yaco",
		"Taco Yana",
		"Tafi Del Valle",
		"Tafi Viejo",
		"Taficillo",
		"Tala Bajada",
		"Tala Caída",
		"Tala Pampa",
		"Tala Paso",
		"Tala Pozo",
		"Tala Sacha",
		"Tala Yaco",
		"Talamuyo",
		"Talilar",
		"Talita Pozo",
		"Talitas",
		"Talleres Nacionales",
		"Tambor De Tacuari",
		"Tapia",
		"Taquello",
		"Taruca Pampa",
		"Tata Yacu",
		"Tecotex",
		"Teniente Berdina",
		"Ticucho",
		"Tierras Blancas",
		"Timbo Nuevo",
		"Timbo Viejo",
		"Tinajeros",
		"Tío Franco",
		"Tío Punco",
		"Tipa Mayo",
		"Tipas",
		"Toco Llana",
		"Toquello",
		"Toro Loco",
		"Toro Muerto",
		"Toro Yaco",
		"Tostado",
		"Totoral",
		"Totorilla",
		"Totoritas",
		"Trancas",
		"Tranquitas",
		"Tres Almacenes",
		"Tres Pozos",
		"Tres Sargentos",
		"Trinidad",
		"Tuna Sola",
		"Tunalito",
		"Tusca Pampa",
		"Tusca Pozo",
		"Tuscal",
		"Tuscal Redondo",
		"Tusquitas",
		"Ucuchacra",
		"Urizar",
		"Uturungu",
		"Uturuno",
		"Va Recaste",
		"Vacahuasi",
		"Valenzuela",
		"Vesubio",
		"Viaducto Del Toro",
		"Viaductos Del Toro",
		"Viclos",
		"Vielos",
		"Vilca Pozo",
		"Villa Alberdi",
		"Villa Alberdi Estación",
		"Villa Alvear",
		"Villa Angelina",
		"Villa Belgrano",
		"Villa Benjamin Araoz",
		"Villa Brava",
		"Villa Burruyacu",
		"Villa Carmela",
		"Villa Carolina",
		"Villa Clodomiro Hileret",
		"Villa Colmena",
		"Villa De Leales",
		"Villa De Los Britos",
		"Villa Desierto De Luz",
		"Villa Devoto",
		"Villa El Bache",
		"Villa El Retiro",
		"Villa Fiad",
		"Villa Gloria",
		"Villa La Colmena",
		"Villa La Soledad",
		"Villa La Trinidad",
		"Villa La Tuna",
		"Villa Leales",
		"Villa Marcos Paz",
		"Villa María",
		"Villa Mercedes",
		"Villa Mitre",
		"Villa Monte Cristo",
		"Villa Muñecas",
		"Villa Nogues",
		"Villa Nougues",
		"Villa Nueva",
		"Villa Nueva Aguilares",
		"Villa Padre Monti",
		"Villa Pujio",
		"Villa Quinteros",
		"Villa Recaste",
		"Villa Rita",
		"Villa Rosa",
		"Villa San Antonio",
		"Villa San Javier",
		"Villa Santa Rosa De Nueva Trin",
		"Villa Sta Rosa De Nva Trinidad",
		"Villa Tercera",
		"Villa Trancas",
		"Villa Vieja",
		"Villa Vieja Santa Ana",
		"Villa Zenon Santillan",
		"Viltran",
		"Vipos",
		"Virginia",
		"Vizcachera",
		"Yaco",
		"Yacuchina",
		"Yacuchiri",
		"Yalapa",
		"Yaminas",
		"Yangallo",
		"Yanima",
		"Yanimas",
		"Yapachin",
		"Yaquilo",
		"Yarami",
		"Yasyamayo",
		"Yatapayana",
		"Yerba Buena",
		"Yerba Huasi",
		"Ympas",
		"Yonopongo",
		"Yonopongo Sud",
		"Yuchaco",
		"Yucumanita",
		"Yumillura",
		"Yunca Suma",
		"Yunopongo Sud",
		"Zanjon Mascio",
		"Zapallar",
		"Zarate",
		"Zavalia",
		"Zurita"
	]
};

const phoneCountryCode$f = '54';
const phoneRegex$f = /^(?:(?:(?:\+|)54)|)(?:(?:(?:9\d{9})|(?:11\d{8})|(?:220|221|223|230|236|237|249|260|261|263|264|266|280|291|294|297|298|299|336|341|342|343|345|345|348|351|353|358|362|364|370|376|379|380|381|383|385|387|388)\d{7})|(?:2202|2221|2223|2224|2225|2226|2227|2229|2241|2242|2243|2244|2245|2246|2252|2254|2255|2257|2261|2262|2264|2265|2266|2267|2268|2271|2272|2273|2274|2281|2283|2284|2285|2286|2291|2292|2296|2297|2302|2314|2316|2317|2320|2323|2324|2325|2326|2331|2333|2334|2335|2336|2337|2338|2342|2343|2344|2345|2346|2352|2353|2354|2355|2356|2357|2358|2392|2393|2394|2395|2396|2473|2474|2475|2477|2478|2622|2624|2625|2626|2634|2646|2647|2648|2651|2655|2656|2657|2658|2901|2902|2903|2920|2921|2922|2923|2924|2925|2926|2927|2928|2929|2931|2932|2933|2934|2935|2936|2940|2942|2945|2946|2948|2952|2953|2954|2962|2963|2964|2966|2972|2982|2983|2984|3327|3329|3382|3385|3387|3388|3400|3401|3402|3404|3405|3406|3407|3408|3409|3435|3436|3437|3438|3442|3444|3445|3446|3447|3454|3455|3456|3458|3460|3462|3463|3464|3465|3466|3467|3468|3469|3471|3472|3476|3482|3483|3487|3489|3491|3492|3493|3496|3497|3498|3521|3522|3524|3525|3532|3533|3537|3541|3542|3543|3544|3546|3547|3548|3549|3562|3563|3564|3571|3572|3573|3574|3575|3576|3582|3583|3584|3585|3711|3715|3716|3718|3721|3725|3731|3734|3735|3741|3743|3751|3754|3755|3756|3757|3758|3772|3773|3774|3775|3777|3781|3782|3786|3821|3825|3826|3827|3832|3835|3837|3838|3841|3843|3844|3845|3846|3854|3855|3856|3857|3858|3861|3862|3863|3865|3867|3868|3869|3873|3876|3877|3878|3885|3886|3887|3888|3891|3892|3894)\d{6})$/;
const areaCodeStartChar$b = '';
const areaCodeEndChar$b = '';
const areaCodeSeparator$f = ' ';
const phoneSeparator$e = '-';

const unformatPhone$f = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$f}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 10 && phone.startsWith(phoneCountryCode$f)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$f = phone => {
  phone = unformatPhone$f(phone);

  if (phone.length === 10) {
    if (phone.startsWith('9')) {
      return `${areaCodeStartChar$b}${phone.substring(0, 1)}${areaCodeEndChar$b}${areaCodeSeparator$f}${phone.substring(1, 6)}${phoneSeparator$e}${phone.substring(6)}`;
    }

    if (phone.startsWith('11')) {
      return `${areaCodeStartChar$b}${phone.substring(0, 2)}${areaCodeEndChar$b}${areaCodeSeparator$f}${phone.substring(2, 6)}${phoneSeparator$e}${phone.substring(6)}`;
    }

    if (phone.startsWith('220') || phone.startsWith('221') || phone.startsWith('223') || phone.startsWith('230') || phone.startsWith('236') || phone.startsWith('237') || phone.startsWith('249') || phone.startsWith('260') || phone.startsWith('261') || phone.startsWith('263') || phone.startsWith('264') || phone.startsWith('266') || phone.startsWith('280') || phone.startsWith('291') || phone.startsWith('294') || phone.startsWith('297') || phone.startsWith('298') || phone.startsWith('299') || phone.startsWith('336') || phone.startsWith('341') || phone.startsWith('342') || phone.startsWith('343') || phone.startsWith('345') || phone.startsWith('345') || phone.startsWith('348') || phone.startsWith('351') || phone.startsWith('353') || phone.startsWith('358') || phone.startsWith('362') || phone.startsWith('364') || phone.startsWith('370') || phone.startsWith('376') || phone.startsWith('379') || phone.startsWith('380') || phone.startsWith('381') || phone.startsWith('383') || phone.startsWith('385') || phone.startsWith('387') || phone.startsWith('388')) {
      return areaCodeStartChar$b + phone.substring(0, 3) + areaCodeEndChar$b + areaCodeSeparator$f + phone.substring(3, 6) + phoneSeparator$e + phone.substring(6);
    }

    return areaCodeStartChar$b + phone.substring(0, 4) + areaCodeEndChar$b + areaCodeSeparator$f + phone.substring(4, 6) + phoneSeparator$e + phone.substring(6);
  }

  return phone;
};

const validatePhone$f = phone => {
  phone = unformatPhone$f(phone);
  return phoneRegex$f.test(phone);
};

const unformatId$b = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const formatId$b = id => {
  id = id.toString().toUpperCase();
  return id;
};

const validatePersonalID$6 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$b(id);

  if (/^\d{6,8}[A-z]$/.test(id)) {
    return true;
  }

  return false;
};

const validateCorporateID$8 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$b(id);

  if (/^([\d]{2})-?([\d]{8})-?([\d]{1})$/.test(id)) {
    return true;
  }

  return false;
};

const ARG = {
  input: {
    document: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00000000A',
      maxLength: 9,
      inputMode: 'text',
      validate: validatePersonalID$6,
      format: formatId$b,
      unformat: unformatId$b
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '(000) 000-000-0000',
      maxLength: 18,
      inputMode: 'numeric',
      validate: validatePhone$f,
      format: formatPhone$f,
      unformat: unformatPhone$f
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '0000',
      maxLength: 4,
      inputMode: 'numeric',
      validate: value => /^[0-9]{4}$/.test(value),
      format: value => msk.fit(value, '9999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '99-99999999-9',
      maxLength: 13,
      inputMode: 'numeric',
      validate: validateCorporateID$8,
      format: formatId$b,
      unformat: unformatId$b
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: mapCountryDataToFirstLevel(countryData$e)
    },
    city: {
      type: 'select',
      enabled: true,
      required: true,
      parent: 'state',
      options: mapCountryDataToSecondLevel(countryData$e)
    },
    neighborhood: {
      type: 'text',
      enabled: false,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 10,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: street => street,
      unformat: street => street,
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

const phoneCountryCode$e = '55';
const phoneRegex$e = /^(?:(?:(?:\+|)55)|)(?:0|)(?:11|12|13|14|15|16|17|18|19|21|22|24|27|28|31|32|33|34|35|36|37|38|41|42|43|44|45|46|47|48|49|51|52|53|54|55|61|62|63|64|65|66|67|68|69|71|72|73|74|75|77|78|79|81|82|83|84|85|86|87|88|89|91|92|93|94|95|96|97|98|99)(?:9\d{8}|[1-8]\d{7})$/;
const areaCodeStartChar$a = '(';
const areaCodeEndChar$a = ')';
const areaCodeSeparator$e = ' ';
const phoneSeparator$d = '-';

const unformatPhone$e = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$e}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 11 && phone.startsWith(phoneCountryCode$e)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$e = phone => {
  phone = unformatPhone$e(phone);

  if (phone.length === 11) {
    return `${areaCodeStartChar$a}${phone.substring(0, 2)}${areaCodeEndChar$a}${areaCodeSeparator$e}${phone.substring(2, 7)}${phoneSeparator$d}${phone.substring(7)}`;
  }

  if (phone.length === 10) {
    return `${areaCodeStartChar$a}${phone.substring(0, 2)}${areaCodeEndChar$a}${areaCodeSeparator$e}${phone.substring(2, 6)}${phoneSeparator$d}${phone.substring(6)}`;
  }

  return phone;
};

const validatePhone$e = phone => {
  phone = unformatPhone$e(phone);
  return phoneRegex$e.test(phone);
};

const DIGIT = '9';
const ALPHA = 'A';
const ALPHANUM = 'S';
const ALL = '*';
const CPF_MASK = '999.999.999-99';

const escape = text => {
  return text ? text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') : '';
};

const match = (char, token) => {
  switch (token) {
    case DIGIT:
      return /[0-9]/.test(char);

    case ALPHA:
      return /[A-ú]/.test(char);

    case ALPHANUM:
      return /[A-ú0-9]/.test(char);

    case ALL:
      return true;

    default:
      return new RegExp(escape(token)).test(char);
  }
};

const unformatCPF = document => {
  return !document || typeof document !== 'string' ? '' : document.replace(/[^\d]+/g, '');
};

const formatCPF = document => {
  if (!document) return '';
  document = document.toString();

  for (let i = 0; i < document.length; i++) {
    // If the character is OK with the mask
    if (match(document[i], CPF_MASK[i])) {
      continue;
    } // If it's there's a space or a non-word character in the mask
    // just insert the character inbetween the document


    if (CPF_MASK[i] === ' ' || new RegExp(/\W/).test(CPF_MASK[i])) {
      const firstPart = document.slice(0, i);
      const secondPart = document.slice(i);
      document = `${firstPart}${CPF_MASK[i]}${secondPart}`;
      document = formatCPF(document);
      break;
    } // If it doesn't match, remove the character


    const firstPart = document.slice(0, i);
    const secondPart = document.slice(i + 1);
    document = `${firstPart}${secondPart}`;
    document = formatCPF(document);
  }

  return document;
};

const unmaskCNPJ = cnpj => {
  return !cnpj || typeof cnpj !== 'string' ? '' : cnpj.replace(/[^\d]+/g, '');
};

const BRA = {
  input: {
    document: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '000.000.000-00',
      maxLength: 14,
      inputMode: 'numeric',
      validate: document => {
        if (!document) {
          return false;
        }

        let sum = 0;
        let remainder;
        document = unformatCPF(document);

        if (document === '00000000000' || document === '11111111111' || document === '22222222222' || document === '33333333333' || document === '44444444444' || document === '55555555555' || document === '66666666666' || document === '77777777777' || document === '88888888888' || document === '99999999999') {
          return false;
        }

        for (let i = 1; i <= 9; i++) {
          sum += parseInt(document.substring(i - 1, i), 10) * (11 - i);
        }

        remainder = sum * 10 % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(document.substring(9, 10), 10)) return false;
        sum = 0;

        for (let i = 1; i <= 10; i++) {
          sum += parseInt(document.substring(i - 1, i), 10) * (12 - i);
        }

        remainder = sum * 10 % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(document.substring(10, 11), 10)) return false;
        return true;
      },
      format: formatCPF,
      unformat: unformatCPF
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '00 00000 0000',
      maxLength: 20,
      inputMode: 'numeric',
      validate: validatePhone$e,
      format: formatPhone$e,
      unformat: unformatPhone$e
    },
    postalCode: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '00000-000',
      maxLength: 9,
      inputMode: 'numeric',
      validate: value => /^[0-9]{5}-?[0-9]{3}$/.test(value),
      format: value => msk.fit(value, '99999-999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '00.000.000/0001-00',
      maxLength: 18,
      inputMode: 'numeric',
      validate: cnpj => {
        if (!cnpj) {
          return false;
        }

        cnpj = unmaskCNPJ(cnpj);

        if (cnpj.length !== 14) {
          return false;
        }

        if (cnpj === '00000000000000' || cnpj === '11111111111111' || cnpj === '22222222222222' || cnpj === '33333333333333' || cnpj === '44444444444444' || cnpj === '55555555555555' || cnpj === '66666666666666' || cnpj === '77777777777777' || cnpj === '88888888888888' || cnpj === '99999999999999') {
          return false;
        } // Validate DVs


        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        const digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
          soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--;

          if (pos < 2) {
            pos = 9;
          }
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

        if (resultado !== parseInt(digitos.charAt(0), 10)) {
          return false;
        }

        tamanho += 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
          soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--;

          if (pos < 2) {
            pos = 9;
          }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

        if (resultado !== parseInt(digitos.charAt(1), 10)) {
          return false;
        }

        return true;
      },
      format: cnpj => {
        return msk.fit(cnpj, '99.999.999/9999-99');
      },
      unformat: unmaskCNPJ
    },
    state: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 10,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    street: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: street => street,
      unformat: street => street,
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$d = {
	"Región Metropolitana": {
		"Alhué": "9650000",
		Buin: "9500000",
		"Calera De Tango": "9560000",
		"Centro de Ski - El Colorado": "7690002",
		"Centro de Ski - Farellones": "7690003",
		"Centro de Ski - La Parva": "7690004",
		"Centro de Ski - Valle Nevado": "7690001",
		Cerrillos: "9200000",
		"Cerro Navia": "9080000",
		Chicureo: "9350001",
		Colina: "9340000",
		"Conchalí": "8540000",
		"Curacaví": "9630000",
		"El Bosque": "8010000",
		"El Monte": "9810000",
		"Estación Central": "9160000",
		Huechuraba: "8580000",
		Independencia: "8380000",
		"Isla De Maipo": "9790000",
		"La Cisterna": "7970000",
		"La Florida": "8240000",
		"La Granja": "8780000",
		"La Pintana": "8820000",
		"La Reina": "7850000",
		Lampa: "9380000",
		"Las Condes": "7550000",
		"Lo Barnechea": "7690000",
		"Lo Barnechea (Excepto Cordillera)": "7690100",
		"Lo Espejo": "9120000",
		"Lo Prado": "8980000",
		Macul: "7810000",
		"Maipú": "9250000",
		"María Pinto": "9620000",
		Melipilla: "9580000",
		"Ñuñoa": "7750000",
		"Padre Hurtado": "9710000",
		Paine: "9540000",
		"Pedro Aguirre Cerda": "8460000",
		"Peñaflor": "9750000",
		"Peñalolén": "7910000",
		Pirque: "9480000",
		Providencia: "7500000",
		Pudahuel: "9020000",
		"Puente Alto": "8150000",
		Quilicura: "8700000",
		"Quinta Normal": "8500000",
		Recoleta: "8420000",
		Renca: "8640000",
		"San Bernardo": "8050000",
		"San Joaquín": "8940000",
		"San José De Maipo": "9460000",
		"San Miguel": "8900000",
		"San Pedro": "9660000",
		"San Ramón": "8860000",
		Santiago: "8320000",
		Talagante: "9670000",
		Tiltil: "9420000",
		Vitacura: "7630000"
	},
	"Región de Arica y Parinacota (XV)": {
		Arica: "1000000",
		Camarones: "1040000",
		"General Lagos": "1080000",
		Putre: "1070000"
	},
	"Región de Tarapacá (I)": {
		"Camiña": "1150000",
		Colchane: "1160000",
		Huara: "1140000",
		Iquique: "1100000",
		Pica: "1170000",
		"Pozo Almonte": "1180000",
		"Alto Hospicio": "1130000"
	},
	"Región de Antofagasta (II)": {
		Antofagasta: "1240000",
		Calama: "1390000",
		"María Elena": "1360000",
		Mejillones: "1310000",
		"Ollagüe": "1420000",
		"San Pedro De Atacama": "1410000",
		"Sierra Gorda": "1320000",
		Taltal: "1300000",
		Tocopilla: "1340000"
	},
	"Región de Atacama (III)": {
		"Alto Del Carmen": "1650000",
		Caldera: "1570000",
		"Chañaral": "1490000",
		"Copiapó": "1530000",
		"Diego De Almagro": "1500000",
		Freirina: "1630000",
		Huasco: "1640000",
		"Tierra Amarilla": "1580000",
		Vallenar: "1610000"
	},
	"Región de Coquimbo (IV)": {
		Andacollo: "1750000",
		Canela: "1960000",
		"Caleta Hornos": "1780008",
		"Combarbalá": "1890000",
		Coquimbo: "1780000",
		Guanaqueros: "1780007",
		Illapel: "1930000",
		"La Higuera": "1740000",
		"La Serena": "1700000",
		"Las Tacas": "1780002",
		"Los Vilos": "1940000",
		"Monte Patria": "1880000",
		Morrillos: "1780004",
		Ovalle: "1840000",
		Paihuano: "1770000",
		"Playa Blanca": "1780003",
		"Puerto Velero": "1780001",
		Punitaqui: "1900000",
		"Río Hurtado": "1870000",
		Salamanca: "1950000",
		Tongoy: "1780006",
		Totoralillo: "1780005",
		"Vicuña": "1760000"
	},
	"Región de Valparaíso (V)": {
		Algarrobo: "2710000",
		Cabildo: "2050000",
		"Calle Larga": "2130000",
		Cartagena: "2680000",
		Casablanca: "2480000",
		Catemu: "2230000",
		"Concón": "2510000",
		"El Quisco": "2700000",
		"El Tabo": "2690000",
		Hijuelas: "2310000",
		"Isla De Pascua": "2770000",
		"Juan Fernández": "2600000",
		"La Calera": "2290000",
		"La Cruz": "2280000",
		"La Ligua": "2030000",
		Limache: "2240000",
		"Llay-Llay": "2220000",
		"Los Andes": "2100000",
		Nogales: "2300000",
		"Olmué": "2330000",
		Panquehue: "2210000",
		Papudo: "2070000",
		Petorca: "2040000",
		"Puchuncaví": "2500000",
		Putaendo: "2190000",
		Quillota: "2260000",
		"Quilpué": "2420000",
		Quintero: "2490000",
		Rinconada: "2140000",
		"San Antonio": "2660000",
		"San Esteban": "2120000",
		"San Felipe": "2170000",
		"Santa María": "2200000",
		"Santo Domingo": "2720000",
		"Valparaíso": "2340000",
		"Villa Alemana": "2450000",
		"Viña Del Mar": "2520000",
		Zapallar: "2060000"
	},
	"Región del Libertador General Bernardo O’Higgins (VI)": {
		"Chépica": "3120000",
		Chimbarongo: "3090000",
		Codegua: "2900000",
		Coinco: "3010000",
		Coltauco: "3000000",
		"Doñihue": "3020000",
		Graneros: "2880000",
		"La Estrella": "3250000",
		"Lago Rapel": "3030001",
		"Las Cabras": "3030000",
		Litueche: "3240000",
		Lolol: "3140000",
		"Machalí": "2910000",
		Malloa: "2950000",
		"Marchigüe": "3260000",
		Mostazal: "2890000",
		Nancagua: "3110000",
		Navidad: "3230000",
		Olivar: "2920000",
		Palmilla: "3160000",
		Paredones: "3270000",
		Peralillo: "3170000",
		Peumo: "2990000",
		Pichidegua: "2980000",
		Pichilemu: "3220000",
		Placilla: "3100000",
		Pumanque: "3150000",
		"Quinta De Tilcoco": "2960000",
		Rancagua: "2820000",
		Rengo: "2940000",
		Requinoa: "2930000",
		"San Fernando": "3070000",
		"San Vicente": "2970000",
		"Santa Cruz": "3130000"
	},
	"Región del Maule (VII)": {
		Cauquenes: "3690000",
		Chanco: "3720000",
		"Colbún": "3610000",
		"Constitución": "3560000",
		Curepto: "3570000",
		"Curicó": "3340000",
		Empedrado: "3540000",
		"Hualañé": "3400000",
		"Licantén": "3410000",
		Linares: "3580000",
		"Longaví": "3620000",
		Maule: "3530000",
		Molina: "3380000",
		Parral: "3630000",
		Pelarco: "3500000",
		Pelluhue: "3710000",
		Pencahue: "3550000",
		Rauco: "3430000",
		Retiro: "3640000",
		"Río Claro": "3510000",
		Romeral: "3370000",
		"Sagrada Familia": "3390000",
		"San Clemente": "3520000",
		"San Javier": "3660000",
		"San Rafael": "3490000",
		Talca: "3460000",
		Teno: "3360000",
		"Vichuquén": "3420000",
		"Villa Alegre": "3650000",
		"Yerbas Buenas": "3600000"
	},
	"Región del Ñuble (XVI)": {
		Bulnes: "3930000",
		"Chillán": "3780000",
		"Chillán Viejo": "3820000",
		Cobquecura: "3990000",
		Coelemu: "3970000",
		Coihueco: "3870000",
		"El Carmen": "3900000",
		Ninhue: "4010000",
		"Ñiquén": "3850000",
		Pemuco: "3910000",
		Pinto: "3880000",
		Portezuelo: "3960000",
		"Quillón": "3940000",
		Quirihue: "4000000",
		Ranquil: "3950000",
		"San Carlos": "3840000",
		"San Fabián": "3860000",
		"San Ignacio": "3890000",
		"San Nicolás": "4020000",
		Treguaco: "3980000",
		Yungay: "3920000"
	},
	"Región del Biobío (VIII)": {
		"Alto Bío Bío": "4590000",
		Antuco: "4490000",
		Arauco: "4360000",
		Cabrero: "4470000",
		"Cañete": "4390000",
		Chiguayante: "4100000",
		"Concepción": "4030000",
		Contulmo: "4400000",
		Coronel: "4190000",
		Curanilahue: "4370000",
		Dichato: "4160001",
		Florida: "4170000",
		"Hualpén": "4600000",
		Hualqui: "4180000",
		Laja: "4560000",
		Lebu: "4350000",
		Lirquen: "4140001",
		"Los Alamos": "4380000",
		"Los Ángeles": "4430000",
		Lota: "4210000",
		"Mulchén": "4530000",
		Nacimiento: "4550000",
		Negrete: "4540000",
		Penco: "4150000",
		Pingueral: "4160002",
		Quilaco: "4520000",
		Quilleco: "4500000",
		Recinto: "3880001",
		"San Pedro De la Paz": "4130000",
		"San Rosendo": "4570000",
		"Santa Bárbara": "4510000",
		"Santa Juana": "4230000",
		Talcahuano: "4260000",
		"Tirúa": "4410000",
		"Tomé": "4160000",
		Tucapel: "4480000",
		Yumbel: "4580000"
	},
	"Región de La Araucanía (IX)": {
		Angol: "4650000",
		Caburga: "4920001",
		Calafquen: "4930001",
		Carahue: "5010000",
		Cholchol: "5040000",
		Collipulli: "4680000",
		Corralco: "4780002",
		Cunco: "4890000",
		"Curacautín": "4700000",
		Curarrehue: "4910000",
		Ercilla: "4710000",
		Freire: "4940000",
		Galvarino: "5030000",
		Gorbea: "4960000",
		"Lago Cólico": "4930002",
		"Lago Cólico Norte": "4890001",
		"Lago Cólico Sur": "4890002",
		Lautaro: "4860000",
		Licanray: "4930001",
		Loncoche: "4970000",
		Lonquimay: "4690000",
		"Los Sauces": "4760000",
		Lumaco: "4740000",
		Malalcahuello: "4780001",
		Melipeuco: "4900000",
		"Nueva Imperial": "5020000",
		"Padre Las Casas": "4850000",
		Perquenco: "4870000",
		"Pitrufquén": "4950000",
		"Pucón": "4920000",
		"Puerto Saavedra": "5000000",
		"Purén": "4750000",
		Renaico: "4670000",
		Temuco: "4780000",
		"Teodoro Schmidt": "4990000",
		"Toltén": "4980000",
		"Traiguén": "4730000",
		Victoria: "4720000",
		"Vilcún": "4880000",
		Villarrica: "4930000"
	},
	"Región de Los Ríos (XIV)": {
		"Coñaripe": "5210001",
		Corral: "5190000",
		Futrono: "5180000",
		"La Union": "5220000",
		"Lago Ranco": "5250000",
		Lanco: "5160000",
		"Los Lagos": "5170000",
		Mafil: "5200000",
		Mariquina: "5150000",
		Paillaco: "5230000",
		Panguipulli: "5210000",
		"Rio Bueno": "5240000",
		Valdivia: "5090000"
	},
	"Región de Los Lagos (X)": {
		Ancud: "5710000",
		Calbuco: "5570000",
		Castro: "5700000",
		"Chaitén": "5850000",
		Chonchi: "5770000",
		"Cochamó": "5560000",
		"Curaco De Vélez": "5740000",
		Dalcahue: "5730000",
		"El Islote": "5370001",
		Ensenada: "5550001",
		Fresia: "5600000",
		Frutillar: "5620000",
		"Futaleufú": "5870000",
		"Hualaihué": "5860000",
		Llanquihue: "5610000",
		"Los Muermos": "5590000",
		"Marina Rupanco": "5360001",
		"Maullín": "5580000",
		Osorno: "5290000",
		Palena: "5880000",
		"Puerto Montt": "5480000",
		"Puerto Octay": "5370000",
		"Puerto Varas": "5550000",
		"Puqueldón": "5760000",
		Purranque: "5380000",
		Puyehue: "5360000",
		"Queilén": "5780000",
		"Quellón": "5790000",
		Quemchi: "5720000",
		Quinchao: "5750000",
		"Río Negro": "5390000",
		"San Juan De la Costa": "5400000",
		"San Pablo": "5350000"
	},
	"Región de Aysén del General Carlos Ibáñez del Campo (XI)": {
		"Aysén": "6000000",
		"Chile Chico": "6050000",
		Cisnes: "6010000",
		Cochrane: "6100000",
		Coyhaique: "5950000",
		Guaitecas: "6020000",
		"Lago Verde": "5960000",
		"O'Higgins": "6110000",
		"Río Ibáñez": "6060000",
		Tortel: "6120000"
	},
	"Región de Magallanes y la Antártica Chilena (XII)": {
		"Antártica": "6360000",
		"Cabo De Hornos": "6350000",
		"Laguna Blanca": "6250000",
		Porvenir: "6300000",
		Primavera: "6310000",
		"Puerto Natales": "6160000",
		"Punta Arenas": "6200000",
		"Río Verde": "6240000",
		"San Gregorio": "6260000",
		Timaukel: "6320000",
		"Torres Del Paine": "6170000"
	}
};

const phoneCountryCode$d = '56';
const phoneRegex$d = /^(?:(?:(?:\+|)56)|)(?:0|)(?:(?:[2-9])\d{8})$/;
const areaCodeStartChar$9 = '';
const areaCodeEndChar$9 = '';
const areaCodeSeparator$d = ' ';
const phoneSeparator$c = ' ';

const unformatPhone$d = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$d}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 9 && phone.startsWith(phoneCountryCode$d)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$d = phone => {
  phone = unformatPhone$d(phone);

  if (phone.length === 9) {
    return areaCodeStartChar$9 + phone.substring(0, 1) + areaCodeEndChar$9 + areaCodeSeparator$d + phone.substring(1, 5) + phoneSeparator$c + phone.substring(5);
  }

  return phone;
};

const validatePhone$d = phone => {
  phone = unformatPhone$d(phone);
  return phoneRegex$d.test(phone);
};

const unformatId$a = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const formatId$a = id => {
  if (!id) return '';
  id = unformatId$a(id);

  if (id.length === 8) {
    return msk.fit(id, '9.999.999-S');
  }

  if (id.length === 9) {
    return msk.fit(id, '99.999.999-S');
  }

  return id;
};

const validateId$1 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$a(id);
  let characters;
  let digits;
  let verifDigit;
  let i;
  let j;
  let k;
  let remainder;
  let series;
  let sum;

  if (/^\d{1,2}\.?\d{3}\.?\d{3}-?[\dkK]$/.test(id)) {
    id = id.replace(/[.-]/g, '');

    if (id.length === 8) {
      id = `0${id}`;
    }

    id = `${id.substring(0, 8)}-${id.substring(8, 9)}`;
    characters = [];
    series = [2, 3, 4, 5, 6, 7];
    digits = id.toString().substring(id.toString().length - 1, id.toString().length);
    id = id.toString().substring(0, id.toString().length - 2);
    i = 0;

    while (i < id.length) {
      characters[i] = id.charAt(id.length - (i + 1));
      i++;
    }

    sum = 0;
    k = 0;
    remainder = 0;
    j = 0;

    while (j < characters.length) {
      if (k === 6) {
        k = 0;
      }

      sum += parseInt(characters[j], 10) * series[k];
      k++;
      j++;
    }

    remainder = sum % 11;
    verifDigit = 11 - remainder;

    if (verifDigit === 10) {
      verifDigit = 'K';
    } else if (verifDigit === 11) {
      verifDigit = 0;
    }

    if (verifDigit.toString().trim().toUpperCase() === digits.toString().trim().toUpperCase()) {
      return true;
    }

    return false;
  }

  return false;
};

const CHL = {
  input: {
    document: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '99.999.999-K',
      maxLength: 12,
      inputMode: 'text',
      validate: validateId$1,
      format: formatId$a,
      unformat: unformatId$a
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '0 0000 0000',
      maxLength: 15,
      inputMode: 'numeric',
      validate: validatePhone$d,
      format: formatPhone$d,
      unformat: unformatPhone$d
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '0000000',
      maxLength: 7,
      inputMode: 'numeric',
      validate: value => /^[0-9]{7}$/.test(value),
      format: value => msk.fit(value, '9999999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '99.999.999-K',
      maxLength: 12,
      inputMode: 'text',
      validate: validateId$1,
      format: formatId$a,
      unformat: unformatId$a
    },
    state: {
      type: 'select',
      required: true,
      enabled: true,
      parent: null,
      options: mapCountryDataToFirstLevel(countryData$d)
    },
    city: {
      type: 'text',
      required: false,
      enabled: false,
      format: value => value,
      inputMode: 'text',
      maxLength: 100,
      placeholder: '',
      unformat: value => value,
      validate: () => true
    },
    neighborhood: {
      type: 'select',
      required: true,
      enabled: true,
      parent: 'state',
      options: mapCountryDataToSecondLevel(countryData$d)
    },
    complement: {
      type: 'text',
      required: false,
      enabled: true,
      maxLength: 750,
      format: value => value,
      inputMode: 'text',
      placeholder: '',
      unformat: value => value,
      validate: () => true
    },
    receiverName: {
      type: 'text',
      required: true,
      enabled: true,
      maxLength: 750,
      format: value => value,
      inputMode: 'text',
      placeholder: '',
      unformat: value => value,
      validate: value => !!value
    },
    number: {
      type: 'text',
      required: true,
      enabled: true,
      maxLength: 750,
      format: value => value,
      inputMode: 'numeric',
      placeholder: '',
      unformat: value => value,
      validate: value => !!value
    },
    street: {
      type: 'text',
      required: true,
      enabled: true,
      maxLength: 750,
      format: value => value,
      inputMode: 'text',
      placeholder: '',
      unformat: value => value,
      validate: value => !!value
    }
  },
  address: {
    postalCodeMode: 'state-neighborhood'
  }
};

var countryData$c = {
	Amazonas: {
		"El Encanto": "91263",
		"La Chorrera": "91405",
		"La Pedrera": "91407",
		"La Victoria": "91430",
		Leticia: "91001",
		"Mirití - Paraná": "91460",
		"Puerto Alegría": "91530",
		"Puerto Arica": "91536",
		"Puerto Nariño": "91540",
		"Puerto Santander": "91669",
		"Tarapacá": "91798"
	},
	Antioquia: {
		Abejorral: "05002",
		"Abriaquí": "05004",
		"Alejandría": "05021",
		Altavista: "05001",
		"Amagá": "05030",
		Amalfi: "05031",
		Andes: "05034",
		"Angelópolis": "05036",
		Angostura: "05038",
		"Anorí": "05040",
		"Anzá": "05044",
		"Apartadó": "05045",
		Arboletes: "05051",
		Argelia: "05055",
		Armenia: "05059",
		Barbosa: "05079",
		Bello: "05088",
		Belmira: "05086",
		Betania: "05091",
		Betulia: "05093",
		"Briceño": "05107",
		"Buriticá": "05113",
		"Cáceres": "05120",
		Caicedo: "05125",
		Caldas: "05129",
		Campamento: "05134",
		"Cañasgordas": "05138",
		"Caracolí": "05142",
		Caramanta: "05145",
		Carepa: "05147",
		Carolina: "05150",
		Caucasia: "05154",
		"Chigorodó": "05172",
		Cisneros: "05190",
		"Ciudad Bolívar": "05101",
		"Cocorná": "05197",
		"Concepción": "05206",
		Concordia: "05209",
		Copacabana: "05212",
		Dabeiba: "05234",
		"Donmatías": "05237",
		"Ebéjico": "05240",
		"El Bagre": "05250",
		"El Carmen De Viboral": "05148",
		"El Santuario": "05697",
		"Entrerríos": "05264",
		Envigado: "05266",
		Fredonia: "05282",
		Frontino: "05284",
		Giraldo: "05306",
		Girardota: "05308",
		"Gómez Plata": "05310",
		Granada: "05313",
		Guadalupe: "05315",
		Guarne: "05318",
		"Guatapé": "05321",
		Heliconia: "05347",
		Hispania: "05353",
		"Itagüí": "05360",
		Ituango: "05361",
		"Jardín": "05364",
		"Jericó": "05368",
		"La Ceja": "05376",
		"La Estrella": "05380",
		"La Pintada": "05390",
		"La Unión": "05400",
		Liborina: "05411",
		Maceo: "05425",
		Marinilla: "05440",
		"Medellín": "05001",
		Montebello: "05467",
		"Murindó": "05475",
		"Mutatá": "05480",
		"Nariño": "05483",
		"Nechí": "05495",
		"Necoclí": "05490",
		Olaya: "05501",
		"Peñol": "05541",
		Peque: "05543",
		Pueblorrico: "05576",
		"Puerto Berrío": "05579",
		"Puerto Nare": "05585",
		"Puerto Triunfo": "05591",
		Remedios: "05604",
		Retiro: "05607",
		Rionegro: "05615",
		Sabanalarga: "05628",
		Sabaneta: "05631",
		Salgar: "05642",
		"San Andrés De Cuerquía": "05647",
		"San Antonio de Prado": "05001",
		"San Carlos": "05649",
		"San Francisco": "05652",
		"San Jerónimo": "05656",
		"San José De La Montaña": "05658",
		"San Juan De Urabá": "05659",
		"San Luis": "05660",
		"San Pedro De Los Milagros": "05664",
		"San Pedro De Urabá": "05665",
		"San Rafael": "05667",
		"San Roque": "05670",
		"San Vicente Ferrer": "05674",
		"Santa Bárbara": "05679",
		"Santa Elena": "05001",
		"Santa Fé De Antioquia": "05042",
		"Santa Rosa De Osos": "05686",
		"Santo Domingo": "05690",
		Segovia: "05736",
		"Sonsón": "05756",
		"Sopetrán": "05761",
		"Támesis": "05789",
		"Tarazá": "05790",
		Tarso: "05792",
		"Titiribí": "05809",
		Toledo: "05819",
		Turbo: "05837",
		Uramita: "05842",
		Urrao: "05847",
		Valdivia: "05854",
		"Valparaíso": "05856",
		"Vegachí": "05858",
		Venecia: "05861",
		"Vigía Del Fuerte": "05873",
		"Yalí": "05885",
		Yarumal: "05887",
		"Yolombó": "05890",
		"Yondó": "05893",
		Zaragoza: "05895"
	},
	Arauca: {
		Arauca: "81001",
		Arauquita: "81065",
		"Cravo Norte": "81220",
		Fortul: "81300",
		"Puerto Rondón": "81591",
		Saravena: "81736",
		Tame: "81794"
	},
	"Atlántico": {
		Baranoa: "08078",
		Barranquilla: "08001",
		"Campo De La Cruz": "08137",
		Candelaria: "08141",
		Galapa: "08296",
		"Juan De Acosta": "08372",
		Luruaco: "08421",
		Malambo: "08433",
		"Manatí": "08436",
		"Palmar De Varela": "08520",
		"Piojó": "08549",
		Polonuevo: "08558",
		Ponedera: "08560",
		"Puerto Colombia": "08573",
		"Repelón": "08606",
		Sabanagrande: "08634",
		Sabanalarga: "08638",
		"Santa Lucía": "08675",
		"Santo Tomás": "08685",
		Soledad: "08758",
		Suan: "08770",
		"Tubará": "08832",
		"Usiacurí": "08849"
	},
	"Bogotá D.C.": {
		"Bogotá D.c.": "11001"
	},
	"Bolívar": {
		"Achí": "13006",
		"Altos Del Rosario": "13030",
		Arenal: "13042",
		Arjona: "13052",
		Arroyohondo: "13062",
		"Barranco De Loba": "13074",
		Calamar: "13140",
		Cantagallo: "13160",
		"Cartagena De Indias": "13001",
		Cicuco: "13188",
		Clemencia: "13222",
		"Córdoba": "13212",
		"El Carmen De Bolívar": "13244",
		"El Guamo": "13248",
		"El Peñón": "13268",
		"Hatillo De Loba": "13300",
		"Magangué": "13430",
		Mahates: "13433",
		Margarita: "13440",
		"María La Baja": "13442",
		"Mompós": "13468",
		Montecristo: "13458",
		Morales: "13473",
		"Norosí": "13490",
		Pinillos: "13549",
		Regidor: "13580",
		"Río Viejo": "13600",
		"San Cristóbal": "13620",
		"San Estanislao": "13647",
		"San Fernando": "13650",
		"San Jacinto": "13654",
		"San Jacinto Del Cauca": "13655",
		"San Juan Nepomuceno": "13657",
		"San Martín De Loba": "13667",
		"San Pablo": "13670",
		"Santa Catalina": "13673",
		"Santa Rosa": "13683",
		"Santa Rosa Del Sur": "13688",
		"Simití": "13744",
		Soplaviento: "13760",
		"Talaigua Nuevo": "13780",
		Tiquisio: "13810",
		Turbaco: "13836",
		"Turbaná": "13838",
		Villanueva: "13873",
		Zambrano: "13894"
	},
	"Boyacá": {
		Almeida: "15022",
		Aquitania: "15047",
		Arcabuco: "15051",
		"Belén": "15087",
		Berbeo: "15090",
		"Betéitiva": "15092",
		Boavita: "15097",
		"Boyacá": "15104",
		"Briceño": "15106",
		Buenavista: "15109",
		"Busbanzá": "15114",
		Caldas: "15131",
		Campohermoso: "15135",
		Cerinza: "15162",
		Chinavita: "15172",
		"Chiquinquirá": "15176",
		"Chíquiza": "15232",
		Chiscas: "15180",
		Chita: "15183",
		Chitaraque: "15185",
		"Chivatá": "15187",
		Chivor: "15236",
		"Ciénega": "15189",
		"Cómbita": "15204",
		Coper: "15212",
		Corrales: "15215",
		"Covarachía": "15218",
		"Cubará": "15223",
		Cucaita: "15224",
		"Cuítiva": "15226",
		Duitama: "15238",
		"El Cocuy": "15244",
		"El Espino": "15248",
		Firavitoba: "15272",
		Floresta: "15276",
		"Gachantivá": "15293",
		"Gámeza": "15296",
		Garagoa: "15299",
		Guacamayas: "15317",
		Guateque: "15322",
		"Guayatá": "15325",
		"Güicán": "15332",
		Iza: "15362",
		Jenesano: "15367",
		"Jericó": "15368",
		"La Capilla": "15380",
		"La Uvita": "15403",
		"La Victoria": "15401",
		Labranzagrande: "15377",
		Macanal: "15425",
		"Maripí": "15442",
		Miraflores: "15455",
		Mongua: "15464",
		"Monguí": "15466",
		"Moniquirá": "15469",
		Motavita: "15476",
		Muzo: "15480",
		Nobsa: "15491",
		"Nuevo Colón": "15494",
		"Oicatá": "15500",
		Otanche: "15507",
		Pachavita: "15511",
		"Páez": "15514",
		Paipa: "15516",
		Pajarito: "15518",
		Panqueba: "15522",
		Pauna: "15531",
		Paya: "15533",
		"Paz De Río": "15537",
		Pesca: "15542",
		Pisba: "15550",
		"Puerto Boyacá": "15572",
		"Quípama": "15580",
		"Ramiriquí": "15599",
		"Ráquira": "15600",
		"Rondón": "15621",
		"Saboyá": "15632",
		"Sáchica": "15638",
		"Samacá": "15646",
		"San Eduardo": "15660",
		"San José De Pare": "15664",
		"San Luis De Gaceno": "15667",
		"San Mateo": "15673",
		"San Miguel De Sema": "15676",
		"San Pablo De Borbur": "15681",
		"Santa María": "15690",
		"Santa Rosa De Viterbo": "15693",
		"Santa Sofía": "15696",
		Santana: "15686",
		Sativanorte: "15720",
		Sativasur: "15723",
		Siachoque: "15740",
		"Soatá": "15753",
		Socha: "15757",
		"Socotá": "15755",
		Sogamoso: "15759",
		Somondoco: "15761",
		Sora: "15762",
		"Soracá": "15764",
		"Sotaquirá": "15763",
		"Susacón": "15774",
		"Sutamarchán": "15776",
		Sutatenza: "15778",
		Tasco: "15790",
		Tenza: "15798",
		"Tibaná": "15804",
		Tibasosa: "15806",
		"Tinjacá": "15808",
		Tipacoque: "15810",
		Toca: "15814",
		"Togüí": "15816",
		"Tópaga": "15820",
		Tota: "15822",
		Tunja: "15001",
		"Tununguá": "15832",
		"Turmequé": "15835",
		Tuta: "15837",
		"Tutazá": "15839",
		"Úmbita": "15842",
		Ventaquemada: "15861",
		"Villa De Leyva": "15407",
		"Viracachá": "15879",
		Zetaquira: "15897"
	},
	Caldas: {
		Aguadas: "17013",
		Anserma: "17042",
		Aranzazu: "17050",
		"Belalcázar": "17088",
		"Chinchiná": "17174",
		Filadelfia: "17272",
		"La Dorada": "17380",
		"La Merced": "17388",
		Manizales: "17001",
		Manzanares: "17433",
		Marmato: "17442",
		Marquetalia: "17444",
		Marulanda: "17446",
		Neira: "17486",
		Norcasia: "17495",
		"Pácora": "17513",
		Palestina: "17524",
		Pensilvania: "17541",
		Riosucio: "17614",
		Risaralda: "17616",
		Salamina: "17653",
		"Samaná": "17662",
		"San José": "17665",
		"Supía": "17777",
		Victoria: "17867",
		"Villamaría": "17873",
		Viterbo: "17877"
	},
	"Caquetá": {
		Albania: "18029",
		"Belén De Los Andaquíes": "18094",
		"Cartagena Del Chairá": "18150",
		Curillo: "18205",
		"El Doncello": "18247",
		"El Paujíl": "18256",
		Florencia: "18001",
		"La Montañita": "18410",
		"Milán": "18460",
		Morelia: "18479",
		"Puerto Rico": "18592",
		"San José Del Fragua": "18610",
		"San Vicente Del Caguán": "18753",
		Solano: "18756",
		Solita: "18785",
		"Valparaíso": "18860"
	},
	Casanare: {
		Aguazul: "85010",
		"Chámeza": "85015",
		"Hato Corozal": "85125",
		"La Salina": "85136",
		"Maní": "85139",
		Monterrey: "85162",
		"Nunchía": "85225",
		"Orocué": "85230",
		"Paz De Ariporo": "85250",
		Pore: "85263",
		Recetor: "85279",
		Sabanalarga: "85300",
		"Sácama": "85315",
		"San Luis De Palenque": "85325",
		"Támara": "85400",
		Tauramena: "85410",
		Trinidad: "85430",
		Villanueva: "85440",
		Yopal: "85001"
	},
	Cauca: {
		Almaguer: "19022",
		Argelia: "19050",
		Balboa: "19075",
		"Bolívar": "19100",
		"Buenos Aires": "19110",
		"Cajibío": "19130",
		Caldono: "19137",
		Caloto: "19142",
		Corinto: "19212",
		"El Tambo": "19256",
		Florencia: "19290",
		"Guachené": "19300",
		"Guapí": "19318",
		"Inzá": "19355",
		"Jambaló": "19364",
		"La Sierra": "19392",
		"La Vega": "19397",
		"López De Micay": "19418",
		Mercaderes: "19450",
		Miranda: "19455",
		Morales: "19473",
		Padilla: "19513",
		"Páez": "19517",
		"Patía": "19532",
		Piamonte: "19533",
		"Piendamó": "19548",
		"Popayán": "19001",
		"Puerto Tejada": "19573",
		"Puracé": "19585",
		Rosas: "19622",
		"San Sebastián": "19693",
		"Santa Rosa": "19701",
		"Santander De Quilichao": "19698",
		Silvia: "19743",
		Sotara: "19760",
		"Suárez": "19780",
		Sucre: "19785",
		"Timbío": "19807",
		"Timbiquí": "19809",
		"Toribío": "19821",
		"Totoró": "19824",
		"Villa Rica": "19845"
	},
	Cesar: {
		Aguachica: "20011",
		"Agustín Codazzi": "20013",
		Astrea: "20032",
		Becerril: "20045",
		Bosconia: "20060",
		Chimichagua: "20175",
		"Chiriguaná": "20178",
		"Curumaní": "20228",
		"El Copey": "20238",
		"El Paso": "20250",
		Gamarra: "20295",
		"González": "20310",
		"La Gloria": "20383",
		"La Jagua De Ibirico": "20400",
		"La Loma": "20250",
		"La Paz": "20621",
		"Manaure Balcón Del Cesar": "20443",
		Pailitas: "20517",
		Pelaya: "20550",
		"Pueblo Bello": "20570",
		"Río De Oro": "20614",
		"San Alberto": "20710",
		"San Diego": "20750",
		"San Martín": "20770",
		Tamalameque: "20787",
		Valledupar: "20001"
	},
	"Chocó": {
		"Acandí": "27006",
		"Alto Baudó": "27025",
		Atrato: "27050",
		"Bagadó": "27073",
		"Bahía Solano": "27075",
		"Bajo Baudó": "27077",
		"Bojayá": "27099",
		"Carmen Del Darién": "27150",
		"Cértegui": "27160",
		Condoto: "27205",
		"El Cantón Del San Pablo": "27135",
		"El Carmen De Atrato": "27245",
		"El Litoral Del San Juan": "27250",
		Istmina: "27361",
		"Juradó": "27372",
		"Lloró": "27413",
		"Medio Atrato": "27425",
		"Medio Baudó": "27430",
		"Medio San Juan": "27450",
		"Nóvita": "27491",
		"Nuquí": "27495",
		"Quibdó": "27001",
		"Río Iró": "27580",
		"Río Quito": "27600",
		Riosucio: "27615",
		"San José Del Palmar": "27660",
		"Sipí": "27745",
		"Tadó": "27787",
		"Unguía": "27800",
		"Unión Panamericana": "27810"
	},
	"Córdoba": {
		Ayapel: "23068",
		Buenavista: "23079",
		Canalete: "23090",
		"Cereté": "23162",
		"Chimá": "23168",
		"Chinú": "23182",
		"Ciénaga De Oro": "23189",
		Cotorra: "23300",
		"La Apartada": "23350",
		Lorica: "23417",
		"Los Córdobas": "23419",
		Momil: "23464",
		"Moñitos": "23500",
		"Montelíbano": "23466",
		"Montería": "23001",
		"Planeta Rica": "23555",
		"Pueblo Nuevo": "23570",
		"Puerto Escondido": "23574",
		"Puerto Libertador": "23580",
		"Purísima De La Concepción": "23586",
		"Sahagún": "23660",
		"San Andrés De Sotavento": "23670",
		"San Antero": "23672",
		"San Bernardo Del Viento": "23675",
		"San Carlos": "23678",
		"San José De Uré": "23682",
		"San Pelayo": "23686",
		Tierralta: "23807",
		"Tuchín": "23815",
		Valencia: "23855"
	},
	Cundinamarca: {
		"Agua De Dios": "25001",
		"Albán": "25019",
		Anapoima: "25035",
		Anolaima: "25040",
		Apulo: "25599",
		"Arbeláez": "25053",
		"Beltrán": "25086",
		Bituima: "25095",
		"Bojacá": "25099",
		Cabrera: "25120",
		Cachipay: "25123",
		"Cajicá": "25126",
		"Caparrapí": "25148",
		"Cáqueza": "25151",
		"Carmen De Carupa": "25154",
		"Chaguaní": "25168",
		"Chía": "25175",
		Chipaque: "25178",
		"Choachí": "25181",
		"Chocontá": "25183",
		Cogua: "25200",
		Cota: "25214",
		"Cucunubá": "25224",
		"El Colegio": "25245",
		"El Peñón": "25258",
		"El Rosal": "25260",
		"Facatativá": "25269",
		"Fómeque": "25279",
		Fosca: "25281",
		Funza: "25286",
		"Fúquene": "25288",
		"Fusagasugá": "25290",
		"Gachalá": "25293",
		"Gachancipá": "25295",
		"Gachetá": "25297",
		Gama: "25299",
		Girardot: "25307",
		Granada: "25312",
		"Guachetá": "25317",
		Guaduas: "25320",
		Guasca: "25322",
		"Guataquí": "25324",
		Guatavita: "25326",
		"Guayabal De Síquima": "25328",
		Guayabetal: "25335",
		"Gutiérrez": "25339",
		"Jerusalén": "25368",
		"Junín": "25372",
		"La Calera": "25377",
		"La Mesa": "25386",
		"La Palma": "25394",
		"La Peña": "25398",
		"La Vega": "25402",
		Lenguazaque: "25407",
		"Machetá": "25426",
		Madrid: "25430",
		Manta: "25436",
		Medina: "25438",
		Mosquera: "25473",
		"Nariño": "25483",
		"Nemocón": "25486",
		Nilo: "25488",
		Nimaima: "25489",
		Nocaima: "25491",
		Pacho: "25513",
		Paime: "25518",
		Pandi: "25524",
		Paratebueno: "25530",
		Pasca: "25535",
		"Puerto Salgar": "25572",
		"Pulí": "25580",
		Quebradanegra: "25592",
		Quetame: "25594",
		Quipile: "25596",
		Ricaurte: "25612",
		"San Antonio Del Tequendama": "25645",
		"San Bernardo": "25649",
		"San Cayetano": "25653",
		"San Francisco": "25658",
		"San Juan De Rioseco": "25662",
		Sasaima: "25718",
		"Sesquilé": "25736",
		"Sibaté": "25740",
		Silvania: "25743",
		Simijaca: "25745",
		Soacha: "25754",
		"Sopó": "25758",
		Subachoque: "25769",
		Suesca: "25772",
		"Supatá": "25777",
		Susa: "25779",
		Sutatausa: "25781",
		Tabio: "25785",
		Tausa: "25793",
		Tena: "25797",
		Tenjo: "25799",
		Tibacuy: "25805",
		Tibirita: "25807",
		Tocaima: "25815",
		"Tocancipá": "25817",
		"Topaipí": "25823",
		"Ubalá": "25839",
		Ubaque: "25841",
		Une: "25845",
		"Útica": "25851",
		Venecia: "25506",
		Vergara: "25862",
		"Vianí": "25867",
		"Villa De San Diego De Ubaté": "25843",
		"Villagómez": "25871",
		"Villapinzón": "25873",
		Villeta: "25875",
		"Viotá": "25878",
		"Yacopí": "25885",
		"Zipacón": "25898",
		"Zipaquirá": "25899"
	},
	"Guainía": {
		"Barranco Minas": "94343",
		Cacahual: "94886",
		"Inírida": "94001",
		"La Guadalupe": "94885",
		Mapiripana: "94663",
		Morichal: "94888",
		"Pana Pana": "94887",
		"Puerto Colombia": "94884",
		"San Felipe": "94883"
	},
	Guaviare: {
		Calamar: "95015",
		"El Retorno": "95025",
		Miraflores: "95200",
		"San José Del Guaviare": "95001"
	},
	Huila: {
		Acevedo: "41006",
		Agrado: "41013",
		Aipe: "41016",
		Algeciras: "41020",
		Altamira: "41026",
		Baraya: "41078",
		Campoalegre: "41132",
		Colombia: "41206",
		"Elías": "41244",
		"Garzón": "41298",
		Gigante: "41306",
		Guadalupe: "41319",
		Hobo: "41349",
		"Íquira": "41357",
		Isnos: "41359",
		"La Argentina": "41378",
		"La Plata": "41396",
		"Nátaga": "41483",
		Neiva: "41001",
		Oporapa: "41503",
		Paicol: "41518",
		Palermo: "41524",
		Palestina: "41530",
		Pital: "41548",
		Pitalito: "41551",
		Rivera: "41615",
		Saladoblanco: "41660",
		"San Agustín": "41668",
		"Santa María": "41676",
		Suaza: "41770",
		Tarqui: "41791",
		Tello: "41799",
		Teruel: "41801",
		Tesalia: "41797",
		"Timaná": "41807",
		Villavieja: "41872",
		"Yaguará": "41885"
	},
	"La Guajira": {
		Albania: "44035",
		Barrancas: "44078",
		Dibulla: "44090",
		"Distracción": "44098",
		"El Molino": "44110",
		Fonseca: "44279",
		Hatonuevo: "44378",
		"La Jagua Del Pilar": "44420",
		Maicao: "44430",
		Manaure: "44560",
		Riohacha: "44001",
		"San Juan Del Cesar": "44650",
		Uribia: "44847",
		Urumita: "44855",
		Villanueva: "44874"
	},
	Magdalena: {
		Algarrobo: "47030",
		Aracataca: "47053",
		"Ariguaní": "47058",
		"Cerro De San Antonio": "47161",
		Chivolo: "47170",
		"Ciénaga": "47189",
		Concordia: "47205",
		"El Banco": "47245",
		"El Piñón": "47258",
		"El Retén": "47268",
		"Fundación": "47288",
		Guamal: "47318",
		"Nueva Granada": "47460",
		Pedraza: "47541",
		"Pijiño Del Carmen": "47545",
		Pivijay: "47551",
		Plato: "47555",
		Puebloviejo: "47570",
		Remolino: "47605",
		"Sabanas De San Ángel": "47660",
		Salamina: "47675",
		"San Sebastián De Buenavista": "47692",
		"San Zenón": "47703",
		"Santa Ana": "47707",
		"Santa Bárbara De Pinto": "47720",
		"Santa Marta": "47001",
		Sitionuevo: "47745",
		Tenerife: "47798",
		"Zapayán": "47960",
		"Zona Bananera": "47980"
	},
	Meta: {
		"Acacías": "50006",
		"Barranca De Upía": "50110",
		Cabuyaro: "50124",
		"Castilla La Nueva": "50150",
		Cumaral: "50226",
		"El Calvario": "50245",
		"El Castillo": "50251",
		"El Dorado": "50270",
		"Fuente De Oro": "50287",
		Granada: "50313",
		Guamal: "50318",
		"La Macarena": "50350",
		"Lejanías": "50400",
		"Mapiripán": "50325",
		Mesetas: "50330",
		"Puerto Concordia": "50450",
		"Puerto Gaitán": "50568",
		"Puerto Lleras": "50577",
		"Puerto López": "50573",
		"Puerto Rico": "50590",
		Restrepo: "50606",
		"San Carlos De Guaroa": "50680",
		"San Juan De Arama": "50683",
		"San Juanito": "50686",
		"San Luis De Cubarral": "50223",
		"San Martín": "50689",
		Uribe: "50370",
		Villavicencio: "50001",
		Vistahermosa: "50711"
	},
	"Nariño": {
		"Albán": "52019",
		Aldana: "52022",
		"Ancuyá": "52036",
		Arboleda: "52051",
		Barbacoas: "52079",
		"Belén": "52083",
		Buesaco: "52110",
		"Chachagüí": "52240",
		"Colón": "52203",
		"Consacá": "52207",
		Contadero: "52210",
		"Córdoba": "52215",
		"Cuaspúd": "52224",
		Cumbal: "52227",
		Cumbitara: "52233",
		"El Charco": "52250",
		"El Peñol": "52254",
		"El Rosario": "52256",
		"El Tablón De Gómez": "52258",
		"El Tambo": "52260",
		"Francisco Pizarro": "52520",
		Funes: "52287",
		Guachucal: "52317",
		Guaitarilla: "52320",
		"Gualmatán": "52323",
		Iles: "52352",
		"Imués": "52354",
		Ipiales: "52356",
		"La Cruz": "52378",
		"La Florida": "52381",
		"La Llanada": "52385",
		"La Tola": "52390",
		"La Unión": "52399",
		Leiva: "52405",
		Linares: "52411",
		Llorente: "52835",
		"Los Andes": "52418",
		"Magüí": "52427",
		Mallama: "52435",
		Mosquera: "52473",
		"Nariño": "52480",
		"Olaya Herrera": "52490",
		Ospina: "52506",
		Pasto: "52001",
		Policarpa: "52540",
		"Potosí": "52560",
		Providencia: "52565",
		Puerres: "52573",
		Pupiales: "52585",
		Ricaurte: "52612",
		"Roberto Payán": "52621",
		Samaniego: "52678",
		"San Andrés De Tumaco": "52835",
		"San Bernardo": "52685",
		"San Lorenzo": "52687",
		"San Pablo": "52693",
		"San Pedro De Cartago": "52694",
		"Sandoná": "52683",
		"Santa Bárbara": "52696",
		Santacruz: "52699",
		Sapuyes: "52720",
		Taminango: "52786",
		Tangua: "52788",
		"Túquerres": "52838",
		Yacuanquer: "52885"
	},
	"Norte De Santander": {
		"Ábrego": "54003",
		Arboledas: "54051",
		Bochalema: "54099",
		Bucarasica: "54109",
		"Cáchira": "54128",
		"Cácota": "54125",
		"Chinácota": "54172",
		"Chitagá": "54174",
		"Convención": "54206",
		"Cúcuta": "54001",
		Cucutilla: "54223",
		Durania: "54239",
		"El Carmen": "54245",
		"El Tarra": "54250",
		"El Zulia": "54261",
		Gramalote: "54313",
		"Hacarí": "54344",
		"Herrán": "54347",
		"La Esperanza": "54385",
		"La Playa": "54398",
		Labateca: "54377",
		"Los Patios": "54405",
		Lourdes: "54418",
		Mutiscua: "54480",
		"Ocaña": "54498",
		Pamplona: "54518",
		Pamplonita: "54520",
		"Puerto Santander": "54553",
		Ragonvalia: "54599",
		Salazar: "54660",
		"San Calixto": "54670",
		"San Cayetano": "54673",
		Santiago: "54680",
		Sardinata: "54720",
		Silos: "54743",
		Teorama: "54800",
		"Tibú": "54810",
		Toledo: "54820",
		"Villa Caro": "54871",
		"Villa Del Rosario": "54874"
	},
	Putumayo: {
		"Colón": "86219",
		Mocoa: "86001",
		Orito: "86320",
		"Puerto Asís": "86568",
		"Puerto Caicedo": "86569",
		"Puerto Guzmán": "86571",
		"Puerto Leguízamo": "86573",
		"San Francisco": "86755",
		"San Miguel": "86757",
		Santiago: "86760",
		Sibundoy: "86749",
		"Valle Del Guamuez": "86865",
		"Villagarzón": "86885"
	},
	Quindio: {
		Armenia: "63001",
		Buenavista: "63111",
		"Calarcá": "63130",
		Circasia: "63190",
		"Córdoba": "63212",
		Filandia: "63272",
		"Génova": "63302",
		"La Tebaida": "63401",
		Montenegro: "63470",
		Pijao: "63548",
		Quimbaya: "63594",
		Salento: "63690"
	},
	Risaralda: {
		"Apía": "66045",
		Balboa: "66075",
		"Belén De Umbría": "66088",
		Dosquebradas: "66170",
		"Guática": "66318",
		"La Celia": "66383",
		"La Virginia": "66400",
		Marsella: "66440",
		"Mistrató": "66456",
		Pereira: "66001",
		"Pueblo Rico": "66572",
		"Quinchía": "66594",
		"Santa Rosa De Cabal": "66682",
		Santuario: "66687"
	},
	"San Andrés, Providencia Y Santa Catalina": {
		Providencia: "88564",
		"San Andrés": "88001"
	},
	Santander: {
		Aguada: "68013",
		Albania: "68020",
		Aratoca: "68051",
		Barbosa: "68077",
		Barichara: "68079",
		Barrancabermeja: "68081",
		Betulia: "68092",
		"Bolívar": "68101",
		Bucaramanga: "68001",
		Cabrera: "68121",
		California: "68132",
		Capitanejo: "68147",
		"Carcasí": "68152",
		"Cepitá": "68160",
		Cerrito: "68162",
		"Charalá": "68167",
		Charta: "68169",
		Chima: "68176",
		"Chipatá": "68179",
		Cimitarra: "68190",
		"Concepción": "68207",
		Confines: "68209",
		"Contratación": "68211",
		Coromoro: "68217",
		"Curití": "68229",
		"El Carmen De Chucurí": "68235",
		"El Guacamayo": "68245",
		"El Peñón": "68250",
		"El Playón": "68255",
		Encino: "68264",
		Enciso: "68266",
		"Florián": "68271",
		Floridablanca: "68276",
		"Galán": "68296",
		"Gámbita": "68298",
		"Girón": "68307",
		Guaca: "68318",
		Guadalupe: "68320",
		"Guapotá": "68322",
		"Guavatá": "68324",
		"Güepsa": "68327",
		Hato: "68344",
		"Jesús María": "68368",
		"Jordán": "68370",
		"La Belleza": "68377",
		"La Paz": "68397",
		"Landázuri": "68385",
		Lebrija: "68406",
		"Los Santos": "68418",
		Macaravita: "68425",
		"Málaga": "68432",
		Matanza: "68444",
		Mogotes: "68464",
		Molagavita: "68468",
		Ocamonte: "68498",
		Oiba: "68500",
		Onzaga: "68502",
		Palmar: "68522",
		"Palmas Del Socorro": "68524",
		"Páramo": "68533",
		Piedecuesta: "68547",
		Pinchote: "68549",
		"Puente Nacional": "68572",
		"Puerto Parra": "68573",
		"Puerto Wilches": "68575",
		Rionegro: "68615",
		"Sabana De Torres": "68655",
		"San Andrés": "68669",
		"San Benito": "68673",
		"San Gil": "68679",
		"San Joaquín": "68682",
		"San José De Miranda": "68684",
		"San Miguel": "68686",
		"San Vicente De Chucurí": "68689",
		"Santa Bárbara": "68705",
		"Santa Helena Del Opón": "68720",
		Simacota: "68745",
		Socorro: "68755",
		Suaita: "68770",
		Sucre: "68773",
		"Suratá": "68780",
		Tona: "68820",
		"Valle De San José": "68855",
		"Vélez": "68861",
		Vetas: "68867",
		Villanueva: "68872",
		Zapatoca: "68895"
	},
	Sucre: {
		Buenavista: "70110",
		Caimito: "70124",
		"Chalán": "70230",
		Coloso: "70204",
		Corozal: "70215",
		"Coveñas": "70221",
		"El Roble": "70233",
		Galeras: "70235",
		Guaranda: "70265",
		"La Unión": "70400",
		"Los Palmitos": "70418",
		Majagual: "70429",
		Morroa: "70473",
		Ovejas: "70508",
		Palmito: "70523",
		"Sampués": "70670",
		"San Benito Abad": "70678",
		"San Juan De Betulia": "70702",
		"San Luis De Sincé": "70742",
		"San Marcos": "70708",
		"San Onofre": "70713",
		"San Pedro": "70717",
		"Santiago De Tolú": "70820",
		Sincelejo: "70001",
		Sucre: "70771",
		"Tolú Viejo": "70823"
	},
	Tolima: {
		Alpujarra: "73024",
		Alvarado: "73026",
		Ambalema: "73030",
		"Anzoátegui": "73043",
		"Armero Guayabal": "73055",
		Ataco: "73067",
		Cajamarca: "73124",
		"Carmen De Apicalá": "73148",
		Casabianca: "73152",
		Chaparral: "73168",
		Coello: "73200",
		Coyaima: "73217",
		Cunday: "73226",
		Dolores: "73236",
		Espinal: "73268",
		Falan: "73270",
		Flandes: "73275",
		Fresno: "73283",
		Guamo: "73319",
		Herveo: "73347",
		Honda: "73349",
		"Ibagué": "73001",
		Icononzo: "73352",
		"Lérida": "73408",
		"Líbano": "73411",
		Melgar: "73449",
		Murillo: "73461",
		Natagaima: "73483",
		Ortega: "73504",
		Palocabildo: "73520",
		Piedras: "73547",
		Planadas: "73555",
		Prado: "73563",
		"Purificación": "73585",
		Rioblanco: "73616",
		Roncesvalles: "73622",
		Rovira: "73624",
		"Saldaña": "73671",
		"San Antonio": "73675",
		"San Luis": "73678",
		"San Sebastián De Mariquita": "73443",
		"Santa Isabel": "73686",
		"Suárez": "73770",
		"Valle De San Juan": "73854",
		Venadillo: "73861",
		Villahermosa: "73870",
		Villarrica: "73873"
	},
	"Valle Del Cauca": {
		"Alcalá": "76020",
		"Andalucía": "76036",
		Ansermanuevo: "76041",
		Argelia: "76054",
		"Bolívar": "76100",
		Buenaventura: "76109",
		Bugalagrande: "76113",
		Caicedonia: "76122",
		Cali: "76001",
		Calima: "76126",
		Candelaria: "76130",
		Cartago: "76147",
		Dagua: "76233",
		"El Águila": "76243",
		"El Cairo": "76246",
		"El Cerrito": "76248",
		"El Dovio": "76250",
		Florida: "76275",
		Ginebra: "76306",
		"Guacarí": "76318",
		"Guadalajara De Buga": "76111",
		"Jamundí": "76364",
		"La Cumbre": "76377",
		"La Unión": "76400",
		"La Victoria": "76403",
		Obando: "76497",
		Palmira: "76520",
		Pradera: "76563",
		Restrepo: "76606",
		"Riofrío": "76616",
		Roldanillo: "76622",
		"San Pedro": "76670",
		Sevilla: "76736",
		Toro: "76823",
		Trujillo: "76828",
		"Tuluá": "76834",
		Ulloa: "76845",
		Versalles: "76863",
		Vijes: "76869",
		Yotoco: "76890",
		Yumbo: "76892",
		Zarzal: "76895"
	},
	"Vaupés": {
		"Carurú": "97161",
		"Mitú": "97001",
		Pacoa: "97511",
		Papunaua: "97777",
		Taraira: "97666",
		"Yavaraté": "97889"
	},
	Vichada: {
		Cumaribo: "99773",
		"La Primavera": "99524",
		"Puerto Carreño": "99001",
		"Santa Rosalía": "99624"
	}
};

const phoneCountryCode$c = '57';
const phoneRegex$c = /^(?:(?:(?:\+|)57)|)(?:0|)(?:(?:(?:[6][0][1245678])\d{7})|(?:3\d{9}))$/;
const areaCodeStartChar$8 = '(';
const areaCodeEndChar$8 = ')';
const areaCodeSeparator$c = ' ';
const phoneSeparator$b = ' ';

const unformatPhone$c = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$c}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 10 && phone.startsWith(phoneCountryCode$c)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$c = phone => {
  phone = unformatPhone$c(phone);

  if (phone.length === 10 && phone[0] === '3') {
    return phone.substring(0, 3) + phoneSeparator$b + phone.substring(3, 6) + phoneSeparator$b + phone.substring(6);
  }

  if (phone.length === 10) {
    return areaCodeStartChar$8 + phone.substring(0, 3) + areaCodeEndChar$8 + areaCodeSeparator$c + phone.substring(3, 6) + phoneSeparator$b + phone.substring(6);
  }

  return phone;
};

const validatePhone$c = phone => {
  phone = unformatPhone$c(phone);
  return phoneRegex$c.test(phone);
};

const unformatPersonalId$1 = personalId => {
  if (!personalId || typeof personalId !== 'string') return '';
  personalId = personalId.replace(/^[^1-9]+/g, '');
  personalId = personalId.replace(/[^\d]+/g, '');
  return personalId;
};

const formatPersonalId$1 = personalId => {
  if (!personalId) return '';
  personalId = unformatPersonalId$1(personalId);
  return personalId;
};

const unformatCorporateId$3 = corporateId => {
  if (!corporateId || typeof corporateId !== 'string') return '';
  corporateId = corporateId.replace(/[^\d]+/g, '');
  return corporateId;
};

const formatCorporateId$3 = corporateId => {
  if (!corporateId) return '';
  corporateId = unformatCorporateId$3(corporateId);

  if (corporateId.length === 9) {
    return msk.fit(corporateId, '99.999.999-9');
  }

  if (corporateId.length === 10) {
    return msk.fit(corporateId, '999.999.999-9');
  }

  if (corporateId.length === 11) {
    return msk.fit(corporateId, '9.999.999.999-9');
  }

  if (corporateId.length === 12) {
    return msk.fit(corporateId, '99.999.999.999-9');
  }

  if (corporateId.length === 13) {
    return msk.fit(corporateId, '999.999.999.999-9');
  }

  if (corporateId.length === 14) {
    return msk.fit(corporateId, '9.999.999.999.999-9');
  }

  if (corporateId.length === 15) {
    return msk.fit(corporateId, '99.999.999.999.999-9');
  }

  if (corporateId.length === 16) {
    return msk.fit(corporateId, '999.999.999.999.999-9');
  }

  return corporateId;
};

const validateCorporateId$1 = corporateId => {
  const _regexFormat = /^(\d|\.|-)+$/;
  const _regexAdjust = /\D/gi;
  const _baseMod = 11;
  const _multipliers = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];

  if (!corporateId) {
    return false;
  }

  corporateId = unformatCorporateId$3(corporateId);

  if (corporateId.length < 9 || corporateId.length > 16) {
    return false;
  }

  if (!_regexFormat.test(corporateId)) {
    return false;
  }

  const adjustedNit = corporateId.replace(_regexAdjust, '');

  if (![7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(adjustedNit.length)) {
    return false;
  }

  const digit = adjustedNit.substring(adjustedNit.length - 1);
  const sequence = adjustedNit.substring(0, adjustedNit.length - 1).split('').reverse();
  let v = 0;

  for (let index = 0; index < sequence.length; index++) {
    v += parseInt(sequence[index], 10) * _multipliers[index];
  }

  let check = v % _baseMod;

  if (check >= 2) {
    check = _baseMod - check;
  }

  return check === parseInt(digit, 10);
};

const COL = {
  input: {
    document: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000000000000',
      maxLength: 12,
      inputMode: 'numeric',
      validate: personalId => {
        if (!personalId) return false;
        if (!/^\d+$/.test(personalId)) return false;
        if (personalId.length < 4 || personalId.length > 12) return false;
        return true;
      },
      format: formatPersonalId$1,
      unformat: unformatPersonalId$1
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 000 0000',
      maxLength: 16,
      inputMode: 'numeric',
      validate: validatePhone$c,
      format: formatPhone$c,
      unformat: unformatPhone$c
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000000',
      maxLength: 6,
      inputMode: 'numeric',
      validate: value => /^[0-9]{6}$/.test(value),
      format: value => msk.fit(value, '999999'),
      unformat: value => value.replace(/[^\d]+/g, '')
    },
    corporateDocument: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00.000.000-0',
      maxLength: 21,
      inputMode: 'numeric',
      validate: validateCorporateId$1,
      format: formatCorporateId$3,
      unformat: unformatCorporateId$3
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: mapCountryDataToFirstLevel(countryData$c)
    },
    city: {
      type: 'select',
      enabled: true,
      required: true,
      parent: 'state',
      options: mapCountryDataToSecondLevel(countryData$c)
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: false,
      required: false,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: street => street,
      unformat: street => street,
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'state-city'
  }
};

var countryData$b = {
	Azuay: {
		Amaluza: "0000",
		Asuncion: "0000",
		"Baños": "0000",
		"Bulan (Jose Victor Izquierdo)": "0000",
		"Camilo Ponce Enriquez": "0000",
		Chaucha: "0000",
		"Checa (Jidcay)": "0000",
		"Chican (Guillermo Ortega)": "0000",
		Chiquintad: "0000",
		Chumblin: "0000",
		Chordeleg: "0000",
		Cochapata: "0000",
		"Cuchil (Cutchil)": "0000",
		Cuenca: "0000",
		Cumbe: "0000",
		"Daniel Cordova Toral (El Oriente)": "0000",
		"Dug Dug": "0000",
		"El Pan": "0000",
		"El Cabo": "0000",
		"El Carmen de Pijili": "0000",
		"El Progreso (Cab. en Zhota)": "0000",
		Giron: "0000",
		Guachapala: "0000",
		Gualaceo: "0000",
		Guarainag: "0000",
		Guel: "0000",
		Jadan: "0000",
		"Jima (Gima)": "0000",
		"La Union": "0000",
		"Las Nieves (Chaya)": "0000",
		Llacao: "0000",
		Ludo: "0000",
		"Luis Cordero Vega": "0000",
		"Luis Galarza Orellana (Cab. en Delegsol)": "0000",
		"Mariano Moreno": "0000",
		Molleturo: "0000",
		Nabon: "0000",
		Nulti: "0000",
		"Octavio Cordero Palacios (Santa Rosa)": "0000",
		"Oña": "0000",
		Paccha: "0000",
		Palmas: "0000",
		Paute: "0000",
		"Ponce Enriquez": "0000",
		Principal: "0000",
		Pucara: "0000",
		Quingeo: "0000",
		"Remigio Crespo Toral (Gulag)": "0000",
		Ricaurte: "0000",
		"San Bartolome": "0000",
		"San Cristobal (Carlos Ordoñez Lazo)": "0000",
		"San Felipe de Oña": "0000",
		"San Fernando": "0000",
		"San Gerardo": "0000",
		"San Joaquin": "0000",
		"San Jose de Raranga": "0000",
		"San Juan": "0000",
		"San Martin de Puzhio": "0000",
		"San rafael de Sharug": "0000",
		"Santa Isabel": "0000",
		Sayausi: "0000",
		"Sevilla De Oro": "0000",
		Sidcay: "0000",
		"Simon Bolivar (Cab. en Gañanzol)": "0000",
		Sigsig: "0000",
		Sinincay: "0000",
		Sosudel: "0000",
		Tarqui: "0000",
		Tomebamba: "0000",
		Turi: "0000",
		Valle: "0000",
		"Victoria del Portete (Irquis)": "0000",
		"Zhaglli (Shaglli)": "0000",
		Zhidmad: "0000"
	},
	Bolivar: {
		"1° de Mayo": "0001",
		"4 esquinas": "0001",
		"Asunción": "0001",
		Balzapamba: "0001",
		Caluma: "0001",
		Chillanes: "0001",
		Chimbo: "0001",
		Echeandia: "0001",
		"Facundo Vela": "0001",
		Guaranda: "0001",
		"Las Naves": "0001",
		"La Magdalena": "0001",
		"Julio E. Moreno (Catanahuan Grande)": "0001",
		"Pisagua Alto": "0001",
		"Pisagua Bajo": "0001",
		"Recinto 24 de Mayo": "0001",
		"Recinto El Palmar": "0001",
		"Recinto La Maritza": "0001",
		"Regulo de Mora": "0001",
		Salinas: "0001",
		"San Jose de Chimbo": "0001",
		"San Jose del Tambo (Tambopamba)": "0001",
		"San Lorenzo": "0001",
		"San Luis de Pambil": "0001",
		"San Miguel de Bolivar": "0001",
		"San Pablo de Atenas": "0001",
		"San Pedro de Guanujo": "0001",
		"San Sebastian": "0001",
		"San Simon (Yacoto)": "0001",
		"Santa Fe": "0001",
		Simiatug: "0001",
		Telimbela: "0001",
		Vinchoa: "0001"
	},
	Canar: {
		Azogues: "0002",
		Biblian: "0002",
		"Cañar": "0002",
		Chontamarca: "0002",
		Chorocopte: "0002",
		Cochancay: "0002",
		Cojitambo: "0002",
		Deieeg: "0002",
		Deleg: "0002",
		Ducur: "0002",
		"El Tambo": "0002",
		"General Morales (Socarte)": "0002",
		Gualleturo: "0002",
		Guapan: "0002",
		"Honorato Vasquez (Tambo Viejo)": "0002",
		Ingapirca: "0002",
		"Javier Loyola (Chuquipata)": "0002",
		Jerusalen: "0002",
		Juncal: "0002",
		"La Troncal": "0002",
		"La Puntilla - El Triunfo": "0002",
		"Luis Cordero": "0002",
		"Manuel J. Calle": "0002",
		"Nazon (Cab. en Pampa de Dominguez)": "0002",
		"Pancho Negro": "0002",
		Pidilig: "0002",
		Rivera: "0002",
		"San Antonio": "0002",
		"San Francisco de Sageo": "0002",
		Solano: "0002",
		Suscal: "0002",
		Taday: "0002",
		Turupamba: "0002",
		Ventura: "0002",
		"Voluntad De Dios": "0002",
		Zhud: "0002"
	},
	Carchi: {
		Bolivar: "0003",
		Concepcion: "0003",
		"Chitan De Navarretes": "0003",
		"Cristobal Colon": "0003",
		Cuesaca: "0003",
		"El Angel": "0003",
		"El Carmelo (El Pun)": "0003",
		"El Chical": "0003",
		"El Goaltal": "0003",
		Espejo: "0003",
		"Fernando Salvador": "0003",
		"Garcia Moreno": "0003",
		Huaca: "0003",
		"Jijon y Caamaño (Cab. en Rio Blanco)": "0003",
		"Juan Montalvo (San Ignacio de Quil)": "0003",
		"Julio Andrade": "0003",
		"La Libertad (Alizo)": "0003",
		"La Paz": "0003",
		"Los Andes": "0003",
		"Mariscal Sucre": "0003",
		"Mira (Chontahuasi)": "0003",
		"Monte Olivo": "0003",
		Montufar: "0003",
		Piartal: "0003",
		Pioter: "0003",
		"San Pedro De Huaca": "0003",
		"San Gabriel": "0003",
		"San Isidro": "0003",
		"San Rafael": "0003",
		"San Vicente de Pusir": "0003",
		"Santa Martha de Cuba": "0003",
		"Tobar Donosco (La Boscana de Camumbi)": "0003",
		"Tufiño": "0003",
		Tulcan: "0003",
		"Urbina (Taya)": "0003"
	},
	Chimborazo: {
		Alausi: "0004",
		Achupallas: "0004",
		"Bilbao (Cab. en Quiluyacu)": "0004",
		"Cacha (Cab. en Machangara)": "0004",
		Cajabamba: "0004",
		Calpi: "0004",
		Chambo: "0004",
		"Cañi": "0004",
		Capzol: "0004",
		Cebadas: "0004",
		Chunchi: "0004",
		Columbe: "0004",
		Colta: "0004",
		Compud: "0004",
		Cumanda: "0004",
		Cubijes: "0004",
		"El Altar": "0004",
		"El Guano": "0004",
		Flores: "0004",
		Gonzol: "0004",
		Guamote: "0004",
		Guanando: "0004",
		Guasuntos: "0004",
		Huigra: "0004",
		Ilapo: "0004",
		"Juan de Velasco (Pangor)": "0004",
		"La Candelaria": "0004",
		"La Providencia": "0004",
		Lican: "0004",
		Licto: "0004",
		Llagos: "0004",
		Matus: "0004",
		Multitud: "0004",
		Pallatanga: "0004",
		Palmira: "0004",
		Penipe: "0004",
		"Pistishi (Nariz del Diablo)": "0004",
		Puela: "0004",
		Pumallacta: "0004",
		Pungala: "0004",
		Punin: "0004",
		Quimiag: "0004",
		Riobamba: "0004",
		"San Andres": "0004",
		"San Antonio de Bayushig": "0004",
		"San Gerardo de Pacalcaguan": "0004",
		"San Isidro de Patulu": "0004",
		"San Jose del Chazo": "0004",
		"San Juan": "0004",
		"San Luis": "0004",
		"Santa Fe de Galan": "0004",
		"Santiago de Quito": "0004",
		Sevilla: "0004",
		Sibambe: "0004",
		Tixan: "0004",
		Valparaiso: "0004",
		Yaruquies: "0004"
	},
	Cotopaxi: {
		"11 de Noviembre (Ilinchisi)": "0005",
		"Alaques (Alaquez)": "0005",
		Anchilivi: "0005",
		Angamarca: "0005",
		"Antonio Jose Holquin (Santa Lucia)": "0005",
		"Belisario Quevedo": "0005",
		Canchagua: "0005",
		Chipualo: "0005",
		Cusubamba: "0005",
		"El corazon": "0005",
		Guaytacama: "0005",
		Guangaje: "0005",
		"Guasaganda (Cab. en Guasaganda Centro)": "0005",
		Isinlivi: "0005",
		"Joseguango Bajo": "0005",
		"La Mana": "0005",
		"Las Pampas": "0005",
		"La Victoria": "0005",
		Lasso: "0005",
		Latacunga: "0005",
		Moraspungo: "0005",
		Mulalao: "0005",
		Mulalillo: "0005",
		"Palo Quemado": "0005",
		Pangua: "0005",
		Panzaleo: "0005",
		Pastocalle: "0005",
		Patain: "0005",
		Pilalo: "0005",
		Pinllopata: "0005",
		Poalo: "0005",
		Pucayacu: "0005",
		Pujili: "0005",
		"Ramon Campaña": "0005",
		Rumipamba: "0005",
		Salcedo: "0005",
		"San Marcos": "0005",
		"San Miguel": "0005",
		"San Juan de Pastocalle": "0005",
		"Santa Ana": "0005",
		Saquisili: "0005",
		Sigchos: "0005",
		Tanicuchi: "0005",
		Tingo: "0005",
		Toacaso: "0005",
		Yanayacu: "0005",
		Zumbahua: "0005"
	},
	"El Oro": {
		"3 Cerritos": "0006",
		"Abañin": "0006",
		Arcapamba: "0006",
		Arenillas: "0006",
		Atahualpa: "0006",
		Ayapamba: "0006",
		"Bajo Alto": "0006",
		Barbones: "0006",
		Balsas: "0006",
		Bellamaria: "0006",
		Bellavista: "0006",
		"Buena Vista": "0006",
		"Caña Quemada": "0006",
		"Capiro (Cab en La Capilla de Capiro)": "0006",
		Carcabon: "0006",
		Casacay: "0006",
		Chacras: "0006",
		Chilla: "0006",
		Cordoncillo: "0006",
		Curtincapa: "0006",
		"El Cambio": "0006",
		"El Guabo": "0006",
		"El Ingenio": "0006",
		"El Pache": "0006",
		"El Paraiso": "0006",
		"El Porton": "0006",
		"El Retiro": "0006",
		Guanazan: "0006",
		"Guizhaguiña": "0006",
		Huaquillas: "0006",
		Huertas: "0006",
		Jambeli: "0006",
		"La Avanzada": "0006",
		"La Bocana": "0006",
		"La Iberia": "0006",
		"Las Lajas": "0006",
		"La Peaña": "0006",
		"La Victoria": "0006",
		"Loma De Franco": "0006",
		Lourdes: "0006",
		Machala: "0006",
		Malvas: "0006",
		Marcabeli: "0006",
		Morales: "0006",
		"Moromoro (Cab. en el Vado)": "0006",
		Muluncay: "0006",
		"Nuevo Puente Internacional Cebef": "0006",
		Paccha: "0006",
		Palmales: "0006",
		Pasaje: "0006",
		Piedras: "0006",
		"Piñas": "0006",
		Portovelo: "0006",
		Progreso: "0006",
		"Puerto Bolivar": "0006",
		"Puerto Hualtaco": "0006",
		"Puerto Jeli": "0006",
		"Rio Bonito": "0006",
		Salatis: "0006",
		Salvias: "0006",
		"San Antonio": "0006",
		"San Isidro": "0006",
		"San Jose": "0006",
		"San Juan de Cerro Azul": "0006",
		"San Roque (Ambrosio Maldonado)": "0006",
		"San Vicente Del Jobo": "0006",
		"Santa Rosa": "0006",
		Saracay: "0006",
		Sinsao: "0006",
		Shumiral: "0006",
		"Tendales (Cab. en Puerto Tendales)": "0006",
		Torata: "0006",
		Uzhcurrumi: "0006",
		Victoria: "0006",
		Zaruma: "0006"
	},
	Esmeraldas: {
		"5 de Junio (Cab. en Uimbi)": "0007",
		"Alto Tambo (Cab. en Guandual": "0007",
		Anchayacu: "0007",
		"Ancon (Pichangal)(Cab. en Palma Real)": "0007",
		Atacames: "0007",
		"Atahualpa (Cab. en Camarones)": "0007",
		Borbon: "0007",
		Calderon: "0007",
		"Camarones (Cab. en San Vicente)": "0007",
		Carondelet: "0007",
		Chinca: "0007",
		Chontaduro: "0007",
		Chumunde: "0007",
		"Chura (Chancama)(Cab. en el Yerbero)": "0007",
		"Colon Eloy del Maria": "0007",
		Concepcion: "0007",
		"Crnel. Carlos Concha Torres (Cab. en Huele)": "0007",
		Cube: "0007",
		"Eloy Alfaro": "0007",
		Esmeraldas: "0007",
		Galera: "0007",
		"La Concordia": "0007",
		"La Independencia": "0007",
		"La Tola": "0007",
		"La Union (Quininde)": "0007",
		"La Y De Calderon": "0007",
		Lagarto: "0007",
		"Las Peñas ": "0007",
		"Luis Vargas Torres (Cab. en Playa de Oro)": "0007",
		Majua: "0007",
		Maldonado: "0007",
		Malimpia: "0007",
		"Mataje (Cab. en Santander)": "0007",
		"Montalvo (Cab. en Horqueta)": "0007",
		Muisne: "0007",
		"Pampanal de Bolivar": "0007",
		"Quingue (Olmedo Perdomo Franco)": "0007",
		Quininde: "0007",
		"Rio Verde": "0007",
		Salima: "0007",
		Same: "0007",
		"San Francisco": "0007",
		"San Francisco de Onzole": "0007",
		"San Gregorio": "0007",
		"San Javier de Cayapas (Cab. en San Javier)": "0007",
		"San Jose de Cayapas": "0007",
		"San Jose de Chamanga (Cab. en Chamanga)": "0007",
		"San Mateo": "0007",
		"Santa Rita": "0007",
		"Santo Domingo de Onzole": "0007",
		"Selva Alegre": "0007",
		Sua: "0007",
		Tabiazo: "0007",
		Tachina: "0007",
		Tambillo: "0007",
		Telembi: "0007",
		Timbire: "0007",
		Tonchigue: "0007",
		Tonsupa: "0007",
		"Tululbi (cab. en Ricaurte)": "0007",
		Urbina: "0007",
		"Valdez (Limones)": "0007",
		Viche: "0007",
		"Vuelta Larga": "0007",
		"San Lorenzo": "0007"
	},
	Galapagos: {
		Bellavista: "0008",
		"El Progreso": "0008",
		Isabela: "0008",
		"Isla Santa Maria (Floreana)(Cab. en Pto. Velasco Ibarra)": "0008",
		"Puerto Ayora": "0008",
		"Puerto Baquerizo Moreno": "0008",
		"Puerto Villamil": "0008",
		"San Cristobal": "0008",
		"Santa Rosa (Incluye La Isla Baltra)": "0008",
		"Santa Cruz": "0008",
		"Tomas de Berlanga (Santo Tomas)": "0008"
	},
	Guayas: {
		"3 Postes": "0009",
		"A. Baquerizo Moreno - Jujan": "0009",
		Balao: "0009",
		"Balao Chico": "0009",
		Balzar: "0009",
		"Base Taura": "0009",
		"Boca De Caña": "0009",
		Boliche: "0009",
		Bucay: "0009",
		Cerecita: "0009",
		Chiveria: "0009",
		Chobo: "0009",
		Chongon: "0009",
		"Cien Familia": "0009",
		Colimes: "0009",
		Coloradal: "0009",
		"Coronel Marcelino Maridueña (San Carlos)": "0009",
		Cumanda: "0009",
		Daule: "0009",
		"Data De Playas": "0009",
		Duran: "0009",
		"El Deseo": "0009",
		"El Empalme": "0009",
		"El Morro": "0009",
		"El Nato": "0009",
		"El Rosario": "0009",
		"El Salitre (Las Ramas)": "0009",
		"El Triunfo": "0009",
		"Eloy Alfaro - Duran": "0009",
		Engabao: "0009",
		"General Vernaza": "0009",
		"General Villamil (Playas)": "0009",
		Guayaquil: "0009",
		"Guayas (Pueblo Nuevo)": "0009",
		"Ingenio San Carlos": "0009",
		"Isidro Ayora": "0009",
		"Jesus Maria": "0009",
		Jujan: "0009",
		Junquillal: "0009",
		"Km 26 - Virgen De Fatima": "0009",
		"La Maravilla": "0009",
		"La Puntilla": "0009",
		"La T De Salitre": "0009",
		"La Toma": "0009",
		"La Victoria (Ñauza)": "0009",
		"Las Animas": "0009",
		"Las Mercedes (Naranjal)": "0009",
		Laurel: "0009",
		Limonal: "0009",
		"Lomas De Sargentillo": "0009",
		"Lorenzo De Garaicoa": "0009",
		"Los Lojas (Enrique Baquerizo Moreno)": "0009",
		"Los Tintos": "0009",
		"Manuel J Calle": "0009",
		"Marcelino Mariduena": "0009",
		"Mariscal Sucre (Huaques)": "0009",
		"Matilde Esther": "0009",
		"Narcisa de Jesus": "0009",
		"Nueva Union": "0009",
		Milagro: "0009",
		Morro: "0009",
		Naranjal: "0009",
		Naranjito: "0009",
		Nobol: "0009",
		Palestina: "0009",
		Pascuales: "0009",
		"Pedro Carbo": "0009",
		Petrillo: "0009",
		Playas: "0009",
		Posorja: "0009",
		Progreso: "0009",
		"Puente Lucia": "0009",
		"Puerto Del Engabao": "0009",
		"Puerto Inca": "0009",
		Puna: "0009",
		"Roberto Astudillo": "0009",
		Sabanilla: "0009",
		"Salitre - Urbina Jado": "0009",
		Samborondon: "0009",
		"San Antonio (Playas)": "0009",
		"San Carlos (Balao)": "0009",
		"San Isidro": "0009",
		"San Jacinto": "0009",
		"San Jacinto De Yaguachi": "0009",
		"Santa Lucia": "0009",
		"Santa Rita (Balao)": "0009",
		"Santa Rosa de Flandes": "0009",
		"Simon Bolivar": "0009",
		Tarifa: "0009",
		Taura: "0009",
		Tenguel: "0009",
		"Urbina Jado - Salitre": "0009",
		"Valle de La Virgen": "0009",
		"Velasco Ibarra (El Empalme)": "0009",
		"Villa Nueva": "0009",
		"Virgen De Fatima Km 26": "0009",
		Yaguachi: "0009",
		"Yaguachi Viejo (Cone)": "0009"
	},
	Imbabura: {
		"6 de Julio de Caellaje (Cab. en Cuellaje)": "0010",
		Aduana: "0010",
		Alpachaca: "0010",
		Ambuqui: "0010",
		"Andrade Marin": "0010",
		Angochagua: "0010",
		"Antonio Ante": "0010",
		Apuela: "0010",
		Atuntaqui: "0010",
		Cahuasqui: "0010",
		Caranqui: "0010",
		Carolina: "0010",
		Chaltura: "0010",
		Chorlavi: "0010",
		Chuga: "0010",
		Cotacachi: "0010",
		"Dr. Miguel Egas Cabezas (Peguche)": "0010",
		"El Olivo": "0010",
		"El Retorno": "0010",
		"Garcia Moreno (Llurimagua)": "0010",
		"Gonzalez Suarez": "0010",
		Ibarra: "0010",
		Imantag: "0010",
		"Imabya (San Luis de Cobuendo)": "0010",
		"La Esperanza": "0010",
		"La Merced de buenos Aires": "0010",
		Lita: "0010",
		"Mariano Acosta": "0010",
		Natabuela: "0010",
		Otavalo: "0010",
		"Pablo Arenas": "0010",
		Pataqui: "0010",
		"Peñaherrera": "0010",
		Pimampiro: "0010",
		Pinsaqui: "0010",
		"Plaza Gutierrez": "0010",
		"Puerto Lago": "0010",
		Quiroga: "0010",
		"San Antonio": "0010",
		"San Antonio De Ibarra": "0010",
		"San Blas": "0010",
		"San Francisco de Natabuela": "0010",
		"San Francisco de Sigsipamba": "0010",
		"San Jose": "0010",
		"San Jose de Chaltura": "0010",
		"San Jose de Quichinche": "0010",
		"San Juan de Iluman": "0010",
		"San Luis (Imbabura)": "0010",
		"San Miguel de Ibarra": "0010",
		"San Miguel De Urcuqui": "0010",
		"San Pablo": "0010",
		"San Pablo Del Lago": "0010",
		"San Rafael": "0010",
		"San Roque": "0010",
		"Santo Domingo Imbabura": "0010",
		"Selva Alegre": "0010",
		Tumbabiro: "0010",
		Urcuqui: "0010",
		"vacas Galindo (El Churo)(Cab. en San Miguel Alto)": "0010",
		Yachai: "0010",
		Yaguarcocha: "0010"
	},
	Loja: {
		"12 de Diciembre (Cab. en Achiotes)": "0011",
		"27 de Abril (Cab. en La Naranja": "0011",
		Alamor: "0011",
		Amaluza: "0011",
		Amarillos: "0011",
		Bellavista: "0011",
		Bolaspamba: "0011",
		Buenavista: "0011",
		Calvas: "0011",
		Cangonama: "0011",
		Cariamanga: "0011",
		Casanga: "0011",
		Catacocha: "0011",
		"Catamayo (La Toma)": "0011",
		"Cazaderos (Cab. en Mangaurco)": "0011",
		Celica: "0011",
		"Changaimina (La Libertad)": "0011",
		Chaguarpamba: "0011",
		Chantaco: "0011",
		Chaquinal: "0011",
		Chuquiribamba: "0011",
		Ciano: "0011",
		Colaisaca: "0011",
		"Cruzpamba (Cab. en Carlos Bustamante": "0011",
		"El Airo": "0011",
		"El Arenal": "0011",
		"El Cisne": "0011",
		"El Igenio": "0011",
		"El Limo (Mariana de Jesus)": "0011",
		"El Lucero": "0011",
		"El Paraiso de Celen": "0011",
		"El Rosario": "0011",
		"El Tablon": "0011",
		Espindola: "0011",
		Fundochamba: "0011",
		Garzareal: "0011",
		Gonzanama: "0011",
		Guachanama: "0011",
		Gualel: "0011",
		Jimbilla: "0011",
		Jimbura: "0011",
		"La Tingue": "0011",
		"La Victoria": "0011",
		Larama: "0011",
		"Lauro Guerrero": "0011",
		Limones: "0011",
		Loja: "0011",
		Lluzhapa: "0011",
		Macara: "0011",
		Malacatos: "0011",
		Manu: "0011",
		Mercadillo: "0011",
		Nambacola: "0011",
		"Nueva Fatima": "0011",
		Olmedo: "0011",
		Orianga: "0011",
		Paletillas: "0011",
		Paltas: "0011",
		Pindal: "0011",
		Pozul: "0011",
		Purunuma: "0011",
		Puyango: "0011",
		Quilanga: "0011",
		Quinara: "0011",
		Sabanilla: "0011",
		"Sabiango (La Capilla)": "0011",
		Sacapalca: "0011",
		"San Antonio": "0011",
		"San Antonio de Las Aradas (Cab. en Las Aradas)": "0011",
		"San Antonio de Qumbe (Cume)": "0011",
		"San Lucas": "0011",
		"San Pablo de Tenta": "0011",
		"San Pedro de La Bendita": "0011",
		"San Pedro de Vilcabamba": "0011",
		"San Sebastian de Yuluc": "0011",
		Sanguillin: "0011",
		"Santa Rufina": "0011",
		"Santa Teresina": "0011",
		Santiago: "0011",
		Saraguro: "0011",
		Sozoranga: "0011",
		"Selva Alegre": "0011",
		Sumaypamba: "0011",
		Tacamoros: "0011",
		"Taquil (Miguel Riofrio)": "0011",
		"Tnte Maximiliano Rodriguez Loaiza": "0011",
		"Urdaneta (Paquishapa)": "0011",
		Utuana: "0011",
		Vicentino: "0011",
		Vilcabamba: "0011",
		Yamana: "0011",
		"Yangana (Arsenio Castillo)": "0011",
		Zambi: "0011",
		Zapotillo: "0011"
	},
	"Los Rios": {
		"Antonio Sotomayor (Cab. en Playas de Vinces)": "0012",
		Baba: "0012",
		Babahoyo: "0012",
		"Buena Fe": "0012",
		Caracol: "0012",
		Catarama: "0012",
		Echeandia: "0012",
		"Entrada De San Juan": "0012",
		"Febres Cordero (Las Juntas)(Cab. en Mata de Cacao)": "0012",
		Fumisa: "0012",
		Guare: "0012",
		Hidrolitoral: "0012",
		"Isla De Bejucal": "0012",
		"La 14 Via El Paraiso": "0012",
		"La Esperanza": "0012",
		"La Julia": "0012",
		"La Union": "0012",
		"La Union (Babahoyo)": "0012",
		"La Union (Valencia)": "0012",
		"Las Naves": "0012",
		"Los Angeles - Recinto": "0012",
		"Mata De Cacao": "0012",
		Mocache: "0012",
		Montalvo: "0012",
		"Nueva Union (Los Rios)": "0012",
		Palenque: "0012",
		Palmisa: "0012",
		"Patricia Pilar": "0012",
		Pimocha: "0012",
		"Pueblo Nuevo (Los Rios)": "0012",
		Puebloviejo: "0012",
		"Puerto Pechiche": "0012",
		Quevedo: "0012",
		Quinsaloma: "0012",
		Ricaurte: "0012",
		"San Camilo": "0012",
		"San Carlos": "0012",
		"San Jacinto de Buena Fe": "0012",
		"San Juan": "0012",
		"San Luis De Pambil": "0012",
		Urdaneta: "0012",
		Valencia: "0012",
		Ventanas: "0012",
		Vinces: "0012",
		Zapotal: "0012",
		Zulema: "0012"
	},
	Manabi: {
		"10 De Agosto": "0013",
		"24 De Mayo": "0013",
		"Abdon Calderon (San Francisco)": "0013",
		"Alhajuela (Bajo Grande)": "0013",
		America: "0013",
		Arenales: "0013",
		"Arq. Sixto Duran Ballen": "0013",
		"Atahualpa Manabi": "0013",
		Ayacucho: "0013",
		Bachillero: "0013",
		"Bahia De Caraquez": "0013",
		Barraganete: "0013",
		Bellavista: "0013",
		Bolivar: "0013",
		Boyaca: "0013",
		Calceta: "0013",
		Calderon: "0013",
		"Campozano (La Palma de Pajan)": "0013",
		Canoa: "0013",
		Canuto: "0013",
		"Cañitas": "0013",
		Cascol: "0013",
		Charapoto: "0013",
		Cheven: "0013",
		Chibunga: "0013",
		Chirijos: "0013",
		Chone: "0013",
		"Ciudad Alfaro": "0013",
		Coaque: "0013",
		Cojimies: "0013",
		Colon: "0013",
		Colorado: "0013",
		Convento: "0013",
		Crucita: "0013",
		"Don Juan": "0013",
		"El Anegado (Cab. en Eloy Alfaro)": "0013",
		"El Carmen": "0013",
		"El Matal": "0013",
		"El Rodeo": "0013",
		"Flavio Alfaro": "0013",
		Guale: "0013",
		"Honorato Vasquez (Cab. en Vasquez)": "0013",
		Jama: "0013",
		Jaramijo: "0013",
		Jipijapa: "0013",
		Junin: "0013",
		Julcuy: "0013",
		"La Chorrera": "0013",
		"La Estancilla": "0013",
		"La Pila": "0013",
		Lascano: "0013",
		"Leonidas Plaza": "0013",
		Lodana: "0013",
		"Los Bajos": "0013",
		Machalilla: "0013",
		Mache: "0013",
		Manta: "0013",
		Membrillal: "0013",
		Membrillo: "0013",
		Montecristi: "0013",
		Noboa: "0013",
		"Nuevo Briceño": "0013",
		Olmedo: "0013",
		Pajan: "0013",
		Pedernales: "0013",
		"Pedro Pablo Gomez": "0013",
		Pichincha: "0013",
		"Playa Prieta": "0013",
		Portoviejo: "0013",
		"Pueblo Nuevos": "0013",
		"Puerto de Cayo": "0013",
		"Puerto Lopez": "0013",
		Quiroga: "0013",
		Ricaurte: "0013",
		"Rio Chico": "0013",
		Rocafuerte: "0013",
		Salango: "0013",
		"San Antonio": "0013",
		"San Clemente": "0013",
		"San Francisco de Novillo (Cab. en Novillo)": "0013",
		"San Isidro": "0013",
		"San Jacinto": "0013",
		"San Pablo (Cab. en Pueblo Nuevo)": "0013",
		"San Pedro de Suma": "0013",
		"San Placido": "0013",
		"San Sebastian": "0013",
		"San Vicente": "0013",
		Sancan: "0013",
		"Santa Ana": "0013",
		"Santa Ana de Vuelta Larga": "0013",
		"Santa Marianita (Boca de Pacoche)": "0013",
		Sosote: "0013",
		Sucre: "0013",
		Tarqui: "0013",
		Tosagua: "0013",
		"Wilfrido Loor Moreira (Maicito)": "0013",
		Zapallo: "0013"
	},
	"Morona Santiago": {
		"16 de Agosto": "0014",
		"Alshi (Cab. en 9 de Octobre)": "0014",
		"Amazonas (Rosario de Cuyes)": "0014",
		Arapicos: "0014",
		Asuncion: "0014",
		Bermejos: "0014",
		Bomboiza: "0014",
		"Chigñinda": "0014",
		Chiguaza: "0014",
		Chupianza: "0014",
		Copal: "0014",
		Cuchaentza: "0014",
		"Cumanda (Cab. en Colonia Agricola Sevilla del Oro)": "0014",
		"El Ideal": "0014",
		"El Rosario": "0014",
		"General Leonidas Plaza Gutierreza (limon)": "0014",
		"General Proaño": "0014",
		Gualaquiza: "0014",
		Huambi: "0014",
		Huamboya: "0014",
		"Huasaga (Cab. en Wampuik)": "0014",
		Indanza: "0014",
		"Limon - Indanza": "0014",
		"Logroño": "0014",
		Macas: "0014",
		Macuma: "0014",
		Mendez: "0014",
		Morona: "0014",
		"Nueva Tarqui": "0014",
		"Pablo Sexto": "0014",
		"Pablo VI": "0014",
		Palora: "0014",
		"Palora (Metzera)": "0014",
		"Pan de Azucar": "0014",
		Patuca: "0014",
		Pumpuentsa: "0014",
		"Rio Blanco": "0014",
		"San Antonio (Cab. en San Antonio Centro)": "0014",
		"San Carlos de Limon": "0014",
		"San Francisco de Chinimbimi": "0014",
		"San Isisdro": "0014",
		"San Jacinto de Wakambeis": "0014",
		"San Jose de Morona": "0014",
		"San Juan Bosco": "0014",
		"San Luis de El Acho (Cab. en El Acho)": "0014",
		"San Miguel de Conchay": "0014",
		"San Miguel de Cuyes": "0014",
		"Sangay (Cab. en Nayamanaca)": "0014",
		"Santa Marianita de Jesus": "0014",
		"Santa Susana de Chiviaza (Cab. en Chiviaza)": "0014",
		Santiago: "0014",
		"Santiago de Pananza": "0014",
		"Sevilla Don Bosco": "0014",
		Shimpis: "0014",
		Sinai: "0014",
		Sucua: "0014",
		Taisha: "0014",
		Tayuza: "0014",
		Tiwintza: "0014",
		Tuutinentza: "0014",
		Yaupi: "0014",
		"Yunganza (Cab. en EL Rosario)": "0014",
		"Zuña (Zuñac)": "0014"
	},
	Napo: {
		Ahuano: "0015",
		"Arosemena Tola": "0015",
		Archidona: "0015",
		Baeza: "0015",
		Borja: "0015",
		"Carlos Julio Arosemena": "0015",
		"Carlos Julio Arosemena Tola": "0015",
		Chontapunta: "0015",
		Cosanga: "0015",
		Cotundo: "0015",
		"El Chaco": "0015",
		"Gonzalo Pizarro": "0015",
		"Gonzalez Diaz de Pineda (El Bombon)": "0015",
		Linares: "0015",
		Loreto: "0015",
		"Nueva Esperanza": "0015",
		Oyacachi: "0015",
		Pano: "0015",
		Papallacta: "0015",
		"Puerto Misahualli": "0015",
		"Puerto Napo": "0015",
		Quijos: "0015",
		"San Pablo de Ushpayacu": "0015",
		Sardinas: "0015",
		Sumaco: "0015",
		Talag: "0015",
		Tazayacu: "0015",
		Tena: "0015"
	},
	Orellana: {
		"Alejandro Labaka": "0016",
		"Avila (Cab. en Huiruno)": "0016",
		Aguarico: "0016",
		"Captan Augusto Rivadeneyra": "0016",
		Cononaco: "0016",
		Dayuma: "0016",
		"El Coca - Francisco De Orellana": "0016",
		"El Dorado": "0016",
		"El Eden": "0016",
		Enocanqui: "0016",
		"Garcia Moreno": "0016",
		"Ines Arango (Cab. en Western)": "0016",
		"La Belleza": "0016",
		"La Joya De Los Sachas": "0016",
		"Lago San Pedro": "0016",
		Loreto: "0016",
		"Nuevo Paraiso (Cab. en Unión Chimborazo)": "0016",
		"Nuevo Rocafuerte": "0016",
		Orellana: "0016",
		Pompeya: "0016",
		"Puerto Francisco de Orellana": "0016",
		"Puerto Murialdo": "0016",
		Rumipamba: "0016",
		"San Carlos": "0016",
		"San Jose de Dahuano": "0016",
		"San Jose de Guayusa": "0016",
		"San Jose de Payamino": "0016",
		"San Luis de Armenia": "0016",
		"San Sebastian del Coca": "0016",
		"San Vicente de Huaticocha": "0016",
		"Santa Maria de Huirima": "0016",
		"Taracoa (Cab. en Nueva Esperanza: Yuca)": "0016",
		Tiputini: "0016",
		"Tres de Noviembre": "0016",
		"Union Milagreña": "0016",
		Yasuni: "0016"
	},
	Pastaza: {
		Arajuno: "0017",
		Canelo: "0017",
		Curaray: "0017",
		"Diez de Agosto": "0017",
		Fatima: "0017",
		"Madre Tierra": "0017",
		Mera: "0017",
		"Montalvo (Andoas)": "0017",
		Pastaza: "0017",
		Pomona: "0017",
		Puyo: "0017",
		"Rio Corrientes": "0017",
		"Rio Tigre": "0017",
		"Santa Clara": "0017",
		"San Jose": "0017",
		Sarayacu: "0017",
		"Shell (El Puyo)": "0017",
		"Simon Bolivar": "0017",
		Tarqui: "0017",
		"Teninete Hugo Ortiz": "0017",
		"Veracruz (Indillama)(Cab. En Inidillama)": "0017"
	},
	Pichincha: {
		"Alangasí": "0018",
		Aloag: "0018",
		Aloasi: "0018",
		"Amaguaña": "0018",
		Ascazubi: "0018",
		"Atahualpa (Habaspamba)": "0018",
		Ayora: "0018",
		Calacali: "0018",
		"Calderon (Carapungo)": "0018",
		Cangahua: "0018",
		Chavezpamba: "0018",
		"Checa (Chilpa)": "0018",
		Cayambe: "0018",
		Conocoto: "0018",
		Cotogchoa: "0018",
		"Cumbayá": "0018",
		Cutuglahua: "0018",
		"El Chaupi": "0018",
		"El Quinche": "0018",
		Guachala: "0018",
		Gualea: "0018",
		Guangopolo: "0018",
		Guayllabamba: "0018",
		"Juan Montalvo": "0018",
		"La Esperanza": "0018",
		"La Merced": "0018",
		"Llano Chico": "0018",
		Lloa: "0018",
		Machachi: "0018",
		Malchingui: "0018",
		"Manuel Cornejo Astorga (Tandapi)": "0018",
		Mejia: "0018",
		Mindo: "0018",
		Nanegal: "0018",
		Nanegalito: "0018",
		Nayo: "0018",
		Nono: "0018",
		"Mitad del Mundo": "0018",
		"Olmedo (Pesillo)": "0018",
		Oton: "0018",
		Pacto: "0018",
		"Pedro Moncayo": "0018",
		"Pedro Vicente Maldonado": "0018",
		Perucho: "0018",
		Pomasqui: "0018",
		Puellaro: "0018",
		"Puerto Quito": "0018",
		Pifo: "0018",
		Pintag: "0018",
		Puembo: "0018",
		Quito: "0018",
		Ruminahui: "0018",
		Rumipamba: "0018",
		"San Antonio": "0018",
		"San Jose de Minas": "0018",
		"San Miguel De Los Bancos": "0018",
		"San Rafael": "0018",
		"Santa Rosa de Cuzubamba": "0018",
		Sangolqui: "0018",
		Tababela: "0018",
		Tabacundo: "0018",
		Tambillo: "0018",
		Tocachi: "0018",
		Tupigachi: "0018",
		Tumbaco: "0018",
		Uyumbicho: "0018",
		"Yaruquí": "0018",
		Zambiza: "0018"
	},
	"Santa Elena": {
		Ancon: "0019",
		Anconcito: "0019",
		Atahualpa: "0019",
		Ballenita: "0019",
		Cadeate: "0019",
		Capaes: "0019",
		Chanduy: "0019",
		Colonche: "0019",
		"El Tambo": "0019",
		"Jambeli Monteverde": "0019",
		"La Libertad": "0019",
		"Libertador Bolivar": "0019",
		Manglaralto: "0019",
		"Montañita": "0019",
		"Monteverde - Jambeli": "0019",
		Muey: "0019",
		Olon: "0019",
		Palmar: "0019",
		Prosperidad: "0019",
		"Punta Barandua": "0019",
		"Punta Blanca": "0019",
		"Punta Carnero": "0019",
		"Punta Centinela": "0019",
		Salinas: "0019",
		"San Jose de Ancon": "0019",
		"San Pablo": "0019",
		"San Pedro": "0019",
		"Santa Elena": "0019",
		"Santa Rosa": "0019",
		"Simon Bolivar (Julio Moreno)": "0019",
		Valdivia: "0019"
	},
	"Santo Domingo De Los Tsachilas": {
		Alluriquin: "0020",
		"El Esfuerzo": "0020",
		"Km 14-Quevedo": "0020",
		"Km 24-Quevedo": "0020",
		"Km 38.5 Via Quevedo": "0020",
		"Km 41 Via Quevedo": "0020",
		"La concordia": "0020",
		"Las Delicias": "0020",
		"Luz De America": "0020",
		"Nuevo Israel": "0020",
		"Puerto Limon": "0020",
		"San Jacinto Del Bua": "0020",
		"Santa Maria del Toachi": "0020",
		"Santo Domingo": "0020",
		"Santo Domingo de los Colorados": "0020",
		"Valle Hermoso": "0020"
	},
	Sucumbios: {
		"7 De Julio": "0021",
		"Aguas Negras": "0021",
		Cascales: "0021",
		Cuyabeno: "0021",
		Dureno: "0021",
		"El Dorado de Cascales": "0021",
		"El Eno": "0021",
		"El Payion de San Francisco": "0021",
		"General Farfan": "0021",
		"Gonzalo Pizarro": "0021",
		Jambeli: "0021",
		"Jivino Verde": "0021",
		"La Bonita": "0021",
		"La Sofia": "0021",
		"Lago Agrio": "0021",
		Limoncocha: "0021",
		"Los Rios": "0021",
		Lumbaqui: "0021",
		"Nueva Loja": "0021",
		Pacayacu: "0021",
		"Palma Roja": "0021",
		"Pañacocha": "0021",
		"Puerto Bolivar (Puerto Montufar)": "0021",
		"Puerto El Carmen del Putumayo": "0021",
		"Puerto Libre": "0021",
		"Puerto Rodriguez": "0021",
		Putumayo: "0021",
		Reventador: "0021",
		"Rosa Florida": "0021",
		"San Pedro de los Cofanes": "0021",
		"San Roque (Cab. en San Vicente)": "0021",
		"Santa Barbara": "0021",
		"Santa Cecilia": "0021",
		"Santa Rosa de Sucumbios": "0021",
		Sevilla: "0021",
		Shushufindi: "0021",
		Sucumbios: "0021",
		Tarapoa: "0021"
	},
	Tungurahua: {
		Ambato: "0022",
		"Atahualpa (Chisalata)": "0022",
		"Augusto N. Martinez (Mundugleo)": "0022",
		"Banos De Agua Santa": "0022",
		"Baquerizo Moreno": "0022",
		"Betinez (Pachanlica)": "0022",
		Cevallos: "0022",
		"Chiquicha (Cab. en Chiquicha Grande)": "0022",
		"Constantino Fernandez (Cab. en Cullitahua)": "0022",
		Cotalo: "0022",
		Cunchibamba: "0022",
		"El Rosario (Rumichaca)": "0022",
		"Emilio Maria Teran (Rumipamba)": "0022",
		"Garcia Moreno (Chumaqui)": "0022",
		"Huachi Grande": "0022",
		Huambalo: "0022",
		Izamba: "0022",
		"Juan Benigno Vela": "0022",
		Lligua: "0022",
		"Los Andes (Cab. en Poatug)": "0022",
		"Marcos Espinel (Chacata)": "0022",
		Mocha: "0022",
		Pasa: "0022",
		Patate: "0022",
		Pelileo: "0022",
		Picaigua: "0022",
		"Pilagñin (Pilahñin)": "0022",
		Pillaro: "0022",
		Pinguili: "0022",
		"Presidente Urbina (Chagrapamba-Patzucul)": "0022",
		Quero: "0022",
		Quinchicoto: "0022",
		"Quisapincha (Quizapincha)": "0022",
		"Rio Negro": "0022",
		"Rio Verde": "0022",
		Rumipamba: "0022",
		Salasaca: "0022",
		"San Andres": "0022",
		"San Bartolome de Pinllog": "0022",
		"San Fernando (Pasa San Fernando)": "0022",
		"San Jose de Paolo": "0022",
		"San Miguelito": "0022",
		"San Pedro De Pelileo": "0022",
		"Santa Rosa (Ambato)": "0022",
		"Santiago De Pillaro": "0022",
		"Sucre (Cab. en Sucre-Patate Urcu)": "0022",
		Tisaleo: "0022",
		Totoras: "0022",
		Ulba: "0022",
		Unamuncho: "0022",
		"Yanayacu - Mochapata (Cab. en Yanayacu)": "0022"
	},
	"Zamora Chinchipe": {
		"28 de Mayo (San Jose de Yacuambi)": "0023",
		Bellavista: "0023",
		"Chicaña": "0023",
		"Centinela Del Condor": "0023",
		Chito: "0023",
		Chinchipe: "0023",
		Cumbaratza: "0023",
		"El Chorro": "0023",
		"El Guisme": "0023",
		"El Pangui": "0023",
		"El Porvenir del Carmen": "0023",
		Guadalupe: "0023",
		Guayzimi: "0023",
		"Imbana (La Victoria de Imbana)": "0023",
		"La Canela": "0023",
		"La Chonta": "0023",
		"La Paz": "0023",
		"Los Encuentros": "0023",
		Nagaritza: "0023",
		"Nuevo Paraiso": "0023",
		"Nuevo Quito": "0023",
		Pachicutza: "0023",
		Palanda: "0023",
		Paquisha: "0023",
		Pucapamba: "0023",
		Sabanilla: "0023",
		"San Andres": "0023",
		"San Carlos de las Minas": "0023",
		"San Francisco del Vergel": "0023",
		Timbara: "0023",
		Tundayme: "0023",
		Tutupali: "0023",
		Valladolid: "0023",
		Yacuambi: "0023",
		Yantzaza: "0023",
		"Yanrzaza (Yanzatza)": "0023",
		Zamora: "0023",
		Zumba: "0023",
		Zumbi: "0023",
		Zurmi: "0023"
	}
};

const phoneCountryCode$b = '593';
const phoneRegex$b = /^(?:(?:(?:\+|)593)|)(?:0|)(?:(?:(?:[234567])\d{7})|(?:9\d{8}))$/;
const areaCodeStartChar$7 = '';
const areaCodeEndChar$7 = '';
const areaCodeSeparator$b = ' ';
const phoneSeparator$a = ' ';

const unformatPhone$b = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$b}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 9 && phone.startsWith(phoneCountryCode$b)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$b = phone => {
  phone = unformatPhone$b(phone);

  if (phone.length === 8) {
    return areaCodeStartChar$7 + phone.substring(0, 1) + areaCodeEndChar$7 + areaCodeSeparator$b + phone.substring(1, 4) + phoneSeparator$a + phone.substring(4);
  }

  if (phone.length === 9 && phone[0] === '9') {
    return areaCodeStartChar$7 + phone.substring(0, 2) + areaCodeEndChar$7 + areaCodeSeparator$b + phone.substring(2, 5) + phoneSeparator$a + phone.substring(5);
  }

  return phone;
};

const validatePhone$b = phone => {
  phone = unformatPhone$b(phone);
  return phoneRegex$b.test(phone);
};

const unformatPersonalId = personalId => {
  if (!personalId || typeof personalId !== 'string') return '';
  personalId = personalId.replace(/^[^0-3,5]/g, '');
  personalId = personalId.replace(/[^\d]+/g, '');
  return personalId;
};

const formatPersonalId = personalId => {
  if (!personalId) return '';
  personalId = unformatPersonalId(personalId);
  return personalId;
};

const validatePersonalId = personalId => {
  if (personalId.length === 10) {
    const digits = personalId.split('').map(Number);
    const provinceCode = digits[0] * 10 + digits[1];

    if (provinceCode >= 1 && (provinceCode <= 24 || provinceCode === 30 || provinceCode === 50)) {
      const verifDigit = digits.pop();
      const calcDigit = digits.reduce((prevValue, currentValue, index) => {
        return prevValue - currentValue * (2 - index % 2) % 9 - Number(currentValue === 9) * 9;
      }, 1000) % 10;
      return calcDigit === verifDigit;
    }
  }

  return false;
};

const unformatCorporateId$2 = corporateId => {
  if (!corporateId || typeof corporateId !== 'string') return '';
  corporateId = corporateId.replace(/^[^0-3,5]/g, '');
  corporateId = corporateId.replace(/[^\d]+/g, '');
  return corporateId;
};

const formatCorporateId$2 = corporateId => {
  if (!corporateId) return '';
  corporateId = unformatCorporateId$2(corporateId);
  return corporateId;
};

const validateCorporateId = corporateId => {
  if (corporateId.length === 13 && /(^([0-1][0-9]|[2][0-4]|[3,5][0])[0-9]{8}[0][0][1])/.test(corporateId)) {
    return true;
  }

  return false;
};

const ECU = {
  input: {
    document: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '0000000000',
      maxLength: 10,
      inputMode: 'numeric',
      validate: validatePersonalId,
      format: formatPersonalId,
      unformat: unformatPersonalId
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '0 000 0000',
      maxLength: 16,
      inputMode: 'numeric',
      validate: validatePhone$b,
      format: formatPhone$b,
      unformat: unformatPhone$b
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000000',
      maxLength: 6,
      inputMode: 'numeric',
      validate: value => /^[0-9]{6}$/.test(value),
      format: value => msk.fit(value, '999999'),
      unformat: value => value.replace(/[^\d]+/g, '')
    },
    corporateDocument: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '0000000000000',
      maxLength: 13,
      inputMode: 'numeric',
      validate: validateCorporateId,
      format: formatCorporateId$2,
      unformat: unformatCorporateId$2
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: mapCountryDataToFirstLevel(countryData$b)
    },
    city: {
      type: 'select',
      enabled: true,
      required: true,
      parent: 'city',
      options: mapCountryDataToSecondLevel(countryData$b)
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: street => street,
      unformat: street => street,
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'state-city'
  }
};

var countryData$a = [
	"Aguascalientes",
	"Baja California",
	"Baja California Sur",
	"Campeche",
	"Chiapas",
	"Chihuahua",
	"Ciudad de México",
	"Coahuila De Zaragoza",
	"Colima",
	"Durango",
	"Guanajuato",
	"Guerrero",
	"Hidalgo",
	"Jalisco",
	"México",
	"Michoacán de Ocampo",
	"Morelos",
	"Nayarit",
	"Nuevo León",
	"Oaxaca",
	"Puebla",
	"Querétaro",
	"Quintana Roo",
	"San Luis Potosí",
	"Sinaloa",
	"Sonora",
	"Tabasco",
	"Tamaulipas",
	"Tlaxcala",
	"Veracruz",
	"Yucatán",
	"Zacatecas"
];

const phoneCountryCode$a = '52';
const phoneRegex$a = /^(?:(?:(?:\+|)52)|)(?:(?:(?:33|55|56|81)\d{8})|(?:221|222|223|224|225|226|227|228|229|231|232|233|235|236|237|238|241|243|244|245|246|247|248|249|271|272|273|274|275|276|278|279|281|282|283|284|285|287|288|294|296|297|311|312|313|314|315|316|317|318|319|321|322|323|324|325|326|327|328|329|341|342|343|344|345|346|347|348|349|351|352|353|354|355|356|357|358|359|371|372|373|374|375|376|377|378|379|381|382|383|384|385|386|387|388|389|391|392|393|394|395|411|412|413|414|415|417|418|419|421|422|423|424|425|426|427|428|429|431|432|433|434|435|436|437|438|440|441|442|443|444|445|446|447|448|449|451|452|453|454|455|456|457|458|459|461|462|463|464|465|466|467|468|469|471|472|473|474|475|476|477|478|479|481|482|483|485|486|487|488|489|492|493|494|495|496|498|499|588|591|592|593|594|595|596|597|599|612|613|614|615|616|618|621|622|623|624|625|626|627|628|629|631|632|633|634|635|636|637|638|639|641|642|643|644|645|646|647|648|649|651|652|653|656|658|659|661|662|663|664|665|666|667|668|669|671|672|673|674|675|676|677|686|687|694|695|696|697|698|711|712|713|714|715|716|717|718|719|721|722|723|724|725|726|727|728|729|731|732|733|734|735|736|737|738|739|741|742|743|744|745|746|747|748|749|751|753|754|755|756|757|758|759|761|762|763|764|765|766|767|768|769|771|772|773|774|775|776|777|778|779|781|782|783|784|785|786|789|791|797|821|823|824|825|826|827|828|829|831|832|833|834|835|836|841|842|844|845|846|861|862|864|866|867|868|869|871|872|873|877|878|891|892|894|897|899|913|914|916|917|918|919|921|922|923|924|932|933|934|936|937|938|951|953|954|958|961|962|963|964|965|966|967|968|969|971|972|981|982|983|984|985|986|987|988|991|992|993|994|995|996|997|998|999)\d{7})$/;
const areaCodeStartChar$6 = '(';
const areaCodeEndChar$6 = ')';
const areaCodeSeparator$a = ' ';
const phoneSeparator$9 = ' ';

const unformatPhone$a = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$a}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 10 && phone.startsWith(phoneCountryCode$a)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$a = phone => {
  phone = unformatPhone$a(phone);

  if (phone.length === 10) {
    if (phone.startsWith('33') || phone.startsWith('55') || phone.startsWith('56') || phone.startsWith('81')) {
      return areaCodeStartChar$6 + phone.substring(0, 2) + areaCodeEndChar$6 + areaCodeSeparator$a + phone.substring(2, 6) + phoneSeparator$9 + phone.substring(6);
    }

    return areaCodeStartChar$6 + phone.substring(0, 3) + areaCodeEndChar$6 + areaCodeSeparator$a + phone.substring(3, 6) + phoneSeparator$9 + phone.substring(6);
  }

  return phone;
};

const validatePhone$a = phone => {
  phone = unformatPhone$a(phone);
  return phoneRegex$a.test(phone);
};

const unformatId$9 = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const formatId$9 = id => {
  id = id.toString().toUpperCase();
  return id;
};

const validatePersonalID$5 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$9(id);

  if (id.startsWith('BUEI') || id.startsWith('BUEY') || id.startsWith('CACA') || id.startsWith('CACO') || id.startsWith('CAGA') || id.startsWith('CAGO') || id.startsWith('CAKA') || id.startsWith('CAKO') || id.startsWith('COGE') || id.startsWith('COJA') || id.startsWith('COJE') || id.startsWith('COJI') || id.startsWith('COJO') || id.startsWith('CULO') || id.startsWith('FETO') || id.startsWith('GUEY') || id.startsWith('JOTO') || id.startsWith('KACA') || id.startsWith('KACO') || id.startsWith('KAGA') || id.startsWith('KAGO') || id.startsWith('KAKA') || id.startsWith('KOGE') || id.startsWith('KOJO') || id.startsWith('KULO') || id.startsWith('MAME') || id.startsWith('MAMO') || id.startsWith('MEAR') || id.startsWith('MEAS') || id.startsWith('MEON') || id.startsWith('MION') || id.startsWith('MOCO') || id.startsWith('MULA') || id.startsWith('PEDA') || id.startsWith('PEDO') || id.startsWith('PENE') || id.startsWith('PUTA') || id.startsWith('PUTO') || id.startsWith('QULO') || id.startsWith('RATA') || id.startsWith('RUIN')) {
    return false;
  }

  if (/^[a-zA-Z]{4}[0-9]{6}([a-zA-Z0-9]{3})$/.test(id)) {
    return true;
  }

  return false;
};

const validateCorporateID$7 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$9(id);

  if (/^[a-zA-Z]{3}[0-9]{6}([a-zA-Z0-9]{3})$/.test(id)) {
    return true;
  }

  return false;
};

const MEX = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: true,
      placeholder: 'AAAA000000AAA',
      maxLength: 13,
      inputMode: 'text',
      validate: validatePersonalID$5,
      format: formatId$9,
      unformat: unformatId$9
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 000 0000',
      maxLength: 18,
      inputMode: 'numeric',
      validate: validatePhone$a,
      format: formatPhone$a,
      unformat: unformatPhone$a
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00000',
      maxLength: 5,
      inputMode: 'numeric',
      validate: value => /^[0-9]{5}$/.test(value),
      format: value => msk.fit(value, '99999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: 'AAA000000AAA',
      maxLength: 12,
      inputMode: 'text',
      validate: validateCorporateID$7,
      format: formatId$9,
      unformat: unformatId$9
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData$a
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      maxLength: 100,
      inputMode: 'text',
      validate: value => !!value,
      format: value => value,
      unformat: value => value
    },
    neighborhood: {
      type: 'dynamic-input',
      enabled: true,
      required: true,
      transform: neighborhood => {
        const options = neighborhood.split('::');

        if (options.length > 1) {
          return {
            type: 'select',
            enabled: true,
            required: true,
            parent: null,
            options
          };
        }

        return {
          type: 'text',
          enabled: true,
          required: true,
          format: value => value,
          inputMode: 'text',
          maxLength: 750,
          placeholder: '',
          unformat: value => value,
          validate: value => !!value
        };
      }
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$9 = [
	"Alabama",
	"Alaska",
	"American Samoa",
	"Arizona",
	"Arkansas",
	"Armed Forces Americas",
	"Armed Forces Europe, the Middle East, and Canada",
	"Armed Forces Pacific",
	"California",
	"Colorado",
	"Connecticut",
	"Delaware",
	"District Of Columbia (Washington, D.C.)",
	"Federated States of Micronesia",
	"Florida",
	"Georgia",
	"Guam",
	"Hawaii",
	"Idaho",
	"Illinois",
	"Indiana",
	"Iowa",
	"Kansas",
	"Kentucky",
	"Louisiana",
	"Maine",
	"Marshall Islands",
	"Maryland",
	"Massachusetts",
	"Michigan",
	"Minnesota",
	"Mississippi",
	"Missouri",
	"Montana",
	"Nebraska",
	"Nevada",
	"New Hampshire",
	"New Jersey",
	"New Mexico",
	"New York",
	"North Carolina",
	"North Dakota",
	"Northern Mariana Islands",
	"Ohio",
	"Oklahoma",
	"Oregon",
	"Palau",
	"Pennsylvania",
	"Puerto Rico",
	"Rhode Island",
	"South Carolina",
	"South Dakota",
	"Tennessee",
	"Texas",
	"U.S. Minor Outlying Islands",
	"U.S. Virgin Islands",
	"Utah",
	"Vermont",
	"Virginia",
	"Washington",
	"West Virginia",
	"Wisconsin",
	"Wyoming"
];

const phoneCountryCode$9 = '1';
const phoneRegex$9 = /^(?:(?:(?:\+|)(?:1|))|)(2[0][1-35-9]|2[1][02-9]|2[2][03-57-9]|2[3][149]|2[4][08]|2[5][1-46]|2[6][0279]|2[7][02469]|2[8][13]|3[0][1-57-9]|3[1][02-9]|3[2][0135-7]|3[3][0-24679]|3[4][167]|3[5][12]|3[6][014]|3[8][056]|4[0][124-9]|4[1][02-579]|4[2][3-5]|4[3][0245]|4[4][023578]|458|4[6][349]|4[7][0589]|4[8][04]|5[0][1-57-9]|5[1][0235-8]|520|5[3][0149]|5[4][01]|5[5][179]|5[6][1-47]|5[7][0-5]|5[8][0256]|6[0][1-35-9]|6[1][024-9]|6[2][03689]|6[3][016]|6[4][016]|6[5][01679]|6[6][01279]|6[7][89]|6[8][0129]|7[0][1-46-8]|7[1][02-9]|7[2][04-7]|7[3][0-247]|7[4][037]|7[5][47]|7[6][02359]|7[7][02-59]|7[8][156]|8[0][1-68]|8[1][02-8]|8[2][068]|8[3][0-289]|8[4][03578]|8[5][046-9]|8[6][02-5]|8[7][028]|9[0][1346-9]|9[1][02-9]|9[2][0589]|9[3][0146-8]|9[4][01579]|9[5][12469]|9[7][0-3589]|9[8][04-69])\d{7}$/;
const areaCodeStartChar$5 = '(';
const areaCodeEndChar$5 = ')';
const areaCodeSeparator$9 = ' ';
const phoneSeparator$8 = ' ';

const unformatPhone$9 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$9}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 10 && phone.startsWith(phoneCountryCode$9)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$9 = phone => {
  phone = unformatPhone$9(phone);

  if (phone.length === 10) {
    return areaCodeStartChar$5 + phone.substring(0, 3) + areaCodeEndChar$5 + areaCodeSeparator$9 + phone.substring(3, 6) + phoneSeparator$8 + phone.substring(6);
  }

  return phone;
};

const validatePhone$9 = phone => {
  phone = unformatPhone$9(phone);
  return phoneRegex$9.test(phone);
};

const unformatId$8 = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const formatId$8 = id => {
  id = id.toString().toUpperCase();
  return id;
};

const validatePersonalID$4 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$8(id);

  if (/^\d{3}-?\d{2}-?\d{4}$/.test(id)) {
    return true;
  }

  return false;
};

const validateCorporateID$6 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$8(id);

  if (/^\d{2}-?\d{7}$/.test(id)) {
    return true;
  }

  return false;
};

const USA = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '000-00-0000',
      maxLength: 11,
      inputMode: 'numeric',
      validate: validatePersonalID$4,
      format: formatId$8,
      unformat: unformatId$8
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 000-0000',
      maxLength: 12,
      inputMode: 'numeric',
      validate: validatePhone$9,
      format: formatPhone$9,
      unformat: unformatPhone$9
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00000',
      maxLength: 5,
      inputMode: 'numeric',
      validate: value => /^[0-9]{5}$/.test(value),
      format: value => msk.fit(value, '99999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '00-0000000',
      maxLength: 10,
      inputMode: 'numeric',
      validate: validateCorporateID$6,
      format: formatId$8,
      unformat: unformatId$8
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData$9
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      maxLength: 100,
      inputMode: 'text',
      validate: value => !!value,
      format: value => value,
      unformat: value => value
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$8 = {
	Carlow: {
		Carlow: "R93",
		"Muine Bheag": "R21"
	},
	Cavan: {
		Belturbet: "H14",
		Cavan: "H12",
		Cootehill: "H16",
		Kingscourt: "A82",
		Virginia: "A82"
	},
	Clare: {
		Ennis: "V95",
		Kilrush: "V15",
		Shannon: "V14"
	},
	Cork: {
		Ballincollig: "P31",
		Bandon: "P72",
		Bantry: "P75",
		Carrigaline: "P43",
		Charleville: "P56",
		Clonakilty: "P85",
		Cobh: "P24",
		"Cork (centre and southside) - Passage West - Cork Airport": "T12",
		"Cork (northside) - Blarney": "T23",
		Crookstown: "P14",
		Donoughmore: "P32",
		Dunmanway: "P47",
		Watergrasshill: "T56",
		Whitechurch: "T34",
		Fermoy: "P61",
		Kinsale: "P17",
		"Little Island": "T45",
		Macroom: "P12",
		Mallow: "P51",
		Midleton: "P25",
		Mitchelstown: "P67",
		Skibbereen: "P81",
		Youghal: "P36"
	},
	Donegal: {
		Donegal: "F94",
		Letterkenny: "F92",
		Lifford: "F93"
	},
	Dublin: {
		Balbriggan: "K32",
		Ballyboughal: "A41",
		Blackrock: "A94",
		Booterstown: "A94",
		"Dublin 1": "D01",
		"Dublin 2": "D02",
		"Dublin 3": "D03",
		"Dublin 4": "D04",
		"Dublin 5": "D05",
		"Dublin 6": "D06",
		"Dublin 6W": "D6W",
		"Dublin 7": "D07",
		"Dublin 8": "D08",
		"Dublin 9": "D09",
		"Dublin 10": "D10",
		"Dublin 11": "D11",
		"Dublin 12": "D12",
		"Dublin 13": "D13",
		"Dublin 14": "D14",
		"Dublin 15": "D15",
		"Dublin 16": "D16",
		"Dublin 17": "D17",
		"Dublin 18": "D18",
		"Dublin 20": "D20",
		"Dublin 22": "D22",
		"Dublin 24": "D24",
		Garristown: "A42",
		Glenageary: "A96",
		Lucan: "K78",
		Lusk: "K45",
		Malahide: "K36",
		Monkstown: "A94",
		Oldtown: "A45",
		Rush: "K56",
		Skerries: "K34",
		"Swords and Dublin Airport": "K67"
	},
	Galway: {
		Athenry: "H65",
		Ballinasloe: "H53",
		Clifden: "H71",
		Galway: "H91",
		Loughrea: "H62",
		Tuam: "H54"
	},
	Kerry: {
		Caherciveen: "V23",
		Killarney: "V93",
		Listowel: "V31",
		Tralee: "V92"
	},
	Kildare: {
		Athy: "R14",
		"Curragh Camp": "R56",
		Kildare: "R51",
		Maynooth: "W23",
		Monasterevin: "W34",
		Naas: "W91",
		Newbridge: "W12"
	},
	Kilkenny: {
		Kilkenny: "R95"
	},
	Laois: {
		Portlaoise: "R32"
	},
	Leitrim: {
		"Carrick-on-Shannon": "N41"
	},
	Limerick: {
		Kilmallock: "V35",
		Limerick: "V94",
		"Newcastle West": "V42"
	},
	Longford: {
		Longford: "N39"
	},
	Louth: {
		Ardee: "A92",
		Drogheda: "A92",
		Dundalk: "A91"
	},
	Mayo: {
		Ballina: "F26",
		Ballinrobe: "F31",
		Ballyhaunis: "F35",
		Castlebar: "F23",
		Claremorris: "F12",
		Westport: "F28"
	},
	Meath: {
		Ashbourne: "A84",
		Dunboyne: "A86",
		Dunshaughlin: "A85",
		Edenderry: "R45",
		Enfield: "A83",
		Kells: "A82",
		"Laytown-Bettystown-Mornington": "A92",
		Navan: "C15",
		Ratoath: "A85",
		Summerhill: "A83"
	},
	Monaghan: {
		Ballybay: "A75",
		Carrickmacross: "A81",
		Castleblaney: "A75",
		Clones: "H23",
		Monaghan: "H18"
	},
	Offaly: {
		Birr: "R42",
		Tullamore: "R35"
	},
	Roscommon: {
		Boyle: "F52",
		Castlerea: "F45",
		Roscommon: "F42"
	},
	Sligo: {
		Ballymote: "F56",
		Sligo: "F91"
	},
	Tipperary: {
		Cahir: "E21",
		"Carrick-on-Suir": "E32",
		Cashel: "E25",
		Clonmel: "E91",
		Nenagh: "E45",
		Roscrea: "E53",
		Thurles: "E41",
		Tipperary: "E34"
	},
	Waterford: {
		Dungarvan: "X35",
		Kilmacthomas: "X42",
		Waterford: "X91"
	},
	Westmeath: {
		Athlone: "N37",
		Mullingar: "N91"
	},
	Wexford: {
		Enniscorthy: "Y21",
		Gorey: "Y25",
		"New Ross": "Y34",
		Wexford: "Y35"
	},
	Wicklow: {
		Arklow: "Y14",
		Bray: "A98",
		Delgany: "A63",
		Greystones: "A63",
		Kilcoole: "A63",
		Newcastle: "A63",
		Newtownmountkennedy: "A63",
		Rathnew: "A67",
		Wicklow: "A67"
	}
};

const phoneCountryCode$8 = '353';
const phoneRegex$8 = /^(?:(?:(?:\+|)353)|)(?:0|)(?:(1|[2,6,7,8,9]\d|[4,5]\d{1,2})[1-9]\d{4,6})$/;
const areaCodeStartChar$4 = '';
const areaCodeEndChar$4 = '';
const areaCodeSeparator$8 = ' ';
const phoneSeparator$7 = ' ';

const unformatPhone$8 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$8}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 9 && phone.startsWith(phoneCountryCode$8)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$8 = phone => {
  phone = unformatPhone$8(phone);

  if (phone.length === 9) {
    return areaCodeStartChar$4 + phone.substring(0, 2) + areaCodeEndChar$4 + areaCodeSeparator$8 + phone.substring(2, 5) + phoneSeparator$7 + phone.substring(5);
  }

  return phone;
};

const validatePhone$8 = phone => {
  phone = unformatPhone$8(phone);
  return phoneRegex$8.test(phone);
};

const unformatId$7 = id => {
  const removeInvalidChars = /[^\w]/g;
  id = id.replace(removeInvalidChars, '');
  id = id.toString().toUpperCase();
  return id;
};

const formatId$7 = id => {
  if (!id) return '';
  id = unformatId$7(id);

  if (id.length === 8) {
    return msk.fit(id, '9999999A');
  }

  if (id.length === 9) {
    return msk.fit(id, '9999999AA');
  }

  return id;
};

const validateId = id => {
  id = unformatId$7(id);

  if (!id) {
    return false;
  }

  if (!/^[\d]{7}[A-Z]{1,2}$/.test(id)) {
    return false;
  }

  if (id.length < 8 || id.length > 9) {
    return false;
  }

  return true;
};

const validateCORID = id => {
  const regexCORID = /^\d{4,7}$/;
  if (!id) return false;
  if (regexCORID.test(id)) return true;
  return false;
};

const unformatPostalCode$2 = postalCode => {
  if (!postalCode || typeof postalCode !== 'string') return '';
  postalCode = postalCode.replace(/[^\w]+/g, '').toUpperCase();
  const outerPart = postalCode.substring(0, postalCode.length - 4);
  const innerPart = postalCode.substring(postalCode.length - 4);
  postalCode = `${outerPart} ${innerPart}`;
  return postalCode;
};

const formatPostalCode$2 = postalCode => {
  postalCode = postalCode.replace(/[^\w]+/g, '').toUpperCase();

  if (postalCode.length === 7) {
    return postalCode.substring(0, 3) + areaCodeSeparator$8 + postalCode.substring(3);
  }

  return postalCode;
};

const validatePostalCode$2 = postalCode => {
  if (!postalCode) return false;
  postalCode = unformatPostalCode$2(postalCode);
  const postalCodePattern = /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/;

  if (postalCode.length > 5 && postalCode.length < 9 && postalCodePattern.test(postalCode)) {
    return true;
  }

  return false;
};

const IRL = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: true,
      placeholder: '0000000AA',
      maxLength: 9,
      inputMode: 'text',
      validate: validateId,
      format: formatId$7,
      unformat: unformatId$7
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 000 0000',
      maxLength: 15,
      inputMode: 'numeric',
      validate: validatePhone$8,
      format: formatPhone$8,
      unformat: unformatPhone$8
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 0000',
      maxLength: 8,
      inputMode: 'numeric',
      validate: validatePostalCode$2,
      format: formatPostalCode$2,
      unformat: unformatPostalCode$2
    },
    corporateDocument: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '9999999',
      maxLength: 7,
      inputMode: 'numeric',
      validate: validateCORID,
      format: formatId$7,
      unformat: unformatId$7
    },
    state: {
      type: 'select',
      required: true,
      enabled: true,
      parent: null,
      options: mapCountryDataToFirstLevel(countryData$8)
    },
    city: {
      type: 'text',
      required: false,
      enabled: false,
      format: value => value,
      inputMode: 'text',
      maxLength: 100,
      placeholder: '',
      unformat: value => value,
      validate: () => true
    },
    neighborhood: {
      type: 'select',
      required: true,
      enabled: true,
      parent: 'state',
      options: mapCountryDataToSecondLevel(countryData$8)
    },
    complement: {
      type: 'text',
      required: false,
      enabled: true,
      maxLength: 750,
      format: value => value,
      inputMode: 'text',
      placeholder: '',
      unformat: value => value,
      validate: () => true
    },
    receiverName: {
      type: 'text',
      required: true,
      enabled: true,
      maxLength: 750,
      format: value => value,
      inputMode: 'text',
      placeholder: '',
      unformat: value => value,
      validate: value => !!value
    },
    number: {
      type: 'text',
      required: true,
      enabled: true,
      maxLength: 750,
      format: value => value,
      inputMode: 'numeric',
      placeholder: '',
      unformat: value => value,
      validate: value => !!value
    },
    street: {
      type: 'text',
      required: true,
      enabled: true,
      maxLength: 750,
      format: value => value,
      inputMode: 'text',
      placeholder: '',
      unformat: value => value,
      validate: value => !!value
    }
  },
  address: {
    postalCodeMode: 'state-neighborhood'
  }
};

var countryData$7 = [
	"Aveiro",
	"Beja",
	"Braga",
	"Bragança",
	"Castelo Branco",
	"Coimbra",
	"Évora",
	"Faro",
	"Guarda",
	"Leiria",
	"Lisboa",
	"Portalegre",
	"Porto",
	"Santarém",
	"Setúbal",
	"Viana do Castelo",
	"Vila Real",
	"Viseu"
];

/* eslint-disable no-else-return */
const phoneCountryCode$7 = '351';
const phoneRegex$7 = /^(?:(?:(?:\+|)351)|)(?:(21|22|91|92|96|93)\d{7,10}|(241|295|235|234|284|253|273|262|272|286|276|239|275|268|266|289|233|291|271|292|277|244|231|278|279|285|283|255|254|236|296|242|245|282||274|256|243|269|238|265|281|249|261|263|252|251|258|259|232|921|925|927|926|929)\d{6,9}|(9240|9241|9242|9243|9244|9220|9221|9222)\d{6,8})$/;
const areaCodeSeparator$7 = ' ';
const phoneSeparator$6 = ' ';

const unformatPhone$7 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$7}`, 'g');

  if (phone.length >= 9 && phone.startsWith(phoneCountryCode$7)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$7 = phone => {
  if (!phone) {
    return '';
  }

  phone = unformatPhone$7(phone);

  if (phone.length > 8 && phone.length < 15) {
    return `${phone.substring(0, 3)}${areaCodeSeparator$7}${phone.substring(3, 6)}${phoneSeparator$6}${phone.substring(6, 12)}`;
  }

  return phone;
};

const validatePhone$7 = phone => {
  phone = unformatPhone$7(phone);
  return phoneRegex$7.test(phone) && phone.length <= 12;
};

const unformatID = document => {
  return !document || typeof document !== 'string' ? '' : document.replace(/[^\w]+/g, '');
};

const formatID = document => {
  if (!document) return '';
  document = unformatID(document);
  return msk.fit(document, '999999999');
};

const validateID$1 = id => {
  const digitsToValidate = id.substring(0, 8);
  let sum = 0;

  for (let i = 0; i < digitsToValidate.length; i++) {
    sum += parseInt(digitsToValidate[i], 10) * (9 - i);
  }

  const remaininder = sum % 11;
  const controlDigit = remaininder < 2 ? 0 : 11 - remaininder;
  return controlDigit === parseInt(id[8], 10);
};

const unmaskCORID = corId => {
  return !corId || typeof corId !== 'string' ? '' : corId.replace(/[^\d]+/g, '');
};

const PRT = {
  input: {
    document: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '999999999',
      maxLength: 9,
      inputMode: 'text',
      validate: validateID$1,
      format: formatID,
      unformat: unformatID
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: false,
      enabled: true,
      placeholder: '00 000 0000',
      maxLength: 20,
      inputMode: 'numeric',
      validate: validatePhone$7,
      format: formatPhone$7,
      unformat: unformatPhone$7
    },
    postalCode: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '9999-999',
      maxLength: 8,
      inputMode: 'numeric',
      validate: value => /^[0-9]{4}-?[0-9]{3}$/.test(value),
      format: value => msk.fit(value, '9999-999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '000 000 000',
      maxLength: 11,
      inputMode: 'numeric',
      validate: corId => {
        if (!corId) {
          return false;
        }

        corId = unmaskCORID(corId);

        if (corId.length !== 9) {
          return false;
        }

        return true;
      },
      format: corId => {
        return msk.fit(corId, '999 999 999');
      },
      unformat: unmaskCORID
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData$7
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 10,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    street: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: street => street,
      unformat: street => street,
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$6 = [
	"Agrigento",
	"Alessandria",
	"Ancona",
	"Aosta",
	"Arezzo",
	"Ascoli Piceno",
	"Asti",
	"Avellino",
	"Bari",
	"Barletta-Andria-Trani",
	"Belluno",
	"Benevento",
	"Bergamo",
	"Biella",
	"Bologna",
	"Brescia",
	"Brindisi",
	"Cagliari",
	"Caltanissetta",
	"Campobasso",
	"Caserta",
	"Catania",
	"Catanzaro",
	"Chieti",
	"Como",
	"Cosenza",
	"Cremona",
	"Crotone",
	"Cuneo",
	"Enna",
	"Fermo",
	"Ferrara",
	"Florence",
	"Foggia",
	"Forlì-Cesena",
	"Frosinone",
	"Genoa",
	"Gorizia",
	"Grosseto",
	"Imperia",
	"Isernia",
	"L'Aquila",
	"La Spezia",
	"Latina",
	"Lecce",
	"Lecco",
	"Livorno",
	"Lodi",
	"Lucca",
	"Macerata",
	"Mantua",
	"Massa-Carrara",
	"Matera",
	"Messina",
	"Milan",
	"Modena",
	"Monza and Brianza",
	"Naples",
	"Novara",
	"Nuoro",
	"Oristano",
	"Padua",
	"Palermo",
	"Parma",
	"Pavia",
	"Perugia",
	"Pesaro and Urbino",
	"Pescara",
	"Piacenza",
	"Pisa",
	"Pistoia",
	"Pordenone",
	"Potenza",
	"Prato",
	"Ragusa",
	"Ravenna",
	"Reggio Calabria",
	"Reggio Emilia",
	"Rieti",
	"Rimini",
	"Rome",
	"Rovigo",
	"Salerno",
	"Sassari",
	"Savona",
	"Siena",
	"Sondrio",
	"South Sardinia",
	"South Tyrol",
	"Syracuse",
	"Taranto",
	"Teramo",
	"Terni",
	"Trapani",
	"Trento",
	"Treviso",
	"Trieste",
	"Turin",
	"Udine",
	"Varese",
	"Venice",
	"Verbano-Cusio-Ossola",
	"Vercelli",
	"Verona",
	"Vibo Valentia",
	"Vicenza",
	"Viterbo "
];

const phoneCountryCode$6 = '39';
const phoneRegex$6 = /^(?:(?:(?:\+|)(?:39|)|))(?:(?:(0[26]\d{4,8})|(0[1345789][0159]\d{3,7})|(0[1345789][234678][1-9]\d{2,6}|(3[1-9]\d{7,8}))))$/;
const areaCodeStartChar$3 = '';
const areaCodeEndChar$3 = '';
const areaCodeSeparator$6 = ' ';
const phoneSeparator$5 = ' ';

const unformatPhone$6 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$6}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 10 && phone.startsWith(phoneCountryCode$6)) {
    phone = phone.replace(removeCountryCodeReg, '');
  }

  return phone;
};

const formatPhone$6 = phone => {
  phone = unformatPhone$6(phone);

  switch (phone.length) {
    case 6:
      if (phone[1] === '2' || phone[1] === '6') {
        return areaCodeStartChar$3 + phone.substring(0, 2) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(2, 4) + phoneSeparator$5 + phone.substring(4, 6);
      }

      if (phone[2] === '0' || phone[2] === '1' || phone[2] === '5' || phone[2] === '9') {
        return areaCodeStartChar$3 + phone.substring(0, 3) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(3, 6);
      }

      return areaCodeStartChar$3 + phone.substring(0, 4) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(4, 6);

    case 7:
      if (phone[1] === '2' || phone[1] === '6') {
        return areaCodeStartChar$3 + phone.substring(0, 2) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(2, 4) + phoneSeparator$5 + phone.substring(4, 7);
      }

      if (phone[2] === '0' || phone[2] === '1' || phone[2] === '5' || phone[2] === '9') {
        return areaCodeStartChar$3 + phone.substring(0, 3) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(3, 5) + phoneSeparator$5 + phone.substring(5, 7);
      }

      return areaCodeStartChar$3 + phone.substring(0, 4) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(4, 7);

    case 8:
      if (phone[1] === '2' || phone[1] === '6') {
        return areaCodeStartChar$3 + phone.substring(0, 2) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(2, 5) + phoneSeparator$5 + phone.substring(5, 8);
      }

      if (phone[2] === '0' || phone[2] === '1' || phone[2] === '5' || phone[2] === '9') {
        return areaCodeStartChar$3 + phone.substring(0, 3) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(3, 5) + phoneSeparator$5 + phone.substring(5, 8);
      }

      return areaCodeStartChar$3 + phone.substring(0, 4) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(4, 6) + phoneSeparator$5 + phone.substring(6, 8);

    case 9:
      if (phone[0] === '3') {
        return areaCodeStartChar$3 + phone.substring(0, 3) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(3, 6) + phoneSeparator$5 + phone.substring(6, 9);
      }

      if (phone[1] === '2' || phone[1] === '6') {
        return areaCodeStartChar$3 + phone.substring(0, 2) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(2, 5) + phoneSeparator$5 + phone.substring(5, 9);
      }

      if (phone[2] === '0' || phone[2] === '1' || phone[2] === '5' || phone[2] === '9') {
        return areaCodeStartChar$3 + phone.substring(0, 3) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(3, 6) + phoneSeparator$5 + phone.substring(6, 9);
      }

      return areaCodeStartChar$3 + phone.substring(0, 4) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(4, 6) + phoneSeparator$5 + phone.substring(6, 9);

    case 10:
      if (phone[0] === '3') {
        return areaCodeStartChar$3 + phone.substring(0, 3) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(3, 6) + phoneSeparator$5 + phone.substring(6, 10);
      }

      if (phone[1] === '2' || phone[1] === '6') {
        return areaCodeStartChar$3 + phone.substring(0, 2) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(2, 6) + phoneSeparator$5 + phone.substring(6, 10);
      }

      if (phone[2] === '0' || phone[2] === '1' || phone[2] === '5' || phone[2] === '9') {
        return areaCodeStartChar$3 + phone.substring(0, 3) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(3, 6) + phoneSeparator$5 + phone.substring(6, 10);
      }

      return areaCodeStartChar$3 + phone.substring(0, 4) + areaCodeEndChar$3 + areaCodeSeparator$6 + phone.substring(4, 6) + phoneSeparator$5 + phone.substring(7, 10);

    default:
      return phone;
  }
};

const validatePhone$6 = phone => {
  phone = unformatPhone$6(phone);
  return phoneRegex$6.test(phone);
};

const unformatCorporateId$1 = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const unformatId$6 = id => {
  const removeInvalidChars = /[^\dA-Za-z]/g;
  id = id.replace(removeInvalidChars, '');
  id = id.toString().toUpperCase();
  return id;
};

const formatId$6 = id => {
  id = unformatId$6(id);
  return id;
};

const formatCorporateId$1 = id => {
  id = unformatCorporateId$1(id);
  return id;
};

const validatePersonalID$3 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$6(id);

  if (/^[A-Z]{6}[\d]{2}[A-Z][\d]{2}[A-Z][\d]{3}[A-Z]$/.test(id)) {
    return true;
  }

  return false;
};

const validateCorporateID$5 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$6(id);

  if (/^\d{11}$/.test(id)) {
    return true;
  }

  return false;
};

const ITA = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: true,
      placeholder: 'AAAAAA00A00A000A',
      maxLength: 16,
      inputMode: 'numeric',
      validate: validatePersonalID$3,
      format: formatId$6,
      unformat: unformatId$6
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 000 0000',
      maxLength: 16,
      inputMode: 'numeric',
      validate: validatePhone$6,
      format: formatPhone$6,
      unformat: unformatPhone$6
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00000',
      maxLength: 5,
      inputMode: 'numeric',
      validate: value => /^[0-9]{5}$/.test(value),
      format: value => msk.fit(value, '99999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '00000000000',
      maxLength: 11,
      inputMode: 'numeric',
      validate: validateCorporateID$5,
      format: formatCorporateId$1,
      unformat: unformatCorporateId$1
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData$6
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      maxLength: 100,
      inputMode: 'text',
      validate: value => !!value,
      format: value => value,
      unformat: value => value
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$5 = [
	"Alberta",
	"British Columbia",
	"Manitoba",
	"New Brunswick",
	"Newfoundland and Labrador",
	"Nova Scotia",
	"Ontario",
	"Prince Edward Island",
	"Quebec",
	"Saskatchewan",
	"Yukon",
	"Nunavut",
	"Northwest Territories"
];

const phoneCountryCode$5 = '1';
const phoneRegex$5 = /^(?:(?:(?:\+|)(?:1|))|)(2[02-68][03469]|3[04-6][3-8]|4[0135-7][01346-8]|5[01478][146-9]|6[013478][23479]|7[04578][023589]|8[01267][3579]|9[0][25])\d{7}$/;
const areaCodeStartChar$2 = '';
const areaCodeEndChar$2 = '';
const areaCodeSeparator$5 = '-';
const phoneSeparator$4 = '-';

const unformatPhone$5 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$5}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 10 && phone.startsWith(phoneCountryCode$5)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$5 = phone => {
  phone = unformatPhone$5(phone);

  if (phone.length === 10) {
    return areaCodeStartChar$2 + phone.substring(0, 3) + areaCodeEndChar$2 + areaCodeSeparator$5 + phone.substring(3, 6) + phoneSeparator$4 + phone.substring(6);
  }

  return phone;
};

const validatePhone$5 = phone => {
  phone = unformatPhone$5(phone);
  return phoneRegex$5.test(phone);
};

const unformatId$5 = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const formatId$5 = id => {
  id = id.toString().toUpperCase();
  return id;
};

const validatePersonalID$2 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$5(id);

  if (/^\d{9}$/.test(id)) {
    return true;
  }

  return false;
};

const validateCorporateID$4 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$5(id);

  if (/^\d{9}$/.test(id)) {
    return true;
  }

  return false;
};

const unformatPostalCode$1 = postalCode => {
  if (!postalCode || typeof postalCode !== 'string') return '';
  postalCode = postalCode.replace(/[^\w]+/g, '').toUpperCase();
  return postalCode;
};

const formatPostalCode$1 = postalCode => {
  postalCode = postalCode.replace(/[^\w]+/g, '').toUpperCase();

  if (postalCode.length === 6) {
    return `${postalCode.substring(0, 3)} ${postalCode.substring(3)}`.toUpperCase();
  }

  return postalCode;
};

const validatePostalCode$1 = postalCode => {
  if (!postalCode) return false;
  postalCode = unformatPostalCode$1(postalCode);
  const postalCodePattern = /^[A-z][0-9][A-z][0-9][A-z][0-9]$/;

  if (postalCode.length > 5 && postalCode.length < 8 && postalCodePattern.test(postalCode)) {
    return true;
  }

  return false;
};

const CAN = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '000000000',
      maxLength: 9,
      inputMode: 'numeric',
      validate: validatePersonalID$2,
      format: formatId$5,
      unformat: unformatId$5
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000-000-0000',
      maxLength: 13,
      inputMode: 'numeric',
      validate: validatePhone$5,
      format: formatPhone$5,
      unformat: unformatPhone$5
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: 'A0A 0A0',
      maxLength: 7,
      inputMode: 'text',
      validate: validatePostalCode$1,
      format: formatPostalCode$1,
      unformat: unformatPostalCode$1
    },
    corporateDocument: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '000000000',
      maxLength: 9,
      inputMode: 'numeric',
      validate: validateCorporateID$4,
      format: formatId$5,
      unformat: unformatId$5
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData$5
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      maxLength: 100,
      inputMode: 'text',
      validate: value => !!value,
      format: value => value,
      unformat: value => value
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$4 = [
	"Álava",
	"Albacete",
	"Alicante",
	"Almería",
	"Asturias",
	"Ávila",
	"Badajoz",
	"Barcelona",
	"Burgos",
	"Cáceres",
	"Cádiz",
	"Cantabria",
	"Castellón",
	"Ciudad Real",
	"Córdoba",
	"Cuenca",
	"Gerona",
	"Granada",
	"Guadalajara",
	"Guipúzcoa",
	"Huelva",
	"Huesca",
	"Islas Baleares",
	"Jaén",
	"La Coruña",
	"La Rioja",
	"Las Palmas",
	"León",
	"Lérida",
	"Lugo",
	"Madrid",
	"Málaga",
	"Murcia",
	"Navarra",
	"Orense",
	"Palencia",
	"Pontevedra",
	"Salamanca",
	"Santa Cruz de Tenerife",
	"Segovia",
	"Sevilla",
	"Soria",
	"Tarragona",
	"Teruel",
	"Toledo",
	"Valencia",
	"Valladolid",
	"Vizcaya",
	"Zamora",
	"Zaragoza",
	"Ceuta",
	"Melilla"
];

const phoneCountryCode$4 = '34';
const phoneRegex$4 = /^(?:\+34|34)?(?:6\d{1,2}|7\d{1,2}|9\d{1,2})\d{6}$/;
const areaCodeSeparator$4 = ' ';
const phoneSeparator$3 = ' ';

const unformatPhone$4 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$4}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length >= 10 && phone.startsWith(phoneCountryCode$4)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$4 = phone => {
  phone = unformatPhone$4(phone);

  if (phone.length === 8) {
    return phone.substring(0, 2) + areaCodeSeparator$4 + phone.substring(2, 4) + phoneSeparator$3 + phone.substring(4, 6) + phoneSeparator$3 + phone.substring(6);
  }

  if (phone.length === 9) {
    return phone.substring(0, 3) + areaCodeSeparator$4 + phone.substring(3, 5) + phoneSeparator$3 + phone.substring(5, 7) + phoneSeparator$3 + phone.substring(7);
  }

  return phone;
};

const validatePhone$4 = phone => {
  phone = unformatPhone$4(phone);
  return phoneRegex$4.test(phone);
};

const unformatId$4 = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
};

const formatId$4 = id => {
  if (!id) return '';
  id = unformatId$4(id);

  if (/^[A-Za-z]/.test(id)) {
    return msk.fit(id, 'A9999999A');
  }

  return msk.fit(id, '99999999A');
};

const formatCoorpId = id => {
  if (!id) return '';
  id = unformatId$4(id);
  return msk.fit(id, '9999999999');
};

const validateID = id => {
  const IDregex = /^(\d{8}[a-zA-Z]|[A-Za-z]\d{7}[A-Za-z])$/;
  const CORIDregex = /^\d{10}$/;
  const emailRegex = /\S+@\S+\.\S+/;

  if (!document) {
    return false;
  }

  if (IDregex.test(id) && !emailRegex.test(id) || CORIDregex.test(id) && !emailRegex.test(id)) {
    return true;
  }

  return false;
};

const ESP = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: true,
      placeholder: '00000000A',
      maxLength: 9,
      inputMode: 'text',
      validate: validateID,
      format: formatId$4,
      unformat: unformatId$4
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 00 00 00',
      maxLength: 13,
      inputMode: 'numeric',
      validate: validatePhone$4,
      format: formatPhone$4,
      unformat: unformatPhone$4
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00000',
      maxLength: 5,
      inputMode: 'numeric',
      validate: value => /^[0-9]{5}$/.test(value),
      format: value => msk.fit(value, '99999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '0000000000',
      maxLength: 10,
      inputMode: 'numeric',
      validate: validateID,
      format: formatCoorpId,
      unformat: unformatId$4
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData$4
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      maxLength: 100,
      inputMode: 'text',
      validate: value => !!value,
      format: value => value,
      unformat: value => value
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$3 = {
	Lima: [
		"Lima",
		"Barranca",
		"Cajatambo",
		"Cañete",
		"Canta",
		"Huaral",
		"Huarochirí",
		"Huaura",
		"Oyón",
		"Yauyos"
	],
	Amazonas: [
		"Bagua",
		"Bongará",
		"Chachapoyas",
		"Condorcanqui",
		"Luya",
		"Rodríguez de Mendoza",
		"Utcubamba"
	],
	Ancash: [
		"Aija",
		"Antonio Raymondi",
		"Asunción",
		"Bolognesi",
		"Carhuaz",
		"Carlos Fermín Fitzcarrald",
		"Casma",
		"Corongo",
		"Huaraz",
		"Huari",
		"Huarmey",
		"Huaylas",
		"Mariscal Luzuriaga",
		"Ocros",
		"Pallasca",
		"Pomabamba",
		"Recuay",
		"Santa",
		"Sihuas",
		"Yungay"
	],
	"Apurímac": [
		"Abancay",
		"Andahuaylas",
		"Antabamba",
		"Aymaraes",
		"Chincheros",
		"Cotabambas",
		"Grau"
	],
	Arequipa: [
		"Arequipa",
		"Camaná",
		"Caravelí",
		"Castilla",
		"Caylloma",
		"Condesuyos",
		"Islay",
		"La Unión"
	],
	Ayacucho: [
		"Cangallo",
		"Huamanga",
		"Huanca Sancos",
		"Huanta",
		"La Mar",
		"Lucanas",
		"Parinacochas",
		"Páucar del Sara Sara",
		"Sucre",
		"Víctor Fajardo",
		"Vilcas Huamán"
	],
	Cajamarca: [
		"Cajabamba",
		"Cajamarca",
		"Celendín",
		"Chota",
		"Contumazá",
		"Cutervo",
		"Hualgayoc",
		"Jaén",
		"San Ignacio",
		"San Marcos",
		"San Miguel",
		"San Pablo",
		"Santa Cruz"
	],
	Callao: [
		"Callao"
	],
	Cusco: [
		"Acomayo",
		"Anta",
		"Calca",
		"Canas",
		"Canchis",
		"Chumbivilcas",
		"Cusco",
		"Espinar",
		"La Convención",
		"Paruro",
		"Paucartambo",
		"Quispicanchi",
		"Urubamba"
	],
	Huancavelica: [
		"Acobamba",
		"Angaraes",
		"Castrovirreyna",
		"Churcampa",
		"Huancavelica",
		"Huaytará",
		"Tayacaja"
	],
	"Huánuco": [
		"Ambo",
		"Dos de Mayo",
		"Huacaybamba",
		"Huamalíes",
		"Huánuco",
		"Lauricocha",
		"Leoncio Prado",
		"Marañón",
		"Pachitea",
		"Puerto Inca",
		"Yarowilca"
	],
	Ica: [
		"Chincha",
		"Ica",
		"Nazca",
		"Palpa",
		"Pisco"
	],
	"Junín": [
		"Chanchamayo",
		"Chupaca",
		"Concepción",
		"Huancayo",
		"Jauja",
		"Junín",
		"Satipo",
		"Tarma",
		"Yauli"
	],
	"La Libertad": [
		"Ascope",
		"Bolívar",
		"Chepén",
		"Gran Chimú",
		"Julcán",
		"Otuzco",
		"Pacasmayo",
		"Pataz",
		"Sánchez Carrión",
		"Santiago de Chuco",
		"Trujillo",
		"Virú"
	],
	Lambayeque: [
		"Chiclayo",
		"Ferreñafe",
		"Lambayeque"
	],
	Loreto: [
		"Alto Amazonas",
		"Datem del Marañón",
		"Loreto",
		"Mariscal Ramón Castilla",
		"Maynas",
		"Putumayo",
		"Requena",
		"Ucayali"
	],
	"Madre de Dios": [
		"Manú",
		"Tahuamanu",
		"Tambopata"
	],
	Moquegua: [
		"General Sánchez Cerro",
		"Ilo",
		"Mariscal Nieto"
	],
	Pasco: [
		"Daniel Alcídes Carrión",
		"Oxapampa",
		"Pasco"
	],
	Piura: [
		"Ayabaca",
		"Huancabamba",
		"Morropón",
		"Paita",
		"Piura",
		"Sechura",
		"Sullana",
		"Talara"
	],
	Puno: [
		"Azángaro",
		"Carabaya",
		"Chucuito",
		"El Collao",
		"Huancané",
		"Lampa",
		"Melgar",
		"Moho",
		"Puno",
		"San Antonio de Putina",
		"San Román",
		"Sandia",
		"Yunguyo"
	],
	"San Martín": [
		"Bellavista",
		"El Dorado",
		"Huallaga",
		"Lamas",
		"Mariscal Cáceres",
		"Moyobamba",
		"Picota",
		"Rioja",
		"San Martín",
		"Tocache"
	],
	Tacna: [
		"Candarave",
		"Jorge Basadre",
		"Tacna",
		"Tarata"
	],
	Tumbes: [
		"Contralmirante Villar",
		"Tumbes",
		"Zarumilla"
	],
	Ucayali: [
		"Atalaya",
		"Coronel Portillo",
		"Padre Abad",
		"Purús"
	]
};

/* eslint-disable no-else-return */
const phoneCountryCode$3 = '51';
const phoneRegex$3 = /^(?:(?:\+|)51|)(?:0|)(?:(?:1\d{7})|(?:9\d{8})|(?:(?:4[1-4]|5[1-46]|6[1-7]|7[2346]|8[234])\d{6}))$/;
const areaCodeStartChar$1 = '(';
const areaCodeEndChar$1 = ')';
const areaCodeSeparator$3 = ' ';
const phoneSeparator$2 = '-';

const unformatPhone$3 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$3}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.startsWith('0')) {
    phone = phone.substring(1);
  }

  if (phone.length > 8 && phone.startsWith(phoneCountryCode$3)) {
    phone = phone.replace(removeCountryCodeReg, '');
  }

  return phone;
};

const formatPhone$3 = phone => {
  phone = unformatPhone$3(phone);

  if (phone.length === 8) {
    if (phone[0] === '1') {
      return areaCodeStartChar$1 + phone.substring(0, 1) + areaCodeEndChar$1 + areaCodeSeparator$3 + phone.substring(1, 4) + phoneSeparator$2 + phone.substring(4, 9);
    }

    return areaCodeStartChar$1 + phone.substring(0, 2) + areaCodeEndChar$1 + areaCodeSeparator$3 + phone.substring(2, 5) + phoneSeparator$2 + phone.substring(5, 9);
  }

  if (phone.length === 9) {
    if (phone[0] === '9') {
      return phone.substring(0, 3) + areaCodeSeparator$3 + phone.substring(3, 6) + areaCodeSeparator$3 + phone.substring(6, 9);
    }

    return phone;
  }

  return phone;
};

const validatePhone$3 = phone => {
  phone = unformatPhone$3(phone);
  return phoneRegex$3.test(phone);
};

const unformatCorporateId = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\d]+/g, '');
};

const unformatId$3 = id => {
  const removeInvalidChars = /[^\d]/g;
  id = id.replace(removeInvalidChars, '');
  return id;
};

const formatId$3 = id => {
  id = unformatId$3(id);
  return id;
};

const formatCorporateId = id => {
  id = unformatCorporateId(id);
  return id;
};

const validatePersonalID$1 = id => {
  id = unformatId$3(id);

  if (!id) {
    return false;
  }

  if (id.length === 8) {
    if (/^[\d]+$/.test(id)) {
      return true;
    }

    return false;
  }

  if (id.length === 9) {
    const weights = [3, 2, 7, 6, 5, 4, 3, 2];
    const vd1 = [6, 5, 4, 3, 2, 1, 1, 0, 9, 8, 7]; // let vd2 = ["K","J","I","H","G","F","E","D","C","B","A"]

    let sum = 0;
    let i = 0;

    for (i = 0; i < weights.length; i++) {
      sum += weights[i] * parseInt(id[i], 10);
    }

    sum %= 11;
    const checksumDNI = vd1[sum]; // + vd2[sum]

    if (id.endsWith(checksumDNI.toString())) {
      return true;
    }

    return false;
  }

  if (id.length === 11) {
    const weightsRUC = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let sumRUC = 0;
    let k = 0;

    for (k = 0; k < weightsRUC.length; k++) {
      sumRUC += weightsRUC[k] * parseInt(id[k], 10);
    }

    sumRUC %= 11;
    const checksumRUC = (11 - sumRUC) % 10;

    if (!(id.startsWith('10') || id.startsWith('15') || id.startsWith('17'))) {
      return false;
    } else if (!id.endsWith(checksumRUC.toString())) {
      return false;
    }

    return true;
  }

  return false;
};

const validateCorporateID$3 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$3(id);
  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  let i = 0;

  for (i = 0; i < weights.length; i++) {
    sum += weights[i] * parseInt(id[i], 10);
  }

  sum %= 11;
  const checksum = (11 - sum) % 10;

  if (id.length !== 11) {
    return false;
  } else if (!id.startsWith('20')) {
    return false;
  } else if (!id.endsWith(checksum.toString())) {
    return false;
  }

  return true;
};

const PER = {
  input: {
    document: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000000000',
      maxLength: 12,
      inputMode: 'numeric',
      validate: validatePersonalID$1,
      format: formatId$3,
      unformat: unformatId$3
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 000 000',
      maxLength: 16,
      inputMode: 'numeric',
      validate: validatePhone$3,
      format: formatPhone$3,
      unformat: unformatPhone$3
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00000',
      maxLength: 5,
      inputMode: 'numeric',
      validate: value => /^[0-9]{5}$/.test(value),
      format: value => msk.fit(value, '99999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '00000000000',
      maxLength: 12,
      inputMode: 'numeric',
      validate: validateCorporateID$3,
      format: formatCorporateId,
      unformat: unformatCorporateId
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: mapCountryDataToFirstLevel(countryData$3)
    },
    city: {
      type: 'select',
      enabled: true,
      required: true,
      parent: 'state',
      options: mapCountryDataToSecondLevel(countryData$3)
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$2 = [
	"Greater London",
	"Aberdeen",
	"Bath And North East Somerse",
	"Belfast",
	"Bournemouth",
	"Brighton And Hove",
	"Bristol",
	"Cambridgeshire",
	"Cardiff",
	"Cheshire",
	"Cornwall",
	"Cumbria",
	"Derry",
	"Devon",
	"Dumfries And Galloway",
	"Dundee",
	"Dungannon",
	"Edinburgh",
	"Glasgow",
	"Highland",
	"Inverclyde",
	"Kent",
	"Kingston Upon Hull",
	"Lancashire",
	"Leicester",
	"Luton",
	"Manchester",
	"Merseyside",
	"Moray",
	"Norfolk",
	"North Yorkshire",
	"Nottingham",
	"Omagh",
	"Oxfordshire",
	"Perthshire And Kinross",
	"Peterborough",
	"Plymouth",
	"Portsmouth",
	"South Ayrshire",
	"South Yorkshire",
	"Southampton",
	"Southend On Sea",
	"Stockton On Tees",
	"Stoke On Trent",
	"Suffolk",
	"Swansea",
	"Tyne And Wear",
	"West Midlands",
	"West Yorkshire",
	"Westminster",
	"York"
];

const phoneCountryCode$2 = '44';
const phoneRegex$2 = /^(?:(?:(?:\+|)(?:44|)|))(?:(?:(01|02|03|05|07|08|09|10|11|12|99)\d{0,4})\d{7})$/;
const areaCodeSeparator$2 = ' ';

const unformatPhone$2 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$2}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length >= 10 && phone.startsWith(phoneCountryCode$2)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$2 = phone => {
  phone = unformatPhone$2(phone);

  if (phone.length === 9) {
    return phone.substring(0, 2) + areaCodeSeparator$2 + phone.substring(2);
  }

  if (phone.length === 10) {
    return phone.substring(0, 3) + areaCodeSeparator$2 + phone.substring(3);
  }

  if (phone.length === 11) {
    return phone.substring(0, 4) + areaCodeSeparator$2 + phone.substring(4);
  }

  if (phone.length === 12) {
    return phone.substring(0, 5) + areaCodeSeparator$2 + phone.substring(5);
  }

  if (phone.length === 13) {
    return phone.substring(0, 6) + areaCodeSeparator$2 + phone.substring(6);
  }

  if (phone.length === 14) {
    return phone.substring(0, 7) + areaCodeSeparator$2 + phone.substring(7);
  }

  return phone;
};

const validatePhone$2 = phone => {
  phone = unformatPhone$2(phone);
  return phoneRegex$2.test(phone);
};

const unformatId$2 = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const formatId$2 = id => {
  id = id.toString().toUpperCase();
  return id;
};

const validateCorporateID$2 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$2(id);
  const regex = /^(GB|XI)\d{9}$/;
  return regex.test(id);
};

const unformatPostalCode = postalCode => {
  if (!postalCode || typeof postalCode !== 'string') return '';
  postalCode = postalCode.replace(/[^\w]+/g, '').toUpperCase();
  const outerPart = postalCode.substring(0, postalCode.length - 3);
  const innerPart = postalCode.substring(postalCode.length - 3);
  postalCode = `${outerPart} ${innerPart}`;
  return postalCode;
};

const formatPostalCode = postalCode => {
  postalCode = postalCode.replace(/[^\w]+/g, '').toUpperCase();

  if (postalCode.length === 5) {
    return postalCode.substring(0, 2) + areaCodeSeparator$2 + postalCode.substring(2);
  }

  if (postalCode.length === 6) {
    return postalCode.substring(0, 3) + areaCodeSeparator$2 + postalCode.substring(3);
  }

  if (postalCode.length === 7) {
    return postalCode.substring(0, 4) + areaCodeSeparator$2 + postalCode.substring(4);
  }

  return postalCode;
};

const validatePostalCode = postalCode => {
  if (!postalCode) return false;
  postalCode = unformatPostalCode(postalCode);
  const innerPostalCodePattern = /^\d[a-zA-Z]{2}$/;

  if (postalCode.length > 5 && postalCode.length < 9 && innerPostalCodePattern.test(postalCode.substring(postalCode.length - 3))) {
    return true;
  }

  return false;
};

const GBR = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '',
      maxLength: 0,
      inputMode: 'text',
      validate: () => true,
      format: formatId$2,
      unformat: unformatId$2
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00 0000000',
      maxLength: 14,
      inputMode: 'numeric',
      validate: validatePhone$2,
      format: formatPhone$2,
      unformat: unformatPhone$2
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: 'AA9A 9AA',
      maxLength: 8,
      inputMode: 'text',
      validate: validatePostalCode,
      format: formatPostalCode,
      unformat: unformatPostalCode
    },
    corporateDocument: {
      type: 'text',
      required: false,
      enabled: true,
      placeholder: 'AA000000000',
      maxLength: 11,
      inputMode: 'text',
      validate: validateCorporateID$2,
      format: formatId$2,
      unformat: unformatId$2
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData$2
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      maxLength: 100,
      inputMode: 'text',
      validate: value => !!value,
      format: value => value,
      unformat: value => value
    },
    neighborhood: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData$1 = [
	"Australian Capital Territory",
	"New South Wales",
	"Northern Territory",
	"Queensland",
	"South Australia",
	"Tasmania",
	"Victoria",
	"Western Australia"
];

const phoneCountryCode$1 = '61';
const phoneRegex$1 = /^(?:(?:(?:\+|)(?:61|)(?:0|)|))([1-5,7-8])[0-9]{8,9}$/;
const areaCodeStartChar = '';
const areaCodeEndChar = '';
const areaCodeSeparator$1 = ' ';
const phoneSeparator$1 = ' ';

const unformatPhone$1 = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode$1}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 8 && phone.startsWith(phoneCountryCode$1)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone$1 = phone => {
  phone = unformatPhone$1(phone);

  if (phone.length > 8 && (phone[0] === '4' || phone[0] === '5')) {
    return areaCodeStartChar + phone.substring(0, 3) + areaCodeEndChar + areaCodeSeparator$1 + phone.substring(3, 6) + phoneSeparator$1 + phone.substring(6);
  }

  if (phone.length > 8 && phone[0] !== '4' && phone[0] !== '5') {
    return areaCodeStartChar + phone.substring(0, 1) + areaCodeEndChar + areaCodeSeparator$1 + phone.substring(1, 5) + phoneSeparator$1 + phone.substring(5);
  }

  return phone;
};

const validatePhone$1 = phone => {
  phone = unformatPhone$1(phone);
  return phoneRegex$1.test(phone);
};

const unformatId$1 = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const formatId$1 = id => {
  return id;
};

const validatePersonalID = id => {
  if (!id) {
    return false;
  }

  id = unformatId$1(id);

  if (/^[a-zA-Z0-9]{6,12}$/.test(id)) {
    return true;
  }

  return false;
};

const validateCorporateID$1 = id => {
  if (!id) {
    return false;
  }

  id = unformatId$1(id);

  if (/^[a-zA-Z0-9]{6,12}$/.test(id)) {
    return true;
  }

  return false;
};

const AUS = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '000000000',
      maxLength: 12,
      inputMode: 'text',
      validate: validatePersonalID,
      format: formatId$1,
      unformat: unformatId$1
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '000 000 0000',
      maxLength: 15,
      inputMode: 'numeric',
      validate: validatePhone$1,
      format: formatPhone$1,
      unformat: unformatPhone$1
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00000',
      maxLength: 5,
      inputMode: 'numeric',
      validate: value => /^[0-9]{4}$/.test(value),
      format: value => msk.fit(value, '9999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '000000000',
      maxLength: 12,
      inputMode: 'text',
      validate: validateCorporateID$1,
      format: formatId$1,
      unformat: unformatId$1
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData$1
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      maxLength: 100,
      inputMode: 'text',
      validate: value => !!value,
      format: value => value,
      unformat: value => value
    },
    neighborhood: {
      type: 'text',
      enabled: false,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

var countryData = [
	"Auckland",
	"Bay of Plenty",
	"Canterbury",
	"Gisborne",
	"Hawke's Bay",
	"Manawatū-Whanganui",
	"Marlborough",
	"Nelson",
	"Northland",
	"Otago",
	"Southland",
	"Taranaki",
	"Tasman",
	"Waikato",
	"Wellington",
	"West Coast"
];

const phoneCountryCode = '64';
const phoneRegex = /^(?:64)?(?:0)?(?:[34679]|2(?:0|1|5|6|7|9)|27(?:2|4|6))\d{6,7}$/;
const areaCodeSeparator = ' ';
const phoneSeparator = ' ';

const unformatPhone = phone => {
  const removeNonDigits = /[^\d]/g;
  const removeCountryCodeReg = new RegExp(`^${phoneCountryCode}`, 'g');
  phone = phone.replace(removeNonDigits, '');

  if (phone.length > 8 && phone.startsWith(phoneCountryCode)) {
    return phone.replace(removeNonDigits, '').replace(removeCountryCodeReg, '');
  }

  return phone.replace(removeNonDigits, '');
};

const formatPhone = phone => {
  phone = unformatPhone(phone);

  if (phone.length === 8 && ['3', '4', '6', '7', '9'].includes(phone[0])) {
    return phone.substring(0, 1) + areaCodeSeparator + phone.substring(1, 4) + phoneSeparator + phone.substring(4);
  }

  if (phone.length === 8 && ['20', '21', '25', '26'].includes(phone.substring(0, 2))) {
    return phone.substring(0, 2) + areaCodeSeparator + phone.substring(2, 5) + phoneSeparator + phone.substring(5);
  }

  if (phone.length === 9 && ['03', '04', '06', '07', '09'].includes(phone.substring(0, 2))) {
    return phone.substring(0, 2) + areaCodeSeparator + phone.substring(2, 5) + phoneSeparator + phone.substring(5);
  }

  if (phone.length === 9 && ['0', '2'].includes(phone[0])) {
    return phone.substring(0, 3) + areaCodeSeparator + phone.substring(3, 6) + phoneSeparator + phone.substring(6);
  }

  if (phone.length === 10) {
    return phone.substring(0, 4) + areaCodeSeparator + phone.substring(4, 7) + phoneSeparator + phone.substring(7);
  }

  return phone;
};

const validatePhone = phone => {
  phone = unformatPhone(phone);
  return phoneRegex.test(phone);
};

const unformatId = id => {
  return !id || typeof id !== 'string' ? '' : id.replace(/[^\w]+/g, '');
};

const formatId = id => {
  return id;
};

const validateCorporateID = id => {
  if (!id) {
    return false;
  }

  id = unformatId(id);

  if (/^9\d{12}$/.test(id)) {
    return true;
  }

  return false;
};

const NZL = {
  input: {
    document: {
      type: 'text',
      required: false,
      enabled: false,
      placeholder: '',
      maxLength: 0,
      inputMode: 'text',
      validate: () => true,
      format: formatId,
      unformat: unformatId
    },
    email: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: email => email,
      unformat: email => email,
      validate: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(value)
    },
    phone: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '00 000 000',
      maxLength: 12,
      inputMode: 'numeric',
      validate: validatePhone,
      format: formatPhone,
      unformat: unformatPhone
    },
    postalCode: {
      type: 'text',
      required: true,
      enabled: true,
      placeholder: '0000',
      maxLength: 4,
      inputMode: 'numeric',
      validate: value => /^\d{4}$/.test(value),
      format: value => msk.fit(value, '9999'),
      unformat: value => value.replace('-', '')
    },
    corporateDocument: {
      type: 'text',
      required: false,
      enabled: true,
      placeholder: '9000000000000',
      maxLength: 13,
      inputMode: 'numeric',
      validate: validateCorporateID,
      format: formatId,
      unformat: unformatId
    },
    state: {
      type: 'select',
      enabled: true,
      required: true,
      parent: null,
      options: countryData
    },
    city: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      maxLength: 100,
      inputMode: 'text',
      validate: value => !!value,
      format: value => value,
      unformat: value => value
    },
    neighborhood: {
      type: 'text',
      enabled: false,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 100,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    complement: {
      type: 'text',
      enabled: true,
      required: false,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: () => true
    },
    number: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'numeric',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => /^[a-zA-Z0-9-]+$/.test(value)
    },
    receiverName: {
      type: 'text',
      enabled: true,
      required: true,
      placeholder: '',
      inputMode: 'text',
      maxLength: 750,
      format: state => state,
      unformat: state => state,
      validate: value => !!value
    },
    street: {
      type: 'text',
      enabled: true,
      required: true,
      format: street => street,
      inputMode: 'text',
      maxLength: 750,
      placeholder: '',
      unformat: () => '',
      validate: street => !!street
    }
  },
  address: {
    postalCodeMode: 'postalcode-api'
  }
};

const COUNTRY_CODE_CONFIG_MAP = {
  ARG,
  BRA,
  CHL,
  MEX,
  ECU,
  COL,
  USA,
  IRL,
  PRT,
  ITA,
  CAN,
  ESP,
  PER,
  GBR,
  AUS,
  NZL
};
const getLocalizationConfig = countryCode => {
  return (countryCode ? COUNTRY_CODE_CONFIG_MAP[countryCode] : BRA) ?? BRA;
};

const useLocalizationState = ({
  countryCode
}) => {
  const initialLocalizationConfig = getLocalizationConfig(countryCode);
  const [localizationConfig, setLocalizationConfig] = useState(initialLocalizationConfig);
  useEffect(() => {
    const newLocalizationConfig = getLocalizationConfig(countryCode);
    setLocalizationConfig(newLocalizationConfig);
  }, [countryCode]);
  return {
    localizationConfig,
    setLocalizationConfig
  };
};

const LOCALIZATION_ADDRESS_INPUTS = ['postalCode', 'state', 'city', 'neighborhood', 'number', 'complement', 'receiverName', 'street'];
const LOCALIZATION_INPUT_TYPES = ['document', 'phone', 'corporateDocument', 'email', ...LOCALIZATION_ADDRESS_INPUTS];

export { ARG, AUS, BRA, CAN, CHL, COL, ECU, ESP, GBR, IRL, ITA, LOCALIZATION_ADDRESS_INPUTS, LOCALIZATION_INPUT_TYPES, LocalizationProvider, MEX, NZL, PER, PRT, USA, getLocalizationConfig, mapCountryDataToFirstLevel, mapCountryDataToSecondLevel, useLocalization, useLocalizationInput, useLocalizationState };
